var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import React, { useReducer, useCallback, useMemo, useEffect, useState, createContext, useContext } from "react";
import ReactDOM from "react-dom";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var colorString$1 = { exports: {} };
var colorName = {
  "aliceblue": [240, 248, 255],
  "antiquewhite": [250, 235, 215],
  "aqua": [0, 255, 255],
  "aquamarine": [127, 255, 212],
  "azure": [240, 255, 255],
  "beige": [245, 245, 220],
  "bisque": [255, 228, 196],
  "black": [0, 0, 0],
  "blanchedalmond": [255, 235, 205],
  "blue": [0, 0, 255],
  "blueviolet": [138, 43, 226],
  "brown": [165, 42, 42],
  "burlywood": [222, 184, 135],
  "cadetblue": [95, 158, 160],
  "chartreuse": [127, 255, 0],
  "chocolate": [210, 105, 30],
  "coral": [255, 127, 80],
  "cornflowerblue": [100, 149, 237],
  "cornsilk": [255, 248, 220],
  "crimson": [220, 20, 60],
  "cyan": [0, 255, 255],
  "darkblue": [0, 0, 139],
  "darkcyan": [0, 139, 139],
  "darkgoldenrod": [184, 134, 11],
  "darkgray": [169, 169, 169],
  "darkgreen": [0, 100, 0],
  "darkgrey": [169, 169, 169],
  "darkkhaki": [189, 183, 107],
  "darkmagenta": [139, 0, 139],
  "darkolivegreen": [85, 107, 47],
  "darkorange": [255, 140, 0],
  "darkorchid": [153, 50, 204],
  "darkred": [139, 0, 0],
  "darksalmon": [233, 150, 122],
  "darkseagreen": [143, 188, 143],
  "darkslateblue": [72, 61, 139],
  "darkslategray": [47, 79, 79],
  "darkslategrey": [47, 79, 79],
  "darkturquoise": [0, 206, 209],
  "darkviolet": [148, 0, 211],
  "deeppink": [255, 20, 147],
  "deepskyblue": [0, 191, 255],
  "dimgray": [105, 105, 105],
  "dimgrey": [105, 105, 105],
  "dodgerblue": [30, 144, 255],
  "firebrick": [178, 34, 34],
  "floralwhite": [255, 250, 240],
  "forestgreen": [34, 139, 34],
  "fuchsia": [255, 0, 255],
  "gainsboro": [220, 220, 220],
  "ghostwhite": [248, 248, 255],
  "gold": [255, 215, 0],
  "goldenrod": [218, 165, 32],
  "gray": [128, 128, 128],
  "green": [0, 128, 0],
  "greenyellow": [173, 255, 47],
  "grey": [128, 128, 128],
  "honeydew": [240, 255, 240],
  "hotpink": [255, 105, 180],
  "indianred": [205, 92, 92],
  "indigo": [75, 0, 130],
  "ivory": [255, 255, 240],
  "khaki": [240, 230, 140],
  "lavender": [230, 230, 250],
  "lavenderblush": [255, 240, 245],
  "lawngreen": [124, 252, 0],
  "lemonchiffon": [255, 250, 205],
  "lightblue": [173, 216, 230],
  "lightcoral": [240, 128, 128],
  "lightcyan": [224, 255, 255],
  "lightgoldenrodyellow": [250, 250, 210],
  "lightgray": [211, 211, 211],
  "lightgreen": [144, 238, 144],
  "lightgrey": [211, 211, 211],
  "lightpink": [255, 182, 193],
  "lightsalmon": [255, 160, 122],
  "lightseagreen": [32, 178, 170],
  "lightskyblue": [135, 206, 250],
  "lightslategray": [119, 136, 153],
  "lightslategrey": [119, 136, 153],
  "lightsteelblue": [176, 196, 222],
  "lightyellow": [255, 255, 224],
  "lime": [0, 255, 0],
  "limegreen": [50, 205, 50],
  "linen": [250, 240, 230],
  "magenta": [255, 0, 255],
  "maroon": [128, 0, 0],
  "mediumaquamarine": [102, 205, 170],
  "mediumblue": [0, 0, 205],
  "mediumorchid": [186, 85, 211],
  "mediumpurple": [147, 112, 219],
  "mediumseagreen": [60, 179, 113],
  "mediumslateblue": [123, 104, 238],
  "mediumspringgreen": [0, 250, 154],
  "mediumturquoise": [72, 209, 204],
  "mediumvioletred": [199, 21, 133],
  "midnightblue": [25, 25, 112],
  "mintcream": [245, 255, 250],
  "mistyrose": [255, 228, 225],
  "moccasin": [255, 228, 181],
  "navajowhite": [255, 222, 173],
  "navy": [0, 0, 128],
  "oldlace": [253, 245, 230],
  "olive": [128, 128, 0],
  "olivedrab": [107, 142, 35],
  "orange": [255, 165, 0],
  "orangered": [255, 69, 0],
  "orchid": [218, 112, 214],
  "palegoldenrod": [238, 232, 170],
  "palegreen": [152, 251, 152],
  "paleturquoise": [175, 238, 238],
  "palevioletred": [219, 112, 147],
  "papayawhip": [255, 239, 213],
  "peachpuff": [255, 218, 185],
  "peru": [205, 133, 63],
  "pink": [255, 192, 203],
  "plum": [221, 160, 221],
  "powderblue": [176, 224, 230],
  "purple": [128, 0, 128],
  "rebeccapurple": [102, 51, 153],
  "red": [255, 0, 0],
  "rosybrown": [188, 143, 143],
  "royalblue": [65, 105, 225],
  "saddlebrown": [139, 69, 19],
  "salmon": [250, 128, 114],
  "sandybrown": [244, 164, 96],
  "seagreen": [46, 139, 87],
  "seashell": [255, 245, 238],
  "sienna": [160, 82, 45],
  "silver": [192, 192, 192],
  "skyblue": [135, 206, 235],
  "slateblue": [106, 90, 205],
  "slategray": [112, 128, 144],
  "slategrey": [112, 128, 144],
  "snow": [255, 250, 250],
  "springgreen": [0, 255, 127],
  "steelblue": [70, 130, 180],
  "tan": [210, 180, 140],
  "teal": [0, 128, 128],
  "thistle": [216, 191, 216],
  "tomato": [255, 99, 71],
  "turquoise": [64, 224, 208],
  "violet": [238, 130, 238],
  "wheat": [245, 222, 179],
  "white": [255, 255, 255],
  "whitesmoke": [245, 245, 245],
  "yellow": [255, 255, 0],
  "yellowgreen": [154, 205, 50]
};
var simpleSwizzle = { exports: {} };
var isArrayish$1 = function isArrayish(obj) {
  if (!obj || typeof obj === "string") {
    return false;
  }
  return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== "String");
};
var isArrayish2 = isArrayish$1;
var concat = Array.prototype.concat;
var slice = Array.prototype.slice;
var swizzle$1 = simpleSwizzle.exports = function swizzle(args) {
  var results = [];
  for (var i = 0, len = args.length; i < len; i++) {
    var arg = args[i];
    if (isArrayish2(arg)) {
      results = concat.call(results, slice.call(arg));
    } else {
      results.push(arg);
    }
  }
  return results;
};
swizzle$1.wrap = function(fn) {
  return function() {
    return fn(swizzle$1(arguments));
  };
};
var simpleSwizzleExports = simpleSwizzle.exports;
var colorNames = colorName;
var swizzle2 = simpleSwizzleExports;
var hasOwnProperty$1 = Object.hasOwnProperty;
var reverseNames = /* @__PURE__ */ Object.create(null);
for (var name in colorNames) {
  if (hasOwnProperty$1.call(colorNames, name)) {
    reverseNames[colorNames[name]] = name;
  }
}
var cs = colorString$1.exports = {
  to: {},
  get: {}
};
cs.get = function(string2) {
  var prefix = string2.substring(0, 3).toLowerCase();
  var val;
  var model;
  switch (prefix) {
    case "hsl":
      val = cs.get.hsl(string2);
      model = "hsl";
      break;
    case "hwb":
      val = cs.get.hwb(string2);
      model = "hwb";
      break;
    default:
      val = cs.get.rgb(string2);
      model = "rgb";
      break;
  }
  if (!val) {
    return null;
  }
  return { model, value: val };
};
cs.get.rgb = function(string2) {
  if (!string2) {
    return null;
  }
  var abbr = /^#([a-f0-9]{3,4})$/i;
  var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
  var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
  var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
  var keyword = /^(\w+)$/;
  var rgb = [0, 0, 0, 1];
  var match5;
  var i;
  var hexAlpha;
  if (match5 = string2.match(hex)) {
    hexAlpha = match5[2];
    match5 = match5[1];
    for (i = 0; i < 3; i++) {
      var i2 = i * 2;
      rgb[i] = parseInt(match5.slice(i2, i2 + 2), 16);
    }
    if (hexAlpha) {
      rgb[3] = parseInt(hexAlpha, 16) / 255;
    }
  } else if (match5 = string2.match(abbr)) {
    match5 = match5[1];
    hexAlpha = match5[3];
    for (i = 0; i < 3; i++) {
      rgb[i] = parseInt(match5[i] + match5[i], 16);
    }
    if (hexAlpha) {
      rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    }
  } else if (match5 = string2.match(rgba)) {
    for (i = 0; i < 3; i++) {
      rgb[i] = parseInt(match5[i + 1], 0);
    }
    if (match5[4]) {
      if (match5[5]) {
        rgb[3] = parseFloat(match5[4]) * 0.01;
      } else {
        rgb[3] = parseFloat(match5[4]);
      }
    }
  } else if (match5 = string2.match(per)) {
    for (i = 0; i < 3; i++) {
      rgb[i] = Math.round(parseFloat(match5[i + 1]) * 2.55);
    }
    if (match5[4]) {
      if (match5[5]) {
        rgb[3] = parseFloat(match5[4]) * 0.01;
      } else {
        rgb[3] = parseFloat(match5[4]);
      }
    }
  } else if (match5 = string2.match(keyword)) {
    if (match5[1] === "transparent") {
      return [0, 0, 0, 0];
    }
    if (!hasOwnProperty$1.call(colorNames, match5[1])) {
      return null;
    }
    rgb = colorNames[match5[1]];
    rgb[3] = 1;
    return rgb;
  } else {
    return null;
  }
  for (i = 0; i < 3; i++) {
    rgb[i] = clamp(rgb[i], 0, 255);
  }
  rgb[3] = clamp(rgb[3], 0, 1);
  return rgb;
};
cs.get.hsl = function(string2) {
  if (!string2) {
    return null;
  }
  var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
  var match5 = string2.match(hsl);
  if (match5) {
    var alpha = parseFloat(match5[4]);
    var h = (parseFloat(match5[1]) % 360 + 360) % 360;
    var s = clamp(parseFloat(match5[2]), 0, 100);
    var l = clamp(parseFloat(match5[3]), 0, 100);
    var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
    return [h, s, l, a];
  }
  return null;
};
cs.get.hwb = function(string2) {
  if (!string2) {
    return null;
  }
  var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
  var match5 = string2.match(hwb);
  if (match5) {
    var alpha = parseFloat(match5[4]);
    var h = (parseFloat(match5[1]) % 360 + 360) % 360;
    var w = clamp(parseFloat(match5[2]), 0, 100);
    var b = clamp(parseFloat(match5[3]), 0, 100);
    var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
    return [h, w, b, a];
  }
  return null;
};
cs.to.hex = function() {
  var rgba = swizzle2(arguments);
  return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (rgba[3] < 1 ? hexDouble(Math.round(rgba[3] * 255)) : "");
};
cs.to.rgb = function() {
  var rgba = swizzle2(arguments);
  return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ")" : "rgba(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ", " + rgba[3] + ")";
};
cs.to.rgb.percent = function() {
  var rgba = swizzle2(arguments);
  var r = Math.round(rgba[0] / 255 * 100);
  var g = Math.round(rgba[1] / 255 * 100);
  var b = Math.round(rgba[2] / 255 * 100);
  return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + r + "%, " + g + "%, " + b + "%)" : "rgba(" + r + "%, " + g + "%, " + b + "%, " + rgba[3] + ")";
};
cs.to.hsl = function() {
  var hsla = swizzle2(arguments);
  return hsla.length < 4 || hsla[3] === 1 ? "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)" : "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + hsla[3] + ")";
};
cs.to.hwb = function() {
  var hwba = swizzle2(arguments);
  var a = "";
  if (hwba.length >= 4 && hwba[3] !== 1) {
    a = ", " + hwba[3];
  }
  return "hwb(" + hwba[0] + ", " + hwba[1] + "%, " + hwba[2] + "%" + a + ")";
};
cs.to.keyword = function(rgb) {
  return reverseNames[rgb.slice(0, 3)];
};
function clamp(num, min2, max2) {
  return Math.min(Math.max(min2, num), max2);
}
function hexDouble(num) {
  var str = Math.round(num).toString(16).toUpperCase();
  return str.length < 2 ? "0" + str : str;
}
var colorStringExports = colorString$1.exports;
const cssKeywords = colorName;
const reverseKeywords = {};
for (const key of Object.keys(cssKeywords)) {
  reverseKeywords[cssKeywords[key]] = key;
}
const convert$2 = {
  rgb: { channels: 3, labels: "rgb" },
  hsl: { channels: 3, labels: "hsl" },
  hsv: { channels: 3, labels: "hsv" },
  hwb: { channels: 3, labels: "hwb" },
  cmyk: { channels: 4, labels: "cmyk" },
  xyz: { channels: 3, labels: "xyz" },
  lab: { channels: 3, labels: "lab" },
  lch: { channels: 3, labels: "lch" },
  hex: { channels: 1, labels: ["hex"] },
  keyword: { channels: 1, labels: ["keyword"] },
  ansi16: { channels: 1, labels: ["ansi16"] },
  ansi256: { channels: 1, labels: ["ansi256"] },
  hcg: { channels: 3, labels: ["h", "c", "g"] },
  apple: { channels: 3, labels: ["r16", "g16", "b16"] },
  gray: { channels: 1, labels: ["gray"] }
};
var conversions$2 = convert$2;
for (const model of Object.keys(convert$2)) {
  if (!("channels" in convert$2[model])) {
    throw new Error("missing channels property: " + model);
  }
  if (!("labels" in convert$2[model])) {
    throw new Error("missing channel labels property: " + model);
  }
  if (convert$2[model].labels.length !== convert$2[model].channels) {
    throw new Error("channel and label counts mismatch: " + model);
  }
  const { channels, labels } = convert$2[model];
  delete convert$2[model].channels;
  delete convert$2[model].labels;
  Object.defineProperty(convert$2[model], "channels", { value: channels });
  Object.defineProperty(convert$2[model], "labels", { value: labels });
}
convert$2.rgb.hsl = function(rgb) {
  const r = rgb[0] / 255;
  const g = rgb[1] / 255;
  const b = rgb[2] / 255;
  const min2 = Math.min(r, g, b);
  const max2 = Math.max(r, g, b);
  const delta = max2 - min2;
  let h;
  let s;
  if (max2 === min2) {
    h = 0;
  } else if (r === max2) {
    h = (g - b) / delta;
  } else if (g === max2) {
    h = 2 + (b - r) / delta;
  } else if (b === max2) {
    h = 4 + (r - g) / delta;
  }
  h = Math.min(h * 60, 360);
  if (h < 0) {
    h += 360;
  }
  const l = (min2 + max2) / 2;
  if (max2 === min2) {
    s = 0;
  } else if (l <= 0.5) {
    s = delta / (max2 + min2);
  } else {
    s = delta / (2 - max2 - min2);
  }
  return [h, s * 100, l * 100];
};
convert$2.rgb.hsv = function(rgb) {
  let rdif;
  let gdif;
  let bdif;
  let h;
  let s;
  const r = rgb[0] / 255;
  const g = rgb[1] / 255;
  const b = rgb[2] / 255;
  const v = Math.max(r, g, b);
  const diff2 = v - Math.min(r, g, b);
  const diffc = function(c) {
    return (v - c) / 6 / diff2 + 1 / 2;
  };
  if (diff2 === 0) {
    h = 0;
    s = 0;
  } else {
    s = diff2 / v;
    rdif = diffc(r);
    gdif = diffc(g);
    bdif = diffc(b);
    if (r === v) {
      h = bdif - gdif;
    } else if (g === v) {
      h = 1 / 3 + rdif - bdif;
    } else if (b === v) {
      h = 2 / 3 + gdif - rdif;
    }
    if (h < 0) {
      h += 1;
    } else if (h > 1) {
      h -= 1;
    }
  }
  return [
    h * 360,
    s * 100,
    v * 100
  ];
};
convert$2.rgb.hwb = function(rgb) {
  const r = rgb[0];
  const g = rgb[1];
  let b = rgb[2];
  const h = convert$2.rgb.hsl(rgb)[0];
  const w = 1 / 255 * Math.min(r, Math.min(g, b));
  b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
  return [h, w * 100, b * 100];
};
convert$2.rgb.cmyk = function(rgb) {
  const r = rgb[0] / 255;
  const g = rgb[1] / 255;
  const b = rgb[2] / 255;
  const k = Math.min(1 - r, 1 - g, 1 - b);
  const c = (1 - r - k) / (1 - k) || 0;
  const m = (1 - g - k) / (1 - k) || 0;
  const y = (1 - b - k) / (1 - k) || 0;
  return [c * 100, m * 100, y * 100, k * 100];
};
function comparativeDistance(x, y) {
  return (x[0] - y[0]) ** 2 + (x[1] - y[1]) ** 2 + (x[2] - y[2]) ** 2;
}
convert$2.rgb.keyword = function(rgb) {
  const reversed = reverseKeywords[rgb];
  if (reversed) {
    return reversed;
  }
  let currentClosestDistance = Infinity;
  let currentClosestKeyword;
  for (const keyword of Object.keys(cssKeywords)) {
    const value = cssKeywords[keyword];
    const distance = comparativeDistance(rgb, value);
    if (distance < currentClosestDistance) {
      currentClosestDistance = distance;
      currentClosestKeyword = keyword;
    }
  }
  return currentClosestKeyword;
};
convert$2.keyword.rgb = function(keyword) {
  return cssKeywords[keyword];
};
convert$2.rgb.xyz = function(rgb) {
  let r = rgb[0] / 255;
  let g = rgb[1] / 255;
  let b = rgb[2] / 255;
  r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92;
  g = g > 0.04045 ? ((g + 0.055) / 1.055) ** 2.4 : g / 12.92;
  b = b > 0.04045 ? ((b + 0.055) / 1.055) ** 2.4 : b / 12.92;
  const x = r * 0.4124 + g * 0.3576 + b * 0.1805;
  const y = r * 0.2126 + g * 0.7152 + b * 0.0722;
  const z = r * 0.0193 + g * 0.1192 + b * 0.9505;
  return [x * 100, y * 100, z * 100];
};
convert$2.rgb.lab = function(rgb) {
  const xyz = convert$2.rgb.xyz(rgb);
  let x = xyz[0];
  let y = xyz[1];
  let z = xyz[2];
  x /= 95.047;
  y /= 100;
  z /= 108.883;
  x = x > 8856e-6 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
  y = y > 8856e-6 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
  z = z > 8856e-6 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
  const l = 116 * y - 16;
  const a = 500 * (x - y);
  const b = 200 * (y - z);
  return [l, a, b];
};
convert$2.hsl.rgb = function(hsl) {
  const h = hsl[0] / 360;
  const s = hsl[1] / 100;
  const l = hsl[2] / 100;
  let t2;
  let t3;
  let val;
  if (s === 0) {
    val = l * 255;
    return [val, val, val];
  }
  if (l < 0.5) {
    t2 = l * (1 + s);
  } else {
    t2 = l + s - l * s;
  }
  const t1 = 2 * l - t2;
  const rgb = [0, 0, 0];
  for (let i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * -(i - 1);
    if (t3 < 0) {
      t3++;
    }
    if (t3 > 1) {
      t3--;
    }
    if (6 * t3 < 1) {
      val = t1 + (t2 - t1) * 6 * t3;
    } else if (2 * t3 < 1) {
      val = t2;
    } else if (3 * t3 < 2) {
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    } else {
      val = t1;
    }
    rgb[i] = val * 255;
  }
  return rgb;
};
convert$2.hsl.hsv = function(hsl) {
  const h = hsl[0];
  let s = hsl[1] / 100;
  let l = hsl[2] / 100;
  let smin = s;
  const lmin = Math.max(l, 0.01);
  l *= 2;
  s *= l <= 1 ? l : 2 - l;
  smin *= lmin <= 1 ? lmin : 2 - lmin;
  const v = (l + s) / 2;
  const sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
  return [h, sv * 100, v * 100];
};
convert$2.hsv.rgb = function(hsv) {
  const h = hsv[0] / 60;
  const s = hsv[1] / 100;
  let v = hsv[2] / 100;
  const hi = Math.floor(h) % 6;
  const f = h - Math.floor(h);
  const p = 255 * v * (1 - s);
  const q = 255 * v * (1 - s * f);
  const t = 255 * v * (1 - s * (1 - f));
  v *= 255;
  switch (hi) {
    case 0:
      return [v, t, p];
    case 1:
      return [q, v, p];
    case 2:
      return [p, v, t];
    case 3:
      return [p, q, v];
    case 4:
      return [t, p, v];
    case 5:
      return [v, p, q];
  }
};
convert$2.hsv.hsl = function(hsv) {
  const h = hsv[0];
  const s = hsv[1] / 100;
  const v = hsv[2] / 100;
  const vmin = Math.max(v, 0.01);
  let sl;
  let l;
  l = (2 - s) * v;
  const lmin = (2 - s) * vmin;
  sl = s * vmin;
  sl /= lmin <= 1 ? lmin : 2 - lmin;
  sl = sl || 0;
  l /= 2;
  return [h, sl * 100, l * 100];
};
convert$2.hwb.rgb = function(hwb) {
  const h = hwb[0] / 360;
  let wh = hwb[1] / 100;
  let bl = hwb[2] / 100;
  const ratio = wh + bl;
  let f;
  if (ratio > 1) {
    wh /= ratio;
    bl /= ratio;
  }
  const i = Math.floor(6 * h);
  const v = 1 - bl;
  f = 6 * h - i;
  if ((i & 1) !== 0) {
    f = 1 - f;
  }
  const n = wh + f * (v - wh);
  let r;
  let g;
  let b;
  switch (i) {
    default:
    case 6:
    case 0:
      r = v;
      g = n;
      b = wh;
      break;
    case 1:
      r = n;
      g = v;
      b = wh;
      break;
    case 2:
      r = wh;
      g = v;
      b = n;
      break;
    case 3:
      r = wh;
      g = n;
      b = v;
      break;
    case 4:
      r = n;
      g = wh;
      b = v;
      break;
    case 5:
      r = v;
      g = wh;
      b = n;
      break;
  }
  return [r * 255, g * 255, b * 255];
};
convert$2.cmyk.rgb = function(cmyk) {
  const c = cmyk[0] / 100;
  const m = cmyk[1] / 100;
  const y = cmyk[2] / 100;
  const k = cmyk[3] / 100;
  const r = 1 - Math.min(1, c * (1 - k) + k);
  const g = 1 - Math.min(1, m * (1 - k) + k);
  const b = 1 - Math.min(1, y * (1 - k) + k);
  return [r * 255, g * 255, b * 255];
};
convert$2.xyz.rgb = function(xyz) {
  const x = xyz[0] / 100;
  const y = xyz[1] / 100;
  const z = xyz[2] / 100;
  let r;
  let g;
  let b;
  r = x * 3.2406 + y * -1.5372 + z * -0.4986;
  g = x * -0.9689 + y * 1.8758 + z * 0.0415;
  b = x * 0.0557 + y * -0.204 + z * 1.057;
  r = r > 31308e-7 ? 1.055 * r ** (1 / 2.4) - 0.055 : r * 12.92;
  g = g > 31308e-7 ? 1.055 * g ** (1 / 2.4) - 0.055 : g * 12.92;
  b = b > 31308e-7 ? 1.055 * b ** (1 / 2.4) - 0.055 : b * 12.92;
  r = Math.min(Math.max(0, r), 1);
  g = Math.min(Math.max(0, g), 1);
  b = Math.min(Math.max(0, b), 1);
  return [r * 255, g * 255, b * 255];
};
convert$2.xyz.lab = function(xyz) {
  let x = xyz[0];
  let y = xyz[1];
  let z = xyz[2];
  x /= 95.047;
  y /= 100;
  z /= 108.883;
  x = x > 8856e-6 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
  y = y > 8856e-6 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
  z = z > 8856e-6 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
  const l = 116 * y - 16;
  const a = 500 * (x - y);
  const b = 200 * (y - z);
  return [l, a, b];
};
convert$2.lab.xyz = function(lab) {
  const l = lab[0];
  const a = lab[1];
  const b = lab[2];
  let x;
  let y;
  let z;
  y = (l + 16) / 116;
  x = a / 500 + y;
  z = y - b / 200;
  const y2 = y ** 3;
  const x2 = x ** 3;
  const z2 = z ** 3;
  y = y2 > 8856e-6 ? y2 : (y - 16 / 116) / 7.787;
  x = x2 > 8856e-6 ? x2 : (x - 16 / 116) / 7.787;
  z = z2 > 8856e-6 ? z2 : (z - 16 / 116) / 7.787;
  x *= 95.047;
  y *= 100;
  z *= 108.883;
  return [x, y, z];
};
convert$2.lab.lch = function(lab) {
  const l = lab[0];
  const a = lab[1];
  const b = lab[2];
  let h;
  const hr = Math.atan2(b, a);
  h = hr * 360 / 2 / Math.PI;
  if (h < 0) {
    h += 360;
  }
  const c = Math.sqrt(a * a + b * b);
  return [l, c, h];
};
convert$2.lch.lab = function(lch) {
  const l = lch[0];
  const c = lch[1];
  const h = lch[2];
  const hr = h / 360 * 2 * Math.PI;
  const a = c * Math.cos(hr);
  const b = c * Math.sin(hr);
  return [l, a, b];
};
convert$2.rgb.ansi16 = function(args, saturation = null) {
  const [r, g, b] = args;
  let value = saturation === null ? convert$2.rgb.hsv(args)[2] : saturation;
  value = Math.round(value / 50);
  if (value === 0) {
    return 30;
  }
  let ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
  if (value === 2) {
    ansi += 60;
  }
  return ansi;
};
convert$2.hsv.ansi16 = function(args) {
  return convert$2.rgb.ansi16(convert$2.hsv.rgb(args), args[2]);
};
convert$2.rgb.ansi256 = function(args) {
  const r = args[0];
  const g = args[1];
  const b = args[2];
  if (r === g && g === b) {
    if (r < 8) {
      return 16;
    }
    if (r > 248) {
      return 231;
    }
    return Math.round((r - 8) / 247 * 24) + 232;
  }
  const ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
  return ansi;
};
convert$2.ansi16.rgb = function(args) {
  let color2 = args % 10;
  if (color2 === 0 || color2 === 7) {
    if (args > 50) {
      color2 += 3.5;
    }
    color2 = color2 / 10.5 * 255;
    return [color2, color2, color2];
  }
  const mult = (~~(args > 50) + 1) * 0.5;
  const r = (color2 & 1) * mult * 255;
  const g = (color2 >> 1 & 1) * mult * 255;
  const b = (color2 >> 2 & 1) * mult * 255;
  return [r, g, b];
};
convert$2.ansi256.rgb = function(args) {
  if (args >= 232) {
    const c = (args - 232) * 10 + 8;
    return [c, c, c];
  }
  args -= 16;
  let rem;
  const r = Math.floor(args / 36) / 5 * 255;
  const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
  const b = rem % 6 / 5 * 255;
  return [r, g, b];
};
convert$2.rgb.hex = function(args) {
  const integer = ((Math.round(args[0]) & 255) << 16) + ((Math.round(args[1]) & 255) << 8) + (Math.round(args[2]) & 255);
  const string2 = integer.toString(16).toUpperCase();
  return "000000".substring(string2.length) + string2;
};
convert$2.hex.rgb = function(args) {
  const match5 = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
  if (!match5) {
    return [0, 0, 0];
  }
  let colorString2 = match5[0];
  if (match5[0].length === 3) {
    colorString2 = colorString2.split("").map((char) => {
      return char + char;
    }).join("");
  }
  const integer = parseInt(colorString2, 16);
  const r = integer >> 16 & 255;
  const g = integer >> 8 & 255;
  const b = integer & 255;
  return [r, g, b];
};
convert$2.rgb.hcg = function(rgb) {
  const r = rgb[0] / 255;
  const g = rgb[1] / 255;
  const b = rgb[2] / 255;
  const max2 = Math.max(Math.max(r, g), b);
  const min2 = Math.min(Math.min(r, g), b);
  const chroma = max2 - min2;
  let grayscale;
  let hue;
  if (chroma < 1) {
    grayscale = min2 / (1 - chroma);
  } else {
    grayscale = 0;
  }
  if (chroma <= 0) {
    hue = 0;
  } else if (max2 === r) {
    hue = (g - b) / chroma % 6;
  } else if (max2 === g) {
    hue = 2 + (b - r) / chroma;
  } else {
    hue = 4 + (r - g) / chroma;
  }
  hue /= 6;
  hue %= 1;
  return [hue * 360, chroma * 100, grayscale * 100];
};
convert$2.hsl.hcg = function(hsl) {
  const s = hsl[1] / 100;
  const l = hsl[2] / 100;
  const c = l < 0.5 ? 2 * s * l : 2 * s * (1 - l);
  let f = 0;
  if (c < 1) {
    f = (l - 0.5 * c) / (1 - c);
  }
  return [hsl[0], c * 100, f * 100];
};
convert$2.hsv.hcg = function(hsv) {
  const s = hsv[1] / 100;
  const v = hsv[2] / 100;
  const c = s * v;
  let f = 0;
  if (c < 1) {
    f = (v - c) / (1 - c);
  }
  return [hsv[0], c * 100, f * 100];
};
convert$2.hcg.rgb = function(hcg) {
  const h = hcg[0] / 360;
  const c = hcg[1] / 100;
  const g = hcg[2] / 100;
  if (c === 0) {
    return [g * 255, g * 255, g * 255];
  }
  const pure = [0, 0, 0];
  const hi = h % 1 * 6;
  const v = hi % 1;
  const w = 1 - v;
  let mg = 0;
  switch (Math.floor(hi)) {
    case 0:
      pure[0] = 1;
      pure[1] = v;
      pure[2] = 0;
      break;
    case 1:
      pure[0] = w;
      pure[1] = 1;
      pure[2] = 0;
      break;
    case 2:
      pure[0] = 0;
      pure[1] = 1;
      pure[2] = v;
      break;
    case 3:
      pure[0] = 0;
      pure[1] = w;
      pure[2] = 1;
      break;
    case 4:
      pure[0] = v;
      pure[1] = 0;
      pure[2] = 1;
      break;
    default:
      pure[0] = 1;
      pure[1] = 0;
      pure[2] = w;
  }
  mg = (1 - c) * g;
  return [
    (c * pure[0] + mg) * 255,
    (c * pure[1] + mg) * 255,
    (c * pure[2] + mg) * 255
  ];
};
convert$2.hcg.hsv = function(hcg) {
  const c = hcg[1] / 100;
  const g = hcg[2] / 100;
  const v = c + g * (1 - c);
  let f = 0;
  if (v > 0) {
    f = c / v;
  }
  return [hcg[0], f * 100, v * 100];
};
convert$2.hcg.hsl = function(hcg) {
  const c = hcg[1] / 100;
  const g = hcg[2] / 100;
  const l = g * (1 - c) + 0.5 * c;
  let s = 0;
  if (l > 0 && l < 0.5) {
    s = c / (2 * l);
  } else if (l >= 0.5 && l < 1) {
    s = c / (2 * (1 - l));
  }
  return [hcg[0], s * 100, l * 100];
};
convert$2.hcg.hwb = function(hcg) {
  const c = hcg[1] / 100;
  const g = hcg[2] / 100;
  const v = c + g * (1 - c);
  return [hcg[0], (v - c) * 100, (1 - v) * 100];
};
convert$2.hwb.hcg = function(hwb) {
  const w = hwb[1] / 100;
  const b = hwb[2] / 100;
  const v = 1 - b;
  const c = v - w;
  let g = 0;
  if (c < 1) {
    g = (v - c) / (1 - c);
  }
  return [hwb[0], c * 100, g * 100];
};
convert$2.apple.rgb = function(apple) {
  return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
};
convert$2.rgb.apple = function(rgb) {
  return [rgb[0] / 255 * 65535, rgb[1] / 255 * 65535, rgb[2] / 255 * 65535];
};
convert$2.gray.rgb = function(args) {
  return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};
convert$2.gray.hsl = function(args) {
  return [0, 0, args[0]];
};
convert$2.gray.hsv = convert$2.gray.hsl;
convert$2.gray.hwb = function(gray) {
  return [0, 100, gray[0]];
};
convert$2.gray.cmyk = function(gray) {
  return [0, 0, 0, gray[0]];
};
convert$2.gray.lab = function(gray) {
  return [gray[0], 0, 0];
};
convert$2.gray.hex = function(gray) {
  const val = Math.round(gray[0] / 100 * 255) & 255;
  const integer = (val << 16) + (val << 8) + val;
  const string2 = integer.toString(16).toUpperCase();
  return "000000".substring(string2.length) + string2;
};
convert$2.rgb.gray = function(rgb) {
  const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
  return [val / 255 * 100];
};
const conversions$1 = conversions$2;
function buildGraph() {
  const graph = {};
  const models2 = Object.keys(conversions$1);
  for (let len = models2.length, i = 0; i < len; i++) {
    graph[models2[i]] = {
      // http://jsperf.com/1-vs-infinity
      // micro-opt, but this is simple.
      distance: -1,
      parent: null
    };
  }
  return graph;
}
function deriveBFS(fromModel) {
  const graph = buildGraph();
  const queue = [fromModel];
  graph[fromModel].distance = 0;
  while (queue.length) {
    const current = queue.pop();
    const adjacents = Object.keys(conversions$1[current]);
    for (let len = adjacents.length, i = 0; i < len; i++) {
      const adjacent = adjacents[i];
      const node = graph[adjacent];
      if (node.distance === -1) {
        node.distance = graph[current].distance + 1;
        node.parent = current;
        queue.unshift(adjacent);
      }
    }
  }
  return graph;
}
function link(from2, to2) {
  return function(args) {
    return to2(from2(args));
  };
}
function wrapConversion(toModel, graph) {
  const path = [graph[toModel].parent, toModel];
  let fn = conversions$1[graph[toModel].parent][toModel];
  let cur = graph[toModel].parent;
  while (graph[cur].parent) {
    path.unshift(graph[cur].parent);
    fn = link(conversions$1[graph[cur].parent][cur], fn);
    cur = graph[cur].parent;
  }
  fn.conversion = path;
  return fn;
}
var route$1 = function(fromModel) {
  const graph = deriveBFS(fromModel);
  const conversion = {};
  const models2 = Object.keys(graph);
  for (let len = models2.length, i = 0; i < len; i++) {
    const toModel = models2[i];
    const node = graph[toModel];
    if (node.parent === null) {
      continue;
    }
    conversion[toModel] = wrapConversion(toModel, graph);
  }
  return conversion;
};
const conversions = conversions$2;
const route = route$1;
const convert$1 = {};
const models = Object.keys(conversions);
function wrapRaw(fn) {
  const wrappedFn = function(...args) {
    const arg0 = args[0];
    if (arg0 === void 0 || arg0 === null) {
      return arg0;
    }
    if (arg0.length > 1) {
      args = arg0;
    }
    return fn(args);
  };
  if ("conversion" in fn) {
    wrappedFn.conversion = fn.conversion;
  }
  return wrappedFn;
}
function wrapRounded(fn) {
  const wrappedFn = function(...args) {
    const arg0 = args[0];
    if (arg0 === void 0 || arg0 === null) {
      return arg0;
    }
    if (arg0.length > 1) {
      args = arg0;
    }
    const result2 = fn(args);
    if (typeof result2 === "object") {
      for (let len = result2.length, i = 0; i < len; i++) {
        result2[i] = Math.round(result2[i]);
      }
    }
    return result2;
  };
  if ("conversion" in fn) {
    wrappedFn.conversion = fn.conversion;
  }
  return wrappedFn;
}
models.forEach((fromModel) => {
  convert$1[fromModel] = {};
  Object.defineProperty(convert$1[fromModel], "channels", { value: conversions[fromModel].channels });
  Object.defineProperty(convert$1[fromModel], "labels", { value: conversions[fromModel].labels });
  const routes = route(fromModel);
  const routeModels = Object.keys(routes);
  routeModels.forEach((toModel) => {
    const fn = routes[toModel];
    convert$1[fromModel][toModel] = wrapRounded(fn);
    convert$1[fromModel][toModel].raw = wrapRaw(fn);
  });
});
var colorConvert = convert$1;
var colorString = colorStringExports;
var convert = colorConvert;
var _slice = [].slice;
var skippedModels = [
  // to be honest, I don't really feel like keyword belongs in color convert, but eh.
  "keyword",
  // gray conflicts with some method names, and has its own method defined.
  "gray",
  // shouldn't really be in color-convert either...
  "hex"
];
var hashedModelKeys = {};
Object.keys(convert).forEach(function(model) {
  hashedModelKeys[_slice.call(convert[model].labels).sort().join("")] = model;
});
var limiters = {};
function Color(obj, model) {
  if (!(this instanceof Color)) {
    return new Color(obj, model);
  }
  if (model && model in skippedModels) {
    model = null;
  }
  if (model && !(model in convert)) {
    throw new Error("Unknown model: " + model);
  }
  var i;
  var channels;
  if (obj == null) {
    this.model = "rgb";
    this.color = [0, 0, 0];
    this.valpha = 1;
  } else if (obj instanceof Color) {
    this.model = obj.model;
    this.color = obj.color.slice();
    this.valpha = obj.valpha;
  } else if (typeof obj === "string") {
    var result2 = colorString.get(obj);
    if (result2 === null) {
      throw new Error("Unable to parse color from string: " + obj);
    }
    this.model = result2.model;
    channels = convert[this.model].channels;
    this.color = result2.value.slice(0, channels);
    this.valpha = typeof result2.value[channels] === "number" ? result2.value[channels] : 1;
  } else if (obj.length) {
    this.model = model || "rgb";
    channels = convert[this.model].channels;
    var newArr = _slice.call(obj, 0, channels);
    this.color = zeroArray(newArr, channels);
    this.valpha = typeof obj[channels] === "number" ? obj[channels] : 1;
  } else if (typeof obj === "number") {
    obj &= 16777215;
    this.model = "rgb";
    this.color = [
      obj >> 16 & 255,
      obj >> 8 & 255,
      obj & 255
    ];
    this.valpha = 1;
  } else {
    this.valpha = 1;
    var keys2 = Object.keys(obj);
    if ("alpha" in obj) {
      keys2.splice(keys2.indexOf("alpha"), 1);
      this.valpha = typeof obj.alpha === "number" ? obj.alpha : 0;
    }
    var hashedKeys = keys2.sort().join("");
    if (!(hashedKeys in hashedModelKeys)) {
      throw new Error("Unable to parse color from object: " + JSON.stringify(obj));
    }
    this.model = hashedModelKeys[hashedKeys];
    var labels = convert[this.model].labels;
    var color2 = [];
    for (i = 0; i < labels.length; i++) {
      color2.push(obj[labels[i]]);
    }
    this.color = zeroArray(color2);
  }
  if (limiters[this.model]) {
    channels = convert[this.model].channels;
    for (i = 0; i < channels; i++) {
      var limit = limiters[this.model][i];
      if (limit) {
        this.color[i] = limit(this.color[i]);
      }
    }
  }
  this.valpha = Math.max(0, Math.min(1, this.valpha));
  if (Object.freeze) {
    Object.freeze(this);
  }
}
Color.prototype = {
  toString: function() {
    return this.string();
  },
  toJSON: function() {
    return this[this.model]();
  },
  string: function(places) {
    var self2 = this.model in colorString.to ? this : this.rgb();
    self2 = self2.round(typeof places === "number" ? places : 1);
    var args = self2.valpha === 1 ? self2.color : self2.color.concat(this.valpha);
    return colorString.to[self2.model](args);
  },
  percentString: function(places) {
    var self2 = this.rgb().round(typeof places === "number" ? places : 1);
    var args = self2.valpha === 1 ? self2.color : self2.color.concat(this.valpha);
    return colorString.to.rgb.percent(args);
  },
  array: function() {
    return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
  },
  object: function() {
    var result2 = {};
    var channels = convert[this.model].channels;
    var labels = convert[this.model].labels;
    for (var i = 0; i < channels; i++) {
      result2[labels[i]] = this.color[i];
    }
    if (this.valpha !== 1) {
      result2.alpha = this.valpha;
    }
    return result2;
  },
  unitArray: function() {
    var rgb = this.rgb().color;
    rgb[0] /= 255;
    rgb[1] /= 255;
    rgb[2] /= 255;
    if (this.valpha !== 1) {
      rgb.push(this.valpha);
    }
    return rgb;
  },
  unitObject: function() {
    var rgb = this.rgb().object();
    rgb.r /= 255;
    rgb.g /= 255;
    rgb.b /= 255;
    if (this.valpha !== 1) {
      rgb.alpha = this.valpha;
    }
    return rgb;
  },
  round: function(places) {
    places = Math.max(places || 0, 0);
    return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
  },
  alpha: function(val) {
    if (arguments.length) {
      return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
    }
    return this.valpha;
  },
  // rgb
  red: getset("rgb", 0, maxfn(255)),
  green: getset("rgb", 1, maxfn(255)),
  blue: getset("rgb", 2, maxfn(255)),
  hue: getset(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, function(val) {
    return (val % 360 + 360) % 360;
  }),
  // eslint-disable-line brace-style
  saturationl: getset("hsl", 1, maxfn(100)),
  lightness: getset("hsl", 2, maxfn(100)),
  saturationv: getset("hsv", 1, maxfn(100)),
  value: getset("hsv", 2, maxfn(100)),
  chroma: getset("hcg", 1, maxfn(100)),
  gray: getset("hcg", 2, maxfn(100)),
  white: getset("hwb", 1, maxfn(100)),
  wblack: getset("hwb", 2, maxfn(100)),
  cyan: getset("cmyk", 0, maxfn(100)),
  magenta: getset("cmyk", 1, maxfn(100)),
  yellow: getset("cmyk", 2, maxfn(100)),
  black: getset("cmyk", 3, maxfn(100)),
  x: getset("xyz", 0, maxfn(100)),
  y: getset("xyz", 1, maxfn(100)),
  z: getset("xyz", 2, maxfn(100)),
  l: getset("lab", 0, maxfn(100)),
  a: getset("lab", 1),
  b: getset("lab", 2),
  keyword: function(val) {
    if (arguments.length) {
      return new Color(val);
    }
    return convert[this.model].keyword(this.color);
  },
  hex: function(val) {
    if (arguments.length) {
      return new Color(val);
    }
    return colorString.to.hex(this.rgb().round().color);
  },
  rgbNumber: function() {
    var rgb = this.rgb().color;
    return (rgb[0] & 255) << 16 | (rgb[1] & 255) << 8 | rgb[2] & 255;
  },
  luminosity: function() {
    var rgb = this.rgb().color;
    var lum = [];
    for (var i = 0; i < rgb.length; i++) {
      var chan = rgb[i] / 255;
      lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
    }
    return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
  },
  contrast: function(color2) {
    var lum1 = this.luminosity();
    var lum2 = color2.luminosity();
    if (lum1 > lum2) {
      return (lum1 + 0.05) / (lum2 + 0.05);
    }
    return (lum2 + 0.05) / (lum1 + 0.05);
  },
  level: function(color2) {
    var contrastRatio2 = this.contrast(color2);
    if (contrastRatio2 >= 7.1) {
      return "AAA";
    }
    return contrastRatio2 >= 4.5 ? "AA" : "";
  },
  isDark: function() {
    var rgb = this.rgb().color;
    var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1e3;
    return yiq < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  negate: function() {
    var rgb = this.rgb();
    for (var i = 0; i < 3; i++) {
      rgb.color[i] = 255 - rgb.color[i];
    }
    return rgb;
  },
  lighten: function(ratio) {
    var hsl = this.hsl();
    hsl.color[2] += hsl.color[2] * ratio;
    return hsl;
  },
  darken: function(ratio) {
    var hsl = this.hsl();
    hsl.color[2] -= hsl.color[2] * ratio;
    return hsl;
  },
  saturate: function(ratio) {
    var hsl = this.hsl();
    hsl.color[1] += hsl.color[1] * ratio;
    return hsl;
  },
  desaturate: function(ratio) {
    var hsl = this.hsl();
    hsl.color[1] -= hsl.color[1] * ratio;
    return hsl;
  },
  whiten: function(ratio) {
    var hwb = this.hwb();
    hwb.color[1] += hwb.color[1] * ratio;
    return hwb;
  },
  blacken: function(ratio) {
    var hwb = this.hwb();
    hwb.color[2] += hwb.color[2] * ratio;
    return hwb;
  },
  grayscale: function() {
    var rgb = this.rgb().color;
    var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
    return Color.rgb(val, val, val);
  },
  fade: function(ratio) {
    return this.alpha(this.valpha - this.valpha * ratio);
  },
  opaquer: function(ratio) {
    return this.alpha(this.valpha + this.valpha * ratio);
  },
  rotate: function(degrees) {
    var hsl = this.hsl();
    var hue = hsl.color[0];
    hue = (hue + degrees) % 360;
    hue = hue < 0 ? 360 + hue : hue;
    hsl.color[0] = hue;
    return hsl;
  },
  mix: function(mixinColor, weight) {
    if (!mixinColor || !mixinColor.rgb) {
      throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
    }
    var color1 = mixinColor.rgb();
    var color2 = this.rgb();
    var p = weight === void 0 ? 0.5 : weight;
    var w = 2 * p - 1;
    var a = color1.alpha() - color2.alpha();
    var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
    var w2 = 1 - w1;
    return Color.rgb(
      w1 * color1.red() + w2 * color2.red(),
      w1 * color1.green() + w2 * color2.green(),
      w1 * color1.blue() + w2 * color2.blue(),
      color1.alpha() * p + color2.alpha() * (1 - p)
    );
  }
};
Object.keys(convert).forEach(function(model) {
  if (skippedModels.indexOf(model) !== -1) {
    return;
  }
  var channels = convert[model].channels;
  Color.prototype[model] = function() {
    if (this.model === model) {
      return new Color(this);
    }
    if (arguments.length) {
      return new Color(arguments, model);
    }
    var newAlpha = typeof arguments[channels] === "number" ? channels : this.valpha;
    return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
  };
  Color[model] = function(color2) {
    if (typeof color2 === "number") {
      color2 = zeroArray(_slice.call(arguments), channels);
    }
    return new Color(color2, model);
  };
});
function roundTo(num, places) {
  return Number(num.toFixed(places));
}
function roundToPlace(places) {
  return function(num) {
    return roundTo(num, places);
  };
}
function getset(model, channel, modifier) {
  model = Array.isArray(model) ? model : [model];
  model.forEach(function(m) {
    (limiters[m] || (limiters[m] = []))[channel] = modifier;
  });
  model = model[0];
  return function(val) {
    var result2;
    if (arguments.length) {
      if (modifier) {
        val = modifier(val);
      }
      result2 = this[model]();
      result2.color[channel] = val;
      return result2;
    }
    result2 = this[model]().color[channel];
    if (modifier) {
      result2 = modifier(result2);
    }
    return result2;
  };
}
function maxfn(max2) {
  return function(v) {
    return Math.max(0, Math.min(max2, v));
  };
}
function assertArray(val) {
  return Array.isArray(val) ? val : [val];
}
function zeroArray(arr, length) {
  for (var i = 0; i < length; i++) {
    if (typeof arr[i] !== "number") {
      arr[i] = 0;
    }
  }
  return arr;
}
var color = Color;
const Color$1 = /* @__PURE__ */ getDefaultExportFromCjs(color);
var lodash = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash.exports;
(function(module2, exports) {
  (function() {
    var undefined$1;
    var VERSION2 = "4.17.21";
    var LARGE_ARRAY_SIZE = 200;
    var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var MAX_MEMOIZE_SIZE = 500;
    var PLACEHOLDER = "__lodash_placeholder__";
    var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    var HOT_COUNT = 800, HOT_SPAN = 16;
    var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
    var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    var wrapFlags = [
      ["ary", WRAP_ARY_FLAG],
      ["bind", WRAP_BIND_FLAG],
      ["bindKey", WRAP_BIND_KEY_FLAG],
      ["curry", WRAP_CURRY_FLAG],
      ["curryRight", WRAP_CURRY_RIGHT_FLAG],
      ["flip", WRAP_FLIP_FLAG],
      ["partial", WRAP_PARTIAL_FLAG],
      ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
      ["rearg", WRAP_REARG_FLAG]
    ];
    var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    var reTrimStart = /^\s+/;
    var reWhitespace = /\s/;
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    var reEscapeChar = /\\(\\)?/g;
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var reFlags = /\w*$/;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsOctal = /^0o[0-7]+$/i;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var reNoMatch = /($^)/;
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
    var reApos = RegExp(rsApos, "g");
    var reComboMark = RegExp(rsCombo, "g");
    var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    var reUnicodeWord = RegExp([
      rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
      rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
      rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
      rsUpper + "+" + rsOptContrUpper,
      rsOrdUpper,
      rsOrdLower,
      rsDigits,
      rsEmoji
    ].join("|"), "g");
    var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var contextProps = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ];
    var templateCounter = -1;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    var deburredLetters = {
      // Latin-1 Supplement block.
      "À": "A",
      "Á": "A",
      "Â": "A",
      "Ã": "A",
      "Ä": "A",
      "Å": "A",
      "à": "a",
      "á": "a",
      "â": "a",
      "ã": "a",
      "ä": "a",
      "å": "a",
      "Ç": "C",
      "ç": "c",
      "Ð": "D",
      "ð": "d",
      "È": "E",
      "É": "E",
      "Ê": "E",
      "Ë": "E",
      "è": "e",
      "é": "e",
      "ê": "e",
      "ë": "e",
      "Ì": "I",
      "Í": "I",
      "Î": "I",
      "Ï": "I",
      "ì": "i",
      "í": "i",
      "î": "i",
      "ï": "i",
      "Ñ": "N",
      "ñ": "n",
      "Ò": "O",
      "Ó": "O",
      "Ô": "O",
      "Õ": "O",
      "Ö": "O",
      "Ø": "O",
      "ò": "o",
      "ó": "o",
      "ô": "o",
      "õ": "o",
      "ö": "o",
      "ø": "o",
      "Ù": "U",
      "Ú": "U",
      "Û": "U",
      "Ü": "U",
      "ù": "u",
      "ú": "u",
      "û": "u",
      "ü": "u",
      "Ý": "Y",
      "ý": "y",
      "ÿ": "y",
      "Æ": "Ae",
      "æ": "ae",
      "Þ": "Th",
      "þ": "th",
      "ß": "ss",
      // Latin Extended-A block.
      "Ā": "A",
      "Ă": "A",
      "Ą": "A",
      "ā": "a",
      "ă": "a",
      "ą": "a",
      "Ć": "C",
      "Ĉ": "C",
      "Ċ": "C",
      "Č": "C",
      "ć": "c",
      "ĉ": "c",
      "ċ": "c",
      "č": "c",
      "Ď": "D",
      "Đ": "D",
      "ď": "d",
      "đ": "d",
      "Ē": "E",
      "Ĕ": "E",
      "Ė": "E",
      "Ę": "E",
      "Ě": "E",
      "ē": "e",
      "ĕ": "e",
      "ė": "e",
      "ę": "e",
      "ě": "e",
      "Ĝ": "G",
      "Ğ": "G",
      "Ġ": "G",
      "Ģ": "G",
      "ĝ": "g",
      "ğ": "g",
      "ġ": "g",
      "ģ": "g",
      "Ĥ": "H",
      "Ħ": "H",
      "ĥ": "h",
      "ħ": "h",
      "Ĩ": "I",
      "Ī": "I",
      "Ĭ": "I",
      "Į": "I",
      "İ": "I",
      "ĩ": "i",
      "ī": "i",
      "ĭ": "i",
      "į": "i",
      "ı": "i",
      "Ĵ": "J",
      "ĵ": "j",
      "Ķ": "K",
      "ķ": "k",
      "ĸ": "k",
      "Ĺ": "L",
      "Ļ": "L",
      "Ľ": "L",
      "Ŀ": "L",
      "Ł": "L",
      "ĺ": "l",
      "ļ": "l",
      "ľ": "l",
      "ŀ": "l",
      "ł": "l",
      "Ń": "N",
      "Ņ": "N",
      "Ň": "N",
      "Ŋ": "N",
      "ń": "n",
      "ņ": "n",
      "ň": "n",
      "ŋ": "n",
      "Ō": "O",
      "Ŏ": "O",
      "Ő": "O",
      "ō": "o",
      "ŏ": "o",
      "ő": "o",
      "Ŕ": "R",
      "Ŗ": "R",
      "Ř": "R",
      "ŕ": "r",
      "ŗ": "r",
      "ř": "r",
      "Ś": "S",
      "Ŝ": "S",
      "Ş": "S",
      "Š": "S",
      "ś": "s",
      "ŝ": "s",
      "ş": "s",
      "š": "s",
      "Ţ": "T",
      "Ť": "T",
      "Ŧ": "T",
      "ţ": "t",
      "ť": "t",
      "ŧ": "t",
      "Ũ": "U",
      "Ū": "U",
      "Ŭ": "U",
      "Ů": "U",
      "Ű": "U",
      "Ų": "U",
      "ũ": "u",
      "ū": "u",
      "ŭ": "u",
      "ů": "u",
      "ű": "u",
      "ų": "u",
      "Ŵ": "W",
      "ŵ": "w",
      "Ŷ": "Y",
      "ŷ": "y",
      "Ÿ": "Y",
      "Ź": "Z",
      "Ż": "Z",
      "Ž": "Z",
      "ź": "z",
      "ż": "z",
      "ž": "z",
      "Ĳ": "IJ",
      "ĳ": "ij",
      "Œ": "Oe",
      "œ": "oe",
      "ŉ": "'n",
      "ſ": "s"
    };
    var htmlEscapes = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };
    var htmlUnescapes = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    };
    var stringEscapes = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    };
    var freeParseFloat = parseFloat, freeParseInt = parseInt;
    var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var freeExports = exports && !exports.nodeType && exports;
    var freeModule = freeExports && true && module2 && !module2.nodeType && module2;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {
      }
    }();
    var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function arrayAggregator(array, setter, iteratee, accumulator) {
      var index = -1, length = array == null ? 0 : array.length;
      while (++index < length) {
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
      }
      return accumulator;
    }
    function arrayEach(array, iteratee) {
      var index = -1, length = array == null ? 0 : array.length;
      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEachRight(array, iteratee) {
      var length = array == null ? 0 : array.length;
      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEvery(array, predicate) {
      var index = -1, length = array == null ? 0 : array.length;
      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }
    function arrayFilter(array, predicate) {
      var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result2[resIndex++] = value;
        }
      }
      return result2;
    }
    function arrayIncludes(array, value) {
      var length = array == null ? 0 : array.length;
      return !!length && baseIndexOf(array, value, 0) > -1;
    }
    function arrayIncludesWith(array, value, comparator) {
      var index = -1, length = array == null ? 0 : array.length;
      while (++index < length) {
        if (comparator(value, array[index])) {
          return true;
        }
      }
      return false;
    }
    function arrayMap(array, iteratee) {
      var index = -1, length = array == null ? 0 : array.length, result2 = Array(length);
      while (++index < length) {
        result2[index] = iteratee(array[index], index, array);
      }
      return result2;
    }
    function arrayPush(array, values) {
      var index = -1, length = values.length, offset2 = array.length;
      while (++index < length) {
        array[offset2 + index] = values[index];
      }
      return array;
    }
    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index = -1, length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }
    function arrayReduceRight(array, iteratee, accumulator, initAccum) {
      var length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }
    function arraySome(array, predicate) {
      var index = -1, length = array == null ? 0 : array.length;
      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }
    var asciiSize = baseProperty("length");
    function asciiToArray(string2) {
      return string2.split("");
    }
    function asciiWords(string2) {
      return string2.match(reAsciiWord) || [];
    }
    function baseFindKey(collection, predicate, eachFunc) {
      var result2;
      eachFunc(collection, function(value, key, collection2) {
        if (predicate(value, key, collection2)) {
          result2 = key;
          return false;
        }
      });
      return result2;
    }
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index-- : ++index < length) {
        if (predicate(array[index], index, array)) {
          return index;
        }
      }
      return -1;
    }
    function baseIndexOf(array, value, fromIndex) {
      return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    function baseIndexOfWith(array, value, fromIndex, comparator) {
      var index = fromIndex - 1, length = array.length;
      while (++index < length) {
        if (comparator(array[index], value)) {
          return index;
        }
      }
      return -1;
    }
    function baseIsNaN(value) {
      return value !== value;
    }
    function baseMean(array, iteratee) {
      var length = array == null ? 0 : array.length;
      return length ? baseSum(array, iteratee) / length : NAN;
    }
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function basePropertyOf(object) {
      return function(key) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function(value, index, collection2) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection2);
      });
      return accumulator;
    }
    function baseSortBy(array, comparer) {
      var length = array.length;
      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }
    function baseSum(array, iteratee) {
      var result2, index = -1, length = array.length;
      while (++index < length) {
        var current = iteratee(array[index]);
        if (current !== undefined$1) {
          result2 = result2 === undefined$1 ? current : result2 + current;
        }
      }
      return result2;
    }
    function baseTimes(n, iteratee) {
      var index = -1, result2 = Array(n);
      while (++index < n) {
        result2[index] = iteratee(index);
      }
      return result2;
    }
    function baseToPairs(object, props) {
      return arrayMap(props, function(key) {
        return [key, object[key]];
      });
    }
    function baseTrim(string2) {
      return string2 ? string2.slice(0, trimmedEndIndex(string2) + 1).replace(reTrimStart, "") : string2;
    }
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    function baseValues(object, props) {
      return arrayMap(props, function(key) {
        return object[key];
      });
    }
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    function charsStartIndex(strSymbols, chrSymbols) {
      var index = -1, length = strSymbols.length;
      while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
      }
      return index;
    }
    function charsEndIndex(strSymbols, chrSymbols) {
      var index = strSymbols.length;
      while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
      }
      return index;
    }
    function countHolders(array, placeholder) {
      var length = array.length, result2 = 0;
      while (length--) {
        if (array[length] === placeholder) {
          ++result2;
        }
      }
      return result2;
    }
    var deburrLetter = basePropertyOf(deburredLetters);
    var escapeHtmlChar = basePropertyOf(htmlEscapes);
    function escapeStringChar(chr) {
      return "\\" + stringEscapes[chr];
    }
    function getValue(object, key) {
      return object == null ? undefined$1 : object[key];
    }
    function hasUnicode(string2) {
      return reHasUnicode.test(string2);
    }
    function hasUnicodeWord(string2) {
      return reHasUnicodeWord.test(string2);
    }
    function iteratorToArray(iterator) {
      var data, result2 = [];
      while (!(data = iterator.next()).done) {
        result2.push(data.value);
      }
      return result2;
    }
    function mapToArray(map2) {
      var index = -1, result2 = Array(map2.size);
      map2.forEach(function(value, key) {
        result2[++index] = [key, value];
      });
      return result2;
    }
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    function replaceHolders(array, placeholder) {
      var index = -1, length = array.length, resIndex = 0, result2 = [];
      while (++index < length) {
        var value = array[index];
        if (value === placeholder || value === PLACEHOLDER) {
          array[index] = PLACEHOLDER;
          result2[resIndex++] = index;
        }
      }
      return result2;
    }
    function setToArray(set2) {
      var index = -1, result2 = Array(set2.size);
      set2.forEach(function(value) {
        result2[++index] = value;
      });
      return result2;
    }
    function setToPairs(set2) {
      var index = -1, result2 = Array(set2.size);
      set2.forEach(function(value) {
        result2[++index] = [value, value];
      });
      return result2;
    }
    function strictIndexOf(array, value, fromIndex) {
      var index = fromIndex - 1, length = array.length;
      while (++index < length) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }
    function strictLastIndexOf(array, value, fromIndex) {
      var index = fromIndex + 1;
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return index;
    }
    function stringSize(string2) {
      return hasUnicode(string2) ? unicodeSize(string2) : asciiSize(string2);
    }
    function stringToArray(string2) {
      return hasUnicode(string2) ? unicodeToArray(string2) : asciiToArray(string2);
    }
    function trimmedEndIndex(string2) {
      var index = string2.length;
      while (index-- && reWhitespace.test(string2.charAt(index))) {
      }
      return index;
    }
    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    function unicodeSize(string2) {
      var result2 = reUnicode.lastIndex = 0;
      while (reUnicode.test(string2)) {
        ++result2;
      }
      return result2;
    }
    function unicodeToArray(string2) {
      return string2.match(reUnicode) || [];
    }
    function unicodeWords(string2) {
      return string2.match(reUnicodeWord) || [];
    }
    var runInContext = function runInContext2(context) {
      context = context == null ? root : _2.defaults(root.Object(), context, _2.pick(root, contextProps));
      var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
      var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
      var coreJsData = context["__core-js_shared__"];
      var funcToString = funcProto.toString;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      var idCounter = 0;
      var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
      }();
      var nativeObjectToString = objectProto.toString;
      var objectCtorString = funcToString.call(Object2);
      var oldDash = root._;
      var reIsNative = RegExp2(
        "^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      );
      var Buffer2 = moduleExports ? context.Buffer : undefined$1, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined$1, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined$1, symIterator = Symbol2 ? Symbol2.iterator : undefined$1, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined$1;
      var defineProperty = function() {
        try {
          var func = getNative(Object2, "defineProperty");
          func({}, "", {});
          return func;
        } catch (e) {
        }
      }();
      var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
      var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined$1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
      var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
      var metaMap = WeakMap && new WeakMap();
      var realNames = {};
      var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
      var symbolProto = Symbol2 ? Symbol2.prototype : undefined$1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1, symbolToString = symbolProto ? symbolProto.toString : undefined$1;
      function lodash2(value) {
        if (isObjectLike(value) && !isArray2(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty2.call(value, "__wrapped__")) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }
      var baseCreate = /* @__PURE__ */ function() {
        function object() {
        }
        return function(proto2) {
          if (!isObject2(proto2)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto2);
          }
          object.prototype = proto2;
          var result3 = new object();
          object.prototype = undefined$1;
          return result3;
        };
      }();
      function baseLodash() {
      }
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }
      lodash2.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "escape": reEscape,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "evaluate": reEvaluate,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "interpolate": reInterpolate,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        "variable": "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        "imports": {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          "_": lodash2
        }
      };
      lodash2.prototype = baseLodash.prototype;
      lodash2.prototype.constructor = lodash2;
      LodashWrapper.prototype = baseCreate(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }
      function lazyClone() {
        var result3 = new LazyWrapper(this.__wrapped__);
        result3.__actions__ = copyArray(this.__actions__);
        result3.__dir__ = this.__dir__;
        result3.__filtered__ = this.__filtered__;
        result3.__iteratees__ = copyArray(this.__iteratees__);
        result3.__takeCount__ = this.__takeCount__;
        result3.__views__ = copyArray(this.__views__);
        return result3;
      }
      function lazyReverse() {
        if (this.__filtered__) {
          var result3 = new LazyWrapper(this);
          result3.__dir__ = -1;
          result3.__filtered__ = true;
        } else {
          result3 = this.clone();
          result3.__dir__ *= -1;
        }
        return result3;
      }
      function lazyValue() {
        var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray2(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
        if (!isArr || !isRight && arrLength == length && takeCount == length) {
          return baseWrapperValue(array, this.__actions__);
        }
        var result3 = [];
        outer:
          while (length-- && resIndex < takeCount) {
            index += dir;
            var iterIndex = -1, value = array[index];
            while (++iterIndex < iterLength) {
              var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
              if (type == LAZY_MAP_FLAG) {
                value = computed;
              } else if (!computed) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result3[resIndex++] = value;
          }
        return result3;
      }
      LazyWrapper.prototype = baseCreate(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;
      function Hash(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }
      function hashDelete(key) {
        var result3 = this.has(key) && delete this.__data__[key];
        this.size -= result3 ? 1 : 0;
        return result3;
      }
      function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
          var result3 = data[key];
          return result3 === HASH_UNDEFINED ? undefined$1 : result3;
        }
        return hasOwnProperty2.call(data, key) ? data[key] : undefined$1;
      }
      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined$1 : hasOwnProperty2.call(data, key);
      }
      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined$1 ? HASH_UNDEFINED : value;
        return this;
      }
      Hash.prototype.clear = hashClear;
      Hash.prototype["delete"] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;
      function ListCache(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }
      function listCacheDelete(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index == lastIndex) {
          data.pop();
        } else {
          splice.call(data, index, 1);
        }
        --this.size;
        return true;
      }
      function listCacheGet(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        return index < 0 ? undefined$1 : data[index][1];
      }
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }
      function listCacheSet(key, value) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index][1] = value;
        }
        return this;
      }
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype["delete"] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;
      function MapCache(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          "hash": new Hash(),
          "map": new (Map || ListCache)(),
          "string": new Hash()
        };
      }
      function mapCacheDelete(key) {
        var result3 = getMapData(this, key)["delete"](key);
        this.size -= result3 ? 1 : 0;
        return result3;
      }
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }
      function mapCacheSet(key, value) {
        var data = getMapData(this, key), size2 = data.size;
        data.set(key, value);
        this.size += data.size == size2 ? 0 : 1;
        return this;
      }
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype["delete"] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;
      function SetCache(values2) {
        var index = -1, length = values2 == null ? 0 : values2.length;
        this.__data__ = new MapCache();
        while (++index < length) {
          this.add(values2[index]);
        }
      }
      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
      }
      function setCacheHas(value) {
        return this.__data__.has(value);
      }
      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;
      function Stack(entries) {
        var data = this.__data__ = new ListCache(entries);
        this.size = data.size;
      }
      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }
      function stackDelete(key) {
        var data = this.__data__, result3 = data["delete"](key);
        this.size = data.size;
        return result3;
      }
      function stackGet(key) {
        return this.__data__.get(key);
      }
      function stackHas(key) {
        return this.__data__.has(key);
      }
      function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache) {
          var pairs = data.__data__;
          if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }
      Stack.prototype.clear = stackClear;
      Stack.prototype["delete"] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;
      function arrayLikeKeys(value, inherited) {
        var isArr = isArray2(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer2(value), isType = !isArr && !isArg && !isBuff && isTypedArray2(value), skipIndexes = isArr || isArg || isBuff || isType, result3 = skipIndexes ? baseTimes(value.length, String2) : [], length = result3.length;
        for (var key in value) {
          if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
          (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
          isIndex(key, length)))) {
            result3.push(key);
          }
        }
        return result3;
      }
      function arraySample(array) {
        var length = array.length;
        return length ? array[baseRandom(0, length - 1)] : undefined$1;
      }
      function arraySampleSize(array, n) {
        return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
      }
      function arrayShuffle(array) {
        return shuffleSelf(copyArray(array));
      }
      function assignMergeValue(object, key, value) {
        if (value !== undefined$1 && !eq(object[key], value) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty2.call(object, key) && eq(objValue, value)) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assocIndexOf(array, key) {
        var length = array.length;
        while (length--) {
          if (eq(array[length][0], key)) {
            return length;
          }
        }
        return -1;
      }
      function baseAggregator(collection, setter, iteratee2, accumulator) {
        baseEach(collection, function(value, key, collection2) {
          setter(accumulator, value, iteratee2(value), collection2);
        });
        return accumulator;
      }
      function baseAssign(object, source) {
        return object && copyObject(source, keys2(source), object);
      }
      function baseAssignIn(object, source) {
        return object && copyObject(source, keysIn(source), object);
      }
      function baseAssignValue(object, key, value) {
        if (key == "__proto__" && defineProperty) {
          defineProperty(object, key, {
            "configurable": true,
            "enumerable": true,
            "value": value,
            "writable": true
          });
        } else {
          object[key] = value;
        }
      }
      function baseAt(object, paths) {
        var index = -1, length = paths.length, result3 = Array2(length), skip = object == null;
        while (++index < length) {
          result3[index] = skip ? undefined$1 : get2(object, paths[index]);
        }
        return result3;
      }
      function baseClamp(number2, lower, upper) {
        if (number2 === number2) {
          if (upper !== undefined$1) {
            number2 = number2 <= upper ? number2 : upper;
          }
          if (lower !== undefined$1) {
            number2 = number2 >= lower ? number2 : lower;
          }
        }
        return number2;
      }
      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result3, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
        if (customizer) {
          result3 = object ? customizer(value, key, object, stack) : customizer(value);
        }
        if (result3 !== undefined$1) {
          return result3;
        }
        if (!isObject2(value)) {
          return value;
        }
        var isArr = isArray2(value);
        if (isArr) {
          result3 = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result3);
          }
        } else {
          var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
          if (isBuffer2(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result3 = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat ? copySymbolsIn(value, baseAssignIn(result3, value)) : copySymbols(value, baseAssign(result3, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }
            result3 = initCloneByTag(value, tag, isDeep);
          }
        }
        stack || (stack = new Stack());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result3);
        if (isSet(value)) {
          value.forEach(function(subValue) {
            result3.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap(value)) {
          value.forEach(function(subValue, key2) {
            result3.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys2;
        var props = isArr ? undefined$1 : keysFunc(value);
        arrayEach(props || value, function(subValue, key2) {
          if (props) {
            key2 = subValue;
            subValue = value[key2];
          }
          assignValue(result3, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
        });
        return result3;
      }
      function baseConforms(source) {
        var props = keys2(source);
        return function(object) {
          return baseConformsTo(object, source, props);
        };
      }
      function baseConformsTo(object, source, props) {
        var length = props.length;
        if (object == null) {
          return !length;
        }
        object = Object2(object);
        while (length--) {
          var key = props[length], predicate = source[key], value = object[key];
          if (value === undefined$1 && !(key in object) || !predicate(value)) {
            return false;
          }
        }
        return true;
      }
      function baseDelay(func, wait, args) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        return setTimeout2(function() {
          func.apply(undefined$1, args);
        }, wait);
      }
      function baseDifference(array, values2, iteratee2, comparator) {
        var index = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result3 = [], valuesLength = values2.length;
        if (!length) {
          return result3;
        }
        if (iteratee2) {
          values2 = arrayMap(values2, baseUnary(iteratee2));
        }
        if (comparator) {
          includes2 = arrayIncludesWith;
          isCommon = false;
        } else if (values2.length >= LARGE_ARRAY_SIZE) {
          includes2 = cacheHas;
          isCommon = false;
          values2 = new SetCache(values2);
        }
        outer:
          while (++index < length) {
            var value = array[index], computed = iteratee2 == null ? value : iteratee2(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values2[valuesIndex] === computed) {
                  continue outer;
                }
              }
              result3.push(value);
            } else if (!includes2(values2, computed, comparator)) {
              result3.push(value);
            }
          }
        return result3;
      }
      var baseEach = createBaseEach(baseForOwn);
      var baseEachRight = createBaseEach(baseForOwnRight, true);
      function baseEvery(collection, predicate) {
        var result3 = true;
        baseEach(collection, function(value, index, collection2) {
          result3 = !!predicate(value, index, collection2);
          return result3;
        });
        return result3;
      }
      function baseExtremum(array, iteratee2, comparator) {
        var index = -1, length = array.length;
        while (++index < length) {
          var value = array[index], current = iteratee2(value);
          if (current != null && (computed === undefined$1 ? current === current && !isSymbol(current) : comparator(current, computed))) {
            var computed = current, result3 = value;
          }
        }
        return result3;
      }
      function baseFill(array, value, start, end) {
        var length = array.length;
        start = toInteger(start);
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end === undefined$1 || end > length ? length : toInteger(end);
        if (end < 0) {
          end += length;
        }
        end = start > end ? 0 : toLength(end);
        while (start < end) {
          array[start++] = value;
        }
        return array;
      }
      function baseFilter(collection, predicate) {
        var result3 = [];
        baseEach(collection, function(value, index, collection2) {
          if (predicate(value, index, collection2)) {
            result3.push(value);
          }
        });
        return result3;
      }
      function baseFlatten(array, depth, predicate, isStrict, result3) {
        var index = -1, length = array.length;
        predicate || (predicate = isFlattenable);
        result3 || (result3 = []);
        while (++index < length) {
          var value = array[index];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              baseFlatten(value, depth - 1, predicate, isStrict, result3);
            } else {
              arrayPush(result3, value);
            }
          } else if (!isStrict) {
            result3[result3.length] = value;
          }
        }
        return result3;
      }
      var baseFor = createBaseFor();
      var baseForRight = createBaseFor(true);
      function baseForOwn(object, iteratee2) {
        return object && baseFor(object, iteratee2, keys2);
      }
      function baseForOwnRight(object, iteratee2) {
        return object && baseForRight(object, iteratee2, keys2);
      }
      function baseFunctions(object, props) {
        return arrayFilter(props, function(key) {
          return isFunction2(object[key]);
        });
      }
      function baseGet(object, path) {
        path = castPath(path, object);
        var index = 0, length = path.length;
        while (object != null && index < length) {
          object = object[toKey(path[index++])];
        }
        return index && index == length ? object : undefined$1;
      }
      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result3 = keysFunc(object);
        return isArray2(object) ? result3 : arrayPush(result3, symbolsFunc(object));
      }
      function baseGetTag(value) {
        if (value == null) {
          return value === undefined$1 ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString(value);
      }
      function baseGt(value, other) {
        return value > other;
      }
      function baseHas(object, key) {
        return object != null && hasOwnProperty2.call(object, key);
      }
      function baseHasIn(object, key) {
        return object != null && key in Object2(object);
      }
      function baseInRange(number2, start, end) {
        return number2 >= nativeMin(start, end) && number2 < nativeMax(start, end);
      }
      function baseIntersection(arrays, iteratee2, comparator) {
        var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result3 = [];
        while (othIndex--) {
          var array = arrays[othIndex];
          if (othIndex && iteratee2) {
            array = arrayMap(array, baseUnary(iteratee2));
          }
          maxLength = nativeMin(array.length, maxLength);
          caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined$1;
        }
        array = arrays[0];
        var index = -1, seen = caches[0];
        outer:
          while (++index < length && result3.length < maxLength) {
            var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? cacheHas(seen, computed) : includes2(result3, computed, comparator))) {
              othIndex = othLength;
              while (--othIndex) {
                var cache = caches[othIndex];
                if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed);
              }
              result3.push(value);
            }
          }
        return result3;
      }
      function baseInverter(object, setter, iteratee2, accumulator) {
        baseForOwn(object, function(value, key, object2) {
          setter(accumulator, iteratee2(value), key, object2);
        });
        return accumulator;
      }
      function baseInvoke(object, path, args) {
        path = castPath(path, object);
        object = parent(object, path);
        var func = object == null ? object : object[toKey(last(path))];
        return func == null ? undefined$1 : apply(func, object, args);
      }
      function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
      }
      function baseIsArrayBuffer(value) {
        return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
      }
      function baseIsDate(value) {
        return isObjectLike(value) && baseGetTag(value) == dateTag;
      }
      function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
      }
      function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;
        var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
        if (isSameTag && isBuffer2(object)) {
          if (!isBuffer2(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack());
          return objIsArr || isTypedArray2(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack());
        return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
      }
      function baseIsMap(value) {
        return isObjectLike(value) && getTag(value) == mapTag;
      }
      function baseIsMatch(object, source, matchData, customizer) {
        var index = matchData.length, length = index, noCustomizer = !customizer;
        if (object == null) {
          return !length;
        }
        object = Object2(object);
        while (index--) {
          var data = matchData[index];
          if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
            return false;
          }
        }
        while (++index < length) {
          data = matchData[index];
          var key = data[0], objValue = object[key], srcValue = data[1];
          if (noCustomizer && data[2]) {
            if (objValue === undefined$1 && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack();
            if (customizer) {
              var result3 = customizer(objValue, srcValue, key, object, source, stack);
            }
            if (!(result3 === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result3)) {
              return false;
            }
          }
        }
        return true;
      }
      function baseIsNative(value) {
        if (!isObject2(value) || isMasked(value)) {
          return false;
        }
        var pattern = isFunction2(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }
      function baseIsRegExp(value) {
        return isObjectLike(value) && baseGetTag(value) == regexpTag;
      }
      function baseIsSet(value) {
        return isObjectLike(value) && getTag(value) == setTag;
      }
      function baseIsTypedArray(value) {
        return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }
      function baseIteratee(value) {
        if (typeof value == "function") {
          return value;
        }
        if (value == null) {
          return identity;
        }
        if (typeof value == "object") {
          return isArray2(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
        }
        return property(value);
      }
      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }
        var result3 = [];
        for (var key in Object2(object)) {
          if (hasOwnProperty2.call(object, key) && key != "constructor") {
            result3.push(key);
          }
        }
        return result3;
      }
      function baseKeysIn(object) {
        if (!isObject2(object)) {
          return nativeKeysIn(object);
        }
        var isProto = isPrototype(object), result3 = [];
        for (var key in object) {
          if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object, key)))) {
            result3.push(key);
          }
        }
        return result3;
      }
      function baseLt(value, other) {
        return value < other;
      }
      function baseMap(collection, iteratee2) {
        var index = -1, result3 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value, key, collection2) {
          result3[++index] = iteratee2(value, key, collection2);
        });
        return result3;
      }
      function baseMatches(source) {
        var matchData = getMatchData(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }
        return function(object) {
          return object === source || baseIsMatch(object, source, matchData);
        };
      }
      function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path), srcValue);
        }
        return function(object) {
          var objValue = get2(object, path);
          return objValue === undefined$1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
        };
      }
      function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
          return;
        }
        baseFor(source, function(srcValue, key) {
          stack || (stack = new Stack());
          if (isObject2(srcValue)) {
            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined$1;
            if (newValue === undefined$1) {
              newValue = srcValue;
            }
            assignMergeValue(object, key, newValue);
          }
        }, keysIn);
      }
      function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined$1;
        var isCommon = newValue === undefined$1;
        if (isCommon) {
          var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer2(srcValue), isTyped = !isArr && !isBuff && isTypedArray2(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray2(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject2(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject2(objValue) || isFunction2(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack["delete"](srcValue);
        }
        assignMergeValue(object, key, newValue);
      }
      function baseNth(array, n) {
        var length = array.length;
        if (!length) {
          return;
        }
        n += n < 0 ? length : 0;
        return isIndex(n, length) ? array[n] : undefined$1;
      }
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap(iteratees, function(iteratee2) {
            if (isArray2(iteratee2)) {
              return function(value) {
                return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
              };
            }
            return iteratee2;
          });
        } else {
          iteratees = [identity];
        }
        var index = -1;
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        var result3 = baseMap(collection, function(value, key, collection2) {
          var criteria = arrayMap(iteratees, function(iteratee2) {
            return iteratee2(value);
          });
          return { "criteria": criteria, "index": ++index, "value": value };
        });
        return baseSortBy(result3, function(object, other) {
          return compareMultiple(object, other, orders);
        });
      }
      function basePick(object, paths) {
        return basePickBy(object, paths, function(value, path) {
          return hasIn(object, path);
        });
      }
      function basePickBy(object, paths, predicate) {
        var index = -1, length = paths.length, result3 = {};
        while (++index < length) {
          var path = paths[index], value = baseGet(object, path);
          if (predicate(value, path)) {
            baseSet(result3, castPath(path, object), value);
          }
        }
        return result3;
      }
      function basePropertyDeep(path) {
        return function(object) {
          return baseGet(object, path);
        };
      }
      function basePullAll(array, values2, iteratee2, comparator) {
        var indexOf3 = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values2.length, seen = array;
        if (array === values2) {
          values2 = copyArray(values2);
        }
        if (iteratee2) {
          seen = arrayMap(array, baseUnary(iteratee2));
        }
        while (++index < length) {
          var fromIndex = 0, value = values2[index], computed = iteratee2 ? iteratee2(value) : value;
          while ((fromIndex = indexOf3(seen, computed, fromIndex, comparator)) > -1) {
            if (seen !== array) {
              splice.call(seen, fromIndex, 1);
            }
            splice.call(array, fromIndex, 1);
          }
        }
        return array;
      }
      function basePullAt(array, indexes) {
        var length = array ? indexes.length : 0, lastIndex = length - 1;
        while (length--) {
          var index = indexes[length];
          if (length == lastIndex || index !== previous) {
            var previous = index;
            if (isIndex(index)) {
              splice.call(array, index, 1);
            } else {
              baseUnset(array, index);
            }
          }
        }
        return array;
      }
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }
      function baseRange(start, end, step, fromRight) {
        var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result3 = Array2(length);
        while (length--) {
          result3[fromRight ? length : ++index] = start;
          start += step;
        }
        return result3;
      }
      function baseRepeat(string2, n) {
        var result3 = "";
        if (!string2 || n < 1 || n > MAX_SAFE_INTEGER) {
          return result3;
        }
        do {
          if (n % 2) {
            result3 += string2;
          }
          n = nativeFloor(n / 2);
          if (n) {
            string2 += string2;
          }
        } while (n);
        return result3;
      }
      function baseRest(func, start) {
        return setToString(overRest(func, start, identity), func + "");
      }
      function baseSample(collection) {
        return arraySample(values(collection));
      }
      function baseSampleSize(collection, n) {
        var array = values(collection);
        return shuffleSelf(array, baseClamp(n, 0, array.length));
      }
      function baseSet(object, path, value, customizer) {
        if (!isObject2(object)) {
          return object;
        }
        path = castPath(path, object);
        var index = -1, length = path.length, lastIndex = length - 1, nested = object;
        while (nested != null && ++index < length) {
          var key = toKey(path[index]), newValue = value;
          if (key === "__proto__" || key === "constructor" || key === "prototype") {
            return object;
          }
          if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
            if (newValue === undefined$1) {
              newValue = isObject2(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object;
      }
      var baseSetData = !metaMap ? identity : function(func, data) {
        metaMap.set(func, data);
        return func;
      };
      var baseSetToString = !defineProperty ? identity : function(func, string2) {
        return defineProperty(func, "toString", {
          "configurable": true,
          "enumerable": false,
          "value": constant(string2),
          "writable": true
        });
      };
      function baseShuffle(collection) {
        return shuffleSelf(values(collection));
      }
      function baseSlice(array, start, end) {
        var index = -1, length = array.length;
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end > length ? length : end;
        if (end < 0) {
          end += length;
        }
        length = start > end ? 0 : end - start >>> 0;
        start >>>= 0;
        var result3 = Array2(length);
        while (++index < length) {
          result3[index] = array[index + start];
        }
        return result3;
      }
      function baseSome(collection, predicate) {
        var result3;
        baseEach(collection, function(value, index, collection2) {
          result3 = predicate(value, index, collection2);
          return !result3;
        });
        return !!result3;
      }
      function baseSortedIndex(array, value, retHighest) {
        var low = 0, high = array == null ? low : array.length;
        if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1, computed = array[mid];
            if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array, value, identity, retHighest);
      }
      function baseSortedIndexBy(array, value, iteratee2, retHighest) {
        var low = 0, high = array == null ? 0 : array.length;
        if (high === 0) {
          return 0;
        }
        value = iteratee2(value);
        var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined$1;
        while (low < high) {
          var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined$1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed <= value : computed < value;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin(high, MAX_ARRAY_INDEX);
      }
      function baseSortedUniq(array, iteratee2) {
        var index = -1, length = array.length, resIndex = 0, result3 = [];
        while (++index < length) {
          var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
          if (!index || !eq(computed, seen)) {
            var seen = computed;
            result3[resIndex++] = value === 0 ? 0 : value;
          }
        }
        return result3;
      }
      function baseToNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        return +value;
      }
      function baseToString(value) {
        if (typeof value == "string") {
          return value;
        }
        if (isArray2(value)) {
          return arrayMap(value, baseToString) + "";
        }
        if (isSymbol(value)) {
          return symbolToString ? symbolToString.call(value) : "";
        }
        var result3 = value + "";
        return result3 == "0" && 1 / value == -INFINITY ? "-0" : result3;
      }
      function baseUniq(array, iteratee2, comparator) {
        var index = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result3 = [], seen = result3;
        if (comparator) {
          isCommon = false;
          includes2 = arrayIncludesWith;
        } else if (length >= LARGE_ARRAY_SIZE) {
          var set3 = iteratee2 ? null : createSet(array);
          if (set3) {
            return setToArray(set3);
          }
          isCommon = false;
          includes2 = cacheHas;
          seen = new SetCache();
        } else {
          seen = iteratee2 ? [] : result3;
        }
        outer:
          while (++index < length) {
            var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed) {
                  continue outer;
                }
              }
              if (iteratee2) {
                seen.push(computed);
              }
              result3.push(value);
            } else if (!includes2(seen, computed, comparator)) {
              if (seen !== result3) {
                seen.push(computed);
              }
              result3.push(value);
            }
          }
        return result3;
      }
      function baseUnset(object, path) {
        path = castPath(path, object);
        object = parent(object, path);
        return object == null || delete object[toKey(last(path))];
      }
      function baseUpdate(object, path, updater, customizer) {
        return baseSet(object, path, updater(baseGet(object, path)), customizer);
      }
      function baseWhile(array, predicate, isDrop, fromRight) {
        var length = array.length, index = fromRight ? length : -1;
        while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {
        }
        return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
      }
      function baseWrapperValue(value, actions) {
        var result3 = value;
        if (result3 instanceof LazyWrapper) {
          result3 = result3.value();
        }
        return arrayReduce(actions, function(result4, action) {
          return action.func.apply(action.thisArg, arrayPush([result4], action.args));
        }, result3);
      }
      function baseXor(arrays, iteratee2, comparator) {
        var length = arrays.length;
        if (length < 2) {
          return length ? baseUniq(arrays[0]) : [];
        }
        var index = -1, result3 = Array2(length);
        while (++index < length) {
          var array = arrays[index], othIndex = -1;
          while (++othIndex < length) {
            if (othIndex != index) {
              result3[index] = baseDifference(result3[index] || array, arrays[othIndex], iteratee2, comparator);
            }
          }
        }
        return baseUniq(baseFlatten(result3, 1), iteratee2, comparator);
      }
      function baseZipObject(props, values2, assignFunc) {
        var index = -1, length = props.length, valsLength = values2.length, result3 = {};
        while (++index < length) {
          var value = index < valsLength ? values2[index] : undefined$1;
          assignFunc(result3, props[index], value);
        }
        return result3;
      }
      function castArrayLikeObject(value) {
        return isArrayLikeObject(value) ? value : [];
      }
      function castFunction(value) {
        return typeof value == "function" ? value : identity;
      }
      function castPath(value, object) {
        if (isArray2(value)) {
          return value;
        }
        return isKey(value, object) ? [value] : stringToPath(toString3(value));
      }
      var castRest = baseRest;
      function castSlice(array, start, end) {
        var length = array.length;
        end = end === undefined$1 ? length : end;
        return !start && end >= length ? array : baseSlice(array, start, end);
      }
      var clearTimeout = ctxClearTimeout || function(id) {
        return root.clearTimeout(id);
      };
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length = buffer.length, result3 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
        buffer.copy(result3);
        return result3;
      }
      function cloneArrayBuffer(arrayBuffer) {
        var result3 = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array2(result3).set(new Uint8Array2(arrayBuffer));
        return result3;
      }
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }
      function cloneRegExp(regexp) {
        var result3 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result3.lastIndex = regexp.lastIndex;
        return result3;
      }
      function cloneSymbol(symbol) {
        return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
      }
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }
      function compareAscending(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
          var othIsDefined = other !== undefined$1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
          if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }
          if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }
      function compareMultiple(object, other, orders) {
        var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
        while (++index < length) {
          var result3 = compareAscending(objCriteria[index], othCriteria[index]);
          if (result3) {
            if (index >= ordersLength) {
              return result3;
            }
            var order = orders[index];
            return result3 * (order == "desc" ? -1 : 1);
          }
        }
        return object.index - other.index;
      }
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result3 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
        while (++leftIndex < leftLength) {
          result3[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result3[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result3[leftIndex++] = args[argsIndex++];
        }
        return result3;
      }
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result3 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
        while (++argsIndex < rangeLength) {
          result3[argsIndex] = args[argsIndex];
        }
        var offset2 = argsIndex;
        while (++rightIndex < rightLength) {
          result3[offset2 + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result3[offset2 + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result3;
      }
      function copyArray(source, array) {
        var index = -1, length = source.length;
        array || (array = Array2(length));
        while (++index < length) {
          array[index] = source[index];
        }
        return array;
      }
      function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index = -1, length = props.length;
        while (++index < length) {
          var key = props[index];
          var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined$1;
          if (newValue === undefined$1) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }
        return object;
      }
      function copySymbols(source, object) {
        return copyObject(source, getSymbols(source), object);
      }
      function copySymbolsIn(source, object) {
        return copyObject(source, getSymbolsIn(source), object);
      }
      function createAggregator(setter, initializer) {
        return function(collection, iteratee2) {
          var func = isArray2(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
          return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
        };
      }
      function createAssigner(assigner) {
        return baseRest(function(object, sources) {
          var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined$1, guard2 = length > 2 ? sources[2] : undefined$1;
          customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined$1;
          if (guard2 && isIterateeCall(sources[0], sources[1], guard2)) {
            customizer = length < 3 ? undefined$1 : customizer;
            length = 1;
          }
          object = Object2(object);
          while (++index < length) {
            var source = sources[index];
            if (source) {
              assigner(object, source, index, customizer);
            }
          }
          return object;
        });
      }
      function createBaseEach(eachFunc, fromRight) {
        return function(collection, iteratee2) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee2);
          }
          var length = collection.length, index = fromRight ? length : -1, iterable = Object2(collection);
          while (fromRight ? index-- : ++index < length) {
            if (iteratee2(iterable[index], index, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      function createBaseFor(fromRight) {
        return function(object, iteratee2, keysFunc) {
          var index = -1, iterable = Object2(object), props = keysFunc(object), length = props.length;
          while (length--) {
            var key = props[fromRight ? length : ++index];
            if (iteratee2(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          return fn.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }
      function createCaseFirst(methodName) {
        return function(string2) {
          string2 = toString3(string2);
          var strSymbols = hasUnicode(string2) ? stringToArray(string2) : undefined$1;
          var chr = strSymbols ? strSymbols[0] : string2.charAt(0);
          var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string2.slice(1);
          return chr[methodName]() + trailing;
        };
      }
      function createCompounder(callback) {
        return function(string2) {
          return arrayReduce(words(deburr(string2).replace(reApos, "")), callback, "");
        };
      }
      function createCtor(Ctor) {
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate(Ctor.prototype), result3 = Ctor.apply(thisBinding, args);
          return isObject2(result3) ? result3 : thisBinding;
        };
      }
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);
        function wrapper() {
          var length = arguments.length, args = Array2(length), index = length, placeholder = getHolder(wrapper);
          while (index--) {
            args[index] = arguments[index];
          }
          var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
          length -= holders.length;
          if (length < arity) {
            return createRecurry(
              func,
              bitmask,
              createHybrid,
              wrapper.placeholder,
              undefined$1,
              args,
              holders,
              undefined$1,
              undefined$1,
              arity - length
            );
          }
          var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          return apply(fn, this, args);
        }
        return wrapper;
      }
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object2(collection);
          if (!isArrayLike(collection)) {
            var iteratee2 = getIteratee(predicate, 3);
            collection = keys2(collection);
            predicate = function(key) {
              return iteratee2(iterable[key], key, iterable);
            };
          }
          var index = findIndexFunc(collection, predicate, fromIndex);
          return index > -1 ? iterable[iteratee2 ? collection[index] : index] : undefined$1;
        };
      }
      function createFlow(fromRight) {
        return flatRest(function(funcs) {
          var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index--) {
            var func = funcs[index];
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            if (prereq && !wrapper && getFuncName(func) == "wrapper") {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index = wrapper ? index : length;
          while (++index < length) {
            func = funcs[index];
            var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined$1;
            if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
              wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            } else {
              wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
          }
          return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && isArray2(value)) {
              return wrapper.plant(value).value();
            }
            var index2 = 0, result3 = length ? funcs[index2].apply(this, args) : value;
            while (++index2 < length) {
              result3 = funcs[index2].call(this, result3);
            }
            return result3;
          };
        });
      }
      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$1 : createCtor(func);
        function wrapper() {
          var length = arguments.length, args = Array2(length), index = length;
          while (index--) {
            args[index] = arguments[index];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length -= holdersCount;
          if (isCurried && length < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(
              func,
              bitmask,
              createHybrid,
              wrapper.placeholder,
              thisArg,
              args,
              newHolders,
              argPos,
              ary2,
              arity - length
            );
          }
          var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
          length = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length > 1) {
            args.reverse();
          }
          if (isAry && ary2 < length) {
            args.length = ary2;
          }
          if (this && this !== root && this instanceof wrapper) {
            fn = Ctor || createCtor(fn);
          }
          return fn.apply(thisBinding, args);
        }
        return wrapper;
      }
      function createInverter(setter, toIteratee) {
        return function(object, iteratee2) {
          return baseInverter(object, setter, toIteratee(iteratee2), {});
        };
      }
      function createMathOperation(operator, defaultValue) {
        return function(value, other) {
          var result3;
          if (value === undefined$1 && other === undefined$1) {
            return defaultValue;
          }
          if (value !== undefined$1) {
            result3 = value;
          }
          if (other !== undefined$1) {
            if (result3 === undefined$1) {
              return other;
            }
            if (typeof value == "string" || typeof other == "string") {
              value = baseToString(value);
              other = baseToString(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }
            result3 = operator(value, other);
          }
          return result3;
        };
      }
      function createOver(arrayFunc) {
        return flatRest(function(iteratees) {
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          return baseRest(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee2) {
              return apply(iteratee2, thisArg, args);
            });
          });
        });
      }
      function createPadding(length, chars) {
        chars = chars === undefined$1 ? " " : baseToString(chars);
        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length) : chars;
        }
        var result3 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
        return hasUnicode(chars) ? castSlice(stringToArray(result3), 0, length).join("") : result3.slice(0, length);
      }
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply(fn, isBind ? thisArg : this, args);
        }
        return wrapper;
      }
      function createRange(fromRight) {
        return function(start, end, step) {
          if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
            end = step = undefined$1;
          }
          start = toFinite(start);
          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          step = step === undefined$1 ? start < end ? 1 : -1 : toFinite(step);
          return baseRange(start, end, step, fromRight);
        };
      }
      function createRelationalOperation(operator) {
        return function(value, other) {
          if (!(typeof value == "string" && typeof other == "string")) {
            value = toNumber(value);
            other = toNumber(other);
          }
          return operator(value, other);
        };
      }
      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$1, newHoldersRight = isCurry ? undefined$1 : holders, newPartials = isCurry ? partials : undefined$1, newPartialsRight = isCurry ? undefined$1 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [
          func,
          bitmask,
          thisArg,
          newPartials,
          newHolders,
          newPartialsRight,
          newHoldersRight,
          argPos,
          ary2,
          arity
        ];
        var result3 = wrapFunc.apply(undefined$1, newData);
        if (isLaziable(func)) {
          setData(result3, newData);
        }
        result3.placeholder = placeholder;
        return setWrapToString(result3, func, bitmask);
      }
      function createRound(methodName) {
        var func = Math2[methodName];
        return function(number2, precision) {
          number2 = toNumber(number2);
          precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
          if (precision && nativeIsFinite(number2)) {
            var pair = (toString3(number2) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
            pair = (toString3(value) + "e").split("e");
            return +(pair[0] + "e" + (+pair[1] - precision));
          }
          return func(number2);
        };
      }
      var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop2 : function(values2) {
        return new Set(values2);
      };
      function createToPairs(keysFunc) {
        return function(object) {
          var tag = getTag(object);
          if (tag == mapTag) {
            return mapToArray(object);
          }
          if (tag == setTag) {
            return setToPairs(object);
          }
          return baseToPairs(object, keysFunc(object));
        };
      }
      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        var length = partials ? partials.length : 0;
        if (!length) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$1;
        }
        ary2 = ary2 === undefined$1 ? ary2 : nativeMax(toInteger(ary2), 0);
        arity = arity === undefined$1 ? arity : toInteger(arity);
        length -= holders ? holders.length : 0;
        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials, holdersRight = holders;
          partials = holders = undefined$1;
        }
        var data = isBindKey ? undefined$1 : getData(func);
        var newData = [
          func,
          bitmask,
          thisArg,
          partials,
          holders,
          partialsRight,
          holdersRight,
          argPos,
          ary2,
          arity
        ];
        if (data) {
          mergeData(newData, data);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result3 = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result3 = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result3 = createPartial(func, bitmask, thisArg, partials);
        } else {
          result3 = createHybrid.apply(undefined$1, newData);
        }
        var setter = data ? baseSetData : setData;
        return setWrapToString(setter(result3, newData), func, bitmask);
      }
      function customDefaultsAssignIn(objValue, srcValue, key, object) {
        if (objValue === undefined$1 || eq(objValue, objectProto[key]) && !hasOwnProperty2.call(object, key)) {
          return srcValue;
        }
        return objValue;
      }
      function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
        if (isObject2(objValue) && isObject2(srcValue)) {
          stack.set(srcValue, objValue);
          baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
          stack["delete"](srcValue);
        }
        return objValue;
      }
      function customOmitClone(value) {
        return isPlainObject2(value) ? undefined$1 : value;
      }
      function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack.get(array);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array;
        }
        var index = -1, result3 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
        stack.set(array, other);
        stack.set(other, array);
        while (++index < arrLength) {
          var arrValue = array[index], othValue = other[index];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
          }
          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }
            result3 = false;
            break;
          }
          if (seen) {
            if (!arraySome(other, function(othValue2, othIndex) {
              if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result3 = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result3 = false;
            break;
          }
        }
        stack["delete"](array);
        stack["delete"](other);
        return result3;
      }
      function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
              return false;
            }
            object = object.buffer;
            other = other.buffer;
          case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
              return false;
            }
            return true;
          case boolTag:
          case dateTag:
          case numberTag:
            return eq(+object, +other);
          case errorTag:
            return object.name == other.name && object.message == other.message;
          case regexpTag:
          case stringTag:
            return object == other + "";
          case mapTag:
            var convert2 = mapToArray;
          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert2 || (convert2 = setToArray);
            if (object.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack.get(object);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;
            stack.set(object, other);
            var result3 = equalArrays(convert2(object), convert2(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result3;
          case symbolTag:
            if (symbolValueOf) {
              return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
        }
        return false;
      }
      function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index = objLength;
        while (index--) {
          var key = objProps[index];
          if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack.get(object);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object;
        }
        var result3 = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;
        while (++index < objLength) {
          key = objProps[index];
          var objValue = object[key], othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
          }
          if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result3 = false;
            break;
          }
          skipCtor || (skipCtor = key == "constructor");
        }
        if (result3 && !skipCtor) {
          var objCtor = object.constructor, othCtor = other.constructor;
          if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
            result3 = false;
          }
        }
        stack["delete"](object);
        stack["delete"](other);
        return result3;
      }
      function flatRest(func) {
        return setToString(overRest(func, undefined$1, flatten), func + "");
      }
      function getAllKeys(object) {
        return baseGetAllKeys(object, keys2, getSymbols);
      }
      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }
      var getData = !metaMap ? noop2 : function(func) {
        return metaMap.get(func);
      };
      function getFuncName(func) {
        var result3 = func.name + "", array = realNames[result3], length = hasOwnProperty2.call(realNames, result3) ? array.length : 0;
        while (length--) {
          var data = array[length], otherFunc = data.func;
          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }
        return result3;
      }
      function getHolder(func) {
        var object = hasOwnProperty2.call(lodash2, "placeholder") ? lodash2 : func;
        return object.placeholder;
      }
      function getIteratee() {
        var result3 = lodash2.iteratee || iteratee;
        result3 = result3 === iteratee ? baseIteratee : result3;
        return arguments.length ? result3(arguments[0], arguments[1]) : result3;
      }
      function getMapData(map3, key) {
        var data = map3.__data__;
        return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
      }
      function getMatchData(object) {
        var result3 = keys2(object), length = result3.length;
        while (length--) {
          var key = result3[length], value = object[key];
          result3[length] = [key, value, isStrictComparable(value)];
        }
        return result3;
      }
      function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined$1;
      }
      function getRawTag(value) {
        var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
        try {
          value[symToStringTag] = undefined$1;
          var unmasked = true;
        } catch (e) {
        }
        var result3 = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result3;
      }
      var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
        if (object == null) {
          return [];
        }
        object = Object2(object);
        return arrayFilter(nativeGetSymbols(object), function(symbol) {
          return propertyIsEnumerable.call(object, symbol);
        });
      };
      var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
        var result3 = [];
        while (object) {
          arrayPush(result3, getSymbols(object));
          object = getPrototype(object);
        }
        return result3;
      };
      var getTag = baseGetTag;
      if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
        getTag = function(value) {
          var result3 = baseGetTag(value), Ctor = result3 == objectTag ? value.constructor : undefined$1, ctorString = Ctor ? toSource(Ctor) : "";
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;
              case mapCtorString:
                return mapTag;
              case promiseCtorString:
                return promiseTag;
              case setCtorString:
                return setTag;
              case weakMapCtorString:
                return weakMapTag;
            }
          }
          return result3;
        };
      }
      function getView(start, end, transforms) {
        var index = -1, length = transforms.length;
        while (++index < length) {
          var data = transforms[index], size2 = data.size;
          switch (data.type) {
            case "drop":
              start += size2;
              break;
            case "dropRight":
              end -= size2;
              break;
            case "take":
              end = nativeMin(end, start + size2);
              break;
            case "takeRight":
              start = nativeMax(start, end - size2);
              break;
          }
        }
        return { "start": start, "end": end };
      }
      function getWrapDetails(source) {
        var match5 = source.match(reWrapDetails);
        return match5 ? match5[1].split(reSplitDetails) : [];
      }
      function hasPath(object, path, hasFunc) {
        path = castPath(path, object);
        var index = -1, length = path.length, result3 = false;
        while (++index < length) {
          var key = toKey(path[index]);
          if (!(result3 = object != null && hasFunc(object, key))) {
            break;
          }
          object = object[key];
        }
        if (result3 || ++index != length) {
          return result3;
        }
        length = object == null ? 0 : object.length;
        return !!length && isLength(length) && isIndex(key, length) && (isArray2(object) || isArguments(object));
      }
      function initCloneArray(array) {
        var length = array.length, result3 = new array.constructor(length);
        if (length && typeof array[0] == "string" && hasOwnProperty2.call(array, "index")) {
          result3.index = array.index;
          result3.input = array.input;
        }
        return result3;
      }
      function initCloneObject(object) {
        return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
      }
      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);
          case boolTag:
          case dateTag:
            return new Ctor(+object);
          case dataViewTag:
            return cloneDataView(object, isDeep);
          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object, isDeep);
          case mapTag:
            return new Ctor();
          case numberTag:
          case stringTag:
            return new Ctor(object);
          case regexpTag:
            return cloneRegExp(object);
          case setTag:
            return new Ctor();
          case symbolTag:
            return cloneSymbol(object);
        }
      }
      function insertWrapDetails(source, details) {
        var length = details.length;
        if (!length) {
          return source;
        }
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
        details = details.join(length > 2 ? ", " : " ");
        return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
      }
      function isFlattenable(value) {
        return isArray2(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }
      function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
      }
      function isIterateeCall(value, index, object) {
        if (!isObject2(object)) {
          return false;
        }
        var type = typeof index;
        if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
          return eq(object[index], value);
        }
        return false;
      }
      function isKey(value, object) {
        if (isArray2(value)) {
          return false;
        }
        var type = typeof value;
        if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
          return true;
        }
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
      }
      function isKeyable(value) {
        var type = typeof value;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
      }
      function isLaziable(func) {
        var funcName = getFuncName(func), other = lodash2[funcName];
        if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data = getData(other);
        return !!data && func === data[0];
      }
      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }
      var isMaskable = coreJsData ? isFunction2 : stubFalse;
      function isPrototype(value) {
        var Ctor = value && value.constructor, proto2 = typeof Ctor == "function" && Ctor.prototype || objectProto;
        return value === proto2;
      }
      function isStrictComparable(value) {
        return value === value && !isObject2(value);
      }
      function matchesStrictComparable(key, srcValue) {
        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === srcValue && (srcValue !== undefined$1 || key in Object2(object));
        };
      }
      function memoizeCapped(func) {
        var result3 = memoize(func, function(key) {
          if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
          }
          return key;
        });
        var cache = result3.cache;
        return result3;
      }
      function mergeData(data, source) {
        var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) {
          return data;
        }
        if (srcBitmask & WRAP_BIND_FLAG) {
          data[2] = source[2];
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        var value = source[3];
        if (value) {
          var partials = data[3];
          data[3] = partials ? composeArgs(partials, value, source[4]) : value;
          data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
        }
        value = source[5];
        if (value) {
          partials = data[5];
          data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
          data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
        }
        value = source[7];
        if (value) {
          data[7] = value;
        }
        if (srcBitmask & WRAP_ARY_FLAG) {
          data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
        }
        if (data[9] == null) {
          data[9] = source[9];
        }
        data[0] = source[0];
        data[1] = newBitmask;
        return data;
      }
      function nativeKeysIn(object) {
        var result3 = [];
        if (object != null) {
          for (var key in Object2(object)) {
            result3.push(key);
          }
        }
        return result3;
      }
      function objectToString(value) {
        return nativeObjectToString.call(value);
      }
      function overRest(func, start, transform2) {
        start = nativeMax(start === undefined$1 ? func.length - 1 : start, 0);
        return function() {
          var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array2(length);
          while (++index < length) {
            array[index] = args[start + index];
          }
          index = -1;
          var otherArgs = Array2(start + 1);
          while (++index < start) {
            otherArgs[index] = args[index];
          }
          otherArgs[start] = transform2(array);
          return apply(func, this, otherArgs);
        };
      }
      function parent(object, path) {
        return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
      }
      function reorder(array, indexes) {
        var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
        while (length--) {
          var index = indexes[length];
          array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
        }
        return array;
      }
      function safeGet(object, key) {
        if (key === "constructor" && typeof object[key] === "function") {
          return;
        }
        if (key == "__proto__") {
          return;
        }
        return object[key];
      }
      var setData = shortOut(baseSetData);
      var setTimeout2 = ctxSetTimeout || function(func, wait) {
        return root.setTimeout(func, wait);
      };
      var setToString = shortOut(baseSetToString);
      function setWrapToString(wrapper, reference, bitmask) {
        var source = reference + "";
        return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
      }
      function shortOut(func) {
        var count = 0, lastCalled = 0;
        return function() {
          var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined$1, arguments);
        };
      }
      function shuffleSelf(array, size2) {
        var index = -1, length = array.length, lastIndex = length - 1;
        size2 = size2 === undefined$1 ? length : size2;
        while (++index < size2) {
          var rand = baseRandom(index, lastIndex), value = array[rand];
          array[rand] = array[index];
          array[index] = value;
        }
        array.length = size2;
        return array;
      }
      var stringToPath = memoizeCapped(function(string2) {
        var result3 = [];
        if (string2.charCodeAt(0) === 46) {
          result3.push("");
        }
        string2.replace(rePropName, function(match5, number2, quote, subString) {
          result3.push(quote ? subString.replace(reEscapeChar, "$1") : number2 || match5);
        });
        return result3;
      });
      function toKey(value) {
        if (typeof value == "string" || isSymbol(value)) {
          return value;
        }
        var result3 = value + "";
        return result3 == "0" && 1 / value == -INFINITY ? "-0" : result3;
      }
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e) {
          }
          try {
            return func + "";
          } catch (e) {
          }
        }
        return "";
      }
      function updateWrapDetails(details, bitmask) {
        arrayEach(wrapFlags, function(pair) {
          var value = "_." + pair[0];
          if (bitmask & pair[1] && !arrayIncludes(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result3 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result3.__actions__ = copyArray(wrapper.__actions__);
        result3.__index__ = wrapper.__index__;
        result3.__values__ = wrapper.__values__;
        return result3;
      }
      function chunk(array, size2, guard2) {
        if (guard2 ? isIterateeCall(array, size2, guard2) : size2 === undefined$1) {
          size2 = 1;
        } else {
          size2 = nativeMax(toInteger(size2), 0);
        }
        var length = array == null ? 0 : array.length;
        if (!length || size2 < 1) {
          return [];
        }
        var index = 0, resIndex = 0, result3 = Array2(nativeCeil(length / size2));
        while (index < length) {
          result3[resIndex++] = baseSlice(array, index, index += size2);
        }
        return result3;
      }
      function compact2(array) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result3 = [];
        while (++index < length) {
          var value = array[index];
          if (value) {
            result3[resIndex++] = value;
          }
        }
        return result3;
      }
      function concat2() {
        var length = arguments.length;
        if (!length) {
          return [];
        }
        var args = Array2(length - 1), array = arguments[0], index = length;
        while (index--) {
          args[index - 1] = arguments[index];
        }
        return arrayPush(isArray2(array) ? copyArray(array) : [array], baseFlatten(args, 1));
      }
      var difference = baseRest(function(array, values2) {
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
      });
      var differenceBy = baseRest(function(array, values2) {
        var iteratee2 = last(values2);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
      });
      var differenceWith = baseRest(function(array, values2) {
        var comparator = last(values2);
        if (isArrayLikeObject(comparator)) {
          comparator = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
      });
      function drop(array, n, guard2) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard2 || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, n < 0 ? 0 : n, length);
      }
      function dropRight(array, n, guard2) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard2 || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }
      function dropRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
      }
      function dropWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
      }
      function fill(array, value, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
          start = 0;
          end = length;
        }
        return baseFill(array, value, start, end);
      }
      function findIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index < 0) {
          index = nativeMax(length + index, 0);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index);
      }
      function findLastIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = length - 1;
        if (fromIndex !== undefined$1) {
          index = toInteger(fromIndex);
          index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index, true);
      }
      function flatten(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, 1) : [];
      }
      function flattenDeep(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, INFINITY) : [];
      }
      function flattenDepth(array, depth) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(array, depth);
      }
      function fromPairs(pairs) {
        var index = -1, length = pairs == null ? 0 : pairs.length, result3 = {};
        while (++index < length) {
          var pair = pairs[index];
          result3[pair[0]] = pair[1];
        }
        return result3;
      }
      function head(array) {
        return array && array.length ? array[0] : undefined$1;
      }
      function indexOf2(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index < 0) {
          index = nativeMax(length + index, 0);
        }
        return baseIndexOf(array, value, index);
      }
      function initial(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 0, -1) : [];
      }
      var intersection = baseRest(function(arrays) {
        var mapped = arrayMap(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });
      var intersectionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        if (iteratee2 === last(mapped)) {
          iteratee2 = undefined$1;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
      });
      var intersectionWith = baseRest(function(arrays) {
        var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        if (comparator) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
      });
      function join(array, separator) {
        return array == null ? "" : nativeJoin.call(array, separator);
      }
      function last(array) {
        var length = array == null ? 0 : array.length;
        return length ? array[length - 1] : undefined$1;
      }
      function lastIndexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = length;
        if (fromIndex !== undefined$1) {
          index = toInteger(fromIndex);
          index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
        }
        return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
      }
      function nth(array, n) {
        return array && array.length ? baseNth(array, toInteger(n)) : undefined$1;
      }
      var pull = baseRest(pullAll);
      function pullAll(array, values2) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
      }
      function pullAllBy(array, values2, iteratee2) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
      }
      function pullAllWith(array, values2, comparator) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined$1, comparator) : array;
      }
      var pullAt = flatRest(function(array, indexes) {
        var length = array == null ? 0 : array.length, result3 = baseAt(array, indexes);
        basePullAt(array, arrayMap(indexes, function(index) {
          return isIndex(index, length) ? +index : index;
        }).sort(compareAscending));
        return result3;
      });
      function remove(array, predicate) {
        var result3 = [];
        if (!(array && array.length)) {
          return result3;
        }
        var index = -1, indexes = [], length = array.length;
        predicate = getIteratee(predicate, 3);
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result3.push(value);
            indexes.push(index);
          }
        }
        basePullAt(array, indexes);
        return result3;
      }
      function reverse2(array) {
        return array == null ? array : nativeReverse.call(array);
      }
      function slice2(array, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
          start = 0;
          end = length;
        } else {
          start = start == null ? 0 : toInteger(start);
          end = end === undefined$1 ? length : toInteger(end);
        }
        return baseSlice(array, start, end);
      }
      function sortedIndex(array, value) {
        return baseSortedIndex(array, value);
      }
      function sortedIndexBy(array, value, iteratee2) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
      }
      function sortedIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index = baseSortedIndex(array, value);
          if (index < length && eq(array[index], value)) {
            return index;
          }
        }
        return -1;
      }
      function sortedLastIndex(array, value) {
        return baseSortedIndex(array, value, true);
      }
      function sortedLastIndexBy(array, value, iteratee2) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
      }
      function sortedLastIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index = baseSortedIndex(array, value, true) - 1;
          if (eq(array[index], value)) {
            return index;
          }
        }
        return -1;
      }
      function sortedUniq(array) {
        return array && array.length ? baseSortedUniq(array) : [];
      }
      function sortedUniqBy(array, iteratee2) {
        return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function tail(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 1, length) : [];
      }
      function take(array, n, guard2) {
        if (!(array && array.length)) {
          return [];
        }
        n = guard2 || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }
      function takeRight(array, n, guard2) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard2 || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, n < 0 ? 0 : n, length);
      }
      function takeRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
      }
      function takeWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
      }
      var union = baseRest(function(arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
      });
      var unionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
      });
      var unionWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
      });
      function uniq(array) {
        return array && array.length ? baseUniq(array) : [];
      }
      function uniqBy(array, iteratee2) {
        return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function uniqWith(array, comparator) {
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return array && array.length ? baseUniq(array, undefined$1, comparator) : [];
      }
      function unzip(array) {
        if (!(array && array.length)) {
          return [];
        }
        var length = 0;
        array = arrayFilter(array, function(group) {
          if (isArrayLikeObject(group)) {
            length = nativeMax(group.length, length);
            return true;
          }
        });
        return baseTimes(length, function(index) {
          return arrayMap(array, baseProperty(index));
        });
      }
      function unzipWith(array, iteratee2) {
        if (!(array && array.length)) {
          return [];
        }
        var result3 = unzip(array);
        if (iteratee2 == null) {
          return result3;
        }
        return arrayMap(result3, function(group) {
          return apply(iteratee2, undefined$1, group);
        });
      }
      var without = baseRest(function(array, values2) {
        return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
      });
      var xor = baseRest(function(arrays) {
        return baseXor(arrayFilter(arrays, isArrayLikeObject));
      });
      var xorBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
      });
      var xorWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
      });
      var zip = baseRest(unzip);
      function zipObject(props, values2) {
        return baseZipObject(props || [], values2 || [], assignValue);
      }
      function zipObjectDeep(props, values2) {
        return baseZipObject(props || [], values2 || [], baseSet);
      }
      var zipWith = baseRest(function(arrays) {
        var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined$1;
        iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$1;
        return unzipWith(arrays, iteratee2);
      });
      function chain2(value) {
        var result3 = lodash2(value);
        result3.__chain__ = true;
        return result3;
      }
      function tap2(value, interceptor) {
        interceptor(value);
        return value;
      }
      function thru(value, interceptor) {
        return interceptor(value);
      }
      var wrapperAt = flatRest(function(paths) {
        var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
          return baseAt(object, paths);
        };
        if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
          return this.thru(interceptor);
        }
        value = value.slice(start, +start + (length ? 1 : 0));
        value.__actions__.push({
          "func": thru,
          "args": [interceptor],
          "thisArg": undefined$1
        });
        return new LodashWrapper(value, this.__chain__).thru(function(array) {
          if (length && !array.length) {
            array.push(undefined$1);
          }
          return array;
        });
      });
      function wrapperChain() {
        return chain2(this);
      }
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }
      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray2(this.value());
        }
        var done = this.__index__ >= this.__values__.length, value = done ? undefined$1 : this.__values__[this.__index__++];
        return { "done": done, "value": value };
      }
      function wrapperToIterator() {
        return this;
      }
      function wrapperPlant(value) {
        var result3, parent2 = this;
        while (parent2 instanceof baseLodash) {
          var clone3 = wrapperClone(parent2);
          clone3.__index__ = 0;
          clone3.__values__ = undefined$1;
          if (result3) {
            previous.__wrapped__ = clone3;
          } else {
            result3 = clone3;
          }
          var previous = clone3;
          parent2 = parent2.__wrapped__;
        }
        previous.__wrapped__ = value;
        return result3;
      }
      function wrapperReverse() {
        var value = this.__wrapped__;
        if (value instanceof LazyWrapper) {
          var wrapped = value;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            "func": thru,
            "args": [reverse2],
            "thisArg": undefined$1
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse2);
      }
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }
      var countBy = createAggregator(function(result3, value, key) {
        if (hasOwnProperty2.call(result3, key)) {
          ++result3[key];
        } else {
          baseAssignValue(result3, key, 1);
        }
      });
      function every(collection, predicate, guard2) {
        var func = isArray2(collection) ? arrayEvery : baseEvery;
        if (guard2 && isIterateeCall(collection, predicate, guard2)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      function filter3(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }
      var find = createFind(findIndex);
      var findLast = createFind(findLastIndex);
      function flatMap2(collection, iteratee2) {
        return baseFlatten(map2(collection, iteratee2), 1);
      }
      function flatMapDeep(collection, iteratee2) {
        return baseFlatten(map2(collection, iteratee2), INFINITY);
      }
      function flatMapDepth(collection, iteratee2, depth) {
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(map2(collection, iteratee2), depth);
      }
      function forEach2(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEach : baseEach;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function forEachRight(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee2, 3));
      }
      var groupBy = createAggregator(function(result3, value, key) {
        if (hasOwnProperty2.call(result3, key)) {
          result3[key].push(value);
        } else {
          baseAssignValue(result3, key, [value]);
        }
      });
      function includes(collection, value, fromIndex, guard2) {
        collection = isArrayLike(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard2 ? toInteger(fromIndex) : 0;
        var length = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax(length + fromIndex, 0);
        }
        return isString2(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
      }
      var invokeMap = baseRest(function(collection, path, args) {
        var index = -1, isFunc = typeof path == "function", result3 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value) {
          result3[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
        });
        return result3;
      });
      var keyBy = createAggregator(function(result3, value, key) {
        baseAssignValue(result3, key, value);
      });
      function map2(collection, iteratee2) {
        var func = isArray2(collection) ? arrayMap : baseMap;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function orderBy(collection, iteratees, orders, guard2) {
        if (collection == null) {
          return [];
        }
        if (!isArray2(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard2 ? undefined$1 : orders;
        if (!isArray2(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }
      var partition2 = createAggregator(function(result3, value, key) {
        result3[key ? 0 : 1].push(value);
      }, function() {
        return [[], []];
      });
      function reduce(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
      }
      function reduceRight(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
      }
      function reject(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }
      function sample(collection) {
        var func = isArray2(collection) ? arraySample : baseSample;
        return func(collection);
      }
      function sampleSize(collection, n, guard2) {
        if (guard2 ? isIterateeCall(collection, n, guard2) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        var func = isArray2(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n);
      }
      function shuffle(collection) {
        var func = isArray2(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }
      function size(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike(collection)) {
          return isString2(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag(collection);
        if (tag == mapTag || tag == setTag) {
          return collection.size;
        }
        return baseKeys(collection).length;
      }
      function some2(collection, predicate, guard2) {
        var func = isArray2(collection) ? arraySome : baseSome;
        if (guard2 && isIterateeCall(collection, predicate, guard2)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      var sortBy = baseRest(function(collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length = iteratees.length;
        if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });
      var now2 = ctxNow || function() {
        return root.Date.now();
      };
      function after(n, func) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function() {
          if (--n < 1) {
            return func.apply(this, arguments);
          }
        };
      }
      function ary(func, n, guard2) {
        n = guard2 ? undefined$1 : n;
        n = func && n == null ? func.length : n;
        return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
      }
      function before(n, func) {
        var result3;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function() {
          if (--n > 0) {
            result3 = func.apply(this, arguments);
          }
          if (n <= 1) {
            func = undefined$1;
          }
          return result3;
        };
      }
      var bind2 = baseRest(function(func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind2));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });
      var bindKey = baseRest(function(object, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object, partials, holders);
      });
      function curry(func, arity, guard2) {
        arity = guard2 ? undefined$1 : arity;
        var result3 = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result3.placeholder = curry.placeholder;
        return result3;
      }
      function curryRight(func, arity, guard2) {
        arity = guard2 ? undefined$1 : arity;
        var result3 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result3.placeholder = curryRight.placeholder;
        return result3;
      }
      function debounce(func, wait, options) {
        var lastArgs, lastThis, maxWait, result3, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        wait = toNumber(wait) || 0;
        if (isObject2(options)) {
          leading = !!options.leading;
          maxing = "maxWait" in options;
          maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs, thisArg = lastThis;
          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time;
          result3 = func.apply(thisArg, args);
          return result3;
        }
        function leadingEdge(time) {
          lastInvokeTime = time;
          timerId = setTimeout2(timerExpired, wait);
          return leading ? invokeFunc(time) : result3;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
          return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now2();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          timerId = setTimeout2(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = undefined$1;
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined$1;
          return result3;
        }
        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }
        function flush() {
          return timerId === undefined$1 ? result3 : trailingEdge(now2());
        }
        function debounced() {
          var time = now2(), isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout(timerId);
              timerId = setTimeout2(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$1) {
            timerId = setTimeout2(timerExpired, wait);
          }
          return result3;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      var defer = baseRest(function(func, args) {
        return baseDelay(func, 1, args);
      });
      var delay = baseRest(function(func, wait, args) {
        return baseDelay(func, toNumber(wait) || 0, args);
      });
      function flip(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }
      function memoize(func, resolver) {
        if (typeof func != "function" || resolver != null && typeof resolver != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        var memoized = function() {
          var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
          if (cache.has(key)) {
            return cache.get(key);
          }
          var result3 = func.apply(this, args);
          memoized.cache = cache.set(key, result3) || cache;
          return result3;
        };
        memoized.cache = new (memoize.Cache || MapCache)();
        return memoized;
      }
      memoize.Cache = MapCache;
      function negate(predicate) {
        if (typeof predicate != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      function once(func) {
        return before(2, func);
      }
      var overArgs = castRest(function(func, transforms) {
        transforms = transforms.length == 1 && isArray2(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
        var funcsLength = transforms.length;
        return baseRest(function(args) {
          var index = -1, length = nativeMin(args.length, funcsLength);
          while (++index < length) {
            args[index] = transforms[index].call(this, args[index]);
          }
          return apply(func, this, args);
        });
      });
      var partial = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
      });
      var partialRight = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
      });
      var rearg = flatRest(function(func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
      });
      function rest(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        start = start === undefined$1 ? start : toInteger(start);
        return baseRest(func, start);
      }
      function spread2(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        start = start == null ? 0 : nativeMax(toInteger(start), 0);
        return baseRest(function(args) {
          var array = args[start], otherArgs = castSlice(args, 0, start);
          if (array) {
            arrayPush(otherArgs, array);
          }
          return apply(func, this, otherArgs);
        });
      }
      function throttle(func, wait, options) {
        var leading = true, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        if (isObject2(options)) {
          leading = "leading" in options ? !!options.leading : leading;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        return debounce(func, wait, {
          "leading": leading,
          "maxWait": wait,
          "trailing": trailing
        });
      }
      function unary(func) {
        return ary(func, 1);
      }
      function wrap(value, wrapper) {
        return partial(castFunction(wrapper), value);
      }
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value = arguments[0];
        return isArray2(value) ? value : [value];
      }
      function clone2(value) {
        return baseClone(value, CLONE_SYMBOLS_FLAG);
      }
      function cloneWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
      }
      function cloneDeep(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }
      function cloneDeepWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
      }
      function conformsTo(object, source) {
        return source == null || baseConformsTo(object, source, keys2(source));
      }
      function eq(value, other) {
        return value === other || value !== value && other !== other;
      }
      var gt = createRelationalOperation(baseGt);
      var gte = createRelationalOperation(function(value, other) {
        return value >= other;
      });
      var isArguments = baseIsArguments(/* @__PURE__ */ function() {
        return arguments;
      }()) ? baseIsArguments : function(value) {
        return isObjectLike(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
      };
      var isArray2 = Array2.isArray;
      var isArrayBuffer2 = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction2(value);
      }
      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }
      function isBoolean2(value) {
        return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
      }
      var isBuffer2 = nativeIsBuffer || stubFalse;
      var isDate2 = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
      function isElement(value) {
        return isObjectLike(value) && value.nodeType === 1 && !isPlainObject2(value);
      }
      function isEmpty(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike(value) && (isArray2(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer2(value) || isTypedArray2(value) || isArguments(value))) {
          return !value.length;
        }
        var tag = getTag(value);
        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }
        if (isPrototype(value)) {
          return !baseKeys(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty2.call(value, key)) {
            return false;
          }
        }
        return true;
      }
      function isEqual(value, other) {
        return baseIsEqual(value, other);
      }
      function isEqualWith(value, other, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        var result3 = customizer ? customizer(value, other) : undefined$1;
        return result3 === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result3;
      }
      function isError2(value) {
        if (!isObjectLike(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject2(value);
      }
      function isFinite2(value) {
        return typeof value == "number" && nativeIsFinite(value);
      }
      function isFunction2(value) {
        if (!isObject2(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }
      function isInteger(value) {
        return typeof value == "number" && value == toInteger(value);
      }
      function isLength(value) {
        return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }
      function isObject2(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
      }
      function isObjectLike(value) {
        return value != null && typeof value == "object";
      }
      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
      function isMatch(object, source) {
        return object === source || baseIsMatch(object, source, getMatchData(source));
      }
      function isMatchWith(object, source, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseIsMatch(object, source, getMatchData(source), customizer);
      }
      function isNaN2(value) {
        return isNumber2(value) && value != +value;
      }
      function isNative(value) {
        if (isMaskable(value)) {
          throw new Error2(CORE_ERROR_TEXT);
        }
        return baseIsNative(value);
      }
      function isNull(value) {
        return value === null;
      }
      function isNil(value) {
        return value == null;
      }
      function isNumber2(value) {
        return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
      }
      function isPlainObject2(value) {
        if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
          return false;
        }
        var proto2 = getPrototype(value);
        if (proto2 === null) {
          return true;
        }
        var Ctor = hasOwnProperty2.call(proto2, "constructor") && proto2.constructor;
        return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
      }
      var isRegExp2 = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
      function isSafeInteger(value) {
        return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
      }
      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
      function isString2(value) {
        return typeof value == "string" || !isArray2(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
      }
      function isSymbol(value) {
        return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
      }
      var isTypedArray2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
      function isUndefined2(value) {
        return value === undefined$1;
      }
      function isWeakMap(value) {
        return isObjectLike(value) && getTag(value) == weakMapTag;
      }
      function isWeakSet(value) {
        return isObjectLike(value) && baseGetTag(value) == weakSetTag;
      }
      var lt = createRelationalOperation(baseLt);
      var lte = createRelationalOperation(function(value, other) {
        return value <= other;
      });
      function toArray2(value) {
        if (!value) {
          return [];
        }
        if (isArrayLike(value)) {
          return isString2(value) ? stringToArray(value) : copyArray(value);
        }
        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }
        var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
        return func(value);
      }
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber(value);
        if (value === INFINITY || value === -INFINITY) {
          var sign2 = value < 0 ? -1 : 1;
          return sign2 * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }
      function toInteger(value) {
        var result3 = toFinite(value), remainder = result3 % 1;
        return result3 === result3 ? remainder ? result3 - remainder : result3 : 0;
      }
      function toLength(value) {
        return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
      }
      function toNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        if (isObject2(value)) {
          var other = typeof value.valueOf == "function" ? value.valueOf() : value;
          value = isObject2(other) ? other + "" : other;
        }
        if (typeof value != "string") {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
      }
      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }
      function toSafeInteger(value) {
        return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
      }
      function toString3(value) {
        return value == null ? "" : baseToString(value);
      }
      var assign2 = createAssigner(function(object, source) {
        if (isPrototype(source) || isArrayLike(source)) {
          copyObject(source, keys2(source), object);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty2.call(source, key)) {
            assignValue(object, key, source[key]);
          }
        }
      });
      var assignIn = createAssigner(function(object, source) {
        copyObject(source, keysIn(source), object);
      });
      var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
        copyObject(source, keysIn(source), object, customizer);
      });
      var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
        copyObject(source, keys2(source), object, customizer);
      });
      var at = flatRest(baseAt);
      function create(prototype2, properties) {
        var result3 = baseCreate(prototype2);
        return properties == null ? result3 : baseAssign(result3, properties);
      }
      var defaults2 = baseRest(function(object, sources) {
        object = Object2(object);
        var index = -1;
        var length = sources.length;
        var guard2 = length > 2 ? sources[2] : undefined$1;
        if (guard2 && isIterateeCall(sources[0], sources[1], guard2)) {
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          var props = keysIn(source);
          var propsIndex = -1;
          var propsLength = props.length;
          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined$1 || eq(value, objectProto[key]) && !hasOwnProperty2.call(object, key)) {
              object[key] = source[key];
            }
          }
        }
        return object;
      });
      var defaultsDeep = baseRest(function(args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply(mergeWith, undefined$1, args);
      });
      function findKey2(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
      }
      function findLastKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
      }
      function forIn(object, iteratee2) {
        return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
      }
      function forInRight(object, iteratee2) {
        return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
      }
      function forOwn(object, iteratee2) {
        return object && baseForOwn(object, getIteratee(iteratee2, 3));
      }
      function forOwnRight(object, iteratee2) {
        return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
      }
      function functions(object) {
        return object == null ? [] : baseFunctions(object, keys2(object));
      }
      function functionsIn(object) {
        return object == null ? [] : baseFunctions(object, keysIn(object));
      }
      function get2(object, path, defaultValue) {
        var result3 = object == null ? undefined$1 : baseGet(object, path);
        return result3 === undefined$1 ? defaultValue : result3;
      }
      function has(object, path) {
        return object != null && hasPath(object, path, baseHas);
      }
      function hasIn(object, path) {
        return object != null && hasPath(object, path, baseHasIn);
      }
      var invert = createInverter(function(result3, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        result3[value] = key;
      }, constant(identity));
      var invertBy = createInverter(function(result3, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        if (hasOwnProperty2.call(result3, value)) {
          result3[value].push(key);
        } else {
          result3[value] = [key];
        }
      }, getIteratee);
      var invoke = baseRest(baseInvoke);
      function keys2(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }
      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }
      function mapKeys(object, iteratee2) {
        var result3 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue(result3, iteratee2(value, key, object2), value);
        });
        return result3;
      }
      function mapValues(object, iteratee2) {
        var result3 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue(result3, key, iteratee2(value, key, object2));
        });
        return result3;
      }
      var merge2 = createAssigner(function(object, source, srcIndex) {
        baseMerge(object, source, srcIndex);
      });
      var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
        baseMerge(object, source, srcIndex, customizer);
      });
      var omit = flatRest(function(object, paths) {
        var result3 = {};
        if (object == null) {
          return result3;
        }
        var isDeep = false;
        paths = arrayMap(paths, function(path) {
          path = castPath(path, object);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject(object, getAllKeysIn(object), result3);
        if (isDeep) {
          result3 = baseClone(result3, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }
        var length = paths.length;
        while (length--) {
          baseUnset(result3, paths[length]);
        }
        return result3;
      });
      function omitBy(object, predicate) {
        return pickBy2(object, negate(getIteratee(predicate)));
      }
      var pick = flatRest(function(object, paths) {
        return object == null ? {} : basePick(object, paths);
      });
      function pickBy2(object, predicate) {
        if (object == null) {
          return {};
        }
        var props = arrayMap(getAllKeysIn(object), function(prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object, props, function(value, path) {
          return predicate(value, path[0]);
        });
      }
      function result2(object, path, defaultValue) {
        path = castPath(path, object);
        var index = -1, length = path.length;
        if (!length) {
          length = 1;
          object = undefined$1;
        }
        while (++index < length) {
          var value = object == null ? undefined$1 : object[toKey(path[index])];
          if (value === undefined$1) {
            index = length;
            value = defaultValue;
          }
          object = isFunction2(value) ? value.call(object) : value;
        }
        return object;
      }
      function set2(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
      }
      function setWith(object, path, value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null ? object : baseSet(object, path, value, customizer);
      }
      var toPairs = createToPairs(keys2);
      var toPairsIn = createToPairs(keysIn);
      function transform(object, iteratee2, accumulator) {
        var isArr = isArray2(object), isArrLike = isArr || isBuffer2(object) || isTypedArray2(object);
        iteratee2 = getIteratee(iteratee2, 4);
        if (accumulator == null) {
          var Ctor = object && object.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject2(object)) {
            accumulator = isFunction2(Ctor) ? baseCreate(getPrototype(object)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object2) {
          return iteratee2(accumulator, value, index, object2);
        });
        return accumulator;
      }
      function unset(object, path) {
        return object == null ? true : baseUnset(object, path);
      }
      function update(object, path, updater) {
        return object == null ? object : baseUpdate(object, path, castFunction(updater));
      }
      function updateWith(object, path, updater, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
      }
      function values(object) {
        return object == null ? [] : baseValues(object, keys2(object));
      }
      function valuesIn(object) {
        return object == null ? [] : baseValues(object, keysIn(object));
      }
      function clamp2(number2, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }
        if (upper !== undefined$1) {
          upper = toNumber(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$1) {
          lower = toNumber(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber(number2), lower, upper);
      }
      function inRange(number2, start, end) {
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        number2 = toNumber(number2);
        return baseInRange(number2, start, end);
      }
      function random(lower, upper, floating) {
        if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
          upper = floating = undefined$1;
        }
        if (floating === undefined$1) {
          if (typeof upper == "boolean") {
            floating = upper;
            upper = undefined$1;
          } else if (typeof lower == "boolean") {
            floating = lower;
            lower = undefined$1;
          }
        }
        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);
          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
        }
        return baseRandom(lower, upper);
      }
      var camelCase = createCompounder(function(result3, word, index) {
        word = word.toLowerCase();
        return result3 + (index ? capitalize2(word) : word);
      });
      function capitalize2(string2) {
        return upperFirst(toString3(string2).toLowerCase());
      }
      function deburr(string2) {
        string2 = toString3(string2);
        return string2 && string2.replace(reLatin, deburrLetter).replace(reComboMark, "");
      }
      function endsWith2(string2, target, position) {
        string2 = toString3(string2);
        target = baseToString(target);
        var length = string2.length;
        position = position === undefined$1 ? length : baseClamp(toInteger(position), 0, length);
        var end = position;
        position -= target.length;
        return position >= 0 && string2.slice(position, end) == target;
      }
      function escape2(string2) {
        string2 = toString3(string2);
        return string2 && reHasUnescapedHtml.test(string2) ? string2.replace(reUnescapedHtml, escapeHtmlChar) : string2;
      }
      function escapeRegExp(string2) {
        string2 = toString3(string2);
        return string2 && reHasRegExpChar.test(string2) ? string2.replace(reRegExpChar, "\\$&") : string2;
      }
      var kebabCase = createCompounder(function(result3, word, index) {
        return result3 + (index ? "-" : "") + word.toLowerCase();
      });
      var lowerCase = createCompounder(function(result3, word, index) {
        return result3 + (index ? " " : "") + word.toLowerCase();
      });
      var lowerFirst = createCaseFirst("toLowerCase");
      function pad(string2, length, chars) {
        string2 = toString3(string2);
        length = toInteger(length);
        var strLength = length ? stringSize(string2) : 0;
        if (!length || strLength >= length) {
          return string2;
        }
        var mid = (length - strLength) / 2;
        return createPadding(nativeFloor(mid), chars) + string2 + createPadding(nativeCeil(mid), chars);
      }
      function padEnd(string2, length, chars) {
        string2 = toString3(string2);
        length = toInteger(length);
        var strLength = length ? stringSize(string2) : 0;
        return length && strLength < length ? string2 + createPadding(length - strLength, chars) : string2;
      }
      function padStart(string2, length, chars) {
        string2 = toString3(string2);
        length = toInteger(length);
        var strLength = length ? stringSize(string2) : 0;
        return length && strLength < length ? createPadding(length - strLength, chars) + string2 : string2;
      }
      function parseInt2(string2, radix, guard2) {
        if (guard2 || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString3(string2).replace(reTrimStart, ""), radix || 0);
      }
      function repeat(string2, n, guard2) {
        if (guard2 ? isIterateeCall(string2, n, guard2) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        return baseRepeat(toString3(string2), n);
      }
      function replace() {
        var args = arguments, string2 = toString3(args[0]);
        return args.length < 3 ? string2 : string2.replace(args[1], args[2]);
      }
      var snakeCase = createCompounder(function(result3, word, index) {
        return result3 + (index ? "_" : "") + word.toLowerCase();
      });
      function split(string2, separator, limit) {
        if (limit && typeof limit != "number" && isIterateeCall(string2, separator, limit)) {
          separator = limit = undefined$1;
        }
        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
        if (!limit) {
          return [];
        }
        string2 = toString3(string2);
        if (string2 && (typeof separator == "string" || separator != null && !isRegExp2(separator))) {
          separator = baseToString(separator);
          if (!separator && hasUnicode(string2)) {
            return castSlice(stringToArray(string2), 0, limit);
          }
        }
        return string2.split(separator, limit);
      }
      var startCase = createCompounder(function(result3, word, index) {
        return result3 + (index ? " " : "") + upperFirst(word);
      });
      function startsWith(string2, target, position) {
        string2 = toString3(string2);
        position = position == null ? 0 : baseClamp(toInteger(position), 0, string2.length);
        target = baseToString(target);
        return string2.slice(position, position + target.length) == target;
      }
      function template(string2, options, guard2) {
        var settings = lodash2.templateSettings;
        if (guard2 && isIterateeCall(string2, options, guard2)) {
          options = undefined$1;
        }
        string2 = toString3(string2);
        options = assignInWith({}, options, settings, customDefaultsAssignIn);
        var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys2(imports), importsValues = baseValues(imports, importsKeys);
        var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
        var reDelimiters = RegExp2(
          (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
          "g"
        );
        var sourceURL = "//# sourceURL=" + (hasOwnProperty2.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
        string2.replace(reDelimiters, function(match5, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset2) {
          interpolateValue || (interpolateValue = esTemplateValue);
          source += string2.slice(index, offset2).replace(reUnescapedString, escapeStringChar);
          if (escapeValue) {
            isEscaping = true;
            source += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index = offset2 + match5.length;
          return match5;
        });
        source += "';\n";
        var variable = hasOwnProperty2.call(options, "variable") && options.variable;
        if (!variable) {
          source = "with (obj) {\n" + source + "\n}\n";
        } else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
        }
        source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
        source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
        var result3 = attempt(function() {
          return Function2(importsKeys, sourceURL + "return " + source).apply(undefined$1, importsValues);
        });
        result3.source = source;
        if (isError2(result3)) {
          throw result3;
        }
        return result3;
      }
      function toLower(value) {
        return toString3(value).toLowerCase();
      }
      function toUpper(value) {
        return toString3(value).toUpperCase();
      }
      function trim2(string2, chars, guard2) {
        string2 = toString3(string2);
        if (string2 && (guard2 || chars === undefined$1)) {
          return baseTrim(string2);
        }
        if (!string2 || !(chars = baseToString(chars))) {
          return string2;
        }
        var strSymbols = stringToArray(string2), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice(strSymbols, start, end).join("");
      }
      function trimEnd(string2, chars, guard2) {
        string2 = toString3(string2);
        if (string2 && (guard2 || chars === undefined$1)) {
          return string2.slice(0, trimmedEndIndex(string2) + 1);
        }
        if (!string2 || !(chars = baseToString(chars))) {
          return string2;
        }
        var strSymbols = stringToArray(string2), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
        return castSlice(strSymbols, 0, end).join("");
      }
      function trimStart(string2, chars, guard2) {
        string2 = toString3(string2);
        if (string2 && (guard2 || chars === undefined$1)) {
          return string2.replace(reTrimStart, "");
        }
        if (!string2 || !(chars = baseToString(chars))) {
          return string2;
        }
        var strSymbols = stringToArray(string2), start = charsStartIndex(strSymbols, stringToArray(chars));
        return castSlice(strSymbols, start).join("");
      }
      function truncate(string2, options) {
        var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
        if (isObject2(options)) {
          var separator = "separator" in options ? options.separator : separator;
          length = "length" in options ? toInteger(options.length) : length;
          omission = "omission" in options ? baseToString(options.omission) : omission;
        }
        string2 = toString3(string2);
        var strLength = string2.length;
        if (hasUnicode(string2)) {
          var strSymbols = stringToArray(string2);
          strLength = strSymbols.length;
        }
        if (length >= strLength) {
          return string2;
        }
        var end = length - stringSize(omission);
        if (end < 1) {
          return omission;
        }
        var result3 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string2.slice(0, end);
        if (separator === undefined$1) {
          return result3 + omission;
        }
        if (strSymbols) {
          end += result3.length - end;
        }
        if (isRegExp2(separator)) {
          if (string2.slice(end).search(separator)) {
            var match5, substring = result3;
            if (!separator.global) {
              separator = RegExp2(separator.source, toString3(reFlags.exec(separator)) + "g");
            }
            separator.lastIndex = 0;
            while (match5 = separator.exec(substring)) {
              var newEnd = match5.index;
            }
            result3 = result3.slice(0, newEnd === undefined$1 ? end : newEnd);
          }
        } else if (string2.indexOf(baseToString(separator), end) != end) {
          var index = result3.lastIndexOf(separator);
          if (index > -1) {
            result3 = result3.slice(0, index);
          }
        }
        return result3 + omission;
      }
      function unescape2(string2) {
        string2 = toString3(string2);
        return string2 && reHasEscapedHtml.test(string2) ? string2.replace(reEscapedHtml, unescapeHtmlChar) : string2;
      }
      var upperCase = createCompounder(function(result3, word, index) {
        return result3 + (index ? " " : "") + word.toUpperCase();
      });
      var upperFirst = createCaseFirst("toUpperCase");
      function words(string2, pattern, guard2) {
        string2 = toString3(string2);
        pattern = guard2 ? undefined$1 : pattern;
        if (pattern === undefined$1) {
          return hasUnicodeWord(string2) ? unicodeWords(string2) : asciiWords(string2);
        }
        return string2.match(pattern) || [];
      }
      var attempt = baseRest(function(func, args) {
        try {
          return apply(func, undefined$1, args);
        } catch (e) {
          return isError2(e) ? e : new Error2(e);
        }
      });
      var bindAll = flatRest(function(object, methodNames) {
        arrayEach(methodNames, function(key) {
          key = toKey(key);
          baseAssignValue(object, key, bind2(object[key], object));
        });
        return object;
      });
      function cond(pairs) {
        var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
        pairs = !length ? [] : arrayMap(pairs, function(pair) {
          if (typeof pair[1] != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return [toIteratee(pair[0]), pair[1]];
        });
        return baseRest(function(args) {
          var index = -1;
          while (++index < length) {
            var pair = pairs[index];
            if (apply(pair[0], this, args)) {
              return apply(pair[1], this, args);
            }
          }
        });
      }
      function conforms(source) {
        return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
      }
      function constant(value) {
        return function() {
          return value;
        };
      }
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }
      var flow = createFlow();
      var flowRight = createFlow(true);
      function identity(value) {
        return value;
      }
      function iteratee(func) {
        return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
      }
      function matches(source) {
        return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
      }
      function matchesProperty(path, srcValue) {
        return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
      }
      var method = baseRest(function(path, args) {
        return function(object) {
          return baseInvoke(object, path, args);
        };
      });
      var methodOf = baseRest(function(object, args) {
        return function(path) {
          return baseInvoke(object, path, args);
        };
      });
      function mixin(object, source, options) {
        var props = keys2(source), methodNames = baseFunctions(source, props);
        if (options == null && !(isObject2(source) && (methodNames.length || !props.length))) {
          options = source;
          source = object;
          object = this;
          methodNames = baseFunctions(source, keys2(source));
        }
        var chain3 = !(isObject2(options) && "chain" in options) || !!options.chain, isFunc = isFunction2(object);
        arrayEach(methodNames, function(methodName) {
          var func = source[methodName];
          object[methodName] = func;
          if (isFunc) {
            object.prototype[methodName] = function() {
              var chainAll = this.__chain__;
              if (chain3 || chainAll) {
                var result3 = object(this.__wrapped__), actions = result3.__actions__ = copyArray(this.__actions__);
                actions.push({ "func": func, "args": arguments, "thisArg": object });
                result3.__chain__ = chainAll;
                return result3;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }
        });
        return object;
      }
      function noConflict() {
        if (root._ === this) {
          root._ = oldDash;
        }
        return this;
      }
      function noop2() {
      }
      function nthArg(n) {
        n = toInteger(n);
        return baseRest(function(args) {
          return baseNth(args, n);
        });
      }
      var over = createOver(arrayMap);
      var overEvery = createOver(arrayEvery);
      var overSome = createOver(arraySome);
      function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
      }
      function propertyOf(object) {
        return function(path) {
          return object == null ? undefined$1 : baseGet(object, path);
        };
      }
      var range = createRange();
      var rangeRight = createRange(true);
      function stubArray() {
        return [];
      }
      function stubFalse() {
        return false;
      }
      function stubObject() {
        return {};
      }
      function stubString() {
        return "";
      }
      function stubTrue() {
        return true;
      }
      function times(n, iteratee2) {
        n = toInteger(n);
        if (n < 1 || n > MAX_SAFE_INTEGER) {
          return [];
        }
        var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
        iteratee2 = getIteratee(iteratee2);
        n -= MAX_ARRAY_LENGTH;
        var result3 = baseTimes(length, iteratee2);
        while (++index < n) {
          iteratee2(index);
        }
        return result3;
      }
      function toPath(value) {
        if (isArray2(value)) {
          return arrayMap(value, toKey);
        }
        return isSymbol(value) ? [value] : copyArray(stringToPath(toString3(value)));
      }
      function uniqueId(prefix) {
        var id = ++idCounter;
        return toString3(prefix) + id;
      }
      var add2 = createMathOperation(function(augend, addend) {
        return augend + addend;
      }, 0);
      var ceil = createRound("ceil");
      var divide = createMathOperation(function(dividend, divisor) {
        return dividend / divisor;
      }, 1);
      var floor = createRound("floor");
      function max2(array) {
        return array && array.length ? baseExtremum(array, identity, baseGt) : undefined$1;
      }
      function maxBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined$1;
      }
      function mean(array) {
        return baseMean(array, identity);
      }
      function meanBy(array, iteratee2) {
        return baseMean(array, getIteratee(iteratee2, 2));
      }
      function min2(array) {
        return array && array.length ? baseExtremum(array, identity, baseLt) : undefined$1;
      }
      function minBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined$1;
      }
      var multiply = createMathOperation(function(multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);
      var round2 = createRound("round");
      var subtract2 = createMathOperation(function(minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);
      function sum(array) {
        return array && array.length ? baseSum(array, identity) : 0;
      }
      function sumBy(array, iteratee2) {
        return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
      }
      lodash2.after = after;
      lodash2.ary = ary;
      lodash2.assign = assign2;
      lodash2.assignIn = assignIn;
      lodash2.assignInWith = assignInWith;
      lodash2.assignWith = assignWith;
      lodash2.at = at;
      lodash2.before = before;
      lodash2.bind = bind2;
      lodash2.bindAll = bindAll;
      lodash2.bindKey = bindKey;
      lodash2.castArray = castArray;
      lodash2.chain = chain2;
      lodash2.chunk = chunk;
      lodash2.compact = compact2;
      lodash2.concat = concat2;
      lodash2.cond = cond;
      lodash2.conforms = conforms;
      lodash2.constant = constant;
      lodash2.countBy = countBy;
      lodash2.create = create;
      lodash2.curry = curry;
      lodash2.curryRight = curryRight;
      lodash2.debounce = debounce;
      lodash2.defaults = defaults2;
      lodash2.defaultsDeep = defaultsDeep;
      lodash2.defer = defer;
      lodash2.delay = delay;
      lodash2.difference = difference;
      lodash2.differenceBy = differenceBy;
      lodash2.differenceWith = differenceWith;
      lodash2.drop = drop;
      lodash2.dropRight = dropRight;
      lodash2.dropRightWhile = dropRightWhile;
      lodash2.dropWhile = dropWhile;
      lodash2.fill = fill;
      lodash2.filter = filter3;
      lodash2.flatMap = flatMap2;
      lodash2.flatMapDeep = flatMapDeep;
      lodash2.flatMapDepth = flatMapDepth;
      lodash2.flatten = flatten;
      lodash2.flattenDeep = flattenDeep;
      lodash2.flattenDepth = flattenDepth;
      lodash2.flip = flip;
      lodash2.flow = flow;
      lodash2.flowRight = flowRight;
      lodash2.fromPairs = fromPairs;
      lodash2.functions = functions;
      lodash2.functionsIn = functionsIn;
      lodash2.groupBy = groupBy;
      lodash2.initial = initial;
      lodash2.intersection = intersection;
      lodash2.intersectionBy = intersectionBy;
      lodash2.intersectionWith = intersectionWith;
      lodash2.invert = invert;
      lodash2.invertBy = invertBy;
      lodash2.invokeMap = invokeMap;
      lodash2.iteratee = iteratee;
      lodash2.keyBy = keyBy;
      lodash2.keys = keys2;
      lodash2.keysIn = keysIn;
      lodash2.map = map2;
      lodash2.mapKeys = mapKeys;
      lodash2.mapValues = mapValues;
      lodash2.matches = matches;
      lodash2.matchesProperty = matchesProperty;
      lodash2.memoize = memoize;
      lodash2.merge = merge2;
      lodash2.mergeWith = mergeWith;
      lodash2.method = method;
      lodash2.methodOf = methodOf;
      lodash2.mixin = mixin;
      lodash2.negate = negate;
      lodash2.nthArg = nthArg;
      lodash2.omit = omit;
      lodash2.omitBy = omitBy;
      lodash2.once = once;
      lodash2.orderBy = orderBy;
      lodash2.over = over;
      lodash2.overArgs = overArgs;
      lodash2.overEvery = overEvery;
      lodash2.overSome = overSome;
      lodash2.partial = partial;
      lodash2.partialRight = partialRight;
      lodash2.partition = partition2;
      lodash2.pick = pick;
      lodash2.pickBy = pickBy2;
      lodash2.property = property;
      lodash2.propertyOf = propertyOf;
      lodash2.pull = pull;
      lodash2.pullAll = pullAll;
      lodash2.pullAllBy = pullAllBy;
      lodash2.pullAllWith = pullAllWith;
      lodash2.pullAt = pullAt;
      lodash2.range = range;
      lodash2.rangeRight = rangeRight;
      lodash2.rearg = rearg;
      lodash2.reject = reject;
      lodash2.remove = remove;
      lodash2.rest = rest;
      lodash2.reverse = reverse2;
      lodash2.sampleSize = sampleSize;
      lodash2.set = set2;
      lodash2.setWith = setWith;
      lodash2.shuffle = shuffle;
      lodash2.slice = slice2;
      lodash2.sortBy = sortBy;
      lodash2.sortedUniq = sortedUniq;
      lodash2.sortedUniqBy = sortedUniqBy;
      lodash2.split = split;
      lodash2.spread = spread2;
      lodash2.tail = tail;
      lodash2.take = take;
      lodash2.takeRight = takeRight;
      lodash2.takeRightWhile = takeRightWhile;
      lodash2.takeWhile = takeWhile;
      lodash2.tap = tap2;
      lodash2.throttle = throttle;
      lodash2.thru = thru;
      lodash2.toArray = toArray2;
      lodash2.toPairs = toPairs;
      lodash2.toPairsIn = toPairsIn;
      lodash2.toPath = toPath;
      lodash2.toPlainObject = toPlainObject;
      lodash2.transform = transform;
      lodash2.unary = unary;
      lodash2.union = union;
      lodash2.unionBy = unionBy;
      lodash2.unionWith = unionWith;
      lodash2.uniq = uniq;
      lodash2.uniqBy = uniqBy;
      lodash2.uniqWith = uniqWith;
      lodash2.unset = unset;
      lodash2.unzip = unzip;
      lodash2.unzipWith = unzipWith;
      lodash2.update = update;
      lodash2.updateWith = updateWith;
      lodash2.values = values;
      lodash2.valuesIn = valuesIn;
      lodash2.without = without;
      lodash2.words = words;
      lodash2.wrap = wrap;
      lodash2.xor = xor;
      lodash2.xorBy = xorBy;
      lodash2.xorWith = xorWith;
      lodash2.zip = zip;
      lodash2.zipObject = zipObject;
      lodash2.zipObjectDeep = zipObjectDeep;
      lodash2.zipWith = zipWith;
      lodash2.entries = toPairs;
      lodash2.entriesIn = toPairsIn;
      lodash2.extend = assignIn;
      lodash2.extendWith = assignInWith;
      mixin(lodash2, lodash2);
      lodash2.add = add2;
      lodash2.attempt = attempt;
      lodash2.camelCase = camelCase;
      lodash2.capitalize = capitalize2;
      lodash2.ceil = ceil;
      lodash2.clamp = clamp2;
      lodash2.clone = clone2;
      lodash2.cloneDeep = cloneDeep;
      lodash2.cloneDeepWith = cloneDeepWith;
      lodash2.cloneWith = cloneWith;
      lodash2.conformsTo = conformsTo;
      lodash2.deburr = deburr;
      lodash2.defaultTo = defaultTo;
      lodash2.divide = divide;
      lodash2.endsWith = endsWith2;
      lodash2.eq = eq;
      lodash2.escape = escape2;
      lodash2.escapeRegExp = escapeRegExp;
      lodash2.every = every;
      lodash2.find = find;
      lodash2.findIndex = findIndex;
      lodash2.findKey = findKey2;
      lodash2.findLast = findLast;
      lodash2.findLastIndex = findLastIndex;
      lodash2.findLastKey = findLastKey;
      lodash2.floor = floor;
      lodash2.forEach = forEach2;
      lodash2.forEachRight = forEachRight;
      lodash2.forIn = forIn;
      lodash2.forInRight = forInRight;
      lodash2.forOwn = forOwn;
      lodash2.forOwnRight = forOwnRight;
      lodash2.get = get2;
      lodash2.gt = gt;
      lodash2.gte = gte;
      lodash2.has = has;
      lodash2.hasIn = hasIn;
      lodash2.head = head;
      lodash2.identity = identity;
      lodash2.includes = includes;
      lodash2.indexOf = indexOf2;
      lodash2.inRange = inRange;
      lodash2.invoke = invoke;
      lodash2.isArguments = isArguments;
      lodash2.isArray = isArray2;
      lodash2.isArrayBuffer = isArrayBuffer2;
      lodash2.isArrayLike = isArrayLike;
      lodash2.isArrayLikeObject = isArrayLikeObject;
      lodash2.isBoolean = isBoolean2;
      lodash2.isBuffer = isBuffer2;
      lodash2.isDate = isDate2;
      lodash2.isElement = isElement;
      lodash2.isEmpty = isEmpty;
      lodash2.isEqual = isEqual;
      lodash2.isEqualWith = isEqualWith;
      lodash2.isError = isError2;
      lodash2.isFinite = isFinite2;
      lodash2.isFunction = isFunction2;
      lodash2.isInteger = isInteger;
      lodash2.isLength = isLength;
      lodash2.isMap = isMap;
      lodash2.isMatch = isMatch;
      lodash2.isMatchWith = isMatchWith;
      lodash2.isNaN = isNaN2;
      lodash2.isNative = isNative;
      lodash2.isNil = isNil;
      lodash2.isNull = isNull;
      lodash2.isNumber = isNumber2;
      lodash2.isObject = isObject2;
      lodash2.isObjectLike = isObjectLike;
      lodash2.isPlainObject = isPlainObject2;
      lodash2.isRegExp = isRegExp2;
      lodash2.isSafeInteger = isSafeInteger;
      lodash2.isSet = isSet;
      lodash2.isString = isString2;
      lodash2.isSymbol = isSymbol;
      lodash2.isTypedArray = isTypedArray2;
      lodash2.isUndefined = isUndefined2;
      lodash2.isWeakMap = isWeakMap;
      lodash2.isWeakSet = isWeakSet;
      lodash2.join = join;
      lodash2.kebabCase = kebabCase;
      lodash2.last = last;
      lodash2.lastIndexOf = lastIndexOf;
      lodash2.lowerCase = lowerCase;
      lodash2.lowerFirst = lowerFirst;
      lodash2.lt = lt;
      lodash2.lte = lte;
      lodash2.max = max2;
      lodash2.maxBy = maxBy;
      lodash2.mean = mean;
      lodash2.meanBy = meanBy;
      lodash2.min = min2;
      lodash2.minBy = minBy;
      lodash2.stubArray = stubArray;
      lodash2.stubFalse = stubFalse;
      lodash2.stubObject = stubObject;
      lodash2.stubString = stubString;
      lodash2.stubTrue = stubTrue;
      lodash2.multiply = multiply;
      lodash2.nth = nth;
      lodash2.noConflict = noConflict;
      lodash2.noop = noop2;
      lodash2.now = now2;
      lodash2.pad = pad;
      lodash2.padEnd = padEnd;
      lodash2.padStart = padStart;
      lodash2.parseInt = parseInt2;
      lodash2.random = random;
      lodash2.reduce = reduce;
      lodash2.reduceRight = reduceRight;
      lodash2.repeat = repeat;
      lodash2.replace = replace;
      lodash2.result = result2;
      lodash2.round = round2;
      lodash2.runInContext = runInContext2;
      lodash2.sample = sample;
      lodash2.size = size;
      lodash2.snakeCase = snakeCase;
      lodash2.some = some2;
      lodash2.sortedIndex = sortedIndex;
      lodash2.sortedIndexBy = sortedIndexBy;
      lodash2.sortedIndexOf = sortedIndexOf;
      lodash2.sortedLastIndex = sortedLastIndex;
      lodash2.sortedLastIndexBy = sortedLastIndexBy;
      lodash2.sortedLastIndexOf = sortedLastIndexOf;
      lodash2.startCase = startCase;
      lodash2.startsWith = startsWith;
      lodash2.subtract = subtract2;
      lodash2.sum = sum;
      lodash2.sumBy = sumBy;
      lodash2.template = template;
      lodash2.times = times;
      lodash2.toFinite = toFinite;
      lodash2.toInteger = toInteger;
      lodash2.toLength = toLength;
      lodash2.toLower = toLower;
      lodash2.toNumber = toNumber;
      lodash2.toSafeInteger = toSafeInteger;
      lodash2.toString = toString3;
      lodash2.toUpper = toUpper;
      lodash2.trim = trim2;
      lodash2.trimEnd = trimEnd;
      lodash2.trimStart = trimStart;
      lodash2.truncate = truncate;
      lodash2.unescape = unescape2;
      lodash2.uniqueId = uniqueId;
      lodash2.upperCase = upperCase;
      lodash2.upperFirst = upperFirst;
      lodash2.each = forEach2;
      lodash2.eachRight = forEachRight;
      lodash2.first = head;
      mixin(lodash2, function() {
        var source = {};
        baseForOwn(lodash2, function(func, methodName) {
          if (!hasOwnProperty2.call(lodash2.prototype, methodName)) {
            source[methodName] = func;
          }
        });
        return source;
      }(), { "chain": false });
      lodash2.VERSION = VERSION2;
      arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
        lodash2[methodName].placeholder = lodash2;
      });
      arrayEach(["drop", "take"], function(methodName, index) {
        LazyWrapper.prototype[methodName] = function(n) {
          n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);
          var result3 = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
          if (result3.__filtered__) {
            result3.__takeCount__ = nativeMin(n, result3.__takeCount__);
          } else {
            result3.__views__.push({
              "size": nativeMin(n, MAX_ARRAY_LENGTH),
              "type": methodName + (result3.__dir__ < 0 ? "Right" : "")
            });
          }
          return result3;
        };
        LazyWrapper.prototype[methodName + "Right"] = function(n) {
          return this.reverse()[methodName](n).reverse();
        };
      });
      arrayEach(["filter", "map", "takeWhile"], function(methodName, index) {
        var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
        LazyWrapper.prototype[methodName] = function(iteratee2) {
          var result3 = this.clone();
          result3.__iteratees__.push({
            "iteratee": getIteratee(iteratee2, 3),
            "type": type
          });
          result3.__filtered__ = result3.__filtered__ || isFilter;
          return result3;
        };
      });
      arrayEach(["head", "last"], function(methodName, index) {
        var takeName = "take" + (index ? "Right" : "");
        LazyWrapper.prototype[methodName] = function() {
          return this[takeName](1).value()[0];
        };
      });
      arrayEach(["initial", "tail"], function(methodName, index) {
        var dropName = "drop" + (index ? "" : "Right");
        LazyWrapper.prototype[methodName] = function() {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });
      LazyWrapper.prototype.compact = function() {
        return this.filter(identity);
      };
      LazyWrapper.prototype.find = function(predicate) {
        return this.filter(predicate).head();
      };
      LazyWrapper.prototype.findLast = function(predicate) {
        return this.reverse().find(predicate);
      };
      LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
        if (typeof path == "function") {
          return new LazyWrapper(this);
        }
        return this.map(function(value) {
          return baseInvoke(value, path, args);
        });
      });
      LazyWrapper.prototype.reject = function(predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };
      LazyWrapper.prototype.slice = function(start, end) {
        start = toInteger(start);
        var result3 = this;
        if (result3.__filtered__ && (start > 0 || end < 0)) {
          return new LazyWrapper(result3);
        }
        if (start < 0) {
          result3 = result3.takeRight(-start);
        } else if (start) {
          result3 = result3.drop(start);
        }
        if (end !== undefined$1) {
          end = toInteger(end);
          result3 = end < 0 ? result3.dropRight(-end) : result3.take(end - start);
        }
        return result3;
      };
      LazyWrapper.prototype.takeRightWhile = function(predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };
      LazyWrapper.prototype.toArray = function() {
        return this.take(MAX_ARRAY_LENGTH);
      };
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
        if (!lodashFunc) {
          return;
        }
        lodash2.prototype[methodName] = function() {
          var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray2(value);
          var interceptor = function(value2) {
            var result4 = lodashFunc.apply(lodash2, arrayPush([value2], args));
            return isTaker && chainAll ? result4[0] : result4;
          };
          if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result3 = func.apply(value, args);
            result3.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$1 });
            return new LodashWrapper(result3, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result3 = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result3.value()[0] : result3.value() : result3;
        };
      });
      arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
        var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
        lodash2.prototype[methodName] = function() {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func.apply(isArray2(value) ? value : [], args);
          }
          return this[chainName](function(value2) {
            return func.apply(isArray2(value2) ? value2 : [], args);
          });
        };
      });
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var lodashFunc = lodash2[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + "";
          if (!hasOwnProperty2.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({ "name": methodName, "func": lodashFunc });
        }
      });
      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
        "name": "wrapper",
        "func": undefined$1
      }];
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;
      lodash2.prototype.at = wrapperAt;
      lodash2.prototype.chain = wrapperChain;
      lodash2.prototype.commit = wrapperCommit;
      lodash2.prototype.next = wrapperNext;
      lodash2.prototype.plant = wrapperPlant;
      lodash2.prototype.reverse = wrapperReverse;
      lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
      lodash2.prototype.first = lodash2.prototype.head;
      if (symIterator) {
        lodash2.prototype[symIterator] = wrapperToIterator;
      }
      return lodash2;
    };
    var _2 = runInContext();
    if (freeModule) {
      (freeModule.exports = _2)._ = _2;
      freeExports._ = _2;
    } else {
      root._ = _2;
    }
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
var lodashExports = lodash.exports;
const _$3 = /* @__PURE__ */ getDefaultExportFromCjs(lodashExports);
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var hookCallback;
function hooks() {
  return hookCallback.apply(null, arguments);
}
function setHookCallback(callback) {
  hookCallback = callback;
}
function isArray$1(input) {
  return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
}
function isObject$1(input) {
  return input != null && Object.prototype.toString.call(input) === "[object Object]";
}
function hasOwnProp(a, b) {
  return Object.prototype.hasOwnProperty.call(a, b);
}
function isObjectEmpty(obj) {
  if (Object.getOwnPropertyNames) {
    return Object.getOwnPropertyNames(obj).length === 0;
  } else {
    var k;
    for (k in obj) {
      if (hasOwnProp(obj, k)) {
        return false;
      }
    }
    return true;
  }
}
function isUndefined$1(input) {
  return input === void 0;
}
function isNumber$1(input) {
  return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
}
function isDate$2(input) {
  return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
}
function map$2(arr, fn) {
  var res = [], i, arrLen = arr.length;
  for (i = 0; i < arrLen; ++i) {
    res.push(fn(arr[i], i));
  }
  return res;
}
function extend$1(a, b) {
  for (var i in b) {
    if (hasOwnProp(b, i)) {
      a[i] = b[i];
    }
  }
  if (hasOwnProp(b, "toString")) {
    a.toString = b.toString;
  }
  if (hasOwnProp(b, "valueOf")) {
    a.valueOf = b.valueOf;
  }
  return a;
}
function createUTC(input, format2, locale2, strict) {
  return createLocalOrUTC(input, format2, locale2, strict, true).utc();
}
function defaultParsingFlags() {
  return {
    empty: false,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: false,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: false,
    userInvalidated: false,
    iso: false,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: false,
    weekdayMismatch: false
  };
}
function getParsingFlags(m) {
  if (m._pf == null) {
    m._pf = defaultParsingFlags();
  }
  return m._pf;
}
var some;
if (Array.prototype.some) {
  some = Array.prototype.some;
} else {
  some = function(fun) {
    var t = Object(this), len = t.length >>> 0, i;
    for (i = 0; i < len; i++) {
      if (i in t && fun.call(this, t[i], i, t)) {
        return true;
      }
    }
    return false;
  };
}
function isValid$1(m) {
  if (m._isValid == null) {
    var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
      return i != null;
    }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
    if (m._strict) {
      isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === void 0;
    }
    if (Object.isFrozen == null || !Object.isFrozen(m)) {
      m._isValid = isNowValid;
    } else {
      return isNowValid;
    }
  }
  return m._isValid;
}
function createInvalid(flags) {
  var m = createUTC(NaN);
  if (flags != null) {
    extend$1(getParsingFlags(m), flags);
  } else {
    getParsingFlags(m).userInvalidated = true;
  }
  return m;
}
var momentProperties = hooks.momentProperties = [], updateInProgress = false;
function copyConfig(to2, from2) {
  var i, prop, val, momentPropertiesLen = momentProperties.length;
  if (!isUndefined$1(from2._isAMomentObject)) {
    to2._isAMomentObject = from2._isAMomentObject;
  }
  if (!isUndefined$1(from2._i)) {
    to2._i = from2._i;
  }
  if (!isUndefined$1(from2._f)) {
    to2._f = from2._f;
  }
  if (!isUndefined$1(from2._l)) {
    to2._l = from2._l;
  }
  if (!isUndefined$1(from2._strict)) {
    to2._strict = from2._strict;
  }
  if (!isUndefined$1(from2._tzm)) {
    to2._tzm = from2._tzm;
  }
  if (!isUndefined$1(from2._isUTC)) {
    to2._isUTC = from2._isUTC;
  }
  if (!isUndefined$1(from2._offset)) {
    to2._offset = from2._offset;
  }
  if (!isUndefined$1(from2._pf)) {
    to2._pf = getParsingFlags(from2);
  }
  if (!isUndefined$1(from2._locale)) {
    to2._locale = from2._locale;
  }
  if (momentPropertiesLen > 0) {
    for (i = 0; i < momentPropertiesLen; i++) {
      prop = momentProperties[i];
      val = from2[prop];
      if (!isUndefined$1(val)) {
        to2[prop] = val;
      }
    }
  }
  return to2;
}
function Moment(config) {
  copyConfig(this, config);
  this._d = new Date(config._d != null ? config._d.getTime() : NaN);
  if (!this.isValid()) {
    this._d = /* @__PURE__ */ new Date(NaN);
  }
  if (updateInProgress === false) {
    updateInProgress = true;
    hooks.updateOffset(this);
    updateInProgress = false;
  }
}
function isMoment(obj) {
  return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
}
function warn(msg) {
  if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) {
    console.warn("Deprecation warning: " + msg);
  }
}
function deprecate(msg, fn) {
  var firstTime = true;
  return extend$1(function() {
    if (hooks.deprecationHandler != null) {
      hooks.deprecationHandler(null, msg);
    }
    if (firstTime) {
      var args = [], arg, i, key, argLen = arguments.length;
      for (i = 0; i < argLen; i++) {
        arg = "";
        if (typeof arguments[i] === "object") {
          arg += "\n[" + i + "] ";
          for (key in arguments[0]) {
            if (hasOwnProp(arguments[0], key)) {
              arg += key + ": " + arguments[0][key] + ", ";
            }
          }
          arg = arg.slice(0, -2);
        } else {
          arg = arguments[i];
        }
        args.push(arg);
      }
      warn(
        msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack
      );
      firstTime = false;
    }
    return fn.apply(this, arguments);
  }, fn);
}
var deprecations = {};
function deprecateSimple(name, msg) {
  if (hooks.deprecationHandler != null) {
    hooks.deprecationHandler(name, msg);
  }
  if (!deprecations[name]) {
    warn(msg);
    deprecations[name] = true;
  }
}
hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;
function isFunction$1(input) {
  return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
}
function set(config) {
  var prop, i;
  for (i in config) {
    if (hasOwnProp(config, i)) {
      prop = config[i];
      if (isFunction$1(prop)) {
        this[i] = prop;
      } else {
        this["_" + i] = prop;
      }
    }
  }
  this._config = config;
  this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function mergeConfigs(parentConfig, childConfig) {
  var res = extend$1({}, parentConfig), prop;
  for (prop in childConfig) {
    if (hasOwnProp(childConfig, prop)) {
      if (isObject$1(parentConfig[prop]) && isObject$1(childConfig[prop])) {
        res[prop] = {};
        extend$1(res[prop], parentConfig[prop]);
        extend$1(res[prop], childConfig[prop]);
      } else if (childConfig[prop] != null) {
        res[prop] = childConfig[prop];
      } else {
        delete res[prop];
      }
    }
  }
  for (prop in parentConfig) {
    if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject$1(parentConfig[prop])) {
      res[prop] = extend$1({}, res[prop]);
    }
  }
  return res;
}
function Locale(config) {
  if (config != null) {
    this.set(config);
  }
}
var keys;
if (Object.keys) {
  keys = Object.keys;
} else {
  keys = function(obj) {
    var i, res = [];
    for (i in obj) {
      if (hasOwnProp(obj, i)) {
        res.push(i);
      }
    }
    return res;
  };
}
var defaultCalendar = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function calendar(key, mom, now2) {
  var output = this._calendar[key] || this._calendar["sameElse"];
  return isFunction$1(output) ? output.call(mom, now2) : output;
}
function zeroFill(number2, targetLength, forceSign) {
  var absNumber = "" + Math.abs(number2), zerosToFill = targetLength - absNumber.length, sign2 = number2 >= 0;
  return (sign2 ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}
var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
function addFormatToken(token2, padded, ordinal2, callback) {
  var func = callback;
  if (typeof callback === "string") {
    func = function() {
      return this[callback]();
    };
  }
  if (token2) {
    formatTokenFunctions[token2] = func;
  }
  if (padded) {
    formatTokenFunctions[padded[0]] = function() {
      return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
    };
  }
  if (ordinal2) {
    formatTokenFunctions[ordinal2] = function() {
      return this.localeData().ordinal(
        func.apply(this, arguments),
        token2
      );
    };
  }
}
function removeFormattingTokens(input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|\]$/g, "");
  }
  return input.replace(/\\/g, "");
}
function makeFormatFunction(format2) {
  var array = format2.match(formattingTokens), i, length;
  for (i = 0, length = array.length; i < length; i++) {
    if (formatTokenFunctions[array[i]]) {
      array[i] = formatTokenFunctions[array[i]];
    } else {
      array[i] = removeFormattingTokens(array[i]);
    }
  }
  return function(mom) {
    var output = "", i2;
    for (i2 = 0; i2 < length; i2++) {
      output += isFunction$1(array[i2]) ? array[i2].call(mom, format2) : array[i2];
    }
    return output;
  };
}
function formatMoment(m, format2) {
  if (!m.isValid()) {
    return m.localeData().invalidDate();
  }
  format2 = expandFormat(format2, m.localeData());
  formatFunctions[format2] = formatFunctions[format2] || makeFormatFunction(format2);
  return formatFunctions[format2](m);
}
function expandFormat(format2, locale2) {
  var i = 5;
  function replaceLongDateFormatTokens(input) {
    return locale2.longDateFormat(input) || input;
  }
  localFormattingTokens.lastIndex = 0;
  while (i >= 0 && localFormattingTokens.test(format2)) {
    format2 = format2.replace(
      localFormattingTokens,
      replaceLongDateFormatTokens
    );
    localFormattingTokens.lastIndex = 0;
    i -= 1;
  }
  return format2;
}
var defaultLongDateFormat = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function longDateFormat(key) {
  var format2 = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
  if (format2 || !formatUpper) {
    return format2;
  }
  this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
    if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") {
      return tok.slice(1);
    }
    return tok;
  }).join("");
  return this._longDateFormat[key];
}
var defaultInvalidDate = "Invalid date";
function invalidDate() {
  return this._invalidDate;
}
var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
function ordinal(number2) {
  return this._ordinal.replace("%d", number2);
}
var defaultRelativeTime = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function relativeTime(number2, withoutSuffix, string2, isFuture) {
  var output = this._relativeTime[string2];
  return isFunction$1(output) ? output(number2, withoutSuffix, string2, isFuture) : output.replace(/%d/i, number2);
}
function pastFuture(diff2, output) {
  var format2 = this._relativeTime[diff2 > 0 ? "future" : "past"];
  return isFunction$1(format2) ? format2(output) : format2.replace(/%s/i, output);
}
var aliases = {};
function addUnitAlias(unit, shorthand) {
  var lowerCase = unit.toLowerCase();
  aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
}
function normalizeUnits(units) {
  return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : void 0;
}
function normalizeObjectUnits(inputObject) {
  var normalizedInput = {}, normalizedProp, prop;
  for (prop in inputObject) {
    if (hasOwnProp(inputObject, prop)) {
      normalizedProp = normalizeUnits(prop);
      if (normalizedProp) {
        normalizedInput[normalizedProp] = inputObject[prop];
      }
    }
  }
  return normalizedInput;
}
var priorities = {};
function addUnitPriority(unit, priority) {
  priorities[unit] = priority;
}
function getPrioritizedUnits(unitsObj) {
  var units = [], u;
  for (u in unitsObj) {
    if (hasOwnProp(unitsObj, u)) {
      units.push({ unit: u, priority: priorities[u] });
    }
  }
  units.sort(function(a, b) {
    return a.priority - b.priority;
  });
  return units;
}
function isLeapYear(year) {
  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
function absFloor(number2) {
  if (number2 < 0) {
    return Math.ceil(number2) || 0;
  } else {
    return Math.floor(number2);
  }
}
function toInt(argumentForCoercion) {
  var coercedNumber = +argumentForCoercion, value = 0;
  if (coercedNumber !== 0 && isFinite(coercedNumber)) {
    value = absFloor(coercedNumber);
  }
  return value;
}
function makeGetSet(unit, keepTime) {
  return function(value) {
    if (value != null) {
      set$1(this, unit, value);
      hooks.updateOffset(this, keepTime);
      return this;
    } else {
      return get(this, unit);
    }
  };
}
function get(mom, unit) {
  return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
}
function set$1(mom, unit, value) {
  if (mom.isValid() && !isNaN(value)) {
    if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
      value = toInt(value);
      mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](
        value,
        mom.month(),
        daysInMonth(value, mom.month())
      );
    } else {
      mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
    }
  }
}
function stringGet(units) {
  units = normalizeUnits(units);
  if (isFunction$1(this[units])) {
    return this[units]();
  }
  return this;
}
function stringSet(units, value) {
  if (typeof units === "object") {
    units = normalizeObjectUnits(units);
    var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
    for (i = 0; i < prioritizedLen; i++) {
      this[prioritized[i].unit](units[prioritized[i].unit]);
    }
  } else {
    units = normalizeUnits(units);
    if (isFunction$1(this[units])) {
      return this[units](value);
    }
  }
  return this;
}
var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
regexes = {};
function addRegexToken(token2, regex, strictRegex) {
  regexes[token2] = isFunction$1(regex) ? regex : function(isStrict, localeData2) {
    return isStrict && strictRegex ? strictRegex : regex;
  };
}
function getParseRegexForToken(token2, config) {
  if (!hasOwnProp(regexes, token2)) {
    return new RegExp(unescapeFormat(token2));
  }
  return regexes[token2](config._strict, config._locale);
}
function unescapeFormat(s) {
  return regexEscape(
    s.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
      }
    )
  );
}
function regexEscape(s) {
  return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var tokens = {};
function addParseToken(token2, callback) {
  var i, func = callback, tokenLen;
  if (typeof token2 === "string") {
    token2 = [token2];
  }
  if (isNumber$1(callback)) {
    func = function(input, array) {
      array[callback] = toInt(input);
    };
  }
  tokenLen = token2.length;
  for (i = 0; i < tokenLen; i++) {
    tokens[token2[i]] = func;
  }
}
function addWeekParseToken(token2, callback) {
  addParseToken(token2, function(input, array, config, token3) {
    config._w = config._w || {};
    callback(input, config._w, config, token3);
  });
}
function addTimeToArrayFromToken(token2, input, config) {
  if (input != null && hasOwnProp(tokens, token2)) {
    tokens[token2](input, config._a, config, token2);
  }
}
var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
function mod(n, x) {
  return (n % x + x) % x;
}
var indexOf;
if (Array.prototype.indexOf) {
  indexOf = Array.prototype.indexOf;
} else {
  indexOf = function(o) {
    var i;
    for (i = 0; i < this.length; ++i) {
      if (this[i] === o) {
        return i;
      }
    }
    return -1;
  };
}
function daysInMonth(year, month) {
  if (isNaN(year) || isNaN(month)) {
    return NaN;
  }
  var modMonth = mod(month, 12);
  year += (month - modMonth) / 12;
  return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
}
addFormatToken("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
addFormatToken("MMM", 0, 0, function(format2) {
  return this.localeData().monthsShort(this, format2);
});
addFormatToken("MMMM", 0, 0, function(format2) {
  return this.localeData().months(this, format2);
});
addUnitAlias("month", "M");
addUnitPriority("month", 8);
addRegexToken("M", match1to2);
addRegexToken("MM", match1to2, match2);
addRegexToken("MMM", function(isStrict, locale2) {
  return locale2.monthsShortRegex(isStrict);
});
addRegexToken("MMMM", function(isStrict, locale2) {
  return locale2.monthsRegex(isStrict);
});
addParseToken(["M", "MM"], function(input, array) {
  array[MONTH] = toInt(input) - 1;
});
addParseToken(["MMM", "MMMM"], function(input, array, config, token2) {
  var month = config._locale.monthsParse(input, token2, config._strict);
  if (month != null) {
    array[MONTH] = month;
  } else {
    getParsingFlags(config).invalidMonth = input;
  }
});
var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
function localeMonths(m, format2) {
  if (!m) {
    return isArray$1(this._months) ? this._months : this._months["standalone"];
  }
  return isArray$1(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format2) ? "format" : "standalone"][m.month()];
}
function localeMonthsShort(m, format2) {
  if (!m) {
    return isArray$1(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
  }
  return isArray$1(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format2) ? "format" : "standalone"][m.month()];
}
function handleStrictParse(monthName, format2, strict) {
  var i, ii, mom, llc = monthName.toLocaleLowerCase();
  if (!this._monthsParse) {
    this._monthsParse = [];
    this._longMonthsParse = [];
    this._shortMonthsParse = [];
    for (i = 0; i < 12; ++i) {
      mom = createUTC([2e3, i]);
      this._shortMonthsParse[i] = this.monthsShort(
        mom,
        ""
      ).toLocaleLowerCase();
      this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
    }
  }
  if (strict) {
    if (format2 === "MMM") {
      ii = indexOf.call(this._shortMonthsParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._longMonthsParse, llc);
      return ii !== -1 ? ii : null;
    }
  } else {
    if (format2 === "MMM") {
      ii = indexOf.call(this._shortMonthsParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._longMonthsParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._longMonthsParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortMonthsParse, llc);
      return ii !== -1 ? ii : null;
    }
  }
}
function localeMonthsParse(monthName, format2, strict) {
  var i, mom, regex;
  if (this._monthsParseExact) {
    return handleStrictParse.call(this, monthName, format2, strict);
  }
  if (!this._monthsParse) {
    this._monthsParse = [];
    this._longMonthsParse = [];
    this._shortMonthsParse = [];
  }
  for (i = 0; i < 12; i++) {
    mom = createUTC([2e3, i]);
    if (strict && !this._longMonthsParse[i]) {
      this._longMonthsParse[i] = new RegExp(
        "^" + this.months(mom, "").replace(".", "") + "$",
        "i"
      );
      this._shortMonthsParse[i] = new RegExp(
        "^" + this.monthsShort(mom, "").replace(".", "") + "$",
        "i"
      );
    }
    if (!strict && !this._monthsParse[i]) {
      regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
      this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
    }
    if (strict && format2 === "MMMM" && this._longMonthsParse[i].test(monthName)) {
      return i;
    } else if (strict && format2 === "MMM" && this._shortMonthsParse[i].test(monthName)) {
      return i;
    } else if (!strict && this._monthsParse[i].test(monthName)) {
      return i;
    }
  }
}
function setMonth(mom, value) {
  var dayOfMonth;
  if (!mom.isValid()) {
    return mom;
  }
  if (typeof value === "string") {
    if (/^\d+$/.test(value)) {
      value = toInt(value);
    } else {
      value = mom.localeData().monthsParse(value);
      if (!isNumber$1(value)) {
        return mom;
      }
    }
  }
  dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
  mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
  return mom;
}
function getSetMonth(value) {
  if (value != null) {
    setMonth(this, value);
    hooks.updateOffset(this, true);
    return this;
  } else {
    return get(this, "Month");
  }
}
function getDaysInMonth() {
  return daysInMonth(this.year(), this.month());
}
function monthsShortRegex(isStrict) {
  if (this._monthsParseExact) {
    if (!hasOwnProp(this, "_monthsRegex")) {
      computeMonthsParse.call(this);
    }
    if (isStrict) {
      return this._monthsShortStrictRegex;
    } else {
      return this._monthsShortRegex;
    }
  } else {
    if (!hasOwnProp(this, "_monthsShortRegex")) {
      this._monthsShortRegex = defaultMonthsShortRegex;
    }
    return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
  }
}
function monthsRegex(isStrict) {
  if (this._monthsParseExact) {
    if (!hasOwnProp(this, "_monthsRegex")) {
      computeMonthsParse.call(this);
    }
    if (isStrict) {
      return this._monthsStrictRegex;
    } else {
      return this._monthsRegex;
    }
  } else {
    if (!hasOwnProp(this, "_monthsRegex")) {
      this._monthsRegex = defaultMonthsRegex;
    }
    return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
  }
}
function computeMonthsParse() {
  function cmpLenRev(a, b) {
    return b.length - a.length;
  }
  var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
  for (i = 0; i < 12; i++) {
    mom = createUTC([2e3, i]);
    shortPieces.push(this.monthsShort(mom, ""));
    longPieces.push(this.months(mom, ""));
    mixedPieces.push(this.months(mom, ""));
    mixedPieces.push(this.monthsShort(mom, ""));
  }
  shortPieces.sort(cmpLenRev);
  longPieces.sort(cmpLenRev);
  mixedPieces.sort(cmpLenRev);
  for (i = 0; i < 12; i++) {
    shortPieces[i] = regexEscape(shortPieces[i]);
    longPieces[i] = regexEscape(longPieces[i]);
  }
  for (i = 0; i < 24; i++) {
    mixedPieces[i] = regexEscape(mixedPieces[i]);
  }
  this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._monthsShortRegex = this._monthsRegex;
  this._monthsStrictRegex = new RegExp(
    "^(" + longPieces.join("|") + ")",
    "i"
  );
  this._monthsShortStrictRegex = new RegExp(
    "^(" + shortPieces.join("|") + ")",
    "i"
  );
}
addFormatToken("Y", 0, 0, function() {
  var y = this.year();
  return y <= 9999 ? zeroFill(y, 4) : "+" + y;
});
addFormatToken(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
addFormatToken(0, ["YYYY", 4], 0, "year");
addFormatToken(0, ["YYYYY", 5], 0, "year");
addFormatToken(0, ["YYYYYY", 6, true], 0, "year");
addUnitAlias("year", "y");
addUnitPriority("year", 1);
addRegexToken("Y", matchSigned);
addRegexToken("YY", match1to2, match2);
addRegexToken("YYYY", match1to4, match4);
addRegexToken("YYYYY", match1to6, match6);
addRegexToken("YYYYYY", match1to6, match6);
addParseToken(["YYYYY", "YYYYYY"], YEAR);
addParseToken("YYYY", function(input, array) {
  array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken("YY", function(input, array) {
  array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken("Y", function(input, array) {
  array[YEAR] = parseInt(input, 10);
});
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
hooks.parseTwoDigitYear = function(input) {
  return toInt(input) + (toInt(input) > 68 ? 1900 : 2e3);
};
var getSetYear = makeGetSet("FullYear", true);
function getIsLeapYear() {
  return isLeapYear(this.year());
}
function createDate(y, m, d, h, M, s, ms) {
  var date;
  if (y < 100 && y >= 0) {
    date = new Date(y + 400, m, d, h, M, s, ms);
    if (isFinite(date.getFullYear())) {
      date.setFullYear(y);
    }
  } else {
    date = new Date(y, m, d, h, M, s, ms);
  }
  return date;
}
function createUTCDate(y) {
  var date, args;
  if (y < 100 && y >= 0) {
    args = Array.prototype.slice.call(arguments);
    args[0] = y + 400;
    date = new Date(Date.UTC.apply(null, args));
    if (isFinite(date.getUTCFullYear())) {
      date.setUTCFullYear(y);
    }
  } else {
    date = new Date(Date.UTC.apply(null, arguments));
  }
  return date;
}
function firstWeekOffset(year, dow, doy) {
  var fwd = 7 + dow - doy, fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
  return -fwdlw + fwd - 1;
}
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
  var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
  if (dayOfYear <= 0) {
    resYear = year - 1;
    resDayOfYear = daysInYear(resYear) + dayOfYear;
  } else if (dayOfYear > daysInYear(year)) {
    resYear = year + 1;
    resDayOfYear = dayOfYear - daysInYear(year);
  } else {
    resYear = year;
    resDayOfYear = dayOfYear;
  }
  return {
    year: resYear,
    dayOfYear: resDayOfYear
  };
}
function weekOfYear(mom, dow, doy) {
  var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
  if (week < 1) {
    resYear = mom.year() - 1;
    resWeek = week + weeksInYear(resYear, dow, doy);
  } else if (week > weeksInYear(mom.year(), dow, doy)) {
    resWeek = week - weeksInYear(mom.year(), dow, doy);
    resYear = mom.year() + 1;
  } else {
    resYear = mom.year();
    resWeek = week;
  }
  return {
    week: resWeek,
    year: resYear
  };
}
function weeksInYear(year, dow, doy) {
  var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
  return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}
addFormatToken("w", ["ww", 2], "wo", "week");
addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
addUnitAlias("week", "w");
addUnitAlias("isoWeek", "W");
addUnitPriority("week", 5);
addUnitPriority("isoWeek", 5);
addRegexToken("w", match1to2);
addRegexToken("ww", match1to2, match2);
addRegexToken("W", match1to2);
addRegexToken("WW", match1to2, match2);
addWeekParseToken(
  ["w", "ww", "W", "WW"],
  function(input, week, config, token2) {
    week[token2.substr(0, 1)] = toInt(input);
  }
);
function localeWeek(mom) {
  return weekOfYear(mom, this._week.dow, this._week.doy).week;
}
var defaultLocaleWeek = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function localeFirstDayOfWeek() {
  return this._week.dow;
}
function localeFirstDayOfYear() {
  return this._week.doy;
}
function getSetWeek(input) {
  var week = this.localeData().week(this);
  return input == null ? week : this.add((input - week) * 7, "d");
}
function getSetISOWeek(input) {
  var week = weekOfYear(this, 1, 4).week;
  return input == null ? week : this.add((input - week) * 7, "d");
}
addFormatToken("d", 0, "do", "day");
addFormatToken("dd", 0, 0, function(format2) {
  return this.localeData().weekdaysMin(this, format2);
});
addFormatToken("ddd", 0, 0, function(format2) {
  return this.localeData().weekdaysShort(this, format2);
});
addFormatToken("dddd", 0, 0, function(format2) {
  return this.localeData().weekdays(this, format2);
});
addFormatToken("e", 0, 0, "weekday");
addFormatToken("E", 0, 0, "isoWeekday");
addUnitAlias("day", "d");
addUnitAlias("weekday", "e");
addUnitAlias("isoWeekday", "E");
addUnitPriority("day", 11);
addUnitPriority("weekday", 11);
addUnitPriority("isoWeekday", 11);
addRegexToken("d", match1to2);
addRegexToken("e", match1to2);
addRegexToken("E", match1to2);
addRegexToken("dd", function(isStrict, locale2) {
  return locale2.weekdaysMinRegex(isStrict);
});
addRegexToken("ddd", function(isStrict, locale2) {
  return locale2.weekdaysShortRegex(isStrict);
});
addRegexToken("dddd", function(isStrict, locale2) {
  return locale2.weekdaysRegex(isStrict);
});
addWeekParseToken(["dd", "ddd", "dddd"], function(input, week, config, token2) {
  var weekday = config._locale.weekdaysParse(input, token2, config._strict);
  if (weekday != null) {
    week.d = weekday;
  } else {
    getParsingFlags(config).invalidWeekday = input;
  }
});
addWeekParseToken(["d", "e", "E"], function(input, week, config, token2) {
  week[token2] = toInt(input);
});
function parseWeekday(input, locale2) {
  if (typeof input !== "string") {
    return input;
  }
  if (!isNaN(input)) {
    return parseInt(input, 10);
  }
  input = locale2.weekdaysParse(input);
  if (typeof input === "number") {
    return input;
  }
  return null;
}
function parseIsoWeekday(input, locale2) {
  if (typeof input === "string") {
    return locale2.weekdaysParse(input) % 7 || 7;
  }
  return isNaN(input) ? null : input;
}
function shiftWeekdays(ws, n) {
  return ws.slice(n, 7).concat(ws.slice(0, n));
}
var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
function localeWeekdays(m, format2) {
  var weekdays = isArray$1(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format2) ? "format" : "standalone"];
  return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
}
function localeWeekdaysShort(m) {
  return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}
function localeWeekdaysMin(m) {
  return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}
function handleStrictParse$1(weekdayName, format2, strict) {
  var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
  if (!this._weekdaysParse) {
    this._weekdaysParse = [];
    this._shortWeekdaysParse = [];
    this._minWeekdaysParse = [];
    for (i = 0; i < 7; ++i) {
      mom = createUTC([2e3, 1]).day(i);
      this._minWeekdaysParse[i] = this.weekdaysMin(
        mom,
        ""
      ).toLocaleLowerCase();
      this._shortWeekdaysParse[i] = this.weekdaysShort(
        mom,
        ""
      ).toLocaleLowerCase();
      this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
    }
  }
  if (strict) {
    if (format2 === "dddd") {
      ii = indexOf.call(this._weekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else if (format2 === "ddd") {
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    }
  } else {
    if (format2 === "dddd") {
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else if (format2 === "ddd") {
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._minWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    } else {
      ii = indexOf.call(this._minWeekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._weekdaysParse, llc);
      if (ii !== -1) {
        return ii;
      }
      ii = indexOf.call(this._shortWeekdaysParse, llc);
      return ii !== -1 ? ii : null;
    }
  }
}
function localeWeekdaysParse(weekdayName, format2, strict) {
  var i, mom, regex;
  if (this._weekdaysParseExact) {
    return handleStrictParse$1.call(this, weekdayName, format2, strict);
  }
  if (!this._weekdaysParse) {
    this._weekdaysParse = [];
    this._minWeekdaysParse = [];
    this._shortWeekdaysParse = [];
    this._fullWeekdaysParse = [];
  }
  for (i = 0; i < 7; i++) {
    mom = createUTC([2e3, 1]).day(i);
    if (strict && !this._fullWeekdaysParse[i]) {
      this._fullWeekdaysParse[i] = new RegExp(
        "^" + this.weekdays(mom, "").replace(".", "\\.?") + "$",
        "i"
      );
      this._shortWeekdaysParse[i] = new RegExp(
        "^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$",
        "i"
      );
      this._minWeekdaysParse[i] = new RegExp(
        "^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$",
        "i"
      );
    }
    if (!this._weekdaysParse[i]) {
      regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
      this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
    }
    if (strict && format2 === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) {
      return i;
    } else if (strict && format2 === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) {
      return i;
    } else if (strict && format2 === "dd" && this._minWeekdaysParse[i].test(weekdayName)) {
      return i;
    } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
      return i;
    }
  }
}
function getSetDayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  if (input != null) {
    input = parseWeekday(input, this.localeData());
    return this.add(input - day, "d");
  } else {
    return day;
  }
}
function getSetLocaleDayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return input == null ? weekday : this.add(input - weekday, "d");
}
function getSetISODayOfWeek(input) {
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  if (input != null) {
    var weekday = parseIsoWeekday(input, this.localeData());
    return this.day(this.day() % 7 ? weekday : weekday - 7);
  } else {
    return this.day() || 7;
  }
}
function weekdaysRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysStrictRegex;
    } else {
      return this._weekdaysRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      this._weekdaysRegex = defaultWeekdaysRegex;
    }
    return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
  }
}
function weekdaysShortRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysShortStrictRegex;
    } else {
      return this._weekdaysShortRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysShortRegex")) {
      this._weekdaysShortRegex = defaultWeekdaysShortRegex;
    }
    return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
  }
}
function weekdaysMinRegex(isStrict) {
  if (this._weekdaysParseExact) {
    if (!hasOwnProp(this, "_weekdaysRegex")) {
      computeWeekdaysParse.call(this);
    }
    if (isStrict) {
      return this._weekdaysMinStrictRegex;
    } else {
      return this._weekdaysMinRegex;
    }
  } else {
    if (!hasOwnProp(this, "_weekdaysMinRegex")) {
      this._weekdaysMinRegex = defaultWeekdaysMinRegex;
    }
    return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
  }
}
function computeWeekdaysParse() {
  function cmpLenRev(a, b) {
    return b.length - a.length;
  }
  var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
  for (i = 0; i < 7; i++) {
    mom = createUTC([2e3, 1]).day(i);
    minp = regexEscape(this.weekdaysMin(mom, ""));
    shortp = regexEscape(this.weekdaysShort(mom, ""));
    longp = regexEscape(this.weekdays(mom, ""));
    minPieces.push(minp);
    shortPieces.push(shortp);
    longPieces.push(longp);
    mixedPieces.push(minp);
    mixedPieces.push(shortp);
    mixedPieces.push(longp);
  }
  minPieces.sort(cmpLenRev);
  shortPieces.sort(cmpLenRev);
  longPieces.sort(cmpLenRev);
  mixedPieces.sort(cmpLenRev);
  this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._weekdaysShortRegex = this._weekdaysRegex;
  this._weekdaysMinRegex = this._weekdaysRegex;
  this._weekdaysStrictRegex = new RegExp(
    "^(" + longPieces.join("|") + ")",
    "i"
  );
  this._weekdaysShortStrictRegex = new RegExp(
    "^(" + shortPieces.join("|") + ")",
    "i"
  );
  this._weekdaysMinStrictRegex = new RegExp(
    "^(" + minPieces.join("|") + ")",
    "i"
  );
}
function hFormat() {
  return this.hours() % 12 || 12;
}
function kFormat() {
  return this.hours() || 24;
}
addFormatToken("H", ["HH", 2], 0, "hour");
addFormatToken("h", ["hh", 2], 0, hFormat);
addFormatToken("k", ["kk", 2], 0, kFormat);
addFormatToken("hmm", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});
addFormatToken("hmmss", 0, 0, function() {
  return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
addFormatToken("Hmm", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2);
});
addFormatToken("Hmmss", 0, 0, function() {
  return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
});
function meridiem(token2, lowercase) {
  addFormatToken(token2, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      lowercase
    );
  });
}
meridiem("a", true);
meridiem("A", false);
addUnitAlias("hour", "h");
addUnitPriority("hour", 13);
function matchMeridiem(isStrict, locale2) {
  return locale2._meridiemParse;
}
addRegexToken("a", matchMeridiem);
addRegexToken("A", matchMeridiem);
addRegexToken("H", match1to2);
addRegexToken("h", match1to2);
addRegexToken("k", match1to2);
addRegexToken("HH", match1to2, match2);
addRegexToken("hh", match1to2, match2);
addRegexToken("kk", match1to2, match2);
addRegexToken("hmm", match3to4);
addRegexToken("hmmss", match5to6);
addRegexToken("Hmm", match3to4);
addRegexToken("Hmmss", match5to6);
addParseToken(["H", "HH"], HOUR);
addParseToken(["k", "kk"], function(input, array, config) {
  var kInput = toInt(input);
  array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(["a", "A"], function(input, array, config) {
  config._isPm = config._locale.isPM(input);
  config._meridiem = input;
});
addParseToken(["h", "hh"], function(input, array, config) {
  array[HOUR] = toInt(input);
  getParsingFlags(config).bigHour = true;
});
addParseToken("hmm", function(input, array, config) {
  var pos = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos));
  array[MINUTE] = toInt(input.substr(pos));
  getParsingFlags(config).bigHour = true;
});
addParseToken("hmmss", function(input, array, config) {
  var pos1 = input.length - 4, pos2 = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos1));
  array[MINUTE] = toInt(input.substr(pos1, 2));
  array[SECOND] = toInt(input.substr(pos2));
  getParsingFlags(config).bigHour = true;
});
addParseToken("Hmm", function(input, array, config) {
  var pos = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos));
  array[MINUTE] = toInt(input.substr(pos));
});
addParseToken("Hmmss", function(input, array, config) {
  var pos1 = input.length - 4, pos2 = input.length - 2;
  array[HOUR] = toInt(input.substr(0, pos1));
  array[MINUTE] = toInt(input.substr(pos1, 2));
  array[SECOND] = toInt(input.substr(pos2));
});
function localeIsPM(input) {
  return (input + "").toLowerCase().charAt(0) === "p";
}
var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet("Hours", true);
function localeMeridiem(hours2, minutes2, isLower) {
  if (hours2 > 11) {
    return isLower ? "pm" : "PM";
  } else {
    return isLower ? "am" : "AM";
  }
}
var baseConfig = {
  calendar: defaultCalendar,
  longDateFormat: defaultLongDateFormat,
  invalidDate: defaultInvalidDate,
  ordinal: defaultOrdinal,
  dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
  relativeTime: defaultRelativeTime,
  months: defaultLocaleMonths,
  monthsShort: defaultLocaleMonthsShort,
  week: defaultLocaleWeek,
  weekdays: defaultLocaleWeekdays,
  weekdaysMin: defaultLocaleWeekdaysMin,
  weekdaysShort: defaultLocaleWeekdaysShort,
  meridiemParse: defaultLocaleMeridiemParse
};
var locales = {}, localeFamilies = {}, globalLocale;
function commonPrefix(arr1, arr2) {
  var i, minl = Math.min(arr1.length, arr2.length);
  for (i = 0; i < minl; i += 1) {
    if (arr1[i] !== arr2[i]) {
      return i;
    }
  }
  return minl;
}
function normalizeLocale(key) {
  return key ? key.toLowerCase().replace("_", "-") : key;
}
function chooseLocale(names) {
  var i = 0, j, next, locale2, split;
  while (i < names.length) {
    split = normalizeLocale(names[i]).split("-");
    j = split.length;
    next = normalizeLocale(names[i + 1]);
    next = next ? next.split("-") : null;
    while (j > 0) {
      locale2 = loadLocale(split.slice(0, j).join("-"));
      if (locale2) {
        return locale2;
      }
      if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
        break;
      }
      j--;
    }
    i++;
  }
  return globalLocale;
}
function isLocaleNameSane(name) {
  return name.match("^[^/\\\\]*$") != null;
}
function loadLocale(name) {
  var oldLocale = null, aliasedRequire;
  if (locales[name] === void 0 && typeof module !== "undefined" && module && module.exports && isLocaleNameSane(name)) {
    try {
      oldLocale = globalLocale._abbr;
      aliasedRequire = require;
      aliasedRequire("./locale/" + name);
      getSetGlobalLocale(oldLocale);
    } catch (e) {
      locales[name] = null;
    }
  }
  return locales[name];
}
function getSetGlobalLocale(key, values) {
  var data;
  if (key) {
    if (isUndefined$1(values)) {
      data = getLocale(key);
    } else {
      data = defineLocale(key, values);
    }
    if (data) {
      globalLocale = data;
    } else {
      if (typeof console !== "undefined" && console.warn) {
        console.warn(
          "Locale " + key + " not found. Did you forget to load it?"
        );
      }
    }
  }
  return globalLocale._abbr;
}
function defineLocale(name, config) {
  if (config !== null) {
    var locale2, parentConfig = baseConfig;
    config.abbr = name;
    if (locales[name] != null) {
      deprecateSimple(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      );
      parentConfig = locales[name]._config;
    } else if (config.parentLocale != null) {
      if (locales[config.parentLocale] != null) {
        parentConfig = locales[config.parentLocale]._config;
      } else {
        locale2 = loadLocale(config.parentLocale);
        if (locale2 != null) {
          parentConfig = locale2._config;
        } else {
          if (!localeFamilies[config.parentLocale]) {
            localeFamilies[config.parentLocale] = [];
          }
          localeFamilies[config.parentLocale].push({
            name,
            config
          });
          return null;
        }
      }
    }
    locales[name] = new Locale(mergeConfigs(parentConfig, config));
    if (localeFamilies[name]) {
      localeFamilies[name].forEach(function(x) {
        defineLocale(x.name, x.config);
      });
    }
    getSetGlobalLocale(name);
    return locales[name];
  } else {
    delete locales[name];
    return null;
  }
}
function updateLocale(name, config) {
  if (config != null) {
    var locale2, tmpLocale, parentConfig = baseConfig;
    if (locales[name] != null && locales[name].parentLocale != null) {
      locales[name].set(mergeConfigs(locales[name]._config, config));
    } else {
      tmpLocale = loadLocale(name);
      if (tmpLocale != null) {
        parentConfig = tmpLocale._config;
      }
      config = mergeConfigs(parentConfig, config);
      if (tmpLocale == null) {
        config.abbr = name;
      }
      locale2 = new Locale(config);
      locale2.parentLocale = locales[name];
      locales[name] = locale2;
    }
    getSetGlobalLocale(name);
  } else {
    if (locales[name] != null) {
      if (locales[name].parentLocale != null) {
        locales[name] = locales[name].parentLocale;
        if (name === getSetGlobalLocale()) {
          getSetGlobalLocale(name);
        }
      } else if (locales[name] != null) {
        delete locales[name];
      }
    }
  }
  return locales[name];
}
function getLocale(key) {
  var locale2;
  if (key && key._locale && key._locale._abbr) {
    key = key._locale._abbr;
  }
  if (!key) {
    return globalLocale;
  }
  if (!isArray$1(key)) {
    locale2 = loadLocale(key);
    if (locale2) {
      return locale2;
    }
    key = [key];
  }
  return chooseLocale(key);
}
function listLocales() {
  return keys(locales);
}
function checkOverflow(m) {
  var overflow, a = m._a;
  if (a && getParsingFlags(m).overflow === -2) {
    overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
    if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
      overflow = DATE;
    }
    if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
      overflow = WEEK;
    }
    if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
      overflow = WEEKDAY;
    }
    getParsingFlags(m).overflow = overflow;
  }
  return m;
}
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, false],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, false],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, false],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, false],
  ["YYYY", /\d{4}/, false]
], isoTimes = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function configFromISO(config) {
  var i, l, string2 = config._i, match5 = extendedIsoRegex.exec(string2) || basicIsoRegex.exec(string2), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
  if (match5) {
    getParsingFlags(config).iso = true;
    for (i = 0, l = isoDatesLen; i < l; i++) {
      if (isoDates[i][1].exec(match5[1])) {
        dateFormat = isoDates[i][0];
        allowTime = isoDates[i][2] !== false;
        break;
      }
    }
    if (dateFormat == null) {
      config._isValid = false;
      return;
    }
    if (match5[3]) {
      for (i = 0, l = isoTimesLen; i < l; i++) {
        if (isoTimes[i][1].exec(match5[3])) {
          timeFormat = (match5[2] || " ") + isoTimes[i][0];
          break;
        }
      }
      if (timeFormat == null) {
        config._isValid = false;
        return;
      }
    }
    if (!allowTime && timeFormat != null) {
      config._isValid = false;
      return;
    }
    if (match5[4]) {
      if (tzRegex.exec(match5[4])) {
        tzFormat = "Z";
      } else {
        config._isValid = false;
        return;
      }
    }
    config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
    configFromStringAndFormat(config);
  } else {
    config._isValid = false;
  }
}
function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  var result2 = [
    untruncateYear(yearStr),
    defaultLocaleMonthsShort.indexOf(monthStr),
    parseInt(dayStr, 10),
    parseInt(hourStr, 10),
    parseInt(minuteStr, 10)
  ];
  if (secondStr) {
    result2.push(parseInt(secondStr, 10));
  }
  return result2;
}
function untruncateYear(yearStr) {
  var year = parseInt(yearStr, 10);
  if (year <= 49) {
    return 2e3 + year;
  } else if (year <= 999) {
    return 1900 + year;
  }
  return year;
}
function preprocessRFC2822(s) {
  return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function checkWeekday(weekdayStr, parsedInput, config) {
  if (weekdayStr) {
    var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(
      parsedInput[0],
      parsedInput[1],
      parsedInput[2]
    ).getDay();
    if (weekdayProvided !== weekdayActual) {
      getParsingFlags(config).weekdayMismatch = true;
      config._isValid = false;
      return false;
    }
  }
  return true;
}
function calculateOffset(obsOffset, militaryOffset, numOffset) {
  if (obsOffset) {
    return obsOffsets[obsOffset];
  } else if (militaryOffset) {
    return 0;
  } else {
    var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
    return h * 60 + m;
  }
}
function configFromRFC2822(config) {
  var match5 = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
  if (match5) {
    parsedArray = extractFromRFC2822Strings(
      match5[4],
      match5[3],
      match5[2],
      match5[5],
      match5[6],
      match5[7]
    );
    if (!checkWeekday(match5[1], parsedArray, config)) {
      return;
    }
    config._a = parsedArray;
    config._tzm = calculateOffset(match5[8], match5[9], match5[10]);
    config._d = createUTCDate.apply(null, config._a);
    config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    getParsingFlags(config).rfc2822 = true;
  } else {
    config._isValid = false;
  }
}
function configFromString(config) {
  var matched = aspNetJsonRegex.exec(config._i);
  if (matched !== null) {
    config._d = /* @__PURE__ */ new Date(+matched[1]);
    return;
  }
  configFromISO(config);
  if (config._isValid === false) {
    delete config._isValid;
  } else {
    return;
  }
  configFromRFC2822(config);
  if (config._isValid === false) {
    delete config._isValid;
  } else {
    return;
  }
  if (config._strict) {
    config._isValid = false;
  } else {
    hooks.createFromInputFallback(config);
  }
}
hooks.createFromInputFallback = deprecate(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(config) {
    config._d = /* @__PURE__ */ new Date(config._i + (config._useUTC ? " UTC" : ""));
  }
);
function defaults$2(a, b, c) {
  if (a != null) {
    return a;
  }
  if (b != null) {
    return b;
  }
  return c;
}
function currentDateArray(config) {
  var nowValue = new Date(hooks.now());
  if (config._useUTC) {
    return [
      nowValue.getUTCFullYear(),
      nowValue.getUTCMonth(),
      nowValue.getUTCDate()
    ];
  }
  return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}
function configFromArray(config) {
  var i, date, input = [], currentDate, expectedWeekday, yearToUse;
  if (config._d) {
    return;
  }
  currentDate = currentDateArray(config);
  if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
    dayOfYearFromWeekInfo(config);
  }
  if (config._dayOfYear != null) {
    yearToUse = defaults$2(config._a[YEAR], currentDate[YEAR]);
    if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
      getParsingFlags(config)._overflowDayOfYear = true;
    }
    date = createUTCDate(yearToUse, 0, config._dayOfYear);
    config._a[MONTH] = date.getUTCMonth();
    config._a[DATE] = date.getUTCDate();
  }
  for (i = 0; i < 3 && config._a[i] == null; ++i) {
    config._a[i] = input[i] = currentDate[i];
  }
  for (; i < 7; i++) {
    config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
  }
  if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
    config._nextDay = true;
    config._a[HOUR] = 0;
  }
  config._d = (config._useUTC ? createUTCDate : createDate).apply(
    null,
    input
  );
  expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
  if (config._tzm != null) {
    config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
  }
  if (config._nextDay) {
    config._a[HOUR] = 24;
  }
  if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) {
    getParsingFlags(config).weekdayMismatch = true;
  }
}
function dayOfYearFromWeekInfo(config) {
  var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
  w = config._w;
  if (w.GG != null || w.W != null || w.E != null) {
    dow = 1;
    doy = 4;
    weekYear = defaults$2(
      w.GG,
      config._a[YEAR],
      weekOfYear(createLocal(), 1, 4).year
    );
    week = defaults$2(w.W, 1);
    weekday = defaults$2(w.E, 1);
    if (weekday < 1 || weekday > 7) {
      weekdayOverflow = true;
    }
  } else {
    dow = config._locale._week.dow;
    doy = config._locale._week.doy;
    curWeek = weekOfYear(createLocal(), dow, doy);
    weekYear = defaults$2(w.gg, config._a[YEAR], curWeek.year);
    week = defaults$2(w.w, curWeek.week);
    if (w.d != null) {
      weekday = w.d;
      if (weekday < 0 || weekday > 6) {
        weekdayOverflow = true;
      }
    } else if (w.e != null) {
      weekday = w.e + dow;
      if (w.e < 0 || w.e > 6) {
        weekdayOverflow = true;
      }
    } else {
      weekday = dow;
    }
  }
  if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
    getParsingFlags(config)._overflowWeeks = true;
  } else if (weekdayOverflow != null) {
    getParsingFlags(config)._overflowWeekday = true;
  } else {
    temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
    config._a[YEAR] = temp.year;
    config._dayOfYear = temp.dayOfYear;
  }
}
hooks.ISO_8601 = function() {
};
hooks.RFC_2822 = function() {
};
function configFromStringAndFormat(config) {
  if (config._f === hooks.ISO_8601) {
    configFromISO(config);
    return;
  }
  if (config._f === hooks.RFC_2822) {
    configFromRFC2822(config);
    return;
  }
  config._a = [];
  getParsingFlags(config).empty = true;
  var string2 = "" + config._i, i, parsedInput, tokens2, token2, skipped, stringLength = string2.length, totalParsedInputLength = 0, era, tokenLen;
  tokens2 = expandFormat(config._f, config._locale).match(formattingTokens) || [];
  tokenLen = tokens2.length;
  for (i = 0; i < tokenLen; i++) {
    token2 = tokens2[i];
    parsedInput = (string2.match(getParseRegexForToken(token2, config)) || [])[0];
    if (parsedInput) {
      skipped = string2.substr(0, string2.indexOf(parsedInput));
      if (skipped.length > 0) {
        getParsingFlags(config).unusedInput.push(skipped);
      }
      string2 = string2.slice(
        string2.indexOf(parsedInput) + parsedInput.length
      );
      totalParsedInputLength += parsedInput.length;
    }
    if (formatTokenFunctions[token2]) {
      if (parsedInput) {
        getParsingFlags(config).empty = false;
      } else {
        getParsingFlags(config).unusedTokens.push(token2);
      }
      addTimeToArrayFromToken(token2, parsedInput, config);
    } else if (config._strict && !parsedInput) {
      getParsingFlags(config).unusedTokens.push(token2);
    }
  }
  getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
  if (string2.length > 0) {
    getParsingFlags(config).unusedInput.push(string2);
  }
  if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
    getParsingFlags(config).bigHour = void 0;
  }
  getParsingFlags(config).parsedDateParts = config._a.slice(0);
  getParsingFlags(config).meridiem = config._meridiem;
  config._a[HOUR] = meridiemFixWrap(
    config._locale,
    config._a[HOUR],
    config._meridiem
  );
  era = getParsingFlags(config).era;
  if (era !== null) {
    config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
  }
  configFromArray(config);
  checkOverflow(config);
}
function meridiemFixWrap(locale2, hour, meridiem2) {
  var isPm;
  if (meridiem2 == null) {
    return hour;
  }
  if (locale2.meridiemHour != null) {
    return locale2.meridiemHour(hour, meridiem2);
  } else if (locale2.isPM != null) {
    isPm = locale2.isPM(meridiem2);
    if (isPm && hour < 12) {
      hour += 12;
    }
    if (!isPm && hour === 12) {
      hour = 0;
    }
    return hour;
  } else {
    return hour;
  }
}
function configFromStringAndArray(config) {
  var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
  if (configfLen === 0) {
    getParsingFlags(config).invalidFormat = true;
    config._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (i = 0; i < configfLen; i++) {
    currentScore = 0;
    validFormatFound = false;
    tempConfig = copyConfig({}, config);
    if (config._useUTC != null) {
      tempConfig._useUTC = config._useUTC;
    }
    tempConfig._f = config._f[i];
    configFromStringAndFormat(tempConfig);
    if (isValid$1(tempConfig)) {
      validFormatFound = true;
    }
    currentScore += getParsingFlags(tempConfig).charsLeftOver;
    currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
    getParsingFlags(tempConfig).score = currentScore;
    if (!bestFormatIsValid) {
      if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
        if (validFormatFound) {
          bestFormatIsValid = true;
        }
      }
    } else {
      if (currentScore < scoreToBeat) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
      }
    }
  }
  extend$1(config, bestMoment || tempConfig);
}
function configFromObject(config) {
  if (config._d) {
    return;
  }
  var i = normalizeObjectUnits(config._i), dayOrDate = i.day === void 0 ? i.date : i.day;
  config._a = map$2(
    [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
    function(obj) {
      return obj && parseInt(obj, 10);
    }
  );
  configFromArray(config);
}
function createFromConfig(config) {
  var res = new Moment(checkOverflow(prepareConfig(config)));
  if (res._nextDay) {
    res.add(1, "d");
    res._nextDay = void 0;
  }
  return res;
}
function prepareConfig(config) {
  var input = config._i, format2 = config._f;
  config._locale = config._locale || getLocale(config._l);
  if (input === null || format2 === void 0 && input === "") {
    return createInvalid({ nullInput: true });
  }
  if (typeof input === "string") {
    config._i = input = config._locale.preparse(input);
  }
  if (isMoment(input)) {
    return new Moment(checkOverflow(input));
  } else if (isDate$2(input)) {
    config._d = input;
  } else if (isArray$1(format2)) {
    configFromStringAndArray(config);
  } else if (format2) {
    configFromStringAndFormat(config);
  } else {
    configFromInput(config);
  }
  if (!isValid$1(config)) {
    config._d = null;
  }
  return config;
}
function configFromInput(config) {
  var input = config._i;
  if (isUndefined$1(input)) {
    config._d = new Date(hooks.now());
  } else if (isDate$2(input)) {
    config._d = new Date(input.valueOf());
  } else if (typeof input === "string") {
    configFromString(config);
  } else if (isArray$1(input)) {
    config._a = map$2(input.slice(0), function(obj) {
      return parseInt(obj, 10);
    });
    configFromArray(config);
  } else if (isObject$1(input)) {
    configFromObject(config);
  } else if (isNumber$1(input)) {
    config._d = new Date(input);
  } else {
    hooks.createFromInputFallback(config);
  }
}
function createLocalOrUTC(input, format2, locale2, strict, isUTC) {
  var c = {};
  if (format2 === true || format2 === false) {
    strict = format2;
    format2 = void 0;
  }
  if (locale2 === true || locale2 === false) {
    strict = locale2;
    locale2 = void 0;
  }
  if (isObject$1(input) && isObjectEmpty(input) || isArray$1(input) && input.length === 0) {
    input = void 0;
  }
  c._isAMomentObject = true;
  c._useUTC = c._isUTC = isUTC;
  c._l = locale2;
  c._i = input;
  c._f = format2;
  c._strict = strict;
  return createFromConfig(c);
}
function createLocal(input, format2, locale2, strict) {
  return createLocalOrUTC(input, format2, locale2, strict, false);
}
var prototypeMin = deprecate(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var other = createLocal.apply(null, arguments);
    if (this.isValid() && other.isValid()) {
      return other < this ? this : other;
    } else {
      return createInvalid();
    }
  }
), prototypeMax = deprecate(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var other = createLocal.apply(null, arguments);
    if (this.isValid() && other.isValid()) {
      return other > this ? this : other;
    } else {
      return createInvalid();
    }
  }
);
function pickBy(fn, moments) {
  var res, i;
  if (moments.length === 1 && isArray$1(moments[0])) {
    moments = moments[0];
  }
  if (!moments.length) {
    return createLocal();
  }
  res = moments[0];
  for (i = 1; i < moments.length; ++i) {
    if (!moments[i].isValid() || moments[i][fn](res)) {
      res = moments[i];
    }
  }
  return res;
}
function min() {
  var args = [].slice.call(arguments, 0);
  return pickBy("isBefore", args);
}
function max() {
  var args = [].slice.call(arguments, 0);
  return pickBy("isAfter", args);
}
var now = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
};
var ordering = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function isDurationValid(m) {
  var key, unitHasDecimal = false, i, orderLen = ordering.length;
  for (key in m) {
    if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
      return false;
    }
  }
  for (i = 0; i < orderLen; ++i) {
    if (m[ordering[i]]) {
      if (unitHasDecimal) {
        return false;
      }
      if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
        unitHasDecimal = true;
      }
    }
  }
  return true;
}
function isValid$1$1() {
  return this._isValid;
}
function createInvalid$1() {
  return createDuration(NaN);
}
function Duration(duration) {
  var normalizedInput = normalizeObjectUnits(duration), years2 = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months2 = normalizedInput.month || 0, weeks2 = normalizedInput.week || normalizedInput.isoWeek || 0, days2 = normalizedInput.day || 0, hours2 = normalizedInput.hour || 0, minutes2 = normalizedInput.minute || 0, seconds2 = normalizedInput.second || 0, milliseconds2 = normalizedInput.millisecond || 0;
  this._isValid = isDurationValid(normalizedInput);
  this._milliseconds = +milliseconds2 + seconds2 * 1e3 + // 1000
  minutes2 * 6e4 + // 1000 * 60
  hours2 * 1e3 * 60 * 60;
  this._days = +days2 + weeks2 * 7;
  this._months = +months2 + quarters * 3 + years2 * 12;
  this._data = {};
  this._locale = getLocale();
  this._bubble();
}
function isDuration(obj) {
  return obj instanceof Duration;
}
function absRound(number2) {
  if (number2 < 0) {
    return Math.round(-1 * number2) * -1;
  } else {
    return Math.round(number2);
  }
}
function compareArrays(array1, array2, dontConvert) {
  var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
  for (i = 0; i < len; i++) {
    if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
      diffs++;
    }
  }
  return diffs + lengthDiff;
}
function offset(token2, separator) {
  addFormatToken(token2, 0, 0, function() {
    var offset2 = this.utcOffset(), sign2 = "+";
    if (offset2 < 0) {
      offset2 = -offset2;
      sign2 = "-";
    }
    return sign2 + zeroFill(~~(offset2 / 60), 2) + separator + zeroFill(~~offset2 % 60, 2);
  });
}
offset("Z", ":");
offset("ZZ", "");
addRegexToken("Z", matchShortOffset);
addRegexToken("ZZ", matchShortOffset);
addParseToken(["Z", "ZZ"], function(input, array, config) {
  config._useUTC = true;
  config._tzm = offsetFromString(matchShortOffset, input);
});
var chunkOffset = /([\+\-]|\d\d)/gi;
function offsetFromString(matcher, string2) {
  var matches = (string2 || "").match(matcher), chunk, parts, minutes2;
  if (matches === null) {
    return null;
  }
  chunk = matches[matches.length - 1] || [];
  parts = (chunk + "").match(chunkOffset) || ["-", 0, 0];
  minutes2 = +(parts[1] * 60) + toInt(parts[2]);
  return minutes2 === 0 ? 0 : parts[0] === "+" ? minutes2 : -minutes2;
}
function cloneWithOffset(input, model) {
  var res, diff2;
  if (model._isUTC) {
    res = model.clone();
    diff2 = (isMoment(input) || isDate$2(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
    res._d.setTime(res._d.valueOf() + diff2);
    hooks.updateOffset(res, false);
    return res;
  } else {
    return createLocal(input).local();
  }
}
function getDateOffset(m) {
  return -Math.round(m._d.getTimezoneOffset());
}
hooks.updateOffset = function() {
};
function getSetOffset(input, keepLocalTime, keepMinutes) {
  var offset2 = this._offset || 0, localAdjust;
  if (!this.isValid()) {
    return input != null ? this : NaN;
  }
  if (input != null) {
    if (typeof input === "string") {
      input = offsetFromString(matchShortOffset, input);
      if (input === null) {
        return this;
      }
    } else if (Math.abs(input) < 16 && !keepMinutes) {
      input = input * 60;
    }
    if (!this._isUTC && keepLocalTime) {
      localAdjust = getDateOffset(this);
    }
    this._offset = input;
    this._isUTC = true;
    if (localAdjust != null) {
      this.add(localAdjust, "m");
    }
    if (offset2 !== input) {
      if (!keepLocalTime || this._changeInProgress) {
        addSubtract(
          this,
          createDuration(input - offset2, "m"),
          1,
          false
        );
      } else if (!this._changeInProgress) {
        this._changeInProgress = true;
        hooks.updateOffset(this, true);
        this._changeInProgress = null;
      }
    }
    return this;
  } else {
    return this._isUTC ? offset2 : getDateOffset(this);
  }
}
function getSetZone(input, keepLocalTime) {
  if (input != null) {
    if (typeof input !== "string") {
      input = -input;
    }
    this.utcOffset(input, keepLocalTime);
    return this;
  } else {
    return -this.utcOffset();
  }
}
function setOffsetToUTC(keepLocalTime) {
  return this.utcOffset(0, keepLocalTime);
}
function setOffsetToLocal(keepLocalTime) {
  if (this._isUTC) {
    this.utcOffset(0, keepLocalTime);
    this._isUTC = false;
    if (keepLocalTime) {
      this.subtract(getDateOffset(this), "m");
    }
  }
  return this;
}
function setOffsetToParsedOffset() {
  if (this._tzm != null) {
    this.utcOffset(this._tzm, false, true);
  } else if (typeof this._i === "string") {
    var tZone = offsetFromString(matchOffset, this._i);
    if (tZone != null) {
      this.utcOffset(tZone);
    } else {
      this.utcOffset(0, true);
    }
  }
  return this;
}
function hasAlignedHourOffset(input) {
  if (!this.isValid()) {
    return false;
  }
  input = input ? createLocal(input).utcOffset() : 0;
  return (this.utcOffset() - input) % 60 === 0;
}
function isDaylightSavingTime() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function isDaylightSavingTimeShifted() {
  if (!isUndefined$1(this._isDSTShifted)) {
    return this._isDSTShifted;
  }
  var c = {}, other;
  copyConfig(c, this);
  c = prepareConfig(c);
  if (c._a) {
    other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
    this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
  } else {
    this._isDSTShifted = false;
  }
  return this._isDSTShifted;
}
function isLocal() {
  return this.isValid() ? !this._isUTC : false;
}
function isUtcOffset() {
  return this.isValid() ? this._isUTC : false;
}
function isUtc() {
  return this.isValid() ? this._isUTC && this._offset === 0 : false;
}
var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function createDuration(input, key) {
  var duration = input, match5 = null, sign2, ret, diffRes;
  if (isDuration(input)) {
    duration = {
      ms: input._milliseconds,
      d: input._days,
      M: input._months
    };
  } else if (isNumber$1(input) || !isNaN(+input)) {
    duration = {};
    if (key) {
      duration[key] = +input;
    } else {
      duration.milliseconds = +input;
    }
  } else if (match5 = aspNetRegex.exec(input)) {
    sign2 = match5[1] === "-" ? -1 : 1;
    duration = {
      y: 0,
      d: toInt(match5[DATE]) * sign2,
      h: toInt(match5[HOUR]) * sign2,
      m: toInt(match5[MINUTE]) * sign2,
      s: toInt(match5[SECOND]) * sign2,
      ms: toInt(absRound(match5[MILLISECOND] * 1e3)) * sign2
      // the millisecond decimal point is included in the match
    };
  } else if (match5 = isoRegex.exec(input)) {
    sign2 = match5[1] === "-" ? -1 : 1;
    duration = {
      y: parseIso(match5[2], sign2),
      M: parseIso(match5[3], sign2),
      w: parseIso(match5[4], sign2),
      d: parseIso(match5[5], sign2),
      h: parseIso(match5[6], sign2),
      m: parseIso(match5[7], sign2),
      s: parseIso(match5[8], sign2)
    };
  } else if (duration == null) {
    duration = {};
  } else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
    diffRes = momentsDifference(
      createLocal(duration.from),
      createLocal(duration.to)
    );
    duration = {};
    duration.ms = diffRes.milliseconds;
    duration.M = diffRes.months;
  }
  ret = new Duration(duration);
  if (isDuration(input) && hasOwnProp(input, "_locale")) {
    ret._locale = input._locale;
  }
  if (isDuration(input) && hasOwnProp(input, "_isValid")) {
    ret._isValid = input._isValid;
  }
  return ret;
}
createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;
function parseIso(inp, sign2) {
  var res = inp && parseFloat(inp.replace(",", "."));
  return (isNaN(res) ? 0 : res) * sign2;
}
function positiveMomentsDifference(base, other) {
  var res = {};
  res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
  if (base.clone().add(res.months, "M").isAfter(other)) {
    --res.months;
  }
  res.milliseconds = +other - +base.clone().add(res.months, "M");
  return res;
}
function momentsDifference(base, other) {
  var res;
  if (!(base.isValid() && other.isValid())) {
    return { milliseconds: 0, months: 0 };
  }
  other = cloneWithOffset(other, base);
  if (base.isBefore(other)) {
    res = positiveMomentsDifference(base, other);
  } else {
    res = positiveMomentsDifference(other, base);
    res.milliseconds = -res.milliseconds;
    res.months = -res.months;
  }
  return res;
}
function createAdder(direction, name) {
  return function(val, period) {
    var dur, tmp;
    if (period !== null && !isNaN(+period)) {
      deprecateSimple(
        name,
        "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
      );
      tmp = val;
      val = period;
      period = tmp;
    }
    dur = createDuration(val, period);
    addSubtract(this, dur, direction);
    return this;
  };
}
function addSubtract(mom, duration, isAdding, updateOffset) {
  var milliseconds2 = duration._milliseconds, days2 = absRound(duration._days), months2 = absRound(duration._months);
  if (!mom.isValid()) {
    return;
  }
  updateOffset = updateOffset == null ? true : updateOffset;
  if (months2) {
    setMonth(mom, get(mom, "Month") + months2 * isAdding);
  }
  if (days2) {
    set$1(mom, "Date", get(mom, "Date") + days2 * isAdding);
  }
  if (milliseconds2) {
    mom._d.setTime(mom._d.valueOf() + milliseconds2 * isAdding);
  }
  if (updateOffset) {
    hooks.updateOffset(mom, days2 || months2);
  }
}
var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
function isString$1(input) {
  return typeof input === "string" || input instanceof String;
}
function isMomentInput(input) {
  return isMoment(input) || isDate$2(input) || isString$1(input) || isNumber$1(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === void 0;
}
function isMomentInputObject(input) {
  var objectTest = isObject$1(input) && !isObjectEmpty(input), propertyTest = false, properties = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], i, property, propertyLen = properties.length;
  for (i = 0; i < propertyLen; i += 1) {
    property = properties[i];
    propertyTest = propertyTest || hasOwnProp(input, property);
  }
  return objectTest && propertyTest;
}
function isNumberOrStringArray(input) {
  var arrayTest = isArray$1(input), dataTypeTest = false;
  if (arrayTest) {
    dataTypeTest = input.filter(function(item) {
      return !isNumber$1(item) && isString$1(input);
    }).length === 0;
  }
  return arrayTest && dataTypeTest;
}
function isCalendarSpec(input) {
  var objectTest = isObject$1(input) && !isObjectEmpty(input), propertyTest = false, properties = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], i, property;
  for (i = 0; i < properties.length; i += 1) {
    property = properties[i];
    propertyTest = propertyTest || hasOwnProp(input, property);
  }
  return objectTest && propertyTest;
}
function getCalendarFormat(myMoment, now2) {
  var diff2 = myMoment.diff(now2, "days", true);
  return diff2 < -6 ? "sameElse" : diff2 < -1 ? "lastWeek" : diff2 < 0 ? "lastDay" : diff2 < 1 ? "sameDay" : diff2 < 2 ? "nextDay" : diff2 < 7 ? "nextWeek" : "sameElse";
}
function calendar$1(time, formats) {
  if (arguments.length === 1) {
    if (!arguments[0]) {
      time = void 0;
      formats = void 0;
    } else if (isMomentInput(arguments[0])) {
      time = arguments[0];
      formats = void 0;
    } else if (isCalendarSpec(arguments[0])) {
      formats = arguments[0];
      time = void 0;
    }
  }
  var now2 = time || createLocal(), sod = cloneWithOffset(now2, this).startOf("day"), format2 = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction$1(formats[format2]) ? formats[format2].call(this, now2) : formats[format2]);
  return this.format(
    output || this.localeData().calendar(format2, this, createLocal(now2))
  );
}
function clone() {
  return new Moment(this);
}
function isAfter(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input);
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() > localInput.valueOf();
  } else {
    return localInput.valueOf() < this.clone().startOf(units).valueOf();
  }
}
function isBefore$1(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input);
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() < localInput.valueOf();
  } else {
    return this.clone().endOf(units).valueOf() < localInput.valueOf();
  }
}
function isBetween(from2, to2, units, inclusivity) {
  var localFrom = isMoment(from2) ? from2 : createLocal(from2), localTo = isMoment(to2) ? to2 : createLocal(to2);
  if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
    return false;
  }
  inclusivity = inclusivity || "()";
  return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
}
function isSame(input, units) {
  var localInput = isMoment(input) ? input : createLocal(input), inputMs;
  if (!(this.isValid() && localInput.isValid())) {
    return false;
  }
  units = normalizeUnits(units) || "millisecond";
  if (units === "millisecond") {
    return this.valueOf() === localInput.valueOf();
  } else {
    inputMs = localInput.valueOf();
    return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
  }
}
function isSameOrAfter(input, units) {
  return this.isSame(input, units) || this.isAfter(input, units);
}
function isSameOrBefore(input, units) {
  return this.isSame(input, units) || this.isBefore(input, units);
}
function diff(input, units, asFloat) {
  var that, zoneDelta, output;
  if (!this.isValid()) {
    return NaN;
  }
  that = cloneWithOffset(input, this);
  if (!that.isValid()) {
    return NaN;
  }
  zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
  units = normalizeUnits(units);
  switch (units) {
    case "year":
      output = monthDiff(this, that) / 12;
      break;
    case "month":
      output = monthDiff(this, that);
      break;
    case "quarter":
      output = monthDiff(this, that) / 3;
      break;
    case "second":
      output = (this - that) / 1e3;
      break;
    case "minute":
      output = (this - that) / 6e4;
      break;
    case "hour":
      output = (this - that) / 36e5;
      break;
    case "day":
      output = (this - that - zoneDelta) / 864e5;
      break;
    case "week":
      output = (this - that - zoneDelta) / 6048e5;
      break;
    default:
      output = this - that;
  }
  return asFloat ? output : absFloor(output);
}
function monthDiff(a, b) {
  if (a.date() < b.date()) {
    return -monthDiff(b, a);
  }
  var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
  if (b - anchor < 0) {
    anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
    adjust = (b - anchor) / (anchor - anchor2);
  } else {
    anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
    adjust = (b - anchor) / (anchor2 - anchor);
  }
  return -(wholeMonthDiff + adjust) || 0;
}
hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function toString$1() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function toISOString(keepOffset) {
  if (!this.isValid()) {
    return null;
  }
  var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
  if (m.year() < 0 || m.year() > 9999) {
    return formatMoment(
      m,
      utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
    );
  }
  if (isFunction$1(Date.prototype.toISOString)) {
    if (utc) {
      return this.toDate().toISOString();
    } else {
      return new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(m, "Z"));
    }
  }
  return formatMoment(
    m,
    utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function inspect() {
  if (!this.isValid()) {
    return "moment.invalid(/* " + this._i + " */)";
  }
  var func = "moment", zone = "", prefix, year, datetime, suffix;
  if (!this.isLocal()) {
    func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
    zone = "Z";
  }
  prefix = "[" + func + '("]';
  year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
  datetime = "-MM-DD[T]HH:mm:ss.SSS";
  suffix = zone + '[")]';
  return this.format(prefix + year + datetime + suffix);
}
function format(inputString) {
  if (!inputString) {
    inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
  }
  var output = formatMoment(this, inputString);
  return this.localeData().postformat(output);
}
function from(time, withoutSuffix) {
  if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
    return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
  } else {
    return this.localeData().invalidDate();
  }
}
function fromNow(withoutSuffix) {
  return this.from(createLocal(), withoutSuffix);
}
function to(time, withoutSuffix) {
  if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
    return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
  } else {
    return this.localeData().invalidDate();
  }
}
function toNow(withoutSuffix) {
  return this.to(createLocal(), withoutSuffix);
}
function locale(key) {
  var newLocaleData;
  if (key === void 0) {
    return this._locale._abbr;
  } else {
    newLocaleData = getLocale(key);
    if (newLocaleData != null) {
      this._locale = newLocaleData;
    }
    return this;
  }
}
var lang = deprecate(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(key) {
    if (key === void 0) {
      return this.localeData();
    } else {
      return this.locale(key);
    }
  }
);
function localeData() {
  return this._locale;
}
var MS_PER_SECOND = 1e3, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
function mod$1(dividend, divisor) {
  return (dividend % divisor + divisor) % divisor;
}
function localStartOfDate(y, m, d) {
  if (y < 100 && y >= 0) {
    return new Date(y + 400, m, d) - MS_PER_400_YEARS;
  } else {
    return new Date(y, m, d).valueOf();
  }
}
function utcStartOfDate(y, m, d) {
  if (y < 100 && y >= 0) {
    return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
  } else {
    return Date.UTC(y, m, d);
  }
}
function startOf(units) {
  var time, startOfDate;
  units = normalizeUnits(units);
  if (units === void 0 || units === "millisecond" || !this.isValid()) {
    return this;
  }
  startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
  switch (units) {
    case "year":
      time = startOfDate(this.year(), 0, 1);
      break;
    case "quarter":
      time = startOfDate(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      time = startOfDate(this.year(), this.month(), 1);
      break;
    case "week":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      time = startOfDate(this.year(), this.month(), this.date());
      break;
    case "hour":
      time = this._d.valueOf();
      time -= mod$1(
        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      );
      break;
    case "minute":
      time = this._d.valueOf();
      time -= mod$1(time, MS_PER_MINUTE);
      break;
    case "second":
      time = this._d.valueOf();
      time -= mod$1(time, MS_PER_SECOND);
      break;
  }
  this._d.setTime(time);
  hooks.updateOffset(this, true);
  return this;
}
function endOf(units) {
  var time, startOfDate;
  units = normalizeUnits(units);
  if (units === void 0 || units === "millisecond" || !this.isValid()) {
    return this;
  }
  startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
  switch (units) {
    case "year":
      time = startOfDate(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      time = startOfDate(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      time = startOfDate(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      time = startOfDate(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      time = this._d.valueOf();
      time += MS_PER_HOUR - mod$1(
        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
        MS_PER_HOUR
      ) - 1;
      break;
    case "minute":
      time = this._d.valueOf();
      time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
      break;
    case "second":
      time = this._d.valueOf();
      time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
      break;
  }
  this._d.setTime(time);
  hooks.updateOffset(this, true);
  return this;
}
function valueOf() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function unix() {
  return Math.floor(this.valueOf() / 1e3);
}
function toDate$1() {
  return new Date(this.valueOf());
}
function toArray$1() {
  var m = this;
  return [
    m.year(),
    m.month(),
    m.date(),
    m.hour(),
    m.minute(),
    m.second(),
    m.millisecond()
  ];
}
function toObject() {
  var m = this;
  return {
    years: m.year(),
    months: m.month(),
    date: m.date(),
    hours: m.hours(),
    minutes: m.minutes(),
    seconds: m.seconds(),
    milliseconds: m.milliseconds()
  };
}
function toJSON() {
  return this.isValid() ? this.toISOString() : null;
}
function isValid$2() {
  return isValid$1(this);
}
function parsingFlags() {
  return extend$1({}, getParsingFlags(this));
}
function invalidAt() {
  return getParsingFlags(this).overflow;
}
function creationData() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
addFormatToken("N", 0, 0, "eraAbbr");
addFormatToken("NN", 0, 0, "eraAbbr");
addFormatToken("NNN", 0, 0, "eraAbbr");
addFormatToken("NNNN", 0, 0, "eraName");
addFormatToken("NNNNN", 0, 0, "eraNarrow");
addFormatToken("y", ["y", 1], "yo", "eraYear");
addFormatToken("y", ["yy", 2], 0, "eraYear");
addFormatToken("y", ["yyy", 3], 0, "eraYear");
addFormatToken("y", ["yyyy", 4], 0, "eraYear");
addRegexToken("N", matchEraAbbr);
addRegexToken("NN", matchEraAbbr);
addRegexToken("NNN", matchEraAbbr);
addRegexToken("NNNN", matchEraName);
addRegexToken("NNNNN", matchEraNarrow);
addParseToken(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(input, array, config, token2) {
    var era = config._locale.erasParse(input, token2, config._strict);
    if (era) {
      getParsingFlags(config).era = era;
    } else {
      getParsingFlags(config).invalidEra = input;
    }
  }
);
addRegexToken("y", matchUnsigned);
addRegexToken("yy", matchUnsigned);
addRegexToken("yyy", matchUnsigned);
addRegexToken("yyyy", matchUnsigned);
addRegexToken("yo", matchEraYearOrdinal);
addParseToken(["y", "yy", "yyy", "yyyy"], YEAR);
addParseToken(["yo"], function(input, array, config, token2) {
  var match5;
  if (config._locale._eraYearOrdinalRegex) {
    match5 = input.match(config._locale._eraYearOrdinalRegex);
  }
  if (config._locale.eraYearOrdinalParse) {
    array[YEAR] = config._locale.eraYearOrdinalParse(input, match5);
  } else {
    array[YEAR] = parseInt(input, 10);
  }
});
function localeEras(m, format2) {
  var i, l, date, eras = this._eras || getLocale("en")._eras;
  for (i = 0, l = eras.length; i < l; ++i) {
    switch (typeof eras[i].since) {
      case "string":
        date = hooks(eras[i].since).startOf("day");
        eras[i].since = date.valueOf();
        break;
    }
    switch (typeof eras[i].until) {
      case "undefined":
        eras[i].until = Infinity;
        break;
      case "string":
        date = hooks(eras[i].until).startOf("day").valueOf();
        eras[i].until = date.valueOf();
        break;
    }
  }
  return eras;
}
function localeErasParse(eraName, format2, strict) {
  var i, l, eras = this.eras(), name, abbr, narrow;
  eraName = eraName.toUpperCase();
  for (i = 0, l = eras.length; i < l; ++i) {
    name = eras[i].name.toUpperCase();
    abbr = eras[i].abbr.toUpperCase();
    narrow = eras[i].narrow.toUpperCase();
    if (strict) {
      switch (format2) {
        case "N":
        case "NN":
        case "NNN":
          if (abbr === eraName) {
            return eras[i];
          }
          break;
        case "NNNN":
          if (name === eraName) {
            return eras[i];
          }
          break;
        case "NNNNN":
          if (narrow === eraName) {
            return eras[i];
          }
          break;
      }
    } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
      return eras[i];
    }
  }
}
function localeErasConvertYear(era, year) {
  var dir = era.since <= era.until ? 1 : -1;
  if (year === void 0) {
    return hooks(era.since).year();
  } else {
    return hooks(era.since).year() + (year - era.offset) * dir;
  }
}
function getEraName() {
  var i, l, val, eras = this.localeData().eras();
  for (i = 0, l = eras.length; i < l; ++i) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until) {
      return eras[i].name;
    }
    if (eras[i].until <= val && val <= eras[i].since) {
      return eras[i].name;
    }
  }
  return "";
}
function getEraNarrow() {
  var i, l, val, eras = this.localeData().eras();
  for (i = 0, l = eras.length; i < l; ++i) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until) {
      return eras[i].narrow;
    }
    if (eras[i].until <= val && val <= eras[i].since) {
      return eras[i].narrow;
    }
  }
  return "";
}
function getEraAbbr() {
  var i, l, val, eras = this.localeData().eras();
  for (i = 0, l = eras.length; i < l; ++i) {
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until) {
      return eras[i].abbr;
    }
    if (eras[i].until <= val && val <= eras[i].since) {
      return eras[i].abbr;
    }
  }
  return "";
}
function getEraYear() {
  var i, l, dir, val, eras = this.localeData().eras();
  for (i = 0, l = eras.length; i < l; ++i) {
    dir = eras[i].since <= eras[i].until ? 1 : -1;
    val = this.clone().startOf("day").valueOf();
    if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
      return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
    }
  }
  return this.year();
}
function erasNameRegex(isStrict) {
  if (!hasOwnProp(this, "_erasNameRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasNameRegex : this._erasRegex;
}
function erasAbbrRegex(isStrict) {
  if (!hasOwnProp(this, "_erasAbbrRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasAbbrRegex : this._erasRegex;
}
function erasNarrowRegex(isStrict) {
  if (!hasOwnProp(this, "_erasNarrowRegex")) {
    computeErasParse.call(this);
  }
  return isStrict ? this._erasNarrowRegex : this._erasRegex;
}
function matchEraAbbr(isStrict, locale2) {
  return locale2.erasAbbrRegex(isStrict);
}
function matchEraName(isStrict, locale2) {
  return locale2.erasNameRegex(isStrict);
}
function matchEraNarrow(isStrict, locale2) {
  return locale2.erasNarrowRegex(isStrict);
}
function matchEraYearOrdinal(isStrict, locale2) {
  return locale2._eraYearOrdinalRegex || matchUnsigned;
}
function computeErasParse() {
  var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
  for (i = 0, l = eras.length; i < l; ++i) {
    namePieces.push(regexEscape(eras[i].name));
    abbrPieces.push(regexEscape(eras[i].abbr));
    narrowPieces.push(regexEscape(eras[i].narrow));
    mixedPieces.push(regexEscape(eras[i].name));
    mixedPieces.push(regexEscape(eras[i].abbr));
    mixedPieces.push(regexEscape(eras[i].narrow));
  }
  this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
  this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
  this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
  this._erasNarrowRegex = new RegExp(
    "^(" + narrowPieces.join("|") + ")",
    "i"
  );
}
addFormatToken(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
addFormatToken(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function addWeekYearFormatToken(token2, getter) {
  addFormatToken(0, [token2, token2.length], 0, getter);
}
addWeekYearFormatToken("gggg", "weekYear");
addWeekYearFormatToken("ggggg", "weekYear");
addWeekYearFormatToken("GGGG", "isoWeekYear");
addWeekYearFormatToken("GGGGG", "isoWeekYear");
addUnitAlias("weekYear", "gg");
addUnitAlias("isoWeekYear", "GG");
addUnitPriority("weekYear", 1);
addUnitPriority("isoWeekYear", 1);
addRegexToken("G", matchSigned);
addRegexToken("g", matchSigned);
addRegexToken("GG", match1to2, match2);
addRegexToken("gg", match1to2, match2);
addRegexToken("GGGG", match1to4, match4);
addRegexToken("gggg", match1to4, match4);
addRegexToken("GGGGG", match1to6, match6);
addRegexToken("ggggg", match1to6, match6);
addWeekParseToken(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(input, week, config, token2) {
    week[token2.substr(0, 2)] = toInt(input);
  }
);
addWeekParseToken(["gg", "GG"], function(input, week, config, token2) {
  week[token2] = hooks.parseTwoDigitYear(input);
});
function getSetWeekYear(input) {
  return getSetWeekYearHelper.call(
    this,
    input,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function getSetISOWeekYear(input) {
  return getSetWeekYearHelper.call(
    this,
    input,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function getISOWeeksInYear() {
  return weeksInYear(this.year(), 1, 4);
}
function getISOWeeksInISOWeekYear() {
  return weeksInYear(this.isoWeekYear(), 1, 4);
}
function getWeeksInYear() {
  var weekInfo = this.localeData()._week;
  return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}
function getWeeksInWeekYear() {
  var weekInfo = this.localeData()._week;
  return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
}
function getSetWeekYearHelper(input, week, weekday, dow, doy) {
  var weeksTarget;
  if (input == null) {
    return weekOfYear(this, dow, doy).year;
  } else {
    weeksTarget = weeksInYear(input, dow, doy);
    if (week > weeksTarget) {
      week = weeksTarget;
    }
    return setWeekAll.call(this, input, week, weekday, dow, doy);
  }
}
function setWeekAll(weekYear, week, weekday, dow, doy) {
  var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
  this.year(date.getUTCFullYear());
  this.month(date.getUTCMonth());
  this.date(date.getUTCDate());
  return this;
}
addFormatToken("Q", 0, "Qo", "quarter");
addUnitAlias("quarter", "Q");
addUnitPriority("quarter", 7);
addRegexToken("Q", match1);
addParseToken("Q", function(input, array) {
  array[MONTH] = (toInt(input) - 1) * 3;
});
function getSetQuarter(input) {
  return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}
addFormatToken("D", ["DD", 2], "Do", "date");
addUnitAlias("date", "D");
addUnitPriority("date", 9);
addRegexToken("D", match1to2);
addRegexToken("DD", match1to2, match2);
addRegexToken("Do", function(isStrict, locale2) {
  return isStrict ? locale2._dayOfMonthOrdinalParse || locale2._ordinalParse : locale2._dayOfMonthOrdinalParseLenient;
});
addParseToken(["D", "DD"], DATE);
addParseToken("Do", function(input, array) {
  array[DATE] = toInt(input.match(match1to2)[0]);
});
var getSetDayOfMonth = makeGetSet("Date", true);
addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
addUnitAlias("dayOfYear", "DDD");
addUnitPriority("dayOfYear", 4);
addRegexToken("DDD", match1to3);
addRegexToken("DDDD", match3);
addParseToken(["DDD", "DDDD"], function(input, array, config) {
  config._dayOfYear = toInt(input);
});
function getSetDayOfYear(input) {
  var dayOfYear = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
}
addFormatToken("m", ["mm", 2], 0, "minute");
addUnitAlias("minute", "m");
addUnitPriority("minute", 14);
addRegexToken("m", match1to2);
addRegexToken("mm", match1to2, match2);
addParseToken(["m", "mm"], MINUTE);
var getSetMinute = makeGetSet("Minutes", false);
addFormatToken("s", ["ss", 2], 0, "second");
addUnitAlias("second", "s");
addUnitPriority("second", 15);
addRegexToken("s", match1to2);
addRegexToken("ss", match1to2, match2);
addParseToken(["s", "ss"], SECOND);
var getSetSecond = makeGetSet("Seconds", false);
addFormatToken("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
addFormatToken(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
addFormatToken(0, ["SSS", 3], 0, "millisecond");
addFormatToken(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
addFormatToken(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
addFormatToken(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
addFormatToken(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
addUnitAlias("millisecond", "ms");
addUnitPriority("millisecond", 16);
addRegexToken("S", match1to3, match1);
addRegexToken("SS", match1to3, match2);
addRegexToken("SSS", match1to3, match3);
var token, getSetMillisecond;
for (token = "SSSS"; token.length <= 9; token += "S") {
  addRegexToken(token, matchUnsigned);
}
function parseMs(input, array) {
  array[MILLISECOND] = toInt(("0." + input) * 1e3);
}
for (token = "S"; token.length <= 9; token += "S") {
  addParseToken(token, parseMs);
}
getSetMillisecond = makeGetSet("Milliseconds", false);
addFormatToken("z", 0, 0, "zoneAbbr");
addFormatToken("zz", 0, 0, "zoneName");
function getZoneAbbr() {
  return this._isUTC ? "UTC" : "";
}
function getZoneName() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var proto = Moment.prototype;
proto.add = add;
proto.calendar = calendar$1;
proto.clone = clone;
proto.diff = diff;
proto.endOf = endOf;
proto.format = format;
proto.from = from;
proto.fromNow = fromNow;
proto.to = to;
proto.toNow = toNow;
proto.get = stringGet;
proto.invalidAt = invalidAt;
proto.isAfter = isAfter;
proto.isBefore = isBefore$1;
proto.isBetween = isBetween;
proto.isSame = isSame;
proto.isSameOrAfter = isSameOrAfter;
proto.isSameOrBefore = isSameOrBefore;
proto.isValid = isValid$2;
proto.lang = lang;
proto.locale = locale;
proto.localeData = localeData;
proto.max = prototypeMax;
proto.min = prototypeMin;
proto.parsingFlags = parsingFlags;
proto.set = stringSet;
proto.startOf = startOf;
proto.subtract = subtract;
proto.toArray = toArray$1;
proto.toObject = toObject;
proto.toDate = toDate$1;
proto.toISOString = toISOString;
proto.inspect = inspect;
if (typeof Symbol !== "undefined" && Symbol.for != null) {
  proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
    return "Moment<" + this.format() + ">";
  };
}
proto.toJSON = toJSON;
proto.toString = toString$1;
proto.unix = unix;
proto.valueOf = valueOf;
proto.creationData = creationData;
proto.eraName = getEraName;
proto.eraNarrow = getEraNarrow;
proto.eraAbbr = getEraAbbr;
proto.eraYear = getEraYear;
proto.year = getSetYear;
proto.isLeapYear = getIsLeapYear;
proto.weekYear = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;
proto.quarter = proto.quarters = getSetQuarter;
proto.month = getSetMonth;
proto.daysInMonth = getDaysInMonth;
proto.week = proto.weeks = getSetWeek;
proto.isoWeek = proto.isoWeeks = getSetISOWeek;
proto.weeksInYear = getWeeksInYear;
proto.weeksInWeekYear = getWeeksInWeekYear;
proto.isoWeeksInYear = getISOWeeksInYear;
proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
proto.date = getSetDayOfMonth;
proto.day = proto.days = getSetDayOfWeek;
proto.weekday = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear = getSetDayOfYear;
proto.hour = proto.hours = getSetHour;
proto.minute = proto.minutes = getSetMinute;
proto.second = proto.seconds = getSetSecond;
proto.millisecond = proto.milliseconds = getSetMillisecond;
proto.utcOffset = getSetOffset;
proto.utc = setOffsetToUTC;
proto.local = setOffsetToLocal;
proto.parseZone = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST = isDaylightSavingTime;
proto.isLocal = isLocal;
proto.isUtcOffset = isUtcOffset;
proto.isUtc = isUtc;
proto.isUTC = isUtc;
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;
proto.dates = deprecate(
  "dates accessor is deprecated. Use date instead.",
  getSetDayOfMonth
);
proto.months = deprecate(
  "months accessor is deprecated. Use month instead",
  getSetMonth
);
proto.years = deprecate(
  "years accessor is deprecated. Use year instead",
  getSetYear
);
proto.zone = deprecate(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  getSetZone
);
proto.isDSTShifted = deprecate(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  isDaylightSavingTimeShifted
);
function createUnix(input) {
  return createLocal(input * 1e3);
}
function createInZone() {
  return createLocal.apply(null, arguments).parseZone();
}
function preParsePostFormat(string2) {
  return string2;
}
var proto$1 = Locale.prototype;
proto$1.calendar = calendar;
proto$1.longDateFormat = longDateFormat;
proto$1.invalidDate = invalidDate;
proto$1.ordinal = ordinal;
proto$1.preparse = preParsePostFormat;
proto$1.postformat = preParsePostFormat;
proto$1.relativeTime = relativeTime;
proto$1.pastFuture = pastFuture;
proto$1.set = set;
proto$1.eras = localeEras;
proto$1.erasParse = localeErasParse;
proto$1.erasConvertYear = localeErasConvertYear;
proto$1.erasAbbrRegex = erasAbbrRegex;
proto$1.erasNameRegex = erasNameRegex;
proto$1.erasNarrowRegex = erasNarrowRegex;
proto$1.months = localeMonths;
proto$1.monthsShort = localeMonthsShort;
proto$1.monthsParse = localeMonthsParse;
proto$1.monthsRegex = monthsRegex;
proto$1.monthsShortRegex = monthsShortRegex;
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;
proto$1.weekdays = localeWeekdays;
proto$1.weekdaysMin = localeWeekdaysMin;
proto$1.weekdaysShort = localeWeekdaysShort;
proto$1.weekdaysParse = localeWeekdaysParse;
proto$1.weekdaysRegex = weekdaysRegex;
proto$1.weekdaysShortRegex = weekdaysShortRegex;
proto$1.weekdaysMinRegex = weekdaysMinRegex;
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;
function get$1(format2, index, field, setter) {
  var locale2 = getLocale(), utc = createUTC().set(setter, index);
  return locale2[field](utc, format2);
}
function listMonthsImpl(format2, index, field) {
  if (isNumber$1(format2)) {
    index = format2;
    format2 = void 0;
  }
  format2 = format2 || "";
  if (index != null) {
    return get$1(format2, index, field, "month");
  }
  var i, out = [];
  for (i = 0; i < 12; i++) {
    out[i] = get$1(format2, i, field, "month");
  }
  return out;
}
function listWeekdaysImpl(localeSorted, format2, index, field) {
  if (typeof localeSorted === "boolean") {
    if (isNumber$1(format2)) {
      index = format2;
      format2 = void 0;
    }
    format2 = format2 || "";
  } else {
    format2 = localeSorted;
    index = format2;
    localeSorted = false;
    if (isNumber$1(format2)) {
      index = format2;
      format2 = void 0;
    }
    format2 = format2 || "";
  }
  var locale2 = getLocale(), shift = localeSorted ? locale2._week.dow : 0, i, out = [];
  if (index != null) {
    return get$1(format2, (index + shift) % 7, field, "day");
  }
  for (i = 0; i < 7; i++) {
    out[i] = get$1(format2, (i + shift) % 7, field, "day");
  }
  return out;
}
function listMonths(format2, index) {
  return listMonthsImpl(format2, index, "months");
}
function listMonthsShort(format2, index) {
  return listMonthsImpl(format2, index, "monthsShort");
}
function listWeekdays(localeSorted, format2, index) {
  return listWeekdaysImpl(localeSorted, format2, index, "weekdays");
}
function listWeekdaysShort(localeSorted, format2, index) {
  return listWeekdaysImpl(localeSorted, format2, index, "weekdaysShort");
}
function listWeekdaysMin(localeSorted, format2, index) {
  return listWeekdaysImpl(localeSorted, format2, index, "weekdaysMin");
}
getSetGlobalLocale("en", {
  eras: [
    {
      since: "0001-01-01",
      until: Infinity,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -Infinity,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(number2) {
    var b = number2 % 10, output = toInt(number2 % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
    return number2 + output;
  }
});
hooks.lang = deprecate(
  "moment.lang is deprecated. Use moment.locale instead.",
  getSetGlobalLocale
);
hooks.langData = deprecate(
  "moment.langData is deprecated. Use moment.localeData instead.",
  getLocale
);
var mathAbs = Math.abs;
function abs() {
  var data = this._data;
  this._milliseconds = mathAbs(this._milliseconds);
  this._days = mathAbs(this._days);
  this._months = mathAbs(this._months);
  data.milliseconds = mathAbs(data.milliseconds);
  data.seconds = mathAbs(data.seconds);
  data.minutes = mathAbs(data.minutes);
  data.hours = mathAbs(data.hours);
  data.months = mathAbs(data.months);
  data.years = mathAbs(data.years);
  return this;
}
function addSubtract$1(duration, input, value, direction) {
  var other = createDuration(input, value);
  duration._milliseconds += direction * other._milliseconds;
  duration._days += direction * other._days;
  duration._months += direction * other._months;
  return duration._bubble();
}
function add$1(input, value) {
  return addSubtract$1(this, input, value, 1);
}
function subtract$1(input, value) {
  return addSubtract$1(this, input, value, -1);
}
function absCeil(number2) {
  if (number2 < 0) {
    return Math.floor(number2);
  } else {
    return Math.ceil(number2);
  }
}
function bubble() {
  var milliseconds2 = this._milliseconds, days2 = this._days, months2 = this._months, data = this._data, seconds2, minutes2, hours2, years2, monthsFromDays;
  if (!(milliseconds2 >= 0 && days2 >= 0 && months2 >= 0 || milliseconds2 <= 0 && days2 <= 0 && months2 <= 0)) {
    milliseconds2 += absCeil(monthsToDays(months2) + days2) * 864e5;
    days2 = 0;
    months2 = 0;
  }
  data.milliseconds = milliseconds2 % 1e3;
  seconds2 = absFloor(milliseconds2 / 1e3);
  data.seconds = seconds2 % 60;
  minutes2 = absFloor(seconds2 / 60);
  data.minutes = minutes2 % 60;
  hours2 = absFloor(minutes2 / 60);
  data.hours = hours2 % 24;
  days2 += absFloor(hours2 / 24);
  monthsFromDays = absFloor(daysToMonths(days2));
  months2 += monthsFromDays;
  days2 -= absCeil(monthsToDays(monthsFromDays));
  years2 = absFloor(months2 / 12);
  months2 %= 12;
  data.days = days2;
  data.months = months2;
  data.years = years2;
  return this;
}
function daysToMonths(days2) {
  return days2 * 4800 / 146097;
}
function monthsToDays(months2) {
  return months2 * 146097 / 4800;
}
function as$1(units) {
  if (!this.isValid()) {
    return NaN;
  }
  var days2, months2, milliseconds2 = this._milliseconds;
  units = normalizeUnits(units);
  if (units === "month" || units === "quarter" || units === "year") {
    days2 = this._days + milliseconds2 / 864e5;
    months2 = this._months + daysToMonths(days2);
    switch (units) {
      case "month":
        return months2;
      case "quarter":
        return months2 / 3;
      case "year":
        return months2 / 12;
    }
  } else {
    days2 = this._days + Math.round(monthsToDays(this._months));
    switch (units) {
      case "week":
        return days2 / 7 + milliseconds2 / 6048e5;
      case "day":
        return days2 + milliseconds2 / 864e5;
      case "hour":
        return days2 * 24 + milliseconds2 / 36e5;
      case "minute":
        return days2 * 1440 + milliseconds2 / 6e4;
      case "second":
        return days2 * 86400 + milliseconds2 / 1e3;
      case "millisecond":
        return Math.floor(days2 * 864e5) + milliseconds2;
      default:
        throw new Error("Unknown unit " + units);
    }
  }
}
function valueOf$1() {
  if (!this.isValid()) {
    return NaN;
  }
  return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
}
function makeAs(alias) {
  return function() {
    return this.as(alias);
  };
}
var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
function clone$1() {
  return createDuration(this);
}
function get$2(units) {
  units = normalizeUnits(units);
  return this.isValid() ? this[units + "s"]() : NaN;
}
function makeGetter(name) {
  return function() {
    return this.isValid() ? this._data[name] : NaN;
  };
}
var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
function weeks() {
  return absFloor(this.days() / 7);
}
var round = Math.round, thresholds = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function substituteTimeAgo(string2, number2, withoutSuffix, isFuture, locale2) {
  return locale2.relativeTime(number2 || 1, !!withoutSuffix, string2, isFuture);
}
function relativeTime$1(posNegDuration, withoutSuffix, thresholds2, locale2) {
  var duration = createDuration(posNegDuration).abs(), seconds2 = round(duration.as("s")), minutes2 = round(duration.as("m")), hours2 = round(duration.as("h")), days2 = round(duration.as("d")), months2 = round(duration.as("M")), weeks2 = round(duration.as("w")), years2 = round(duration.as("y")), a = seconds2 <= thresholds2.ss && ["s", seconds2] || seconds2 < thresholds2.s && ["ss", seconds2] || minutes2 <= 1 && ["m"] || minutes2 < thresholds2.m && ["mm", minutes2] || hours2 <= 1 && ["h"] || hours2 < thresholds2.h && ["hh", hours2] || days2 <= 1 && ["d"] || days2 < thresholds2.d && ["dd", days2];
  if (thresholds2.w != null) {
    a = a || weeks2 <= 1 && ["w"] || weeks2 < thresholds2.w && ["ww", weeks2];
  }
  a = a || months2 <= 1 && ["M"] || months2 < thresholds2.M && ["MM", months2] || years2 <= 1 && ["y"] || ["yy", years2];
  a[2] = withoutSuffix;
  a[3] = +posNegDuration > 0;
  a[4] = locale2;
  return substituteTimeAgo.apply(null, a);
}
function getSetRelativeTimeRounding(roundingFunction) {
  if (roundingFunction === void 0) {
    return round;
  }
  if (typeof roundingFunction === "function") {
    round = roundingFunction;
    return true;
  }
  return false;
}
function getSetRelativeTimeThreshold(threshold, limit) {
  if (thresholds[threshold] === void 0) {
    return false;
  }
  if (limit === void 0) {
    return thresholds[threshold];
  }
  thresholds[threshold] = limit;
  if (threshold === "s") {
    thresholds.ss = limit - 1;
  }
  return true;
}
function humanize(argWithSuffix, argThresholds) {
  if (!this.isValid()) {
    return this.localeData().invalidDate();
  }
  var withSuffix = false, th = thresholds, locale2, output;
  if (typeof argWithSuffix === "object") {
    argThresholds = argWithSuffix;
    argWithSuffix = false;
  }
  if (typeof argWithSuffix === "boolean") {
    withSuffix = argWithSuffix;
  }
  if (typeof argThresholds === "object") {
    th = Object.assign({}, thresholds, argThresholds);
    if (argThresholds.s != null && argThresholds.ss == null) {
      th.ss = argThresholds.s - 1;
    }
  }
  locale2 = this.localeData();
  output = relativeTime$1(this, !withSuffix, th, locale2);
  if (withSuffix) {
    output = locale2.pastFuture(+this, output);
  }
  return locale2.postformat(output);
}
var abs$1 = Math.abs;
function sign(x) {
  return (x > 0) - (x < 0) || +x;
}
function toISOString$1() {
  if (!this.isValid()) {
    return this.localeData().invalidDate();
  }
  var seconds2 = abs$1(this._milliseconds) / 1e3, days2 = abs$1(this._days), months2 = abs$1(this._months), minutes2, hours2, years2, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
  if (!total) {
    return "P0D";
  }
  minutes2 = absFloor(seconds2 / 60);
  hours2 = absFloor(minutes2 / 60);
  seconds2 %= 60;
  minutes2 %= 60;
  years2 = absFloor(months2 / 12);
  months2 %= 12;
  s = seconds2 ? seconds2.toFixed(3).replace(/\.?0+$/, "") : "";
  totalSign = total < 0 ? "-" : "";
  ymSign = sign(this._months) !== sign(total) ? "-" : "";
  daysSign = sign(this._days) !== sign(total) ? "-" : "";
  hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
  return totalSign + "P" + (years2 ? ymSign + years2 + "Y" : "") + (months2 ? ymSign + months2 + "M" : "") + (days2 ? daysSign + days2 + "D" : "") + (hours2 || minutes2 || seconds2 ? "T" : "") + (hours2 ? hmsSign + hours2 + "H" : "") + (minutes2 ? hmsSign + minutes2 + "M" : "") + (seconds2 ? hmsSign + s + "S" : "");
}
var proto$2 = Duration.prototype;
proto$2.isValid = isValid$1$1;
proto$2.abs = abs;
proto$2.add = add$1;
proto$2.subtract = subtract$1;
proto$2.as = as$1;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds = asSeconds;
proto$2.asMinutes = asMinutes;
proto$2.asHours = asHours;
proto$2.asDays = asDays;
proto$2.asWeeks = asWeeks;
proto$2.asMonths = asMonths;
proto$2.asQuarters = asQuarters;
proto$2.asYears = asYears;
proto$2.valueOf = valueOf$1;
proto$2._bubble = bubble;
proto$2.clone = clone$1;
proto$2.get = get$2;
proto$2.milliseconds = milliseconds;
proto$2.seconds = seconds;
proto$2.minutes = minutes;
proto$2.hours = hours;
proto$2.days = days;
proto$2.weeks = weeks;
proto$2.months = months;
proto$2.years = years;
proto$2.humanize = humanize;
proto$2.toISOString = toISOString$1;
proto$2.toString = toISOString$1;
proto$2.toJSON = toISOString$1;
proto$2.locale = locale;
proto$2.localeData = localeData;
proto$2.toIsoString = deprecate(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  toISOString$1
);
proto$2.lang = lang;
addFormatToken("X", 0, 0, "unix");
addFormatToken("x", 0, 0, "valueOf");
addRegexToken("x", matchSigned);
addRegexToken("X", matchTimestamp);
addParseToken("X", function(input, array, config) {
  config._d = new Date(parseFloat(input) * 1e3);
});
addParseToken("x", function(input, array, config) {
  config._d = new Date(toInt(input));
});
//! moment.js
hooks.version = "2.29.4";
setHookCallback(createLocal);
hooks.fn = proto;
hooks.min = min;
hooks.max = max;
hooks.now = now;
hooks.utc = createUTC;
hooks.unix = createUnix;
hooks.months = listMonths;
hooks.isDate = isDate$2;
hooks.locale = getSetGlobalLocale;
hooks.invalid = createInvalid;
hooks.duration = createDuration;
hooks.isMoment = isMoment;
hooks.weekdays = listWeekdays;
hooks.parseZone = createInZone;
hooks.localeData = getLocale;
hooks.isDuration = isDuration;
hooks.monthsShort = listMonthsShort;
hooks.weekdaysMin = listWeekdaysMin;
hooks.defineLocale = defineLocale;
hooks.updateLocale = updateLocale;
hooks.locales = listLocales;
hooks.weekdaysShort = listWeekdaysShort;
hooks.normalizeUnits = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat = getCalendarFormat;
hooks.prototype = proto;
hooks.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
var Option = {};
var Applicative = {};
var Apply = {};
var _function = {};
(function(exports) {
  var __spreadArray = commonjsGlobal && commonjsGlobal.__spreadArray || function(to2, from2, pack) {
    if (pack || arguments.length === 2)
      for (var i = 0, l = from2.length, ar; i < l; i++) {
        if (ar || !(i in from2)) {
          if (!ar)
            ar = Array.prototype.slice.call(from2, 0, i);
          ar[i] = from2[i];
        }
      }
    return to2.concat(ar || Array.prototype.slice.call(from2));
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.dual = exports.getEndomorphismMonoid = exports.SK = exports.hole = exports.constVoid = exports.constUndefined = exports.constNull = exports.constFalse = exports.constTrue = exports.unsafeCoerce = exports.apply = exports.getRing = exports.getSemiring = exports.getMonoid = exports.getSemigroup = exports.getBooleanAlgebra = void 0;
  exports.identity = identity;
  exports.constant = constant;
  exports.flip = flip;
  exports.flow = flow;
  exports.tuple = tuple;
  exports.increment = increment;
  exports.decrement = decrement;
  exports.absurd = absurd;
  exports.tupled = tupled;
  exports.untupled = untupled;
  exports.pipe = pipe;
  exports.not = not;
  var getBooleanAlgebra = function(B) {
    return function() {
      return {
        meet: function(x, y) {
          return function(a) {
            return B.meet(x(a), y(a));
          };
        },
        join: function(x, y) {
          return function(a) {
            return B.join(x(a), y(a));
          };
        },
        zero: function() {
          return B.zero;
        },
        one: function() {
          return B.one;
        },
        implies: function(x, y) {
          return function(a) {
            return B.implies(x(a), y(a));
          };
        },
        not: function(x) {
          return function(a) {
            return B.not(x(a));
          };
        }
      };
    };
  };
  exports.getBooleanAlgebra = getBooleanAlgebra;
  var getSemigroup = function(S2) {
    return function() {
      return {
        concat: function(f, g) {
          return function(a) {
            return S2.concat(f(a), g(a));
          };
        }
      };
    };
  };
  exports.getSemigroup = getSemigroup;
  var getMonoid = function(M) {
    var getSemigroupM = (0, exports.getSemigroup)(M);
    return function() {
      return {
        concat: getSemigroupM().concat,
        empty: function() {
          return M.empty;
        }
      };
    };
  };
  exports.getMonoid = getMonoid;
  var getSemiring = function(S2) {
    return {
      add: function(f, g) {
        return function(x) {
          return S2.add(f(x), g(x));
        };
      },
      zero: function() {
        return S2.zero;
      },
      mul: function(f, g) {
        return function(x) {
          return S2.mul(f(x), g(x));
        };
      },
      one: function() {
        return S2.one;
      }
    };
  };
  exports.getSemiring = getSemiring;
  var getRing = function(R) {
    var S2 = (0, exports.getSemiring)(R);
    return {
      add: S2.add,
      mul: S2.mul,
      one: S2.one,
      zero: S2.zero,
      sub: function(f, g) {
        return function(x) {
          return R.sub(f(x), g(x));
        };
      }
    };
  };
  exports.getRing = getRing;
  var apply = function(a) {
    return function(f) {
      return f(a);
    };
  };
  exports.apply = apply;
  function identity(a) {
    return a;
  }
  exports.unsafeCoerce = identity;
  function constant(a) {
    return function() {
      return a;
    };
  }
  exports.constTrue = constant(true);
  exports.constFalse = constant(false);
  exports.constNull = constant(null);
  exports.constUndefined = constant(void 0);
  exports.constVoid = exports.constUndefined;
  function flip(f) {
    return function() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      if (args.length > 1) {
        return f(args[1], args[0]);
      }
      return function(a) {
        return f(a)(args[0]);
      };
    };
  }
  function flow(ab, bc, cd, de, ef, fg, gh, hi, ij) {
    switch (arguments.length) {
      case 1:
        return ab;
      case 2:
        return function() {
          return bc(ab.apply(this, arguments));
        };
      case 3:
        return function() {
          return cd(bc(ab.apply(this, arguments)));
        };
      case 4:
        return function() {
          return de(cd(bc(ab.apply(this, arguments))));
        };
      case 5:
        return function() {
          return ef(de(cd(bc(ab.apply(this, arguments)))));
        };
      case 6:
        return function() {
          return fg(ef(de(cd(bc(ab.apply(this, arguments))))));
        };
      case 7:
        return function() {
          return gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))));
        };
      case 8:
        return function() {
          return hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments))))))));
        };
      case 9:
        return function() {
          return ij(hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))))));
        };
    }
    return;
  }
  function tuple() {
    var t = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      t[_i] = arguments[_i];
    }
    return t;
  }
  function increment(n) {
    return n + 1;
  }
  function decrement(n) {
    return n - 1;
  }
  function absurd(_2) {
    throw new Error("Called `absurd` function which should be uncallable");
  }
  function tupled(f) {
    return function(a) {
      return f.apply(void 0, a);
    };
  }
  function untupled(f) {
    return function() {
      var a = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        a[_i] = arguments[_i];
      }
      return f(a);
    };
  }
  function pipe(a, ab, bc, cd, de, ef, fg, gh, hi) {
    switch (arguments.length) {
      case 1:
        return a;
      case 2:
        return ab(a);
      case 3:
        return bc(ab(a));
      case 4:
        return cd(bc(ab(a)));
      case 5:
        return de(cd(bc(ab(a))));
      case 6:
        return ef(de(cd(bc(ab(a)))));
      case 7:
        return fg(ef(de(cd(bc(ab(a))))));
      case 8:
        return gh(fg(ef(de(cd(bc(ab(a)))))));
      case 9:
        return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
      default: {
        var ret = arguments[0];
        for (var i = 1; i < arguments.length; i++) {
          ret = arguments[i](ret);
        }
        return ret;
      }
    }
  }
  exports.hole = absurd;
  var SK = function(_2, b) {
    return b;
  };
  exports.SK = SK;
  function not(predicate) {
    return function(a) {
      return !predicate(a);
    };
  }
  var getEndomorphismMonoid = function() {
    return {
      concat: function(first, second) {
        return flow(first, second);
      },
      empty: identity
    };
  };
  exports.getEndomorphismMonoid = getEndomorphismMonoid;
  var dual = function(arity, body) {
    var isDataFirst = typeof arity === "number" ? function(args) {
      return args.length >= arity;
    } : arity;
    return function() {
      var args = Array.from(arguments);
      if (isDataFirst(arguments)) {
        return body.apply(this, args);
      }
      return function(self2) {
        return body.apply(void 0, __spreadArray([self2], args, false));
      };
    };
  };
  exports.dual = dual;
})(_function);
var internal = {};
(function(exports) {
  var __spreadArray = commonjsGlobal && commonjsGlobal.__spreadArray || function(to2, from2, pack) {
    if (pack || arguments.length === 2)
      for (var i = 0, l = from2.length, ar; i < l; i++) {
        if (ar || !(i in from2)) {
          if (!ar)
            ar = Array.prototype.slice.call(from2, 0, i);
          ar[i] = from2[i];
        }
      }
    return to2.concat(ar || Array.prototype.slice.call(from2));
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.flatMapReader = exports.flatMapTask = exports.flatMapIO = exports.flatMapEither = exports.flatMapOption = exports.flatMapNullable = exports.liftOption = exports.liftNullable = exports.fromReadonlyNonEmptyArray = exports.has = exports.emptyRecord = exports.emptyReadonlyArray = exports.tail = exports.head = exports.isNonEmpty = exports.singleton = exports.right = exports.left = exports.isRight = exports.isLeft = exports.some = exports.none = exports.isSome = exports.isNone = void 0;
  var function_12 = _function;
  var isNone = function(fa) {
    return fa._tag === "None";
  };
  exports.isNone = isNone;
  var isSome = function(fa) {
    return fa._tag === "Some";
  };
  exports.isSome = isSome;
  exports.none = { _tag: "None" };
  var some2 = function(a) {
    return { _tag: "Some", value: a };
  };
  exports.some = some2;
  var isLeft = function(ma) {
    return ma._tag === "Left";
  };
  exports.isLeft = isLeft;
  var isRight = function(ma) {
    return ma._tag === "Right";
  };
  exports.isRight = isRight;
  var left2 = function(e) {
    return { _tag: "Left", left: e };
  };
  exports.left = left2;
  var right2 = function(a) {
    return { _tag: "Right", right: a };
  };
  exports.right = right2;
  var singleton = function(a) {
    return [a];
  };
  exports.singleton = singleton;
  var isNonEmpty = function(as2) {
    return as2.length > 0;
  };
  exports.isNonEmpty = isNonEmpty;
  var head = function(as2) {
    return as2[0];
  };
  exports.head = head;
  var tail = function(as2) {
    return as2.slice(1);
  };
  exports.tail = tail;
  exports.emptyReadonlyArray = [];
  exports.emptyRecord = {};
  exports.has = Object.prototype.hasOwnProperty;
  var fromReadonlyNonEmptyArray = function(as2) {
    return __spreadArray([as2[0]], as2.slice(1), true);
  };
  exports.fromReadonlyNonEmptyArray = fromReadonlyNonEmptyArray;
  var liftNullable = function(F) {
    return function(f, onNullable) {
      return function() {
        var a = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          a[_i] = arguments[_i];
        }
        var o = f.apply(void 0, a);
        return F.fromEither(o == null ? (0, exports.left)(onNullable.apply(void 0, a)) : (0, exports.right)(o));
      };
    };
  };
  exports.liftNullable = liftNullable;
  var liftOption = function(F) {
    return function(f, onNone) {
      return function() {
        var a = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          a[_i] = arguments[_i];
        }
        var o = f.apply(void 0, a);
        return F.fromEither((0, exports.isNone)(o) ? (0, exports.left)(onNone.apply(void 0, a)) : (0, exports.right)(o.value));
      };
    };
  };
  exports.liftOption = liftOption;
  var flatMapNullable = function(F, M) {
    return /* @__PURE__ */ (0, function_12.dual)(3, function(self2, f, onNullable) {
      return M.flatMap(self2, (0, exports.liftNullable)(F)(f, onNullable));
    });
  };
  exports.flatMapNullable = flatMapNullable;
  var flatMapOption = function(F, M) {
    return /* @__PURE__ */ (0, function_12.dual)(3, function(self2, f, onNone) {
      return M.flatMap(self2, (0, exports.liftOption)(F)(f, onNone));
    });
  };
  exports.flatMapOption = flatMapOption;
  var flatMapEither = function(F, M) {
    return /* @__PURE__ */ (0, function_12.dual)(2, function(self2, f) {
      return M.flatMap(self2, function(a) {
        return F.fromEither(f(a));
      });
    });
  };
  exports.flatMapEither = flatMapEither;
  var flatMapIO = function(F, M) {
    return /* @__PURE__ */ (0, function_12.dual)(2, function(self2, f) {
      return M.flatMap(self2, function(a) {
        return F.fromIO(f(a));
      });
    });
  };
  exports.flatMapIO = flatMapIO;
  var flatMapTask = function(F, M) {
    return /* @__PURE__ */ (0, function_12.dual)(2, function(self2, f) {
      return M.flatMap(self2, function(a) {
        return F.fromTask(f(a));
      });
    });
  };
  exports.flatMapTask = flatMapTask;
  var flatMapReader = function(F, M) {
    return /* @__PURE__ */ (0, function_12.dual)(2, function(self2, f) {
      return M.flatMap(self2, function(a) {
        return F.fromReader(f(a));
      });
    });
  };
  exports.flatMapReader = flatMapReader;
})(internal);
var __createBinding$4 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = { enumerable: true, get: function() {
      return m[k];
    } };
  }
  Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$4 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
} : function(o, v) {
  o["default"] = v;
});
var __importStar$4 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
  if (mod2 && mod2.__esModule)
    return mod2;
  var result2 = {};
  if (mod2 != null) {
    for (var k in mod2)
      if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
        __createBinding$4(result2, mod2, k);
  }
  __setModuleDefault$4(result2, mod2);
  return result2;
};
Object.defineProperty(Apply, "__esModule", { value: true });
Apply.ap = ap$1;
Apply.apFirst = apFirst;
Apply.apSecond = apSecond;
Apply.apS = apS;
Apply.getApplySemigroup = getApplySemigroup;
Apply.sequenceT = sequenceT;
Apply.sequenceS = sequenceS;
var function_1$8 = _function;
var _$2 = __importStar$4(internal);
function ap$1(F, G) {
  return function(fa) {
    return function(fab) {
      return F.ap(F.map(fab, function(gab) {
        return function(ga) {
          return G.ap(gab, ga);
        };
      }), fa);
    };
  };
}
function apFirst(A) {
  return function(second) {
    return function(first) {
      return A.ap(A.map(first, function(a) {
        return function() {
          return a;
        };
      }), second);
    };
  };
}
function apSecond(A) {
  return function(second) {
    return function(first) {
      return A.ap(A.map(first, function() {
        return function(b) {
          return b;
        };
      }), second);
    };
  };
}
function apS(F) {
  return function(name, fb) {
    return function(fa) {
      return F.ap(F.map(fa, function(a) {
        return function(b) {
          var _a;
          return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
        };
      }), fb);
    };
  };
}
function getApplySemigroup(F) {
  return function(S2) {
    return {
      concat: function(first, second) {
        return F.ap(F.map(first, function(x) {
          return function(y) {
            return S2.concat(x, y);
          };
        }), second);
      }
    };
  };
}
function curried(f, n, acc) {
  return function(x) {
    var combined = Array(acc.length + 1);
    for (var i = 0; i < acc.length; i++) {
      combined[i] = acc[i];
    }
    combined[acc.length] = x;
    return n === 0 ? f.apply(null, combined) : curried(f, n - 1, combined);
  };
}
var tupleConstructors = {
  1: function(a) {
    return [a];
  },
  2: function(a) {
    return function(b) {
      return [a, b];
    };
  },
  3: function(a) {
    return function(b) {
      return function(c) {
        return [a, b, c];
      };
    };
  },
  4: function(a) {
    return function(b) {
      return function(c) {
        return function(d) {
          return [a, b, c, d];
        };
      };
    };
  },
  5: function(a) {
    return function(b) {
      return function(c) {
        return function(d) {
          return function(e) {
            return [a, b, c, d, e];
          };
        };
      };
    };
  }
};
function getTupleConstructor(len) {
  if (!_$2.has.call(tupleConstructors, len)) {
    tupleConstructors[len] = curried(function_1$8.tuple, len - 1, []);
  }
  return tupleConstructors[len];
}
function sequenceT(F) {
  return function() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var len = args.length;
    var f = getTupleConstructor(len);
    var fas = F.map(args[0], f);
    for (var i = 1; i < len; i++) {
      fas = F.ap(fas, args[i]);
    }
    return fas;
  };
}
function getRecordConstructor(keys2) {
  var len = keys2.length;
  switch (len) {
    case 1:
      return function(a) {
        var _a;
        return _a = {}, _a[keys2[0]] = a, _a;
      };
    case 2:
      return function(a) {
        return function(b) {
          var _a;
          return _a = {}, _a[keys2[0]] = a, _a[keys2[1]] = b, _a;
        };
      };
    case 3:
      return function(a) {
        return function(b) {
          return function(c) {
            var _a;
            return _a = {}, _a[keys2[0]] = a, _a[keys2[1]] = b, _a[keys2[2]] = c, _a;
          };
        };
      };
    case 4:
      return function(a) {
        return function(b) {
          return function(c) {
            return function(d) {
              var _a;
              return _a = {}, _a[keys2[0]] = a, _a[keys2[1]] = b, _a[keys2[2]] = c, _a[keys2[3]] = d, _a;
            };
          };
        };
      };
    case 5:
      return function(a) {
        return function(b) {
          return function(c) {
            return function(d) {
              return function(e) {
                var _a;
                return _a = {}, _a[keys2[0]] = a, _a[keys2[1]] = b, _a[keys2[2]] = c, _a[keys2[3]] = d, _a[keys2[4]] = e, _a;
              };
            };
          };
        };
      };
    default:
      return curried(function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        var r = {};
        for (var i = 0; i < len; i++) {
          r[keys2[i]] = args[i];
        }
        return r;
      }, len - 1, []);
  }
}
function sequenceS(F) {
  return function(r) {
    var keys2 = Object.keys(r);
    var len = keys2.length;
    var f = getRecordConstructor(keys2);
    var fr = F.map(r[keys2[0]], f);
    for (var i = 1; i < len; i++) {
      fr = F.ap(fr, r[keys2[i]]);
    }
    return fr;
  };
}
var Functor = {};
Object.defineProperty(Functor, "__esModule", { value: true });
Functor.map = map$1;
Functor.flap = flap;
Functor.bindTo = bindTo;
Functor.let = let_;
Functor.getFunctorComposition = getFunctorComposition;
Functor.as = as;
Functor.asUnit = asUnit;
var function_1$7 = _function;
function map$1(F, G) {
  return function(f) {
    return function(fa) {
      return F.map(fa, function(ga) {
        return G.map(ga, f);
      });
    };
  };
}
function flap(F) {
  return function(a) {
    return function(fab) {
      return F.map(fab, function(f) {
        return f(a);
      });
    };
  };
}
function bindTo(F) {
  return function(name) {
    return function(fa) {
      return F.map(fa, function(a) {
        var _a;
        return _a = {}, _a[name] = a, _a;
      });
    };
  };
}
function let_(F) {
  return function(name, f) {
    return function(fa) {
      return F.map(fa, function(a) {
        var _a;
        return Object.assign({}, a, (_a = {}, _a[name] = f(a), _a));
      });
    };
  };
}
function getFunctorComposition(F, G) {
  var _map = map$1(F, G);
  return {
    map: function(fga, f) {
      return (0, function_1$7.pipe)(fga, _map(f));
    }
  };
}
function as(F) {
  return function(self2, b) {
    return F.map(self2, function() {
      return b;
    });
  };
}
function asUnit(F) {
  var asM = as(F);
  return function(self2) {
    return asM(self2, void 0);
  };
}
Object.defineProperty(Applicative, "__esModule", { value: true });
Applicative.getApplicativeMonoid = getApplicativeMonoid;
Applicative.getApplicativeComposition = getApplicativeComposition;
var Apply_1$1 = Apply;
var function_1$6 = _function;
var Functor_1$3 = Functor;
function getApplicativeMonoid(F) {
  var f = (0, Apply_1$1.getApplySemigroup)(F);
  return function(M) {
    return {
      concat: f(M).concat,
      empty: F.of(M.empty)
    };
  };
}
function getApplicativeComposition(F, G) {
  var map2 = (0, Functor_1$3.getFunctorComposition)(F, G).map;
  var _ap = (0, Apply_1$1.ap)(F, G);
  return {
    map: map2,
    of: function(a) {
      return F.of(G.of(a));
    },
    ap: function(fgab, fga) {
      return (0, function_1$6.pipe)(fgab, _ap(fga));
    }
  };
}
var Chain = {};
Object.defineProperty(Chain, "__esModule", { value: true });
Chain.chainFirst = chainFirst;
Chain.tap = tap;
Chain.bind = bind$1;
function chainFirst(M) {
  var tapM = tap(M);
  return function(f) {
    return function(first) {
      return tapM(first, f);
    };
  };
}
function tap(M) {
  return function(first, f) {
    return M.chain(first, function(a) {
      return M.map(f(a), function() {
        return a;
      });
    });
  };
}
function bind$1(M) {
  return function(name, f) {
    return function(ma) {
      return M.chain(ma, function(a) {
        return M.map(f(a), function(b) {
          var _a;
          return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
        });
      });
    };
  };
}
var FromEither = {};
var __createBinding$3 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = { enumerable: true, get: function() {
      return m[k];
    } };
  }
  Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$3 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
} : function(o, v) {
  o["default"] = v;
});
var __importStar$3 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
  if (mod2 && mod2.__esModule)
    return mod2;
  var result2 = {};
  if (mod2 != null) {
    for (var k in mod2)
      if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
        __createBinding$3(result2, mod2, k);
  }
  __setModuleDefault$3(result2, mod2);
  return result2;
};
Object.defineProperty(FromEither, "__esModule", { value: true });
FromEither.fromOption = fromOption;
FromEither.fromPredicate = fromPredicate;
FromEither.fromOptionK = fromOptionK;
FromEither.chainOptionK = chainOptionK;
FromEither.fromEitherK = fromEitherK;
FromEither.chainEitherK = chainEitherK;
FromEither.chainFirstEitherK = chainFirstEitherK;
FromEither.filterOrElse = filterOrElse;
FromEither.tapEither = tapEither;
var Chain_1$2 = Chain;
var function_1$5 = _function;
var _$1 = __importStar$3(internal);
function fromOption(F) {
  return function(onNone) {
    return function(ma) {
      return F.fromEither(_$1.isNone(ma) ? _$1.left(onNone()) : _$1.right(ma.value));
    };
  };
}
function fromPredicate(F) {
  return function(predicate, onFalse) {
    return function(a) {
      return F.fromEither(predicate(a) ? _$1.right(a) : _$1.left(onFalse(a)));
    };
  };
}
function fromOptionK(F) {
  var fromOptionF = fromOption(F);
  return function(onNone) {
    var from2 = fromOptionF(onNone);
    return function(f) {
      return (0, function_1$5.flow)(f, from2);
    };
  };
}
function chainOptionK(F, M) {
  var fromOptionKF = fromOptionK(F);
  return function(onNone) {
    var from2 = fromOptionKF(onNone);
    return function(f) {
      return function(ma) {
        return M.chain(ma, from2(f));
      };
    };
  };
}
function fromEitherK(F) {
  return function(f) {
    return (0, function_1$5.flow)(f, F.fromEither);
  };
}
function chainEitherK(F, M) {
  var fromEitherKF = fromEitherK(F);
  return function(f) {
    return function(ma) {
      return M.chain(ma, fromEitherKF(f));
    };
  };
}
function chainFirstEitherK(F, M) {
  var tapEitherM = tapEither(F, M);
  return function(f) {
    return function(ma) {
      return tapEitherM(ma, f);
    };
  };
}
function filterOrElse(F, M) {
  return function(predicate, onFalse) {
    return function(ma) {
      return M.chain(ma, function(a) {
        return F.fromEither(predicate(a) ? _$1.right(a) : _$1.left(onFalse(a)));
      });
    };
  };
}
function tapEither(F, M) {
  var fromEither = fromEitherK(F);
  var tapM = (0, Chain_1$2.tap)(M);
  return function(self2, f) {
    return tapM(self2, fromEither(f));
  };
}
var Predicate = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.and = exports.or = exports.not = exports.Contravariant = exports.getMonoidAll = exports.getSemigroupAll = exports.getMonoidAny = exports.getSemigroupAny = exports.URI = exports.contramap = void 0;
  var function_12 = _function;
  var contramap_ = function(predicate, f) {
    return (0, function_12.pipe)(predicate, (0, exports.contramap)(f));
  };
  var contramap = function(f) {
    return function(predicate) {
      return (0, function_12.flow)(f, predicate);
    };
  };
  exports.contramap = contramap;
  exports.URI = "Predicate";
  var getSemigroupAny = function() {
    return {
      concat: function(first, second) {
        return (0, function_12.pipe)(first, (0, exports.or)(second));
      }
    };
  };
  exports.getSemigroupAny = getSemigroupAny;
  var getMonoidAny = function() {
    return {
      concat: (0, exports.getSemigroupAny)().concat,
      empty: function_12.constFalse
    };
  };
  exports.getMonoidAny = getMonoidAny;
  var getSemigroupAll = function() {
    return {
      concat: function(first, second) {
        return (0, function_12.pipe)(first, (0, exports.and)(second));
      }
    };
  };
  exports.getSemigroupAll = getSemigroupAll;
  var getMonoidAll = function() {
    return {
      concat: (0, exports.getSemigroupAll)().concat,
      empty: function_12.constTrue
    };
  };
  exports.getMonoidAll = getMonoidAll;
  exports.Contravariant = {
    URI: exports.URI,
    contramap: contramap_
  };
  var not = function(predicate) {
    return function(a) {
      return !predicate(a);
    };
  };
  exports.not = not;
  var or = function(second) {
    return function(first) {
      return function(a) {
        return first(a) || second(a);
      };
    };
  };
  exports.or = or;
  var and = function(second) {
    return function(first) {
      return function(a) {
        return first(a) && second(a);
      };
    };
  };
  exports.and = and;
})(Predicate);
var Semigroup = {};
var Magma = {};
Object.defineProperty(Magma, "__esModule", { value: true });
Magma.concatAll = Magma.endo = Magma.filterSecond = Magma.filterFirst = Magma.reverse = void 0;
var reverse = function(M) {
  return {
    concat: function(first, second) {
      return M.concat(second, first);
    }
  };
};
Magma.reverse = reverse;
var filterFirst = function(predicate) {
  return function(M) {
    return {
      concat: function(first, second) {
        return predicate(first) ? M.concat(first, second) : second;
      }
    };
  };
};
Magma.filterFirst = filterFirst;
var filterSecond = function(predicate) {
  return function(M) {
    return {
      concat: function(first, second) {
        return predicate(second) ? M.concat(first, second) : first;
      }
    };
  };
};
Magma.filterSecond = filterSecond;
var endo = function(f) {
  return function(M) {
    return {
      concat: function(first, second) {
        return M.concat(f(first), f(second));
      }
    };
  };
};
Magma.endo = endo;
var concatAll = function(M) {
  return function(startWith) {
    return function(as2) {
      return as2.reduce(function(a, acc) {
        return M.concat(a, acc);
      }, startWith);
    };
  };
};
Magma.concatAll = concatAll;
var Ord = {};
var Eq = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.eqDate = exports.eqNumber = exports.eqString = exports.eqBoolean = exports.eq = exports.strictEqual = exports.getStructEq = exports.getTupleEq = exports.Contravariant = exports.getMonoid = exports.getSemigroup = exports.eqStrict = exports.URI = exports.contramap = exports.tuple = exports.struct = exports.fromEquals = void 0;
  var function_12 = _function;
  var fromEquals = function(equals) {
    return {
      equals: function(x, y) {
        return x === y || equals(x, y);
      }
    };
  };
  exports.fromEquals = fromEquals;
  var struct = function(eqs) {
    return (0, exports.fromEquals)(function(first, second) {
      for (var key in eqs) {
        if (!eqs[key].equals(first[key], second[key])) {
          return false;
        }
      }
      return true;
    });
  };
  exports.struct = struct;
  var tuple = function() {
    var eqs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      eqs[_i] = arguments[_i];
    }
    return (0, exports.fromEquals)(function(first, second) {
      return eqs.every(function(E2, i) {
        return E2.equals(first[i], second[i]);
      });
    });
  };
  exports.tuple = tuple;
  var contramap_ = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.contramap)(f));
  };
  var contramap = function(f) {
    return function(fa) {
      return (0, exports.fromEquals)(function(x, y) {
        return fa.equals(f(x), f(y));
      });
    };
  };
  exports.contramap = contramap;
  exports.URI = "Eq";
  exports.eqStrict = {
    equals: function(a, b) {
      return a === b;
    }
  };
  var empty = {
    equals: function() {
      return true;
    }
  };
  var getSemigroup = function() {
    return {
      concat: function(x, y) {
        return (0, exports.fromEquals)(function(a, b) {
          return x.equals(a, b) && y.equals(a, b);
        });
      }
    };
  };
  exports.getSemigroup = getSemigroup;
  var getMonoid = function() {
    return {
      concat: (0, exports.getSemigroup)().concat,
      empty
    };
  };
  exports.getMonoid = getMonoid;
  exports.Contravariant = {
    URI: exports.URI,
    contramap: contramap_
  };
  exports.getTupleEq = exports.tuple;
  exports.getStructEq = exports.struct;
  exports.strictEqual = exports.eqStrict.equals;
  exports.eq = exports.Contravariant;
  exports.eqBoolean = exports.eqStrict;
  exports.eqString = exports.eqStrict;
  exports.eqNumber = exports.eqStrict;
  exports.eqDate = {
    equals: function(first, second) {
      return first.valueOf() === second.valueOf();
    }
  };
})(Eq);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.ordDate = exports.ordNumber = exports.ordString = exports.ordBoolean = exports.ord = exports.getDualOrd = exports.getTupleOrd = exports.between = exports.clamp = exports.max = exports.min = exports.geq = exports.leq = exports.gt = exports.lt = exports.equals = exports.trivial = exports.Contravariant = exports.getMonoid = exports.getSemigroup = exports.URI = exports.contramap = exports.reverse = exports.tuple = exports.fromCompare = exports.equalsDefault = void 0;
  var Eq_1 = Eq;
  var function_12 = _function;
  var equalsDefault = function(compare2) {
    return function(first, second) {
      return first === second || compare2(first, second) === 0;
    };
  };
  exports.equalsDefault = equalsDefault;
  var fromCompare = function(compare2) {
    return {
      equals: (0, exports.equalsDefault)(compare2),
      compare: function(first, second) {
        return first === second ? 0 : compare2(first, second);
      }
    };
  };
  exports.fromCompare = fromCompare;
  var tuple = function() {
    var ords = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      ords[_i] = arguments[_i];
    }
    return (0, exports.fromCompare)(function(first, second) {
      var i = 0;
      for (; i < ords.length - 1; i++) {
        var r = ords[i].compare(first[i], second[i]);
        if (r !== 0) {
          return r;
        }
      }
      return ords[i].compare(first[i], second[i]);
    });
  };
  exports.tuple = tuple;
  var reverse2 = function(O) {
    return (0, exports.fromCompare)(function(first, second) {
      return O.compare(second, first);
    });
  };
  exports.reverse = reverse2;
  var contramap_ = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.contramap)(f));
  };
  var contramap = function(f) {
    return function(fa) {
      return (0, exports.fromCompare)(function(first, second) {
        return fa.compare(f(first), f(second));
      });
    };
  };
  exports.contramap = contramap;
  exports.URI = "Ord";
  var getSemigroup = function() {
    return {
      concat: function(first, second) {
        return (0, exports.fromCompare)(function(a, b) {
          var ox = first.compare(a, b);
          return ox !== 0 ? ox : second.compare(a, b);
        });
      }
    };
  };
  exports.getSemigroup = getSemigroup;
  var getMonoid = function() {
    return {
      concat: (0, exports.getSemigroup)().concat,
      empty: (0, exports.fromCompare)(function() {
        return 0;
      })
    };
  };
  exports.getMonoid = getMonoid;
  exports.Contravariant = {
    URI: exports.URI,
    contramap: contramap_
  };
  exports.trivial = {
    equals: function_12.constTrue,
    compare: /* @__PURE__ */ (0, function_12.constant)(0)
  };
  var equals = function(O) {
    return function(second) {
      return function(first) {
        return first === second || O.compare(first, second) === 0;
      };
    };
  };
  exports.equals = equals;
  var lt = function(O) {
    return function(first, second) {
      return O.compare(first, second) === -1;
    };
  };
  exports.lt = lt;
  var gt = function(O) {
    return function(first, second) {
      return O.compare(first, second) === 1;
    };
  };
  exports.gt = gt;
  var leq = function(O) {
    return function(first, second) {
      return O.compare(first, second) !== 1;
    };
  };
  exports.leq = leq;
  var geq = function(O) {
    return function(first, second) {
      return O.compare(first, second) !== -1;
    };
  };
  exports.geq = geq;
  var min2 = function(O) {
    return function(first, second) {
      return first === second || O.compare(first, second) < 1 ? first : second;
    };
  };
  exports.min = min2;
  var max2 = function(O) {
    return function(first, second) {
      return first === second || O.compare(first, second) > -1 ? first : second;
    };
  };
  exports.max = max2;
  var clamp2 = function(O) {
    var minO = (0, exports.min)(O);
    var maxO = (0, exports.max)(O);
    return function(low, hi) {
      return function(a) {
        return maxO(minO(a, hi), low);
      };
    };
  };
  exports.clamp = clamp2;
  var between = function(O) {
    var ltO = (0, exports.lt)(O);
    var gtO = (0, exports.gt)(O);
    return function(low, hi) {
      return function(a) {
        return ltO(a, low) || gtO(a, hi) ? false : true;
      };
    };
  };
  exports.between = between;
  exports.getTupleOrd = exports.tuple;
  exports.getDualOrd = exports.reverse;
  exports.ord = exports.Contravariant;
  function compare(first, second) {
    return first < second ? -1 : first > second ? 1 : 0;
  }
  var strictOrd = {
    equals: Eq_1.eqStrict.equals,
    compare
  };
  exports.ordBoolean = strictOrd;
  exports.ordString = strictOrd;
  exports.ordNumber = strictOrd;
  exports.ordDate = (0, function_12.pipe)(
    exports.ordNumber,
    /* @__PURE__ */ (0, exports.contramap)(function(date) {
      return date.valueOf();
    })
  );
})(Ord);
(function(exports) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule)
      return mod2;
    var result2 = {};
    if (mod2 != null) {
      for (var k in mod2)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
          __createBinding2(result2, mod2, k);
    }
    __setModuleDefault2(result2, mod2);
    return result2;
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.semigroupProduct = exports.semigroupSum = exports.semigroupString = exports.getFunctionSemigroup = exports.semigroupAny = exports.semigroupAll = exports.getIntercalateSemigroup = exports.getMeetSemigroup = exports.getJoinSemigroup = exports.getDualSemigroup = exports.getStructSemigroup = exports.getTupleSemigroup = exports.getFirstSemigroup = exports.getLastSemigroup = exports.getObjectSemigroup = exports.semigroupVoid = exports.concatAll = exports.last = exports.first = exports.intercalate = exports.tuple = exports.struct = exports.reverse = exports.constant = exports.max = exports.min = void 0;
  exports.fold = fold;
  var function_12 = _function;
  var _2 = __importStar2(internal);
  var M = __importStar2(Magma);
  var Or = __importStar2(Ord);
  var min2 = function(O) {
    return {
      concat: Or.min(O)
    };
  };
  exports.min = min2;
  var max2 = function(O) {
    return {
      concat: Or.max(O)
    };
  };
  exports.max = max2;
  var constant = function(a) {
    return {
      concat: function() {
        return a;
      }
    };
  };
  exports.constant = constant;
  exports.reverse = M.reverse;
  var struct = function(semigroups) {
    return {
      concat: function(first2, second) {
        var r = {};
        for (var k in semigroups) {
          if (_2.has.call(semigroups, k)) {
            r[k] = semigroups[k].concat(first2[k], second[k]);
          }
        }
        return r;
      }
    };
  };
  exports.struct = struct;
  var tuple = function() {
    var semigroups = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      semigroups[_i] = arguments[_i];
    }
    return {
      concat: function(first2, second) {
        return semigroups.map(function(s, i) {
          return s.concat(first2[i], second[i]);
        });
      }
    };
  };
  exports.tuple = tuple;
  var intercalate = function(middle) {
    return function(S2) {
      return {
        concat: function(x, y) {
          return S2.concat(x, S2.concat(middle, y));
        }
      };
    };
  };
  exports.intercalate = intercalate;
  var first = function() {
    return { concat: function_12.identity };
  };
  exports.first = first;
  var last = function() {
    return { concat: function(_3, y) {
      return y;
    } };
  };
  exports.last = last;
  exports.concatAll = M.concatAll;
  exports.semigroupVoid = (0, exports.constant)(void 0);
  var getObjectSemigroup = function() {
    return {
      concat: function(first2, second) {
        return Object.assign({}, first2, second);
      }
    };
  };
  exports.getObjectSemigroup = getObjectSemigroup;
  exports.getLastSemigroup = exports.last;
  exports.getFirstSemigroup = exports.first;
  exports.getTupleSemigroup = exports.tuple;
  exports.getStructSemigroup = exports.struct;
  exports.getDualSemigroup = exports.reverse;
  exports.getJoinSemigroup = exports.max;
  exports.getMeetSemigroup = exports.min;
  exports.getIntercalateSemigroup = exports.intercalate;
  function fold(S2) {
    var concatAllS = (0, exports.concatAll)(S2);
    return function(startWith, as2) {
      return as2 === void 0 ? concatAllS(startWith) : concatAllS(startWith)(as2);
    };
  }
  exports.semigroupAll = {
    concat: function(x, y) {
      return x && y;
    }
  };
  exports.semigroupAny = {
    concat: function(x, y) {
      return x || y;
    }
  };
  exports.getFunctionSemigroup = function_12.getSemigroup;
  exports.semigroupString = {
    concat: function(x, y) {
      return x + y;
    }
  };
  exports.semigroupSum = {
    concat: function(x, y) {
      return x + y;
    }
  };
  exports.semigroupProduct = {
    concat: function(x, y) {
      return x * y;
    }
  };
})(Semigroup);
var Separated = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.right = exports.left = exports.flap = exports.Functor = exports.Bifunctor = exports.URI = exports.bimap = exports.mapLeft = exports.map = exports.separated = void 0;
  var function_12 = _function;
  var Functor_12 = Functor;
  var separated = function(left3, right3) {
    return { left: left3, right: right3 };
  };
  exports.separated = separated;
  var _map = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.map)(f));
  };
  var _mapLeft = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.mapLeft)(f));
  };
  var _bimap = function(fa, g, f) {
    return (0, function_12.pipe)(fa, (0, exports.bimap)(g, f));
  };
  var map2 = function(f) {
    return function(fa) {
      return (0, exports.separated)((0, exports.left)(fa), f((0, exports.right)(fa)));
    };
  };
  exports.map = map2;
  var mapLeft2 = function(f) {
    return function(fa) {
      return (0, exports.separated)(f((0, exports.left)(fa)), (0, exports.right)(fa));
    };
  };
  exports.mapLeft = mapLeft2;
  var bimap2 = function(f, g) {
    return function(fa) {
      return (0, exports.separated)(f((0, exports.left)(fa)), g((0, exports.right)(fa)));
    };
  };
  exports.bimap = bimap2;
  exports.URI = "Separated";
  exports.Bifunctor = {
    URI: exports.URI,
    mapLeft: _mapLeft,
    bimap: _bimap
  };
  exports.Functor = {
    URI: exports.URI,
    map: _map
  };
  exports.flap = (0, Functor_12.flap)(exports.Functor);
  var left2 = function(s) {
    return s.left;
  };
  exports.left = left2;
  var right2 = function(s) {
    return s.right;
  };
  exports.right = right2;
})(Separated);
var Witherable = {};
var __createBinding$2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = { enumerable: true, get: function() {
      return m[k];
    } };
  }
  Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
} : function(o, v) {
  o["default"] = v;
});
var __importStar$2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
  if (mod2 && mod2.__esModule)
    return mod2;
  var result2 = {};
  if (mod2 != null) {
    for (var k in mod2)
      if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
        __createBinding$2(result2, mod2, k);
  }
  __setModuleDefault$2(result2, mod2);
  return result2;
};
Object.defineProperty(Witherable, "__esModule", { value: true });
Witherable.wiltDefault = wiltDefault;
Witherable.witherDefault = witherDefault;
Witherable.filterE = filterE;
var _ = __importStar$2(internal);
function wiltDefault(T, C) {
  return function(F) {
    var traverseF = T.traverse(F);
    return function(wa, f) {
      return F.map(traverseF(wa, f), C.separate);
    };
  };
}
function witherDefault(T, C) {
  return function(F) {
    var traverseF = T.traverse(F);
    return function(wa, f) {
      return F.map(traverseF(wa, f), C.compact);
    };
  };
}
function filterE(W) {
  return function(F) {
    var witherF = W.wither(F);
    return function(predicate) {
      return function(ga) {
        return witherF(ga, function(a) {
          return F.map(predicate(a), function(b) {
            return b ? _.some(a) : _.none;
          });
        });
      };
    };
  };
}
var Zero = {};
Object.defineProperty(Zero, "__esModule", { value: true });
Zero.guard = guard;
function guard(F, P) {
  return function(b) {
    return b ? P.of(void 0) : F.zero();
  };
}
(function(exports) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule)
      return mod2;
    var result2 = {};
    if (mod2 != null) {
      for (var k in mod2)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
          __createBinding2(result2, mod2, k);
    }
    __setModuleDefault2(result2, mod2);
    return result2;
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.throwError = exports.Witherable = exports.wilt = exports.wither = exports.Traversable = exports.sequence = exports.traverse = exports.Filterable = exports.partitionMap = exports.partition = exports.filterMap = exports.filter = exports.Compactable = exports.separate = exports.compact = exports.Extend = exports.extend = exports.Alternative = exports.guard = exports.Zero = exports.zero = exports.Alt = exports.alt = exports.altW = exports.orElse = exports.Foldable = exports.reduceRight = exports.foldMap = exports.reduce = exports.Monad = exports.Chain = exports.flatMap = exports.Applicative = exports.Apply = exports.ap = exports.Pointed = exports.of = exports.asUnit = exports.as = exports.Functor = exports.map = exports.getMonoid = exports.getOrd = exports.getEq = exports.getShow = exports.URI = exports.getRight = exports.getLeft = exports.some = exports.none = void 0;
  exports.getLastMonoid = exports.getFirstMonoid = exports.getApplyMonoid = exports.getApplySemigroup = exports.option = exports.mapNullable = exports.chainFirst = exports.chain = exports.sequenceArray = exports.traverseArray = exports.traverseArrayWithIndex = exports.traverseReadonlyArrayWithIndex = exports.traverseReadonlyNonEmptyArrayWithIndex = exports.ApT = exports.apS = exports.bind = exports.let = exports.bindTo = exports.Do = exports.exists = exports.toUndefined = exports.toNullable = exports.chainNullableK = exports.fromNullableK = exports.tryCatchK = exports.tryCatch = exports.fromNullable = exports.chainFirstEitherK = exports.chainEitherK = exports.fromEitherK = exports.duplicate = exports.tapEither = exports.tap = exports.flatten = exports.apSecond = exports.apFirst = exports.flap = exports.getOrElse = exports.getOrElseW = exports.fold = exports.match = exports.foldW = exports.matchW = exports.isNone = exports.isSome = exports.FromEither = exports.fromEither = exports.MonadThrow = void 0;
  exports.fromPredicate = fromPredicate2;
  exports.elem = elem;
  exports.getRefinement = getRefinement;
  var Applicative_1 = Applicative;
  var Apply_12 = Apply;
  var chainable = __importStar2(Chain);
  var FromEither_1 = FromEither;
  var function_12 = _function;
  var Functor_12 = Functor;
  var _2 = __importStar2(internal);
  var Predicate_12 = Predicate;
  var Semigroup_1 = Semigroup;
  var Separated_12 = Separated;
  var Witherable_1 = Witherable;
  var Zero_1 = Zero;
  exports.none = _2.none;
  exports.some = _2.some;
  function fromPredicate2(predicate) {
    return function(a) {
      return predicate(a) ? (0, exports.some)(a) : exports.none;
    };
  }
  var getLeft = function(ma) {
    return ma._tag === "Right" ? exports.none : (0, exports.some)(ma.left);
  };
  exports.getLeft = getLeft;
  var getRight = function(ma) {
    return ma._tag === "Left" ? exports.none : (0, exports.some)(ma.right);
  };
  exports.getRight = getRight;
  var _map = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.map)(f));
  };
  var _ap = function(fab, fa) {
    return (0, function_12.pipe)(fab, (0, exports.ap)(fa));
  };
  var _reduce = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduce)(b, f));
  };
  var _foldMap = function(M) {
    var foldMapM = (0, exports.foldMap)(M);
    return function(fa, f) {
      return (0, function_12.pipe)(fa, foldMapM(f));
    };
  };
  var _reduceRight = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduceRight)(b, f));
  };
  var _traverse = function(F) {
    var traverseF = (0, exports.traverse)(F);
    return function(ta, f) {
      return (0, function_12.pipe)(ta, traverseF(f));
    };
  };
  var _alt = function(fa, that) {
    return (0, function_12.pipe)(fa, (0, exports.alt)(that));
  };
  var _filter = function(fa, predicate) {
    return (0, function_12.pipe)(fa, (0, exports.filter)(predicate));
  };
  var _filterMap = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.filterMap)(f));
  };
  var _extend = function(wa, f) {
    return (0, function_12.pipe)(wa, (0, exports.extend)(f));
  };
  var _partition = function(fa, predicate) {
    return (0, function_12.pipe)(fa, (0, exports.partition)(predicate));
  };
  var _partitionMap = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.partitionMap)(f));
  };
  exports.URI = "Option";
  var getShow = function(S2) {
    return {
      show: function(ma) {
        return (0, exports.isNone)(ma) ? "none" : "some(".concat(S2.show(ma.value), ")");
      }
    };
  };
  exports.getShow = getShow;
  var getEq = function(E2) {
    return {
      equals: function(x, y) {
        return x === y || ((0, exports.isNone)(x) ? (0, exports.isNone)(y) : (0, exports.isNone)(y) ? false : E2.equals(x.value, y.value));
      }
    };
  };
  exports.getEq = getEq;
  var getOrd = function(O) {
    return {
      equals: (0, exports.getEq)(O).equals,
      compare: function(x, y) {
        return x === y ? 0 : (0, exports.isSome)(x) ? (0, exports.isSome)(y) ? O.compare(x.value, y.value) : 1 : -1;
      }
    };
  };
  exports.getOrd = getOrd;
  var getMonoid = function(S2) {
    return {
      concat: function(x, y) {
        return (0, exports.isNone)(x) ? y : (0, exports.isNone)(y) ? x : (0, exports.some)(S2.concat(x.value, y.value));
      },
      empty: exports.none
    };
  };
  exports.getMonoid = getMonoid;
  var map2 = function(f) {
    return function(fa) {
      return (0, exports.isNone)(fa) ? exports.none : (0, exports.some)(f(fa.value));
    };
  };
  exports.map = map2;
  exports.Functor = {
    URI: exports.URI,
    map: _map
  };
  exports.as = (0, function_12.dual)(2, (0, Functor_12.as)(exports.Functor));
  exports.asUnit = (0, Functor_12.asUnit)(exports.Functor);
  exports.of = exports.some;
  exports.Pointed = {
    URI: exports.URI,
    of: exports.of
  };
  var ap2 = function(fa) {
    return function(fab) {
      return (0, exports.isNone)(fab) ? exports.none : (0, exports.isNone)(fa) ? exports.none : (0, exports.some)(fab.value(fa.value));
    };
  };
  exports.ap = ap2;
  exports.Apply = {
    URI: exports.URI,
    map: _map,
    ap: _ap
  };
  exports.Applicative = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of
  };
  exports.flatMap = (0, function_12.dual)(2, function(ma, f) {
    return (0, exports.isNone)(ma) ? exports.none : f(ma.value);
  });
  exports.Chain = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    chain: exports.flatMap
  };
  exports.Monad = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of,
    chain: exports.flatMap
  };
  var reduce = function(b, f) {
    return function(fa) {
      return (0, exports.isNone)(fa) ? b : f(b, fa.value);
    };
  };
  exports.reduce = reduce;
  var foldMap = function(M) {
    return function(f) {
      return function(fa) {
        return (0, exports.isNone)(fa) ? M.empty : f(fa.value);
      };
    };
  };
  exports.foldMap = foldMap;
  var reduceRight = function(b, f) {
    return function(fa) {
      return (0, exports.isNone)(fa) ? b : f(fa.value, b);
    };
  };
  exports.reduceRight = reduceRight;
  exports.Foldable = {
    URI: exports.URI,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight
  };
  exports.orElse = (0, function_12.dual)(2, function(self2, that) {
    return (0, exports.isNone)(self2) ? that() : self2;
  });
  exports.altW = exports.orElse;
  exports.alt = exports.orElse;
  exports.Alt = {
    URI: exports.URI,
    map: _map,
    alt: _alt
  };
  var zero = function() {
    return exports.none;
  };
  exports.zero = zero;
  exports.Zero = {
    URI: exports.URI,
    zero: exports.zero
  };
  exports.guard = (0, Zero_1.guard)(exports.Zero, exports.Pointed);
  exports.Alternative = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of,
    alt: _alt,
    zero: exports.zero
  };
  var extend2 = function(f) {
    return function(wa) {
      return (0, exports.isNone)(wa) ? exports.none : (0, exports.some)(f(wa));
    };
  };
  exports.extend = extend2;
  exports.Extend = {
    URI: exports.URI,
    map: _map,
    extend: _extend
  };
  exports.compact = (0, exports.flatMap)(function_12.identity);
  var defaultSeparated = /* @__PURE__ */ (0, Separated_12.separated)(exports.none, exports.none);
  var separate2 = function(ma) {
    return (0, exports.isNone)(ma) ? defaultSeparated : (0, Separated_12.separated)((0, exports.getLeft)(ma.value), (0, exports.getRight)(ma.value));
  };
  exports.separate = separate2;
  exports.Compactable = {
    URI: exports.URI,
    compact: exports.compact,
    separate: exports.separate
  };
  var filter3 = function(predicate) {
    return function(fa) {
      return (0, exports.isNone)(fa) ? exports.none : predicate(fa.value) ? fa : exports.none;
    };
  };
  exports.filter = filter3;
  var filterMap2 = function(f) {
    return function(fa) {
      return (0, exports.isNone)(fa) ? exports.none : f(fa.value);
    };
  };
  exports.filterMap = filterMap2;
  var partition2 = function(predicate) {
    return function(fa) {
      return (0, Separated_12.separated)(_filter(fa, (0, Predicate_12.not)(predicate)), _filter(fa, predicate));
    };
  };
  exports.partition = partition2;
  var partitionMap2 = function(f) {
    return (0, function_12.flow)((0, exports.map)(f), exports.separate);
  };
  exports.partitionMap = partitionMap2;
  exports.Filterable = {
    URI: exports.URI,
    map: _map,
    compact: exports.compact,
    separate: exports.separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap
  };
  var traverse = function(F) {
    return function(f) {
      return function(ta) {
        return (0, exports.isNone)(ta) ? F.of(exports.none) : F.map(f(ta.value), exports.some);
      };
    };
  };
  exports.traverse = traverse;
  var sequence = function(F) {
    return function(ta) {
      return (0, exports.isNone)(ta) ? F.of(exports.none) : F.map(ta.value, exports.some);
    };
  };
  exports.sequence = sequence;
  exports.Traversable = {
    URI: exports.URI,
    map: _map,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence
  };
  var _wither = /* @__PURE__ */ (0, Witherable_1.witherDefault)(exports.Traversable, exports.Compactable);
  var _wilt = /* @__PURE__ */ (0, Witherable_1.wiltDefault)(exports.Traversable, exports.Compactable);
  var wither = function(F) {
    var _witherF = _wither(F);
    return function(f) {
      return function(fa) {
        return _witherF(fa, f);
      };
    };
  };
  exports.wither = wither;
  var wilt = function(F) {
    var _wiltF = _wilt(F);
    return function(f) {
      return function(fa) {
        return _wiltF(fa, f);
      };
    };
  };
  exports.wilt = wilt;
  exports.Witherable = {
    URI: exports.URI,
    map: _map,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence,
    compact: exports.compact,
    separate: exports.separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap,
    wither: _wither,
    wilt: _wilt
  };
  var throwError = function() {
    return exports.none;
  };
  exports.throwError = throwError;
  exports.MonadThrow = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of,
    chain: exports.flatMap,
    throwError: exports.throwError
  };
  exports.fromEither = exports.getRight;
  exports.FromEither = {
    URI: exports.URI,
    fromEither: exports.fromEither
  };
  exports.isSome = _2.isSome;
  var isNone = function(fa) {
    return fa._tag === "None";
  };
  exports.isNone = isNone;
  var matchW = function(onNone, onSome) {
    return function(ma) {
      return (0, exports.isNone)(ma) ? onNone() : onSome(ma.value);
    };
  };
  exports.matchW = matchW;
  exports.foldW = exports.matchW;
  exports.match = exports.matchW;
  exports.fold = exports.match;
  var getOrElseW = function(onNone) {
    return function(ma) {
      return (0, exports.isNone)(ma) ? onNone() : ma.value;
    };
  };
  exports.getOrElseW = getOrElseW;
  exports.getOrElse = exports.getOrElseW;
  exports.flap = (0, Functor_12.flap)(exports.Functor);
  exports.apFirst = (0, Apply_12.apFirst)(exports.Apply);
  exports.apSecond = (0, Apply_12.apSecond)(exports.Apply);
  exports.flatten = exports.compact;
  exports.tap = (0, function_12.dual)(2, chainable.tap(exports.Chain));
  exports.tapEither = (0, function_12.dual)(2, (0, FromEither_1.tapEither)(exports.FromEither, exports.Chain));
  exports.duplicate = (0, exports.extend)(function_12.identity);
  exports.fromEitherK = (0, FromEither_1.fromEitherK)(exports.FromEither);
  exports.chainEitherK = /* @__PURE__ */ (0, FromEither_1.chainEitherK)(exports.FromEither, exports.Chain);
  exports.chainFirstEitherK = exports.tapEither;
  var fromNullable2 = function(a) {
    return a == null ? exports.none : (0, exports.some)(a);
  };
  exports.fromNullable = fromNullable2;
  var tryCatch = function(f) {
    try {
      return (0, exports.some)(f());
    } catch (e) {
      return exports.none;
    }
  };
  exports.tryCatch = tryCatch;
  var tryCatchK = function(f) {
    return function() {
      var a = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        a[_i] = arguments[_i];
      }
      return (0, exports.tryCatch)(function() {
        return f.apply(void 0, a);
      });
    };
  };
  exports.tryCatchK = tryCatchK;
  var fromNullableK2 = function(f) {
    return (0, function_12.flow)(f, exports.fromNullable);
  };
  exports.fromNullableK = fromNullableK2;
  var chainNullableK2 = function(f) {
    return function(ma) {
      return (0, exports.isNone)(ma) ? exports.none : (0, exports.fromNullable)(f(ma.value));
    };
  };
  exports.chainNullableK = chainNullableK2;
  exports.toNullable = (0, exports.match)(function_12.constNull, function_12.identity);
  exports.toUndefined = (0, exports.match)(function_12.constUndefined, function_12.identity);
  function elem(E2) {
    return function(a, ma) {
      if (ma === void 0) {
        var elemE_1 = elem(E2);
        return function(ma2) {
          return elemE_1(a, ma2);
        };
      }
      return (0, exports.isNone)(ma) ? false : E2.equals(a, ma.value);
    };
  }
  var exists = function(predicate) {
    return function(ma) {
      return (0, exports.isNone)(ma) ? false : predicate(ma.value);
    };
  };
  exports.exists = exists;
  exports.Do = (0, exports.of)(_2.emptyRecord);
  exports.bindTo = (0, Functor_12.bindTo)(exports.Functor);
  var let_2 = /* @__PURE__ */ (0, Functor_12.let)(exports.Functor);
  exports.let = let_2;
  exports.bind = chainable.bind(exports.Chain);
  exports.apS = (0, Apply_12.apS)(exports.Apply);
  exports.ApT = (0, exports.of)(_2.emptyReadonlyArray);
  var traverseReadonlyNonEmptyArrayWithIndex = function(f) {
    return function(as2) {
      var o = f(0, _2.head(as2));
      if ((0, exports.isNone)(o)) {
        return exports.none;
      }
      var out = [o.value];
      for (var i = 1; i < as2.length; i++) {
        var o_1 = f(i, as2[i]);
        if ((0, exports.isNone)(o_1)) {
          return exports.none;
        }
        out.push(o_1.value);
      }
      return (0, exports.some)(out);
    };
  };
  exports.traverseReadonlyNonEmptyArrayWithIndex = traverseReadonlyNonEmptyArrayWithIndex;
  var traverseReadonlyArrayWithIndex = function(f) {
    var g = (0, exports.traverseReadonlyNonEmptyArrayWithIndex)(f);
    return function(as2) {
      return _2.isNonEmpty(as2) ? g(as2) : exports.ApT;
    };
  };
  exports.traverseReadonlyArrayWithIndex = traverseReadonlyArrayWithIndex;
  exports.traverseArrayWithIndex = exports.traverseReadonlyArrayWithIndex;
  var traverseArray = function(f) {
    return (0, exports.traverseReadonlyArrayWithIndex)(function(_3, a) {
      return f(a);
    });
  };
  exports.traverseArray = traverseArray;
  exports.sequenceArray = /* @__PURE__ */ (0, exports.traverseArray)(function_12.identity);
  exports.chain = exports.flatMap;
  exports.chainFirst = exports.tap;
  function getRefinement(getOption) {
    return function(a) {
      return (0, exports.isSome)(getOption(a));
    };
  }
  exports.mapNullable = exports.chainNullableK;
  exports.option = {
    URI: exports.URI,
    map: _map,
    of: exports.of,
    ap: _ap,
    chain: exports.flatMap,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence,
    zero: exports.zero,
    alt: _alt,
    extend: _extend,
    compact: exports.compact,
    separate: exports.separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap,
    wither: _wither,
    wilt: _wilt,
    throwError: exports.throwError
  };
  exports.getApplySemigroup = (0, Apply_12.getApplySemigroup)(exports.Apply);
  exports.getApplyMonoid = (0, Applicative_1.getApplicativeMonoid)(exports.Applicative);
  var getFirstMonoid = function() {
    return (0, exports.getMonoid)((0, Semigroup_1.first)());
  };
  exports.getFirstMonoid = getFirstMonoid;
  var getLastMonoid = function() {
    return (0, exports.getMonoid)((0, Semigroup_1.last)());
  };
  exports.getLastMonoid = getLastMonoid;
})(Option);
var boolean = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.Show = exports.Ord = exports.MonoidAny = exports.MonoidAll = exports.SemigroupAny = exports.SemigroupAll = exports.BooleanAlgebra = exports.Eq = exports.fold = exports.match = exports.foldW = exports.matchW = exports.isBoolean = void 0;
  var isBoolean2 = function(u) {
    return typeof u === "boolean";
  };
  exports.isBoolean = isBoolean2;
  var matchW = function(onFalse, onTrue) {
    return function(value) {
      return value ? onTrue() : onFalse();
    };
  };
  exports.matchW = matchW;
  exports.foldW = exports.matchW;
  exports.match = exports.foldW;
  exports.fold = exports.match;
  exports.Eq = {
    equals: function(first, second) {
      return first === second;
    }
  };
  exports.BooleanAlgebra = {
    meet: function(first, second) {
      return first && second;
    },
    join: function(first, second) {
      return first || second;
    },
    zero: false,
    one: true,
    implies: function(first, second) {
      return !first || second;
    },
    not: function(b) {
      return !b;
    }
  };
  exports.SemigroupAll = {
    concat: function(first, second) {
      return first && second;
    }
  };
  exports.SemigroupAny = {
    concat: function(first, second) {
      return first || second;
    }
  };
  exports.MonoidAll = {
    concat: exports.SemigroupAll.concat,
    empty: true
  };
  exports.MonoidAny = {
    concat: exports.SemigroupAny.concat,
    empty: false
  };
  exports.Ord = {
    equals: exports.Eq.equals,
    compare: function(first, second) {
      return first < second ? -1 : first > second ? 1 : 0;
    }
  };
  exports.Show = {
    show: function(b) {
      return JSON.stringify(b);
    }
  };
})(boolean);
var string = {};
var ReadonlyNonEmptyArray = {};
(function(exports) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule)
      return mod2;
    var result2 = {};
    if (mod2 != null) {
      for (var k in mod2)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
          __createBinding2(result2, mod2, k);
    }
    __setModuleDefault2(result2, mod2);
    return result2;
  };
  var __spreadArray = commonjsGlobal && commonjsGlobal.__spreadArray || function(to2, from2, pack) {
    if (pack || arguments.length === 2)
      for (var i = 0, l = from2.length, ar; i < l; i++) {
        if (ar || !(i in from2)) {
          if (!ar)
            ar = Array.prototype.slice.call(from2, 0, i);
          ar[i] = from2[i];
        }
      }
    return to2.concat(ar || Array.prototype.slice.call(from2));
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.traverse = exports.reduceRightWithIndex = exports.foldMapWithIndex = exports.reduceWithIndex = exports.reduceRight = exports.foldMap = exports.reduce = exports.mapWithIndex = exports.map = exports.flatten = exports.duplicate = exports.extend = exports.flatMap = exports.ap = exports.alt = exports.altW = exports.of = exports.chunksOf = exports.splitAt = exports.chop = exports.chainWithIndex = exports.intersperse = exports.prependAll = exports.unzip = exports.zipWith = exports.modifyAt = exports.updateAt = exports.sort = exports.groupBy = exports.reverse = exports.fromArray = exports.unappend = exports.unprepend = exports.range = exports.replicate = exports.makeBy = exports.fromReadonlyArray = exports.rotate = exports.union = exports.sortBy = exports.uniq = exports.unsafeUpdateAt = exports.unsafeInsertAt = exports.append = exports.appendW = exports.prepend = exports.prependW = exports.isOutOfBound = exports.isNonEmpty = exports.empty = void 0;
  exports.insertAt = exports.snoc = exports.unsnoc = exports.uncons = exports.filterWithIndex = exports.chain = exports.intercalate = exports.updateLast = exports.modifyLast = exports.updateHead = exports.modifyHead = exports.matchRight = exports.matchLeft = exports.concatAll = exports.max = exports.min = exports.init = exports.last = exports.tail = exports.head = exports.apS = exports.bind = exports.let = exports.bindTo = exports.Do = exports.Comonad = exports.Alt = exports.TraversableWithIndex = exports.Traversable = exports.FoldableWithIndex = exports.Foldable = exports.Monad = exports.chainFirst = exports.Chain = exports.Applicative = exports.apSecond = exports.apFirst = exports.Apply = exports.FunctorWithIndex = exports.Pointed = exports.flap = exports.Functor = exports.getUnionSemigroup = exports.getEq = exports.getSemigroup = exports.getShow = exports.URI = exports.extract = exports.traverseWithIndex = exports.sequence = void 0;
  exports.readonlyNonEmptyArray = exports.fold = exports.prependToAll = void 0;
  exports.concatW = concatW;
  exports.concat = concat2;
  exports.group = group;
  exports.zip = zip;
  exports.groupSort = groupSort;
  exports.filter = filter3;
  exports.cons = cons;
  var Apply_12 = Apply;
  var Chain_12 = Chain;
  var Eq_1 = Eq;
  var function_12 = _function;
  var Functor_12 = Functor;
  var _2 = __importStar2(internal);
  var Ord_1 = Ord;
  var Se = __importStar2(Semigroup);
  exports.empty = _2.emptyReadonlyArray;
  exports.isNonEmpty = _2.isNonEmpty;
  var isOutOfBound = function(i, as2) {
    return i < 0 || i >= as2.length;
  };
  exports.isOutOfBound = isOutOfBound;
  var prependW = function(head) {
    return function(tail) {
      return __spreadArray([head], tail, true);
    };
  };
  exports.prependW = prependW;
  exports.prepend = exports.prependW;
  var appendW = function(end) {
    return function(init3) {
      return __spreadArray(__spreadArray([], init3, true), [end], false);
    };
  };
  exports.appendW = appendW;
  exports.append = exports.appendW;
  var unsafeInsertAt = function(i, a, as2) {
    if ((0, exports.isNonEmpty)(as2)) {
      var xs = _2.fromReadonlyNonEmptyArray(as2);
      xs.splice(i, 0, a);
      return xs;
    }
    return [a];
  };
  exports.unsafeInsertAt = unsafeInsertAt;
  var unsafeUpdateAt = function(i, a, as2) {
    if (as2[i] === a) {
      return as2;
    } else {
      var xs = _2.fromReadonlyNonEmptyArray(as2);
      xs[i] = a;
      return xs;
    }
  };
  exports.unsafeUpdateAt = unsafeUpdateAt;
  var uniq = function(E2) {
    return function(as2) {
      if (as2.length === 1) {
        return as2;
      }
      var out = [(0, exports.head)(as2)];
      var rest = (0, exports.tail)(as2);
      var _loop_1 = function(a2) {
        if (out.every(function(o) {
          return !E2.equals(o, a2);
        })) {
          out.push(a2);
        }
      };
      for (var _i = 0, rest_1 = rest; _i < rest_1.length; _i++) {
        var a = rest_1[_i];
        _loop_1(a);
      }
      return out;
    };
  };
  exports.uniq = uniq;
  var sortBy = function(ords) {
    if ((0, exports.isNonEmpty)(ords)) {
      var M = (0, Ord_1.getMonoid)();
      return (0, exports.sort)(ords.reduce(M.concat, M.empty));
    }
    return function_12.identity;
  };
  exports.sortBy = sortBy;
  var union = function(E2) {
    var uniqE = (0, exports.uniq)(E2);
    return function(second) {
      return function(first) {
        return uniqE((0, function_12.pipe)(first, concat2(second)));
      };
    };
  };
  exports.union = union;
  var rotate = function(n) {
    return function(as2) {
      var len = as2.length;
      var m = Math.round(n) % len;
      if ((0, exports.isOutOfBound)(Math.abs(m), as2) || m === 0) {
        return as2;
      }
      if (m < 0) {
        var _a = (0, exports.splitAt)(-m)(as2), f = _a[0], s = _a[1];
        return (0, function_12.pipe)(s, concat2(f));
      } else {
        return (0, exports.rotate)(m - len)(as2);
      }
    };
  };
  exports.rotate = rotate;
  var fromReadonlyArray = function(as2) {
    return (0, exports.isNonEmpty)(as2) ? _2.some(as2) : _2.none;
  };
  exports.fromReadonlyArray = fromReadonlyArray;
  var makeBy = function(f) {
    return function(n) {
      var j = Math.max(0, Math.floor(n));
      var out = [f(0)];
      for (var i = 1; i < j; i++) {
        out.push(f(i));
      }
      return out;
    };
  };
  exports.makeBy = makeBy;
  var replicate = function(a) {
    return (0, exports.makeBy)(function() {
      return a;
    });
  };
  exports.replicate = replicate;
  var range = function(start, end) {
    return start <= end ? (0, exports.makeBy)(function(i) {
      return start + i;
    })(end - start + 1) : [start];
  };
  exports.range = range;
  var unprepend = function(as2) {
    return [(0, exports.head)(as2), (0, exports.tail)(as2)];
  };
  exports.unprepend = unprepend;
  var unappend = function(as2) {
    return [(0, exports.init)(as2), (0, exports.last)(as2)];
  };
  exports.unappend = unappend;
  var fromArray = function(as2) {
    return (0, exports.fromReadonlyArray)(as2.slice());
  };
  exports.fromArray = fromArray;
  function concatW(second) {
    return function(first) {
      return first.concat(second);
    };
  }
  function concat2(x, y) {
    return y ? x.concat(y) : function(y2) {
      return y2.concat(x);
    };
  }
  var reverse2 = function(as2) {
    return as2.length === 1 ? as2 : __spreadArray([(0, exports.last)(as2)], as2.slice(0, -1).reverse(), true);
  };
  exports.reverse = reverse2;
  function group(E2) {
    return function(as2) {
      var len = as2.length;
      if (len === 0) {
        return exports.empty;
      }
      var out = [];
      var head = as2[0];
      var nea = [head];
      for (var i = 1; i < len; i++) {
        var a = as2[i];
        if (E2.equals(a, head)) {
          nea.push(a);
        } else {
          out.push(nea);
          head = a;
          nea = [head];
        }
      }
      out.push(nea);
      return out;
    };
  }
  var groupBy = function(f) {
    return function(as2) {
      var out = {};
      for (var _i = 0, as_1 = as2; _i < as_1.length; _i++) {
        var a = as_1[_i];
        var k = f(a);
        if (_2.has.call(out, k)) {
          out[k].push(a);
        } else {
          out[k] = [a];
        }
      }
      return out;
    };
  };
  exports.groupBy = groupBy;
  var sort = function(O) {
    return function(as2) {
      return as2.length === 1 ? as2 : as2.slice().sort(O.compare);
    };
  };
  exports.sort = sort;
  var updateAt = function(i, a) {
    return (0, exports.modifyAt)(i, function() {
      return a;
    });
  };
  exports.updateAt = updateAt;
  var modifyAt = function(i, f) {
    return function(as2) {
      return (0, exports.isOutOfBound)(i, as2) ? _2.none : _2.some((0, exports.unsafeUpdateAt)(i, f(as2[i]), as2));
    };
  };
  exports.modifyAt = modifyAt;
  var zipWith = function(as2, bs, f) {
    var cs2 = [f(as2[0], bs[0])];
    var len = Math.min(as2.length, bs.length);
    for (var i = 1; i < len; i++) {
      cs2[i] = f(as2[i], bs[i]);
    }
    return cs2;
  };
  exports.zipWith = zipWith;
  function zip(as2, bs) {
    if (bs === void 0) {
      return function(bs2) {
        return zip(bs2, as2);
      };
    }
    return (0, exports.zipWith)(as2, bs, function(a, b) {
      return [a, b];
    });
  }
  var unzip = function(abs2) {
    var fa = [abs2[0][0]];
    var fb = [abs2[0][1]];
    for (var i = 1; i < abs2.length; i++) {
      fa[i] = abs2[i][0];
      fb[i] = abs2[i][1];
    }
    return [fa, fb];
  };
  exports.unzip = unzip;
  var prependAll = function(middle) {
    return function(as2) {
      var out = [middle, as2[0]];
      for (var i = 1; i < as2.length; i++) {
        out.push(middle, as2[i]);
      }
      return out;
    };
  };
  exports.prependAll = prependAll;
  var intersperse = function(middle) {
    return function(as2) {
      var rest = (0, exports.tail)(as2);
      return (0, exports.isNonEmpty)(rest) ? (0, function_12.pipe)(rest, (0, exports.prependAll)(middle), (0, exports.prepend)((0, exports.head)(as2))) : as2;
    };
  };
  exports.intersperse = intersperse;
  var chainWithIndex = function(f) {
    return function(as2) {
      var out = _2.fromReadonlyNonEmptyArray(f(0, (0, exports.head)(as2)));
      for (var i = 1; i < as2.length; i++) {
        var bs = f(i, as2[i]);
        for (var j = 0; j < bs.length; j++) {
          out.push(bs[j]);
        }
      }
      return out;
    };
  };
  exports.chainWithIndex = chainWithIndex;
  var chop = function(f) {
    return function(as2) {
      var _a = f(as2), b = _a[0], rest = _a[1];
      var out = [b];
      var next = rest;
      while ((0, exports.isNonEmpty)(next)) {
        var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
        out.push(b_1);
        next = rest_2;
      }
      return out;
    };
  };
  exports.chop = chop;
  var splitAt = function(n) {
    return function(as2) {
      var m = Math.max(1, n);
      return m >= as2.length ? [as2, exports.empty] : [(0, function_12.pipe)(as2.slice(1, m), (0, exports.prepend)((0, exports.head)(as2))), as2.slice(m)];
    };
  };
  exports.splitAt = splitAt;
  var chunksOf = function(n) {
    return (0, exports.chop)((0, exports.splitAt)(n));
  };
  exports.chunksOf = chunksOf;
  var _map = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.map)(f));
  };
  var _mapWithIndex = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.mapWithIndex)(f));
  };
  var _ap = function(fab, fa) {
    return (0, function_12.pipe)(fab, (0, exports.ap)(fa));
  };
  var _extend = function(wa, f) {
    return (0, function_12.pipe)(wa, (0, exports.extend)(f));
  };
  var _reduce = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduce)(b, f));
  };
  var _foldMap = function(M) {
    var foldMapM = (0, exports.foldMap)(M);
    return function(fa, f) {
      return (0, function_12.pipe)(fa, foldMapM(f));
    };
  };
  var _reduceRight = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduceRight)(b, f));
  };
  var _traverse = function(F) {
    var traverseF = (0, exports.traverse)(F);
    return function(ta, f) {
      return (0, function_12.pipe)(ta, traverseF(f));
    };
  };
  var _alt = function(fa, that) {
    return (0, function_12.pipe)(fa, (0, exports.alt)(that));
  };
  var _reduceWithIndex = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduceWithIndex)(b, f));
  };
  var _foldMapWithIndex = function(M) {
    var foldMapWithIndexM = (0, exports.foldMapWithIndex)(M);
    return function(fa, f) {
      return (0, function_12.pipe)(fa, foldMapWithIndexM(f));
    };
  };
  var _reduceRightWithIndex = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduceRightWithIndex)(b, f));
  };
  var _traverseWithIndex = function(F) {
    var traverseWithIndexF = (0, exports.traverseWithIndex)(F);
    return function(ta, f) {
      return (0, function_12.pipe)(ta, traverseWithIndexF(f));
    };
  };
  exports.of = _2.singleton;
  var altW = function(that) {
    return function(as2) {
      return (0, function_12.pipe)(as2, concatW(that()));
    };
  };
  exports.altW = altW;
  exports.alt = exports.altW;
  var ap2 = function(as2) {
    return (0, exports.flatMap)(function(f) {
      return (0, function_12.pipe)(as2, (0, exports.map)(f));
    });
  };
  exports.ap = ap2;
  exports.flatMap = (0, function_12.dual)(2, function(ma, f) {
    return (0, function_12.pipe)(ma, (0, exports.chainWithIndex)(function(i, a) {
      return f(a, i);
    }));
  });
  var extend2 = function(f) {
    return function(as2) {
      var next = (0, exports.tail)(as2);
      var out = [f(as2)];
      while ((0, exports.isNonEmpty)(next)) {
        out.push(f(next));
        next = (0, exports.tail)(next);
      }
      return out;
    };
  };
  exports.extend = extend2;
  exports.duplicate = /* @__PURE__ */ (0, exports.extend)(function_12.identity);
  exports.flatten = /* @__PURE__ */ (0, exports.flatMap)(function_12.identity);
  var map2 = function(f) {
    return (0, exports.mapWithIndex)(function(_3, a) {
      return f(a);
    });
  };
  exports.map = map2;
  var mapWithIndex = function(f) {
    return function(as2) {
      var out = [f(0, (0, exports.head)(as2))];
      for (var i = 1; i < as2.length; i++) {
        out.push(f(i, as2[i]));
      }
      return out;
    };
  };
  exports.mapWithIndex = mapWithIndex;
  var reduce = function(b, f) {
    return (0, exports.reduceWithIndex)(b, function(_3, b2, a) {
      return f(b2, a);
    });
  };
  exports.reduce = reduce;
  var foldMap = function(S2) {
    return function(f) {
      return function(as2) {
        return as2.slice(1).reduce(function(s, a) {
          return S2.concat(s, f(a));
        }, f(as2[0]));
      };
    };
  };
  exports.foldMap = foldMap;
  var reduceRight = function(b, f) {
    return (0, exports.reduceRightWithIndex)(b, function(_3, b2, a) {
      return f(b2, a);
    });
  };
  exports.reduceRight = reduceRight;
  var reduceWithIndex = function(b, f) {
    return function(as2) {
      return as2.reduce(function(b2, a, i) {
        return f(i, b2, a);
      }, b);
    };
  };
  exports.reduceWithIndex = reduceWithIndex;
  var foldMapWithIndex = function(S2) {
    return function(f) {
      return function(as2) {
        return as2.slice(1).reduce(function(s, a, i) {
          return S2.concat(s, f(i + 1, a));
        }, f(0, as2[0]));
      };
    };
  };
  exports.foldMapWithIndex = foldMapWithIndex;
  var reduceRightWithIndex = function(b, f) {
    return function(as2) {
      return as2.reduceRight(function(b2, a, i) {
        return f(i, a, b2);
      }, b);
    };
  };
  exports.reduceRightWithIndex = reduceRightWithIndex;
  var traverse = function(F) {
    var traverseWithIndexF = (0, exports.traverseWithIndex)(F);
    return function(f) {
      return traverseWithIndexF(function(_3, a) {
        return f(a);
      });
    };
  };
  exports.traverse = traverse;
  var sequence = function(F) {
    return (0, exports.traverseWithIndex)(F)(function_12.SK);
  };
  exports.sequence = sequence;
  var traverseWithIndex = function(F) {
    return function(f) {
      return function(as2) {
        var out = F.map(f(0, (0, exports.head)(as2)), exports.of);
        for (var i = 1; i < as2.length; i++) {
          out = F.ap(F.map(out, function(bs) {
            return function(b) {
              return (0, function_12.pipe)(bs, (0, exports.append)(b));
            };
          }), f(i, as2[i]));
        }
        return out;
      };
    };
  };
  exports.traverseWithIndex = traverseWithIndex;
  exports.extract = _2.head;
  exports.URI = "ReadonlyNonEmptyArray";
  var getShow = function(S2) {
    return {
      show: function(as2) {
        return "[".concat(as2.map(S2.show).join(", "), "]");
      }
    };
  };
  exports.getShow = getShow;
  var getSemigroup = function() {
    return {
      concat: concat2
    };
  };
  exports.getSemigroup = getSemigroup;
  var getEq = function(E2) {
    return (0, Eq_1.fromEquals)(function(xs, ys) {
      return xs.length === ys.length && xs.every(function(x, i) {
        return E2.equals(x, ys[i]);
      });
    });
  };
  exports.getEq = getEq;
  var getUnionSemigroup = function(E2) {
    var unionE = (0, exports.union)(E2);
    return {
      concat: function(first, second) {
        return unionE(second)(first);
      }
    };
  };
  exports.getUnionSemigroup = getUnionSemigroup;
  exports.Functor = {
    URI: exports.URI,
    map: _map
  };
  exports.flap = (0, Functor_12.flap)(exports.Functor);
  exports.Pointed = {
    URI: exports.URI,
    of: exports.of
  };
  exports.FunctorWithIndex = {
    URI: exports.URI,
    map: _map,
    mapWithIndex: _mapWithIndex
  };
  exports.Apply = {
    URI: exports.URI,
    map: _map,
    ap: _ap
  };
  exports.apFirst = (0, Apply_12.apFirst)(exports.Apply);
  exports.apSecond = (0, Apply_12.apSecond)(exports.Apply);
  exports.Applicative = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of
  };
  exports.Chain = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    chain: exports.flatMap
  };
  exports.chainFirst = (0, Chain_12.chainFirst)(exports.Chain);
  exports.Monad = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of,
    chain: exports.flatMap
  };
  exports.Foldable = {
    URI: exports.URI,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight
  };
  exports.FoldableWithIndex = {
    URI: exports.URI,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    reduceWithIndex: _reduceWithIndex,
    foldMapWithIndex: _foldMapWithIndex,
    reduceRightWithIndex: _reduceRightWithIndex
  };
  exports.Traversable = {
    URI: exports.URI,
    map: _map,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence
  };
  exports.TraversableWithIndex = {
    URI: exports.URI,
    map: _map,
    mapWithIndex: _mapWithIndex,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence,
    reduceWithIndex: _reduceWithIndex,
    foldMapWithIndex: _foldMapWithIndex,
    reduceRightWithIndex: _reduceRightWithIndex,
    traverseWithIndex: _traverseWithIndex
  };
  exports.Alt = {
    URI: exports.URI,
    map: _map,
    alt: _alt
  };
  exports.Comonad = {
    URI: exports.URI,
    map: _map,
    extend: _extend,
    extract: exports.extract
  };
  exports.Do = (0, exports.of)(_2.emptyRecord);
  exports.bindTo = (0, Functor_12.bindTo)(exports.Functor);
  var let_2 = /* @__PURE__ */ (0, Functor_12.let)(exports.Functor);
  exports.let = let_2;
  exports.bind = (0, Chain_12.bind)(exports.Chain);
  exports.apS = (0, Apply_12.apS)(exports.Apply);
  exports.head = exports.extract;
  exports.tail = _2.tail;
  var last = function(as2) {
    return as2[as2.length - 1];
  };
  exports.last = last;
  var init2 = function(as2) {
    return as2.slice(0, -1);
  };
  exports.init = init2;
  var min2 = function(O) {
    var S2 = Se.min(O);
    return function(as2) {
      return as2.reduce(S2.concat);
    };
  };
  exports.min = min2;
  var max2 = function(O) {
    var S2 = Se.max(O);
    return function(as2) {
      return as2.reduce(S2.concat);
    };
  };
  exports.max = max2;
  var concatAll2 = function(S2) {
    return function(as2) {
      return as2.reduce(S2.concat);
    };
  };
  exports.concatAll = concatAll2;
  var matchLeft = function(f) {
    return function(as2) {
      return f((0, exports.head)(as2), (0, exports.tail)(as2));
    };
  };
  exports.matchLeft = matchLeft;
  var matchRight = function(f) {
    return function(as2) {
      return f((0, exports.init)(as2), (0, exports.last)(as2));
    };
  };
  exports.matchRight = matchRight;
  var modifyHead = function(f) {
    return function(as2) {
      return __spreadArray([f((0, exports.head)(as2))], (0, exports.tail)(as2), true);
    };
  };
  exports.modifyHead = modifyHead;
  var updateHead = function(a) {
    return (0, exports.modifyHead)(function() {
      return a;
    });
  };
  exports.updateHead = updateHead;
  var modifyLast = function(f) {
    return function(as2) {
      return (0, function_12.pipe)((0, exports.init)(as2), (0, exports.append)(f((0, exports.last)(as2))));
    };
  };
  exports.modifyLast = modifyLast;
  var updateLast = function(a) {
    return (0, exports.modifyLast)(function() {
      return a;
    });
  };
  exports.updateLast = updateLast;
  var intercalate = function(S2) {
    var concatAllS = (0, exports.concatAll)(S2);
    return function(middle) {
      return (0, function_12.flow)((0, exports.intersperse)(middle), concatAllS);
    };
  };
  exports.intercalate = intercalate;
  exports.chain = exports.flatMap;
  function groupSort(O) {
    var sortO = (0, exports.sort)(O);
    var groupO = group(O);
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? groupO(sortO(as2)) : exports.empty;
    };
  }
  function filter3(predicate) {
    return (0, exports.filterWithIndex)(function(_3, a) {
      return predicate(a);
    });
  }
  var filterWithIndex = function(predicate) {
    return function(as2) {
      return (0, exports.fromReadonlyArray)(as2.filter(function(a, i) {
        return predicate(i, a);
      }));
    };
  };
  exports.filterWithIndex = filterWithIndex;
  exports.uncons = exports.unprepend;
  exports.unsnoc = exports.unappend;
  function cons(head, tail) {
    return tail === void 0 ? (0, exports.prepend)(head) : (0, function_12.pipe)(tail, (0, exports.prepend)(head));
  }
  var snoc = function(init3, end) {
    return (0, function_12.pipe)(init3, concat2([end]));
  };
  exports.snoc = snoc;
  var insertAt = function(i, a) {
    return function(as2) {
      return i < 0 || i > as2.length ? _2.none : _2.some((0, exports.unsafeInsertAt)(i, a, as2));
    };
  };
  exports.insertAt = insertAt;
  exports.prependToAll = exports.prependAll;
  exports.fold = exports.concatAll;
  exports.readonlyNonEmptyArray = {
    URI: exports.URI,
    of: exports.of,
    map: _map,
    mapWithIndex: _mapWithIndex,
    ap: _ap,
    chain: exports.flatMap,
    extend: _extend,
    extract: exports.extract,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence,
    reduceWithIndex: _reduceWithIndex,
    foldMapWithIndex: _foldMapWithIndex,
    reduceRightWithIndex: _reduceRightWithIndex,
    traverseWithIndex: _traverseWithIndex,
    alt: _alt
  };
})(ReadonlyNonEmptyArray);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.endsWith = exports.startsWith = exports.includes = exports.split = exports.size = exports.isEmpty = exports.slice = exports.trimRight = exports.trimLeft = exports.trim = exports.replace = exports.toLowerCase = exports.toUpperCase = exports.isString = exports.Show = exports.Ord = exports.Monoid = exports.empty = exports.Semigroup = exports.Eq = void 0;
  var ReadonlyNonEmptyArray_1 = ReadonlyNonEmptyArray;
  exports.Eq = {
    equals: function(first, second) {
      return first === second;
    }
  };
  exports.Semigroup = {
    concat: function(first, second) {
      return first + second;
    }
  };
  exports.empty = "";
  exports.Monoid = {
    concat: exports.Semigroup.concat,
    empty: exports.empty
  };
  exports.Ord = {
    equals: exports.Eq.equals,
    compare: function(first, second) {
      return first < second ? -1 : first > second ? 1 : 0;
    }
  };
  exports.Show = {
    show: function(s) {
      return JSON.stringify(s);
    }
  };
  var isString2 = function(u) {
    return typeof u === "string";
  };
  exports.isString = isString2;
  var toUpperCase = function(s) {
    return s.toUpperCase();
  };
  exports.toUpperCase = toUpperCase;
  var toLowerCase = function(s) {
    return s.toLowerCase();
  };
  exports.toLowerCase = toLowerCase;
  var replace = function(searchValue, replaceValue) {
    return function(s) {
      return s.replace(searchValue, replaceValue);
    };
  };
  exports.replace = replace;
  var trim2 = function(s) {
    return s.trim();
  };
  exports.trim = trim2;
  var trimLeft = function(s) {
    return s.trimLeft();
  };
  exports.trimLeft = trimLeft;
  var trimRight = function(s) {
    return s.trimRight();
  };
  exports.trimRight = trimRight;
  var slice2 = function(start, end) {
    return function(s) {
      return s.slice(start, end);
    };
  };
  exports.slice = slice2;
  var isEmpty = function(s) {
    return s.length === 0;
  };
  exports.isEmpty = isEmpty;
  var size = function(s) {
    return s.length;
  };
  exports.size = size;
  var split = function(separator) {
    return function(s) {
      var out = s.split(separator);
      return (0, ReadonlyNonEmptyArray_1.isNonEmpty)(out) ? out : [s];
    };
  };
  exports.split = split;
  var includes = function(searchString, position) {
    return function(s) {
      return s.includes(searchString, position);
    };
  };
  exports.includes = includes;
  var startsWith = function(searchString, position) {
    return function(s) {
      return s.startsWith(searchString, position);
    };
  };
  exports.startsWith = startsWith;
  var endsWith2 = function(searchString, position) {
    return function(s) {
      return s.endsWith(searchString, position);
    };
  };
  exports.endsWith = endsWith2;
})(string);
const constructFromSymbol = Symbol.for("constructDateFrom");
function constructFrom(date, value) {
  if (typeof date === "function")
    return date(value);
  if (date && typeof date === "object" && constructFromSymbol in date)
    return date[constructFromSymbol](value);
  if (date instanceof Date)
    return new date.constructor(value);
  return new Date(value);
}
function toDate(argument, context) {
  return constructFrom(context || argument, argument);
}
function isDate$1(value) {
  return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
function isValid(date) {
  return !(!isDate$1(date) && typeof date !== "number" || isNaN(+toDate(date)));
}
function isBefore(date, dateToCompare) {
  return +toDate(date) < +toDate(dateToCompare);
}
function isStorageObject(item) {
  const tmp = item;
  return tmp.expires !== void 0 && tmp.data !== void 0 || tmp.data !== void 0;
}
function isValidJson(item) {
  try {
    JSON.parse(item);
    return true;
  } catch {
    return false;
  }
}
function encodeToStorageObject(obj) {
  return {
    data: obj.data,
    expires: typeof obj.expires === "string" ? obj.expires : null
  };
}
function decodeToStorageObject(obj) {
  return {
    data: obj.data,
    expires: _function.pipe(
      obj.expires,
      Option.fromNullable,
      Option.chain((data) => {
        return typeof data === "string" ? Option.some(data) : Option.none;
      }),
      Option.chain((dateStr) => {
        return isValid(new Date(dateStr)) ? Option.some(new Date(dateStr)) : Option.none;
      })
    )
  };
}
function getRawItem(key) {
  const item = window.localStorage.getItem(key);
  if (typeof item === "string" && item !== null) {
    return Option.some(item);
  }
  return Option.none;
}
function getLocalItem(key) {
  return _function.pipe(
    key,
    getRawItem,
    Option.map((item) => _function.pipe(
      item,
      isValidJson,
      boolean.match(
        () => item,
        () => JSON.parse(item)
      )
    )),
    Option.map((d) => _function.pipe(
      d,
      isStorageObject,
      boolean.match(
        () => decodeToStorageObject({ data: d }),
        () => decodeToStorageObject(d)
      )
    ))
  );
}
function getItem(key) {
  if (typeof key !== "string")
    return void 0;
  return _function.pipe(
    key,
    getLocalItem,
    Option.map((item) => item.data),
    Option.getOrElseW(() => void 0)
  );
}
function deleteKey(key) {
  var _a;
  if (key === null)
    return void 0;
  return (_a = window == null ? void 0 : window.localStorage) == null ? void 0 : _a.removeItem(key);
}
function hasKey(key) {
  if (key === null)
    return false;
  const item = getLocalItem(key);
  const hasExpired = _function.pipe(
    item,
    Option.chain((item2) => item2.expires),
    Option.map((date) => hooks().isAfter(date)),
    Option.getOrElse(() => false)
  );
  const keyIsValid = Option.isSome(item) && !hasExpired;
  if (hasExpired) {
    deleteKey(key);
    return false;
  }
  return keyIsValid;
}
function setItem(key, item) {
  if (key === null)
    return void 0;
  const storageObject = JSON.stringify(encodeToStorageObject({ data: item }));
  const event = new CustomEvent("localStorageUpdate", {
    detail: { key, item }
  });
  window.dispatchEvent(event);
  try {
    window.localStorage.setItem(key, storageObject);
  } catch (err) {
    console.log("settingERROR", err);
  }
}
function setItemWithExpiryDate(key, item, expires) {
  const t1 = key === null;
  const t2 = !isValid(new Date(expires));
  const t3 = isBefore(new Date(expires), /* @__PURE__ */ new Date());
  const t4 = string.isEmpty(expires);
  const tests = [t1, t2, t3, t4].some((test) => test);
  console.log({ key, expires, t1, t2, t3, t4, tests });
  if (tests)
    return void 0;
  const storageObject = JSON.stringify(encodeToStorageObject({ data: item, expires }));
  window.localStorage.setItem(key, storageObject);
}
const useLocalStorage = () => {
  return {
    getItem,
    setItem,
    setItemWithExpiryDate,
    hasKey,
    deleteKey
  };
};
var md5$1 = { exports: {} };
var crypt = { exports: {} };
(function() {
  var base64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", crypt$1 = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return n << b | n >>> 32 - b;
    },
    // Bit-wise rotation right
    rotr: function(n, b) {
      return n << 32 - b | n >>> b;
    },
    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      if (n.constructor == Number) {
        return crypt$1.rotl(n, 8) & 16711935 | crypt$1.rotl(n, 24) & 4278255360;
      }
      for (var i = 0; i < n.length; i++)
        n[i] = crypt$1.endian(n[i]);
      return n;
    },
    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },
    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << 24 - b % 32;
      return words;
    },
    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push(words[b >>> 5] >>> 24 - b % 32 & 255);
      return bytes;
    },
    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 15).toString(16));
      }
      return hex.join("");
    },
    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },
    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 63));
          else
            base64.push("=");
      }
      return base64.join("");
    },
    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, "");
      for (var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4) {
        if (imod4 == 0)
          continue;
        bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
      }
      return bytes;
    }
  };
  crypt.exports = crypt$1;
})();
var cryptExports = crypt.exports;
var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },
    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },
  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 255);
      return bytes;
    },
    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join("");
    }
  }
};
var charenc_1 = charenc;
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var isBuffer_1 = function(obj) {
  return obj != null && (isBuffer$1(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
};
function isBuffer$1(obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
function isSlowBuffer(obj) {
  return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isBuffer$1(obj.slice(0, 0));
}
(function() {
  var crypt2 = cryptExports, utf8 = charenc_1.utf8, isBuffer2 = isBuffer_1, bin = charenc_1.bin, md52 = function(message, options) {
    if (message.constructor == String)
      if (options && options.encoding === "binary")
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer2(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message) && message.constructor !== Uint8Array)
      message = message.toString();
    var m = crypt2.bytesToWords(message), l = message.length * 8, a = 1732584193, b = -271733879, c = -1732584194, d = 271733878;
    for (var i = 0; i < m.length; i++) {
      m[i] = (m[i] << 8 | m[i] >>> 24) & 16711935 | (m[i] << 24 | m[i] >>> 8) & 4278255360;
    }
    m[l >>> 5] |= 128 << l % 32;
    m[(l + 64 >>> 9 << 4) + 14] = l;
    var FF = md52._ff, GG = md52._gg, HH = md52._hh, II = md52._ii;
    for (var i = 0; i < m.length; i += 16) {
      var aa = a, bb = b, cc = c, dd = d;
      a = FF(a, b, c, d, m[i + 0], 7, -680876936);
      d = FF(d, a, b, c, m[i + 1], 12, -389564586);
      c = FF(c, d, a, b, m[i + 2], 17, 606105819);
      b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i + 4], 7, -176418897);
      d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
      c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i + 7], 22, -45705983);
      a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
      d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i + 10], 17, -42063);
      b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
      a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
      d = FF(d, a, b, c, m[i + 13], 12, -40341101);
      c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
      b = FF(b, c, d, a, m[i + 15], 22, 1236535329);
      a = GG(a, b, c, d, m[i + 1], 5, -165796510);
      d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
      c = GG(c, d, a, b, m[i + 11], 14, 643717713);
      b = GG(b, c, d, a, m[i + 0], 20, -373897302);
      a = GG(a, b, c, d, m[i + 5], 5, -701558691);
      d = GG(d, a, b, c, m[i + 10], 9, 38016083);
      c = GG(c, d, a, b, m[i + 15], 14, -660478335);
      b = GG(b, c, d, a, m[i + 4], 20, -405537848);
      a = GG(a, b, c, d, m[i + 9], 5, 568446438);
      d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
      c = GG(c, d, a, b, m[i + 3], 14, -187363961);
      b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
      a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
      d = GG(d, a, b, c, m[i + 2], 9, -51403784);
      c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
      b = GG(b, c, d, a, m[i + 12], 20, -1926607734);
      a = HH(a, b, c, d, m[i + 5], 4, -378558);
      d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
      b = HH(b, c, d, a, m[i + 14], 23, -35309556);
      a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
      d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
      c = HH(c, d, a, b, m[i + 7], 16, -155497632);
      b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
      a = HH(a, b, c, d, m[i + 13], 4, 681279174);
      d = HH(d, a, b, c, m[i + 0], 11, -358537222);
      c = HH(c, d, a, b, m[i + 3], 16, -722521979);
      b = HH(b, c, d, a, m[i + 6], 23, 76029189);
      a = HH(a, b, c, d, m[i + 9], 4, -640364487);
      d = HH(d, a, b, c, m[i + 12], 11, -421815835);
      c = HH(c, d, a, b, m[i + 15], 16, 530742520);
      b = HH(b, c, d, a, m[i + 2], 23, -995338651);
      a = II(a, b, c, d, m[i + 0], 6, -198630844);
      d = II(d, a, b, c, m[i + 7], 10, 1126891415);
      c = II(c, d, a, b, m[i + 14], 15, -1416354905);
      b = II(b, c, d, a, m[i + 5], 21, -57434055);
      a = II(a, b, c, d, m[i + 12], 6, 1700485571);
      d = II(d, a, b, c, m[i + 3], 10, -1894986606);
      c = II(c, d, a, b, m[i + 10], 15, -1051523);
      b = II(b, c, d, a, m[i + 1], 21, -2054922799);
      a = II(a, b, c, d, m[i + 8], 6, 1873313359);
      d = II(d, a, b, c, m[i + 15], 10, -30611744);
      c = II(c, d, a, b, m[i + 6], 15, -1560198380);
      b = II(b, c, d, a, m[i + 13], 21, 1309151649);
      a = II(a, b, c, d, m[i + 4], 6, -145523070);
      d = II(d, a, b, c, m[i + 11], 10, -1120210379);
      c = II(c, d, a, b, m[i + 2], 15, 718787259);
      b = II(b, c, d, a, m[i + 9], 21, -343485551);
      a = a + aa >>> 0;
      b = b + bb >>> 0;
      c = c + cc >>> 0;
      d = d + dd >>> 0;
    }
    return crypt2.endian([a, b, c, d]);
  };
  md52._ff = function(a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return (n << s | n >>> 32 - s) + b;
  };
  md52._gg = function(a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return (n << s | n >>> 32 - s) + b;
  };
  md52._hh = function(a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return (n << s | n >>> 32 - s) + b;
  };
  md52._ii = function(a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return (n << s | n >>> 32 - s) + b;
  };
  md52._blocksize = 16;
  md52._digestsize = 16;
  md5$1.exports = function(message, options) {
    if (message === void 0 || message === null)
      throw new Error("Illegal argument " + message);
    var digestbytes = crypt2.wordsToBytes(md52(message, options));
    return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt2.bytesToHex(digestbytes);
  };
})();
var md5Exports = md5$1.exports;
const md5 = /* @__PURE__ */ getDefaultExportFromCjs(md5Exports);
function useGravatar(email) {
  const emailHash = md5(email);
  const gravatarUrl = "https://www.gravatar.com/avatar/";
  return `${gravatarUrl}${emailHash}`;
}
function usePortal(portal, content, element = document.body) {
  return React.useMemo(() => {
    if (portal)
      return ReactDOM.createPortal(content, element);
    return content;
  }, [portal, content]);
}
function useComponentVisible(initialIsVisible) {
  const [isComponentVisible, setIsComponentVisible] = React.useState(initialIsVisible);
  const ref = React.useRef(null);
  const handleClickOutside = (event) => {
    var _a;
    if ((ref == null ? void 0 : ref.current) && !((_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.contains(event.target))) {
      setIsComponentVisible(false);
    }
  };
  React.useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => document.removeEventListener("click", handleClickOutside, true);
  }, []);
  return { ref, isComponentVisible, setIsComponentVisible };
}
const resetForm = "RESET_FORM";
const setErrors = "SET_ERRORS";
const setTouch = "SET_TOUCH";
const updateValue = "UPDATE_VALUE";
const setSubmitting = "SET_SUBMIT";
function reducer(state, action) {
  switch (action.type) {
    case resetForm: {
      return action.payload;
    }
    case setErrors: {
      return {
        ...state,
        errors: action.payload
      };
    }
    case setTouch: {
      return {
        ...state,
        isDirty: !_$3.isEqual(action.payload.defaults, state.data),
        touched: {
          ...state.touched,
          [action.payload.key]: true
        }
      };
    }
    case updateValue: {
      return {
        ...state,
        isDirty: !_$3.isEqual(action.payload.defaults, state.data),
        touched: {
          ...state.touched,
          [action.payload.touchedKey]: true
        },
        data: {
          ...state.data,
          [action.payload.key]: action.payload.value
        }
      };
    }
    case setSubmitting: {
      return {
        ...state,
        isSubmitting: action.payload,
        attempted: action.payload ? state.attempted + 1 : state.attempted
      };
    }
    default:
      return state;
  }
}
function createState(data) {
  return {
    data,
    errors: {},
    isDirty: false,
    isSubmitting: false,
    canSubmit: false,
    touched: {},
    attempted: 0
  };
}
const useForm = (props, ...plugins) => {
  const [state, dispatch] = useReducer(reducer, props.data, createState);
  const isComplete = () => !!(!state.isDirty || Object.keys(state.errors).length > 0);
  const onChange = (key, value, index) => {
    const str = index ? `${String(key)}[${index}]` : key;
    dispatch({ type: updateValue, payload: { key, value, touchedKey: str } });
  };
  const setTouched = useCallback((name) => {
    dispatch({ type: setTouch, payload: { key: name, defaults: props.data } });
  }, [state.touched]);
  const setIsSubmitting = useCallback((value) => {
    dispatch({ type: setSubmitting, payload: value });
  }, [state.touched]);
  const onSubmit = useCallback(() => {
    dispatch({ type: setSubmitting, payload: true });
    validate(state.data).then(async (errors) => {
      dispatch({ type: setErrors, payload: errors });
      if (!Object.keys(errors).length) {
        await props.onSubmit(state.data);
        dispatch({ type: setSubmitting, payload: false });
      } else {
        dispatch({ type: setSubmitting, payload: false });
      }
    });
  }, [state.data]);
  const resolveErrors = (err) => {
    const errors = {};
    if (err.inner) {
      if (err.inner.length === 0) {
        errors[err.path] = err.message;
      }
      err.inner.forEach((error) => {
        if (!(errors == null ? void 0 : errors[error.path])) {
          errors[error.path] = error.message;
        }
      });
    }
    return errors;
  };
  const runScheme = (data) => props.validation.validate(data, { abortEarly: false });
  const validate = (data) => {
    const promise = runScheme(data);
    return new Promise((resolve) => {
      promise.then(
        () => resolve({}),
        (err) => resolve(resolveErrors(err))
      );
    });
  };
  function reset(data) {
    dispatch({
      type: resetForm,
      payload: {
        data,
        errors: {},
        isDirty: false,
        isSubmitting: false,
        touched: {},
        attempted: 0
      }
    });
  }
  const canSubmit = useMemo(
    () => Object.keys(state.errors).length === 0,
    [state.errors]
  );
  useEffect(() => {
    dispatch({
      type: resetForm,
      payload: {
        data: props.data,
        errors: {},
        isDirty: false,
        isSubmitting: false,
        touched: {},
        attempted: 0
      }
    });
  }, []);
  useEffect(() => {
    validate(state.data).then((errors) => {
      dispatch({ type: setErrors, payload: errors });
    });
  }, [state.data]);
  const hasError = useCallback((key) => {
    var _a, _b;
    const hasBeenTouched = (_a = state.touched) == null ? void 0 : _a[key];
    const hasError2 = Boolean((_b = state.errors) == null ? void 0 : _b[key]);
    const submitAttempted = state.attempted > 0;
    return hasBeenTouched && hasError2 || submitAttempted && hasError2;
  }, [state.touch, state.errors]);
  const getErrorMessage = useCallback((key) => {
    var _a;
    return hasError(key) ? (_a = state.errors) == null ? void 0 : _a[key] : "";
  }, [state]);
  return {
    canSubmit,
    data: state.data,
    errors: state.errors,
    isComplete,
    isDirty: state.isDirty,
    isSubmitting: state.isSubmitting,
    onChange,
    onSubmit,
    reset,
    setIsSubmitting,
    setTouched,
    touched: state.touched,
    hasError,
    getErrorMessage
  };
};
const useFieldArray = ({
  defaults: defaults2 = [
    {
      existing: false,
      trashed: false,
      // @ts-ignore
      value: ""
    }
  ],
  key,
  max: max2 = 5,
  min: min2 = 1,
  onChange
}) => {
  const [items, setItems] = useState(defaults2);
  const [hasMax, setHasMax] = useState(false);
  const [hasMin, setHasMin] = useState(false);
  const [counters, setCounters] = useState({
    liveItems: defaults2.length,
    maxItems: max2,
    minItems: min2,
    totalItems: defaults2.length,
    trashedItems: 0
  });
  const addItem = () => {
    if (!hasMax) {
      setItems((prev) => {
        const copy = [...prev];
        copy.push({
          existing: false,
          trashed: false,
          // @ts-ignore
          value: ""
        });
        return copy;
      });
    }
  };
  const removeItem = (index) => {
    if (!hasMin) {
      setItems((prev) => [...prev.slice(0, index), ...prev.slice(index + 1)]);
    }
  };
  const restoreItem = (index) => {
    setItems((prev) => {
      const copy = [...prev];
      copy[index].trashed = false;
      return copy;
    });
  };
  const trashItem = (index) => {
    setItems((prev) => {
      const copy = [...prev];
      copy[index].trashed = true;
      return copy;
    });
  };
  const updateItem = (key2, value) => {
    setItems((prev) => {
      const copy = [...prev];
      copy[key2] = {
        existing: copy[key2].existing,
        trashed: copy[key2].trashed,
        value
      };
      return copy;
    });
  };
  useEffect(() => {
    const counters2 = {
      liveItems: items.filter((item) => !item.trashed).length,
      maxItems: max2,
      minItems: min2,
      totalItems: items.length,
      trashedItems: items.filter((item) => item.trashed).length
    };
    setCounters(counters2);
    onChange(key, items);
  }, [items]);
  useEffect(() => {
    setHasMax(counters.liveItems >= max2);
    setHasMin(counters.liveItems <= min2);
  }, [counters]);
  return {
    addItem,
    counters,
    hasMax,
    hasMin,
    items,
    removeItem,
    restoreItem,
    trashItem,
    updateItem
  };
};
const AccessGroups = {
  "Guest": "Guest",
  "Clients": "Clients",
  "Agentpowerusers": "AgentPowerUsers",
  "Agentadministrators": "AgentAdministrators",
  "Users": "Users",
  "PowerUsers": "PowerUsers",
  "Underwriters": "Underwriters",
  "Administrators": "Administrators",
  "AdmSuperUsers": "AdmSuperUsers"
};
const Environments = {
  dev: "DEV",
  labs: "LABS",
  beta: "BETA",
  live: "LIVE"
};
var ResponseStatus = /* @__PURE__ */ ((ResponseStatus2) => {
  ResponseStatus2[ResponseStatus2["Success"] = 0] = "Success";
  ResponseStatus2[ResponseStatus2["Error"] = 1] = "Error";
  return ResponseStatus2;
})(ResponseStatus || {});
var SortDirection = /* @__PURE__ */ ((SortDirection2) => {
  SortDirection2["Ascending"] = "ASC";
  SortDirection2["Descending"] = "DESC";
  return SortDirection2;
})(SortDirection || {});
const userTypeMap = {
  guest: -1,
  clients: 0,
  agentpowerusers: 1,
  agentadministrators: 2,
  users: 3,
  powerusers: 4,
  underwriters: 5,
  administrators: 6,
  admsuperusers: 7
};
const userTypeRe = /^is(?<type>guest|client|agentpoweruser|agentadministrator|user|poweruser|underwriter|administrator|admsuperuser)s?/;
const handler = {
  get(target, prop) {
    if (target == null ? void 0 : target[prop])
      return target[prop];
    if (prop.toLowerCase().match(userTypeRe)) {
      const match5 = prop.toLowerCase().match(userTypeRe);
      const test = `${match5[1]}s`;
      return target[target.current] == (target == null ? void 0 : target[test]);
    }
    return getUserType(target.current.type);
  }
};
function isAccessGroup(userType) {
  return Object.keys(userTypeMap).includes(userType.toLowerCase());
}
function getAccessGroup(user) {
  const ag = (user == null ? void 0 : user.AccessGroup) ?? (user == null ? void 0 : user.accessGroup) ?? AccessGroups.Guest;
  return isAccessGroup(ag) ? ag : AccessGroups.Guest;
}
function getUserType(accessGroup) {
  const userTypeLevel = (userTypeMap == null ? void 0 : userTypeMap[accessGroup == null ? void 0 : accessGroup.toLowerCase()]) ?? -1;
  const ag = isAccessGroup(accessGroup) ? accessGroup : AccessGroups.Guest;
  const target = {
    current: { type: ag, level: userTypeLevel },
    ...userTypeMap
  };
  return new Proxy(target, handler);
}
function getEnvironment(url) {
  if (url.indexOf("dev.") !== -1 || /^https:\/\/(?:\d{1,3}\.){3}\d{1,3}/.test(url)) {
    return Environments.dev;
  }
  if (url.indexOf("schemeserve-secondary") !== -1) {
    return Environments.dev;
  }
  if (url.indexOf(".local") !== -1) {
    return Environments.dev;
  }
  if (url.indexOf("localhost:") !== -1) {
    return Environments.dev;
  }
  if (url.indexOf("beta.") !== -1) {
    return Environments.beta;
  }
  if (url.indexOf("labs.") !== -1) {
    return Environments.labs;
  }
  return Environments.live;
}
function convertCamelCaseToSentenceCase(str) {
  const result2 = str.replace(/([A-Z])/g, " $1");
  return result2.charAt(0).toUpperCase() + result2.slice(1);
}
function getModuleSize(size) {
  if (size <= 576)
    return "phone";
  if (size <= 768)
    return "tablet";
  if (size <= 992)
    return "desktop";
  return "desktop";
}
function formatMoney(currency, local = "en-GB") {
  return (value) => new Intl.NumberFormat(local, {
    style: "currency",
    currency: currency.code
  }).format(value).replace(/[a-z][A-Z]/gi, "");
}
function filterNullValues(params) {
  return Object.entries(params).reduce((acc, [key, value]) => {
    if (value === null || value === void 0 || value === "")
      return acc;
    return {
      ...acc,
      [key]: value
    };
  }, {});
}
var Either = {};
var ChainRec = {};
Object.defineProperty(ChainRec, "__esModule", { value: true });
ChainRec.tailRec = void 0;
var tailRec = function(startWith, f) {
  var ab = f(startWith);
  while (ab._tag === "Left") {
    ab = f(ab.left);
  }
  return ab.right;
};
ChainRec.tailRec = tailRec;
(function(exports) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule)
      return mod2;
    var result2 = {};
    if (mod2 != null) {
      for (var k in mod2)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
          __createBinding2(result2, mod2, k);
    }
    __setModuleDefault2(result2, mod2);
    return result2;
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.match = exports.foldW = exports.matchW = exports.isRight = exports.isLeft = exports.fromOption = exports.fromPredicate = exports.FromEither = exports.MonadThrow = exports.throwError = exports.ChainRec = exports.Extend = exports.extend = exports.Alt = exports.alt = exports.altW = exports.Bifunctor = exports.mapLeft = exports.bimap = exports.Traversable = exports.sequence = exports.traverse = exports.Foldable = exports.reduceRight = exports.foldMap = exports.reduce = exports.Monad = exports.Chain = exports.Applicative = exports.Apply = exports.ap = exports.apW = exports.Pointed = exports.of = exports.asUnit = exports.as = exports.Functor = exports.map = exports.getAltValidation = exports.getApplicativeValidation = exports.getWitherable = exports.getFilterable = exports.getCompactable = exports.getSemigroup = exports.getEq = exports.getShow = exports.URI = exports.flatMap = exports.right = exports.left = void 0;
  exports.either = exports.stringifyJSON = exports.chainFirstW = exports.chainFirst = exports.chain = exports.chainW = exports.sequenceArray = exports.traverseArray = exports.traverseArrayWithIndex = exports.traverseReadonlyArrayWithIndex = exports.traverseReadonlyNonEmptyArrayWithIndex = exports.ApT = exports.apSW = exports.apS = exports.bindW = exports.bind = exports.let = exports.bindTo = exports.Do = exports.exists = exports.toUnion = exports.chainNullableK = exports.fromNullableK = exports.tryCatchK = exports.tryCatch = exports.fromNullable = exports.orElse = exports.orElseW = exports.swap = exports.filterOrElseW = exports.filterOrElse = exports.flatMapOption = exports.flatMapNullable = exports.liftOption = exports.liftNullable = exports.chainOptionKW = exports.chainOptionK = exports.fromOptionK = exports.duplicate = exports.flatten = exports.flattenW = exports.tap = exports.apSecondW = exports.apSecond = exports.apFirstW = exports.apFirst = exports.flap = exports.getOrElse = exports.getOrElseW = exports.fold = void 0;
  exports.getValidationMonoid = exports.getValidationSemigroup = exports.getApplyMonoid = exports.getApplySemigroup = void 0;
  exports.toError = toError;
  exports.elem = elem;
  exports.parseJSON = parseJSON;
  exports.getValidation = getValidation;
  var Applicative_1 = Applicative;
  var Apply_12 = Apply;
  var chainable = __importStar2(Chain);
  var ChainRec_1 = ChainRec;
  var FromEither_1 = FromEither;
  var function_12 = _function;
  var Functor_12 = Functor;
  var _2 = __importStar2(internal);
  var Separated_12 = Separated;
  var Witherable_1 = Witherable;
  exports.left = _2.left;
  exports.right = _2.right;
  exports.flatMap = (0, function_12.dual)(2, function(ma, f) {
    return (0, exports.isLeft)(ma) ? ma : f(ma.right);
  });
  var _map = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.map)(f));
  };
  var _ap = function(fab, fa) {
    return (0, function_12.pipe)(fab, (0, exports.ap)(fa));
  };
  var _reduce = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduce)(b, f));
  };
  var _foldMap = function(M) {
    return function(fa, f) {
      var foldMapM = (0, exports.foldMap)(M);
      return (0, function_12.pipe)(fa, foldMapM(f));
    };
  };
  var _reduceRight = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduceRight)(b, f));
  };
  var _traverse = function(F) {
    var traverseF = (0, exports.traverse)(F);
    return function(ta, f) {
      return (0, function_12.pipe)(ta, traverseF(f));
    };
  };
  var _bimap = function(fa, f, g) {
    return (0, function_12.pipe)(fa, (0, exports.bimap)(f, g));
  };
  var _mapLeft = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.mapLeft)(f));
  };
  var _alt = function(fa, that) {
    return (0, function_12.pipe)(fa, (0, exports.alt)(that));
  };
  var _extend = function(wa, f) {
    return (0, function_12.pipe)(wa, (0, exports.extend)(f));
  };
  var _chainRec = function(a, f) {
    return (0, ChainRec_1.tailRec)(f(a), function(e) {
      return (0, exports.isLeft)(e) ? (0, exports.right)((0, exports.left)(e.left)) : (0, exports.isLeft)(e.right) ? (0, exports.left)(f(e.right.left)) : (0, exports.right)((0, exports.right)(e.right.right));
    });
  };
  exports.URI = "Either";
  var getShow = function(SE, SA) {
    return {
      show: function(ma) {
        return (0, exports.isLeft)(ma) ? "left(".concat(SE.show(ma.left), ")") : "right(".concat(SA.show(ma.right), ")");
      }
    };
  };
  exports.getShow = getShow;
  var getEq = function(EL, EA) {
    return {
      equals: function(x, y) {
        return x === y || ((0, exports.isLeft)(x) ? (0, exports.isLeft)(y) && EL.equals(x.left, y.left) : (0, exports.isRight)(y) && EA.equals(x.right, y.right));
      }
    };
  };
  exports.getEq = getEq;
  var getSemigroup = function(S2) {
    return {
      concat: function(x, y) {
        return (0, exports.isLeft)(y) ? x : (0, exports.isLeft)(x) ? y : (0, exports.right)(S2.concat(x.right, y.right));
      }
    };
  };
  exports.getSemigroup = getSemigroup;
  var getCompactable = function(M) {
    var empty = (0, exports.left)(M.empty);
    return {
      URI: exports.URI,
      _E: void 0,
      compact: function(ma) {
        return (0, exports.isLeft)(ma) ? ma : ma.right._tag === "None" ? empty : (0, exports.right)(ma.right.value);
      },
      separate: function(ma) {
        return (0, exports.isLeft)(ma) ? (0, Separated_12.separated)(ma, ma) : (0, exports.isLeft)(ma.right) ? (0, Separated_12.separated)((0, exports.right)(ma.right.left), empty) : (0, Separated_12.separated)(empty, (0, exports.right)(ma.right.right));
      }
    };
  };
  exports.getCompactable = getCompactable;
  var getFilterable = function(M) {
    var empty = (0, exports.left)(M.empty);
    var _a = (0, exports.getCompactable)(M), compact2 = _a.compact, separate2 = _a.separate;
    var filter3 = function(ma, predicate) {
      return (0, exports.isLeft)(ma) ? ma : predicate(ma.right) ? ma : empty;
    };
    var partition2 = function(ma, p) {
      return (0, exports.isLeft)(ma) ? (0, Separated_12.separated)(ma, ma) : p(ma.right) ? (0, Separated_12.separated)(empty, (0, exports.right)(ma.right)) : (0, Separated_12.separated)((0, exports.right)(ma.right), empty);
    };
    return {
      URI: exports.URI,
      _E: void 0,
      map: _map,
      compact: compact2,
      separate: separate2,
      filter: filter3,
      filterMap: function(ma, f) {
        if ((0, exports.isLeft)(ma)) {
          return ma;
        }
        var ob = f(ma.right);
        return ob._tag === "None" ? empty : (0, exports.right)(ob.value);
      },
      partition: partition2,
      partitionMap: function(ma, f) {
        if ((0, exports.isLeft)(ma)) {
          return (0, Separated_12.separated)(ma, ma);
        }
        var e = f(ma.right);
        return (0, exports.isLeft)(e) ? (0, Separated_12.separated)((0, exports.right)(e.left), empty) : (0, Separated_12.separated)(empty, (0, exports.right)(e.right));
      }
    };
  };
  exports.getFilterable = getFilterable;
  var getWitherable = function(M) {
    var F_ = (0, exports.getFilterable)(M);
    var C = (0, exports.getCompactable)(M);
    return {
      URI: exports.URI,
      _E: void 0,
      map: _map,
      compact: F_.compact,
      separate: F_.separate,
      filter: F_.filter,
      filterMap: F_.filterMap,
      partition: F_.partition,
      partitionMap: F_.partitionMap,
      traverse: _traverse,
      sequence: exports.sequence,
      reduce: _reduce,
      foldMap: _foldMap,
      reduceRight: _reduceRight,
      wither: (0, Witherable_1.witherDefault)(exports.Traversable, C),
      wilt: (0, Witherable_1.wiltDefault)(exports.Traversable, C)
    };
  };
  exports.getWitherable = getWitherable;
  var getApplicativeValidation = function(SE) {
    return {
      URI: exports.URI,
      _E: void 0,
      map: _map,
      ap: function(fab, fa) {
        return (0, exports.isLeft)(fab) ? (0, exports.isLeft)(fa) ? (0, exports.left)(SE.concat(fab.left, fa.left)) : fab : (0, exports.isLeft)(fa) ? fa : (0, exports.right)(fab.right(fa.right));
      },
      of: exports.of
    };
  };
  exports.getApplicativeValidation = getApplicativeValidation;
  var getAltValidation = function(SE) {
    return {
      URI: exports.URI,
      _E: void 0,
      map: _map,
      alt: function(me, that) {
        if ((0, exports.isRight)(me)) {
          return me;
        }
        var ea = that();
        return (0, exports.isLeft)(ea) ? (0, exports.left)(SE.concat(me.left, ea.left)) : ea;
      }
    };
  };
  exports.getAltValidation = getAltValidation;
  var map2 = function(f) {
    return function(fa) {
      return (0, exports.isLeft)(fa) ? fa : (0, exports.right)(f(fa.right));
    };
  };
  exports.map = map2;
  exports.Functor = {
    URI: exports.URI,
    map: _map
  };
  exports.as = (0, function_12.dual)(2, (0, Functor_12.as)(exports.Functor));
  exports.asUnit = (0, Functor_12.asUnit)(exports.Functor);
  exports.of = exports.right;
  exports.Pointed = {
    URI: exports.URI,
    of: exports.of
  };
  var apW = function(fa) {
    return function(fab) {
      return (0, exports.isLeft)(fab) ? fab : (0, exports.isLeft)(fa) ? fa : (0, exports.right)(fab.right(fa.right));
    };
  };
  exports.apW = apW;
  exports.ap = exports.apW;
  exports.Apply = {
    URI: exports.URI,
    map: _map,
    ap: _ap
  };
  exports.Applicative = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of
  };
  exports.Chain = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    chain: exports.flatMap
  };
  exports.Monad = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of,
    chain: exports.flatMap
  };
  var reduce = function(b, f) {
    return function(fa) {
      return (0, exports.isLeft)(fa) ? b : f(b, fa.right);
    };
  };
  exports.reduce = reduce;
  var foldMap = function(M) {
    return function(f) {
      return function(fa) {
        return (0, exports.isLeft)(fa) ? M.empty : f(fa.right);
      };
    };
  };
  exports.foldMap = foldMap;
  var reduceRight = function(b, f) {
    return function(fa) {
      return (0, exports.isLeft)(fa) ? b : f(fa.right, b);
    };
  };
  exports.reduceRight = reduceRight;
  exports.Foldable = {
    URI: exports.URI,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight
  };
  var traverse = function(F) {
    return function(f) {
      return function(ta) {
        return (0, exports.isLeft)(ta) ? F.of((0, exports.left)(ta.left)) : F.map(f(ta.right), exports.right);
      };
    };
  };
  exports.traverse = traverse;
  var sequence = function(F) {
    return function(ma) {
      return (0, exports.isLeft)(ma) ? F.of((0, exports.left)(ma.left)) : F.map(ma.right, exports.right);
    };
  };
  exports.sequence = sequence;
  exports.Traversable = {
    URI: exports.URI,
    map: _map,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence
  };
  var bimap2 = function(f, g) {
    return function(fa) {
      return (0, exports.isLeft)(fa) ? (0, exports.left)(f(fa.left)) : (0, exports.right)(g(fa.right));
    };
  };
  exports.bimap = bimap2;
  var mapLeft2 = function(f) {
    return function(fa) {
      return (0, exports.isLeft)(fa) ? (0, exports.left)(f(fa.left)) : fa;
    };
  };
  exports.mapLeft = mapLeft2;
  exports.Bifunctor = {
    URI: exports.URI,
    bimap: _bimap,
    mapLeft: _mapLeft
  };
  var altW = function(that) {
    return function(fa) {
      return (0, exports.isLeft)(fa) ? that() : fa;
    };
  };
  exports.altW = altW;
  exports.alt = exports.altW;
  exports.Alt = {
    URI: exports.URI,
    map: _map,
    alt: _alt
  };
  var extend2 = function(f) {
    return function(wa) {
      return (0, exports.isLeft)(wa) ? wa : (0, exports.right)(f(wa));
    };
  };
  exports.extend = extend2;
  exports.Extend = {
    URI: exports.URI,
    map: _map,
    extend: _extend
  };
  exports.ChainRec = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    chain: exports.flatMap,
    chainRec: _chainRec
  };
  exports.throwError = exports.left;
  exports.MonadThrow = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of,
    chain: exports.flatMap,
    throwError: exports.throwError
  };
  exports.FromEither = {
    URI: exports.URI,
    fromEither: function_12.identity
  };
  exports.fromPredicate = (0, FromEither_1.fromPredicate)(exports.FromEither);
  exports.fromOption = /* @__PURE__ */ (0, FromEither_1.fromOption)(exports.FromEither);
  exports.isLeft = _2.isLeft;
  exports.isRight = _2.isRight;
  var matchW = function(onLeft, onRight) {
    return function(ma) {
      return (0, exports.isLeft)(ma) ? onLeft(ma.left) : onRight(ma.right);
    };
  };
  exports.matchW = matchW;
  exports.foldW = exports.matchW;
  exports.match = exports.matchW;
  exports.fold = exports.match;
  var getOrElseW = function(onLeft) {
    return function(ma) {
      return (0, exports.isLeft)(ma) ? onLeft(ma.left) : ma.right;
    };
  };
  exports.getOrElseW = getOrElseW;
  exports.getOrElse = exports.getOrElseW;
  exports.flap = (0, Functor_12.flap)(exports.Functor);
  exports.apFirst = (0, Apply_12.apFirst)(exports.Apply);
  exports.apFirstW = exports.apFirst;
  exports.apSecond = (0, Apply_12.apSecond)(exports.Apply);
  exports.apSecondW = exports.apSecond;
  exports.tap = (0, function_12.dual)(2, chainable.tap(exports.Chain));
  exports.flattenW = /* @__PURE__ */ (0, exports.flatMap)(function_12.identity);
  exports.flatten = exports.flattenW;
  exports.duplicate = (0, exports.extend)(function_12.identity);
  exports.fromOptionK = /* @__PURE__ */ (0, FromEither_1.fromOptionK)(exports.FromEither);
  exports.chainOptionK = (0, FromEither_1.chainOptionK)(exports.FromEither, exports.Chain);
  exports.chainOptionKW = exports.chainOptionK;
  var _FromEither = {
    fromEither: exports.FromEither.fromEither
  };
  exports.liftNullable = _2.liftNullable(_FromEither);
  exports.liftOption = _2.liftOption(_FromEither);
  var _FlatMap = {
    flatMap: exports.flatMap
  };
  exports.flatMapNullable = _2.flatMapNullable(_FromEither, _FlatMap);
  exports.flatMapOption = _2.flatMapOption(_FromEither, _FlatMap);
  exports.filterOrElse = (0, FromEither_1.filterOrElse)(exports.FromEither, exports.Chain);
  exports.filterOrElseW = exports.filterOrElse;
  var swap2 = function(ma) {
    return (0, exports.isLeft)(ma) ? (0, exports.right)(ma.left) : (0, exports.left)(ma.right);
  };
  exports.swap = swap2;
  var orElseW = function(onLeft) {
    return function(ma) {
      return (0, exports.isLeft)(ma) ? onLeft(ma.left) : ma;
    };
  };
  exports.orElseW = orElseW;
  exports.orElse = exports.orElseW;
  var fromNullable2 = function(e) {
    return function(a) {
      return a == null ? (0, exports.left)(e) : (0, exports.right)(a);
    };
  };
  exports.fromNullable = fromNullable2;
  var tryCatch = function(f, onThrow) {
    try {
      return (0, exports.right)(f());
    } catch (e) {
      return (0, exports.left)(onThrow(e));
    }
  };
  exports.tryCatch = tryCatch;
  var tryCatchK = function(f, onThrow) {
    return function() {
      var a = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        a[_i] = arguments[_i];
      }
      return (0, exports.tryCatch)(function() {
        return f.apply(void 0, a);
      }, onThrow);
    };
  };
  exports.tryCatchK = tryCatchK;
  var fromNullableK2 = function(e) {
    var from2 = (0, exports.fromNullable)(e);
    return function(f) {
      return (0, function_12.flow)(f, from2);
    };
  };
  exports.fromNullableK = fromNullableK2;
  var chainNullableK2 = function(e) {
    var from2 = (0, exports.fromNullableK)(e);
    return function(f) {
      return (0, exports.flatMap)(from2(f));
    };
  };
  exports.chainNullableK = chainNullableK2;
  exports.toUnion = (0, exports.foldW)(function_12.identity, function_12.identity);
  function toError(e) {
    try {
      return e instanceof Error ? e : new Error(String(e));
    } catch (error) {
      return new Error();
    }
  }
  function elem(E2) {
    return function(a, ma) {
      if (ma === void 0) {
        var elemE_1 = elem(E2);
        return function(ma2) {
          return elemE_1(a, ma2);
        };
      }
      return (0, exports.isLeft)(ma) ? false : E2.equals(a, ma.right);
    };
  }
  var exists = function(predicate) {
    return function(ma) {
      return (0, exports.isLeft)(ma) ? false : predicate(ma.right);
    };
  };
  exports.exists = exists;
  exports.Do = (0, exports.of)(_2.emptyRecord);
  exports.bindTo = (0, Functor_12.bindTo)(exports.Functor);
  var let_2 = /* @__PURE__ */ (0, Functor_12.let)(exports.Functor);
  exports.let = let_2;
  exports.bind = chainable.bind(exports.Chain);
  exports.bindW = exports.bind;
  exports.apS = (0, Apply_12.apS)(exports.Apply);
  exports.apSW = exports.apS;
  exports.ApT = (0, exports.of)(_2.emptyReadonlyArray);
  var traverseReadonlyNonEmptyArrayWithIndex = function(f) {
    return function(as2) {
      var e = f(0, _2.head(as2));
      if ((0, exports.isLeft)(e)) {
        return e;
      }
      var out = [e.right];
      for (var i = 1; i < as2.length; i++) {
        var e_1 = f(i, as2[i]);
        if ((0, exports.isLeft)(e_1)) {
          return e_1;
        }
        out.push(e_1.right);
      }
      return (0, exports.right)(out);
    };
  };
  exports.traverseReadonlyNonEmptyArrayWithIndex = traverseReadonlyNonEmptyArrayWithIndex;
  var traverseReadonlyArrayWithIndex = function(f) {
    var g = (0, exports.traverseReadonlyNonEmptyArrayWithIndex)(f);
    return function(as2) {
      return _2.isNonEmpty(as2) ? g(as2) : exports.ApT;
    };
  };
  exports.traverseReadonlyArrayWithIndex = traverseReadonlyArrayWithIndex;
  exports.traverseArrayWithIndex = exports.traverseReadonlyArrayWithIndex;
  var traverseArray = function(f) {
    return (0, exports.traverseReadonlyArrayWithIndex)(function(_3, a) {
      return f(a);
    });
  };
  exports.traverseArray = traverseArray;
  exports.sequenceArray = /* @__PURE__ */ (0, exports.traverseArray)(function_12.identity);
  exports.chainW = exports.flatMap;
  exports.chain = exports.flatMap;
  exports.chainFirst = exports.tap;
  exports.chainFirstW = exports.tap;
  function parseJSON(s, onError) {
    return (0, exports.tryCatch)(function() {
      return JSON.parse(s);
    }, onError);
  }
  var stringifyJSON = function(u, onError) {
    return (0, exports.tryCatch)(function() {
      var s = JSON.stringify(u);
      if (typeof s !== "string") {
        throw new Error("Converting unsupported structure to JSON");
      }
      return s;
    }, onError);
  };
  exports.stringifyJSON = stringifyJSON;
  exports.either = {
    URI: exports.URI,
    map: _map,
    of: exports.of,
    ap: _ap,
    chain: exports.flatMap,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence,
    bimap: _bimap,
    mapLeft: _mapLeft,
    alt: _alt,
    extend: _extend,
    chainRec: _chainRec,
    throwError: exports.throwError
  };
  exports.getApplySemigroup = /* @__PURE__ */ (0, Apply_12.getApplySemigroup)(exports.Apply);
  exports.getApplyMonoid = /* @__PURE__ */ (0, Applicative_1.getApplicativeMonoid)(exports.Applicative);
  var getValidationSemigroup = function(SE, SA) {
    return (0, Apply_12.getApplySemigroup)((0, exports.getApplicativeValidation)(SE))(SA);
  };
  exports.getValidationSemigroup = getValidationSemigroup;
  var getValidationMonoid = function(SE, MA) {
    return (0, Applicative_1.getApplicativeMonoid)((0, exports.getApplicativeValidation)(SE))(MA);
  };
  exports.getValidationMonoid = getValidationMonoid;
  function getValidation(SE) {
    var ap2 = (0, exports.getApplicativeValidation)(SE).ap;
    var alt2 = (0, exports.getAltValidation)(SE).alt;
    return {
      URI: exports.URI,
      _E: void 0,
      map: _map,
      of: exports.of,
      chain: exports.flatMap,
      bimap: _bimap,
      mapLeft: _mapLeft,
      reduce: _reduce,
      foldMap: _foldMap,
      reduceRight: _reduceRight,
      extend: _extend,
      traverse: _traverse,
      sequence: exports.sequence,
      chainRec: _chainRec,
      throwError: exports.throwError,
      ap: ap2,
      alt: alt2
    };
  }
})(Either);
var TaskEither = {};
var Compactable = {};
var __createBinding$1 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = { enumerable: true, get: function() {
      return m[k];
    } };
  }
  Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault$1 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
} : function(o, v) {
  o["default"] = v;
});
var __importStar$1 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
  if (mod2 && mod2.__esModule)
    return mod2;
  var result2 = {};
  if (mod2 != null) {
    for (var k in mod2)
      if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
        __createBinding$1(result2, mod2, k);
  }
  __setModuleDefault$1(result2, mod2);
  return result2;
};
Object.defineProperty(Compactable, "__esModule", { value: true });
Compactable.compact = compact;
Compactable.separate = separate;
Compactable.getCompactableComposition = getCompactableComposition;
var function_1$4 = _function;
var Functor_1$2 = Functor;
var Option_1$1 = Option;
var S = __importStar$1(Separated);
function compact(F, G) {
  return function(fga) {
    return F.map(fga, G.compact);
  };
}
function separate(F, C, G) {
  var _compact = compact(F, C);
  var _map = (0, Functor_1$2.map)(F, G);
  return function(fge) {
    return S.separated(_compact((0, function_1$4.pipe)(fge, _map(Option_1$1.getLeft))), _compact((0, function_1$4.pipe)(fge, _map(Option_1$1.getRight))));
  };
}
function getCompactableComposition(F, G) {
  var map2 = (0, Functor_1$2.getFunctorComposition)(F, G).map;
  return {
    map: map2,
    compact: compact(F, G),
    separate: separate(F, G, G)
  };
}
var EitherT = {};
var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = { enumerable: true, get: function() {
      return m[k];
    } };
  }
  Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
  if (k2 === void 0)
    k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
} : function(o, v) {
  o["default"] = v;
});
var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
  if (mod2 && mod2.__esModule)
    return mod2;
  var result2 = {};
  if (mod2 != null) {
    for (var k in mod2)
      if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
        __createBinding(result2, mod2, k);
  }
  __setModuleDefault(result2, mod2);
  return result2;
};
Object.defineProperty(EitherT, "__esModule", { value: true });
EitherT.right = right;
EitherT.left = left;
EitherT.rightF = rightF;
EitherT.leftF = leftF;
EitherT.fromNullable = fromNullable;
EitherT.fromNullableK = fromNullableK;
EitherT.chainNullableK = chainNullableK;
EitherT.map = map;
EitherT.ap = ap;
EitherT.chain = chain;
EitherT.flatMap = flatMap;
EitherT.alt = alt;
EitherT.bimap = bimap;
EitherT.mapBoth = mapBoth;
EitherT.mapLeft = mapLeft;
EitherT.mapError = mapError;
EitherT.altValidation = altValidation;
EitherT.match = match$1;
EitherT.matchE = matchE;
EitherT.getOrElse = getOrElse;
EitherT.orElse = orElse;
EitherT.orElseFirst = orElseFirst;
EitherT.tapError = tapError;
EitherT.orLeft = orLeft;
EitherT.swap = swap;
EitherT.toUnion = toUnion;
EitherT.getEitherM = getEitherM;
var Apply_1 = Apply;
var E = __importStar(Either);
var function_1$3 = _function;
var Functor_1$1 = Functor;
function right(F) {
  return (0, function_1$3.flow)(E.right, F.of);
}
function left(F) {
  return (0, function_1$3.flow)(E.left, F.of);
}
function rightF(F) {
  return function(fa) {
    return F.map(fa, E.right);
  };
}
function leftF(F) {
  return function(fe) {
    return F.map(fe, E.left);
  };
}
function fromNullable(F) {
  return function(e) {
    return (0, function_1$3.flow)(E.fromNullable(e), F.of);
  };
}
function fromNullableK(F) {
  var fromNullableF = fromNullable(F);
  return function(e) {
    var fromNullableFE = fromNullableF(e);
    return function(f) {
      return (0, function_1$3.flow)(f, fromNullableFE);
    };
  };
}
function chainNullableK(M) {
  var chainM = chain(M);
  var fromNullableKM = fromNullableK(M);
  return function(e) {
    var fromNullableKMe = fromNullableKM(e);
    return function(f) {
      return chainM(fromNullableKMe(f));
    };
  };
}
function map(F) {
  return (0, Functor_1$1.map)(F, E.Functor);
}
function ap(F) {
  return (0, Apply_1.ap)(F, E.Apply);
}
function chain(M) {
  var flatMapM = flatMap(M);
  return function(f) {
    return function(ma) {
      return flatMapM(ma, f);
    };
  };
}
function flatMap(M) {
  return function(ma, f) {
    return M.chain(ma, function(e) {
      return E.isLeft(e) ? M.of(e) : f(e.right);
    });
  };
}
function alt(M) {
  return function(second) {
    return function(first) {
      return M.chain(first, function(e) {
        return E.isLeft(e) ? second() : M.of(e);
      });
    };
  };
}
function bimap(F) {
  var mapBothF = mapBoth(F);
  return function(f, g) {
    return function(self2) {
      return mapBothF(self2, f, g);
    };
  };
}
function mapBoth(F) {
  return function(self2, f, g) {
    return F.map(self2, E.bimap(f, g));
  };
}
function mapLeft(F) {
  var mapErrorF = mapError(F);
  return function(f) {
    return function(self2) {
      return mapErrorF(self2, f);
    };
  };
}
function mapError(F) {
  return function(self2, f) {
    return F.map(self2, E.mapLeft(f));
  };
}
function altValidation(M, S2) {
  return function(second) {
    return function(first) {
      return M.chain(first, E.match(function(e1) {
        return M.map(second(), E.mapLeft(function(e2) {
          return S2.concat(e1, e2);
        }));
      }, right(M)));
    };
  };
}
function match$1(F) {
  return function(onLeft, onRight) {
    return function(ma) {
      return F.map(ma, E.match(onLeft, onRight));
    };
  };
}
function matchE(M) {
  return function(onLeft, onRight) {
    return function(ma) {
      return M.chain(ma, E.match(onLeft, onRight));
    };
  };
}
function getOrElse(M) {
  return function(onLeft) {
    return function(ma) {
      return M.chain(ma, E.match(onLeft, M.of));
    };
  };
}
function orElse(M) {
  return function(onLeft) {
    return function(ma) {
      return M.chain(ma, function(e) {
        return E.isLeft(e) ? onLeft(e.left) : M.of(e);
      });
    };
  };
}
function orElseFirst(M) {
  var tapErrorM = tapError(M);
  return function(onLeft) {
    return function(ma) {
      return tapErrorM(ma, onLeft);
    };
  };
}
function tapError(M) {
  var orElseM = orElse(M);
  return function(ma, onLeft) {
    return (0, function_1$3.pipe)(ma, orElseM(function(e) {
      return M.map(onLeft(e), function(eb) {
        return E.isLeft(eb) ? eb : E.left(e);
      });
    }));
  };
}
function orLeft(M) {
  return function(onLeft) {
    return function(ma) {
      return M.chain(ma, E.match(function(e) {
        return M.map(onLeft(e), E.left);
      }, function(a) {
        return M.of(E.right(a));
      }));
    };
  };
}
function swap(F) {
  return function(ma) {
    return F.map(ma, E.swap);
  };
}
function toUnion(F) {
  return function(fa) {
    return F.map(fa, E.toUnion);
  };
}
function getEitherM(M) {
  var _ap = ap(M);
  var _map = map(M);
  var _chain = chain(M);
  var _alt = alt(M);
  var _bimap = bimap(M);
  var _mapLeft = mapLeft(M);
  var _fold = matchE(M);
  var _getOrElse = getOrElse(M);
  var _orElse = orElse(M);
  return {
    map: function(fa, f) {
      return (0, function_1$3.pipe)(fa, _map(f));
    },
    ap: function(fab, fa) {
      return (0, function_1$3.pipe)(fab, _ap(fa));
    },
    of: right(M),
    chain: function(ma, f) {
      return (0, function_1$3.pipe)(ma, _chain(f));
    },
    alt: function(fa, that) {
      return (0, function_1$3.pipe)(fa, _alt(that));
    },
    bimap: function(fea, f, g) {
      return (0, function_1$3.pipe)(fea, _bimap(f, g));
    },
    mapLeft: function(fea, f) {
      return (0, function_1$3.pipe)(fea, _mapLeft(f));
    },
    fold: function(fa, onLeft, onRight) {
      return (0, function_1$3.pipe)(fa, _fold(onLeft, onRight));
    },
    getOrElse: function(fa, onLeft) {
      return (0, function_1$3.pipe)(fa, _getOrElse(onLeft));
    },
    orElse: function(fa, f) {
      return (0, function_1$3.pipe)(fa, _orElse(f));
    },
    swap: swap(M),
    rightM: rightF(M),
    leftM: leftF(M),
    left: left(M)
  };
}
var Filterable = {};
Object.defineProperty(Filterable, "__esModule", { value: true });
Filterable.filter = filter;
Filterable.filterMap = filterMap;
Filterable.partition = partition;
Filterable.partitionMap = partitionMap;
Filterable.getFilterableComposition = getFilterableComposition;
var Compactable_1 = Compactable;
var function_1$2 = _function;
var Functor_1 = Functor;
var Option_1 = Option;
var Predicate_1 = Predicate;
var Separated_1 = Separated;
function filter(F, G) {
  return function(predicate) {
    return function(fga) {
      return F.map(fga, function(ga) {
        return G.filter(ga, predicate);
      });
    };
  };
}
function filterMap(F, G) {
  return function(f) {
    return function(fga) {
      return F.map(fga, function(ga) {
        return G.filterMap(ga, f);
      });
    };
  };
}
function partition(F, G) {
  var _filter = filter(F, G);
  return function(predicate) {
    var left2 = _filter((0, Predicate_1.not)(predicate));
    var right2 = _filter(predicate);
    return function(fgb) {
      return (0, Separated_1.separated)(left2(fgb), right2(fgb));
    };
  };
}
function partitionMap(F, G) {
  var _filterMap = filterMap(F, G);
  return function(f) {
    return function(fga) {
      return (0, Separated_1.separated)((0, function_1$2.pipe)(fga, _filterMap(function(a) {
        return (0, Option_1.getLeft)(f(a));
      })), (0, function_1$2.pipe)(fga, _filterMap(function(a) {
        return (0, Option_1.getRight)(f(a));
      })));
    };
  };
}
function getFilterableComposition(F, G) {
  var map2 = (0, Functor_1.getFunctorComposition)(F, G).map;
  var _compact = (0, Compactable_1.compact)(F, G);
  var _separate = (0, Compactable_1.separate)(F, G, G);
  var _filter = filter(F, G);
  var _filterMap = filterMap(F, G);
  var _partition = partition(F, G);
  var _partitionMap = partitionMap(F, G);
  return {
    map: map2,
    compact: _compact,
    separate: _separate,
    filter: function(fga, f) {
      return (0, function_1$2.pipe)(fga, _filter(f));
    },
    filterMap: function(fga, f) {
      return (0, function_1$2.pipe)(fga, _filterMap(f));
    },
    partition: function(fga, p) {
      return (0, function_1$2.pipe)(fga, _partition(p));
    },
    partitionMap: function(fga, f) {
      return (0, function_1$2.pipe)(fga, _partitionMap(f));
    }
  };
}
var FromIO = {};
Object.defineProperty(FromIO, "__esModule", { value: true });
FromIO.fromIOK = fromIOK;
FromIO.chainIOK = chainIOK;
FromIO.chainFirstIOK = chainFirstIOK;
FromIO.tapIO = tapIO;
var Chain_1$1 = Chain;
var function_1$1 = _function;
function fromIOK(F) {
  return function(f) {
    return (0, function_1$1.flow)(f, F.fromIO);
  };
}
function chainIOK(F, M) {
  return function(f) {
    var g = (0, function_1$1.flow)(f, F.fromIO);
    return function(first) {
      return M.chain(first, g);
    };
  };
}
function chainFirstIOK(F, M) {
  var tapIOM = tapIO(F, M);
  return function(f) {
    return function(first) {
      return tapIOM(first, f);
    };
  };
}
function tapIO(F, M) {
  var chainFirstM = (0, Chain_1$1.tap)(M);
  return function(self2, f) {
    return chainFirstM(self2, (0, function_1$1.flow)(f, F.fromIO));
  };
}
var FromTask = {};
Object.defineProperty(FromTask, "__esModule", { value: true });
FromTask.fromTaskK = fromTaskK;
FromTask.chainTaskK = chainTaskK;
FromTask.chainFirstTaskK = chainFirstTaskK;
FromTask.tapTask = tapTask;
var Chain_1 = Chain;
var function_1 = _function;
function fromTaskK(F) {
  return function(f) {
    return (0, function_1.flow)(f, F.fromTask);
  };
}
function chainTaskK(F, M) {
  return function(f) {
    var g = (0, function_1.flow)(f, F.fromTask);
    return function(first) {
      return M.chain(first, g);
    };
  };
}
function chainFirstTaskK(F, M) {
  var tapTaskM = tapTask(F, M);
  return function(f) {
    return function(first) {
      return tapTaskM(first, f);
    };
  };
}
function tapTask(F, M) {
  var tapM = (0, Chain_1.tap)(M);
  return function(self2, f) {
    return tapM(self2, (0, function_1.flow)(f, F.fromTask));
  };
}
var Task = {};
(function(exports) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule)
      return mod2;
    var result2 = {};
    if (mod2 != null) {
      for (var k in mod2)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
          __createBinding2(result2, mod2, k);
    }
    __setModuleDefault2(result2, mod2);
    return result2;
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.chainFirst = exports.chain = exports.sequenceSeqArray = exports.traverseSeqArray = exports.traverseSeqArrayWithIndex = exports.sequenceArray = exports.traverseArray = exports.traverseArrayWithIndex = exports.traverseReadonlyArrayWithIndexSeq = exports.traverseReadonlyNonEmptyArrayWithIndexSeq = exports.traverseReadonlyArrayWithIndex = exports.traverseReadonlyNonEmptyArrayWithIndex = exports.ApT = exports.apS = exports.bind = exports.let = exports.bindTo = exports.Do = exports.never = exports.FromTask = exports.chainFirstIOK = exports.chainIOK = exports.fromIOK = exports.tapIO = exports.tap = exports.flatMapIO = exports.FromIO = exports.MonadTask = exports.fromTask = exports.MonadIO = exports.Monad = exports.Chain = exports.ApplicativeSeq = exports.ApplySeq = exports.ApplicativePar = exports.apSecond = exports.apFirst = exports.ApplyPar = exports.Pointed = exports.flap = exports.asUnit = exports.as = exports.Functor = exports.URI = exports.flatten = exports.flatMap = exports.of = exports.ap = exports.map = exports.fromIO = void 0;
  exports.getMonoid = exports.getSemigroup = exports.taskSeq = exports.task = void 0;
  exports.delay = delay;
  exports.getRaceMonoid = getRaceMonoid;
  var Applicative_1 = Applicative;
  var Apply_12 = Apply;
  var chainable = __importStar2(Chain);
  var FromIO_1 = FromIO;
  var function_12 = _function;
  var Functor_12 = Functor;
  var _2 = __importStar2(internal);
  var fromIO = function(ma) {
    return function() {
      return Promise.resolve().then(ma);
    };
  };
  exports.fromIO = fromIO;
  function delay(millis) {
    return function(ma) {
      return function() {
        return new Promise(function(resolve) {
          setTimeout(function() {
            Promise.resolve().then(ma).then(resolve);
          }, millis);
        });
      };
    };
  }
  var _map = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.map)(f));
  };
  var _apPar = function(fab, fa) {
    return (0, function_12.pipe)(fab, (0, exports.ap)(fa));
  };
  var _apSeq = function(fab, fa) {
    return (0, exports.flatMap)(fab, function(f) {
      return (0, function_12.pipe)(fa, (0, exports.map)(f));
    });
  };
  var map2 = function(f) {
    return function(fa) {
      return function() {
        return Promise.resolve().then(fa).then(f);
      };
    };
  };
  exports.map = map2;
  var ap2 = function(fa) {
    return function(fab) {
      return function() {
        return Promise.all([Promise.resolve().then(fab), Promise.resolve().then(fa)]).then(function(_a) {
          var f = _a[0], a = _a[1];
          return f(a);
        });
      };
    };
  };
  exports.ap = ap2;
  var of = function(a) {
    return function() {
      return Promise.resolve(a);
    };
  };
  exports.of = of;
  exports.flatMap = (0, function_12.dual)(2, function(ma, f) {
    return function() {
      return Promise.resolve().then(ma).then(function(a) {
        return f(a)();
      });
    };
  });
  exports.flatten = (0, exports.flatMap)(function_12.identity);
  exports.URI = "Task";
  function getRaceMonoid() {
    return {
      concat: function(x, y) {
        return function() {
          return Promise.race([Promise.resolve().then(x), Promise.resolve().then(y)]);
        };
      },
      empty: exports.never
    };
  }
  exports.Functor = {
    URI: exports.URI,
    map: _map
  };
  exports.as = (0, function_12.dual)(2, (0, Functor_12.as)(exports.Functor));
  exports.asUnit = (0, Functor_12.asUnit)(exports.Functor);
  exports.flap = (0, Functor_12.flap)(exports.Functor);
  exports.Pointed = {
    URI: exports.URI,
    of: exports.of
  };
  exports.ApplyPar = {
    URI: exports.URI,
    map: _map,
    ap: _apPar
  };
  exports.apFirst = (0, Apply_12.apFirst)(exports.ApplyPar);
  exports.apSecond = (0, Apply_12.apSecond)(exports.ApplyPar);
  exports.ApplicativePar = {
    URI: exports.URI,
    map: _map,
    ap: _apPar,
    of: exports.of
  };
  exports.ApplySeq = {
    URI: exports.URI,
    map: _map,
    ap: _apSeq
  };
  exports.ApplicativeSeq = {
    URI: exports.URI,
    map: _map,
    ap: _apSeq,
    of: exports.of
  };
  exports.Chain = {
    URI: exports.URI,
    map: _map,
    ap: _apPar,
    chain: exports.flatMap
  };
  exports.Monad = {
    URI: exports.URI,
    map: _map,
    of: exports.of,
    ap: _apPar,
    chain: exports.flatMap
  };
  exports.MonadIO = {
    URI: exports.URI,
    map: _map,
    of: exports.of,
    ap: _apPar,
    chain: exports.flatMap,
    fromIO: exports.fromIO
  };
  exports.fromTask = function_12.identity;
  exports.MonadTask = {
    URI: exports.URI,
    map: _map,
    of: exports.of,
    ap: _apPar,
    chain: exports.flatMap,
    fromIO: exports.fromIO,
    fromTask: exports.fromTask
  };
  exports.FromIO = {
    URI: exports.URI,
    fromIO: exports.fromIO
  };
  var _FlatMap = {
    flatMap: exports.flatMap
  };
  var _FromIO = {
    fromIO: exports.FromIO.fromIO
  };
  exports.flatMapIO = _2.flatMapIO(_FromIO, _FlatMap);
  exports.tap = (0, function_12.dual)(2, chainable.tap(exports.Chain));
  exports.tapIO = (0, function_12.dual)(2, (0, FromIO_1.tapIO)(exports.FromIO, exports.Chain));
  exports.fromIOK = /* @__PURE__ */ (0, FromIO_1.fromIOK)(exports.FromIO);
  exports.chainIOK = exports.flatMapIO;
  exports.chainFirstIOK = exports.tapIO;
  exports.FromTask = {
    URI: exports.URI,
    fromIO: exports.fromIO,
    fromTask: exports.fromTask
  };
  var never = function() {
    return new Promise(function(_3) {
      return void 0;
    });
  };
  exports.never = never;
  exports.Do = (0, exports.of)(_2.emptyRecord);
  exports.bindTo = (0, Functor_12.bindTo)(exports.Functor);
  var let_2 = /* @__PURE__ */ (0, Functor_12.let)(exports.Functor);
  exports.let = let_2;
  exports.bind = chainable.bind(exports.Chain);
  exports.apS = (0, Apply_12.apS)(exports.ApplyPar);
  exports.ApT = (0, exports.of)(_2.emptyReadonlyArray);
  var traverseReadonlyNonEmptyArrayWithIndex = function(f) {
    return function(as2) {
      return function() {
        return Promise.all(as2.map(function(a, i) {
          return Promise.resolve().then(function() {
            return f(i, a)();
          });
        }));
      };
    };
  };
  exports.traverseReadonlyNonEmptyArrayWithIndex = traverseReadonlyNonEmptyArrayWithIndex;
  var traverseReadonlyArrayWithIndex = function(f) {
    var g = (0, exports.traverseReadonlyNonEmptyArrayWithIndex)(f);
    return function(as2) {
      return _2.isNonEmpty(as2) ? g(as2) : exports.ApT;
    };
  };
  exports.traverseReadonlyArrayWithIndex = traverseReadonlyArrayWithIndex;
  var traverseReadonlyNonEmptyArrayWithIndexSeq = function(f) {
    return function(as2) {
      return function() {
        return _2.tail(as2).reduce(function(acc, a, i) {
          return acc.then(function(bs) {
            return Promise.resolve().then(f(i + 1, a)).then(function(b) {
              bs.push(b);
              return bs;
            });
          });
        }, Promise.resolve().then(f(0, _2.head(as2))).then(_2.singleton));
      };
    };
  };
  exports.traverseReadonlyNonEmptyArrayWithIndexSeq = traverseReadonlyNonEmptyArrayWithIndexSeq;
  var traverseReadonlyArrayWithIndexSeq = function(f) {
    var g = (0, exports.traverseReadonlyNonEmptyArrayWithIndexSeq)(f);
    return function(as2) {
      return _2.isNonEmpty(as2) ? g(as2) : exports.ApT;
    };
  };
  exports.traverseReadonlyArrayWithIndexSeq = traverseReadonlyArrayWithIndexSeq;
  exports.traverseArrayWithIndex = exports.traverseReadonlyArrayWithIndex;
  var traverseArray = function(f) {
    return (0, exports.traverseReadonlyArrayWithIndex)(function(_3, a) {
      return f(a);
    });
  };
  exports.traverseArray = traverseArray;
  exports.sequenceArray = /* @__PURE__ */ (0, exports.traverseArray)(function_12.identity);
  exports.traverseSeqArrayWithIndex = exports.traverseReadonlyArrayWithIndexSeq;
  var traverseSeqArray = function(f) {
    return (0, exports.traverseReadonlyArrayWithIndexSeq)(function(_3, a) {
      return f(a);
    });
  };
  exports.traverseSeqArray = traverseSeqArray;
  exports.sequenceSeqArray = /* @__PURE__ */ (0, exports.traverseSeqArray)(function_12.identity);
  exports.chain = exports.flatMap;
  exports.chainFirst = exports.tap;
  exports.task = {
    URI: exports.URI,
    map: _map,
    of: exports.of,
    ap: _apPar,
    chain: exports.flatMap,
    fromIO: exports.fromIO,
    fromTask: exports.fromTask
  };
  exports.taskSeq = {
    URI: exports.URI,
    map: _map,
    of: exports.of,
    ap: _apSeq,
    chain: exports.flatMap,
    fromIO: exports.fromIO,
    fromTask: exports.fromTask
  };
  exports.getSemigroup = (0, Apply_12.getApplySemigroup)(exports.ApplySeq);
  exports.getMonoid = (0, Applicative_1.getApplicativeMonoid)(exports.ApplicativeSeq);
})(Task);
(function(exports) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule)
      return mod2;
    var result2 = {};
    if (mod2 != null) {
      for (var k in mod2)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
          __createBinding2(result2, mod2, k);
    }
    __setModuleDefault2(result2, mod2);
    return result2;
  };
  var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result2) {
        result2.done ? resolve(result2.value) : adopt(result2.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var __generator = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body) {
    var _3 = { label: 0, sent: function() {
      if (t[0] & 1)
        throw t[1];
      return t[1];
    }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
      return this;
    }), g;
    function verb(n) {
      return function(v) {
        return step([n, v]);
      };
    }
    function step(op) {
      if (f)
        throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_3 = 0)), _3)
        try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
            return t;
          if (y = 0, t)
            op = [op[0] & 2, t.value];
          switch (op[0]) {
            case 0:
            case 1:
              t = op;
              break;
            case 4:
              _3.label++;
              return { value: op[1], done: false };
            case 5:
              _3.label++;
              y = op[1];
              op = [0];
              continue;
            case 7:
              op = _3.ops.pop();
              _3.trys.pop();
              continue;
            default:
              if (!(t = _3.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                _3 = 0;
                continue;
              }
              if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                _3.label = op[1];
                break;
              }
              if (op[0] === 6 && _3.label < t[1]) {
                _3.label = t[1];
                t = op;
                break;
              }
              if (t && _3.label < t[2]) {
                _3.label = t[2];
                _3.ops.push(op);
                break;
              }
              if (t[2])
                _3.ops.pop();
              _3.trys.pop();
              continue;
          }
          op = body.call(thisArg, _3);
        } catch (e) {
          op = [6, e];
          y = 0;
        } finally {
          f = t = 0;
        }
      if (op[0] & 5)
        throw op[1];
      return { value: op[0] ? op[1] : void 0, done: true };
    }
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.throwError = exports.of = exports.altW = exports.alt = exports.flatten = exports.flattenW = exports.flatMap = exports.apW = exports.ap = exports.mapLeft = exports.mapError = exports.bimap = exports.mapBoth = exports.map = exports.fromIOEitherK = exports.chainTaskOptionK = exports.chainTaskOptionKW = exports.fromTaskOptionK = exports.swap = exports.orLeft = exports.orElseFirstTaskK = exports.orElseFirstIOK = exports.tapError = exports.orElseW = exports.orElse = exports.chainNullableK = exports.fromNullableK = exports.fromNullable = exports.toUnion = exports.tryCatchK = exports.tryCatch = exports.getOrElseW = exports.getOrElse = exports.foldW = exports.matchEW = exports.fold = exports.matchE = exports.matchW = exports.match = exports.fromTaskOption = exports.fromIOEither = exports.fromEither = exports.fromTask = exports.fromIO = exports.leftIO = exports.rightIO = exports.leftTask = exports.rightTask = exports.right = exports.left = void 0;
  exports.fromEitherK = exports.filterOrElseW = exports.filterOrElse = exports.fromPredicate = exports.chainFirstEitherKW = exports.chainFirstEitherK = exports.chainEitherKW = exports.chainEitherK = exports.flatMapTaskOption = exports.flatMapIOEither = exports.flatMapTask = exports.flatMapIO = exports.flatMapEither = exports.flatMapOption = exports.flatMapNullable = exports.liftOption = exports.liftNullable = exports.chainOptionKW = exports.chainOptionK = exports.fromOptionK = exports.fromOption = exports.Alt = exports.Bifunctor = exports.tapTask = exports.tapIO = exports.tapEither = exports.tap = exports.FromTask = exports.FromIO = exports.FromEither = exports.MonadThrow = exports.MonadTask = exports.MonadIO = exports.Monad = exports.Chain = exports.ApplicativeSeq = exports.ApplySeq = exports.ApplicativePar = exports.apSecondW = exports.apSecond = exports.apFirstW = exports.apFirst = exports.ApplyPar = exports.Pointed = exports.flap = exports.asUnit = exports.as = exports.Functor = exports.getCompactable = exports.URI = void 0;
  exports.getSemigroup = exports.getApplyMonoid = exports.getApplySemigroup = exports.taskEitherSeq = exports.taskEither = exports.orElseFirstW = exports.orElseFirst = exports.chainFirstW = exports.chainFirst = exports.chainW = exports.chain = exports.sequenceSeqArray = exports.traverseSeqArray = exports.traverseSeqArrayWithIndex = exports.sequenceArray = exports.traverseArray = exports.traverseArrayWithIndex = exports.traverseReadonlyArrayWithIndexSeq = exports.traverseReadonlyNonEmptyArrayWithIndexSeq = exports.traverseReadonlyArrayWithIndex = exports.traverseReadonlyNonEmptyArrayWithIndex = exports.ApT = exports.apSW = exports.apS = exports.bindW = exports.bind = exports.let = exports.bindTo = exports.Do = exports.bracketW = exports.bracket = exports.chainIOEitherK = exports.chainIOEitherKW = exports.chainFirstTaskK = exports.chainTaskK = exports.fromTaskK = exports.chainFirstIOK = exports.chainIOK = exports.fromIOK = void 0;
  exports.getApplicativeTaskValidation = getApplicativeTaskValidation;
  exports.getAltTaskValidation = getAltTaskValidation;
  exports.getFilterable = getFilterable;
  exports.taskify = taskify;
  exports.getTaskValidation = getTaskValidation;
  var Applicative_1 = Applicative;
  var Apply_12 = Apply;
  var chainable = __importStar2(Chain);
  var Compactable_12 = Compactable;
  var E2 = __importStar2(Either);
  var ET = __importStar2(EitherT);
  var Filterable_1 = Filterable;
  var FromEither_1 = FromEither;
  var FromIO_1 = FromIO;
  var FromTask_1 = FromTask;
  var function_12 = _function;
  var Functor_12 = Functor;
  var _2 = __importStar2(internal);
  var T = __importStar2(Task);
  exports.left = ET.left(T.Pointed);
  exports.right = ET.right(T.Pointed);
  exports.rightTask = ET.rightF(T.Functor);
  exports.leftTask = ET.leftF(T.Functor);
  exports.rightIO = (0, function_12.flow)(T.fromIO, exports.rightTask);
  exports.leftIO = (0, function_12.flow)(T.fromIO, exports.leftTask);
  exports.fromIO = exports.rightIO;
  exports.fromTask = exports.rightTask;
  exports.fromEither = T.of;
  exports.fromIOEither = T.fromIO;
  var fromTaskOption = function(onNone) {
    return T.map(E2.fromOption(onNone));
  };
  exports.fromTaskOption = fromTaskOption;
  exports.match = /* @__PURE__ */ ET.match(T.Functor);
  exports.matchW = exports.match;
  exports.matchE = ET.matchE(T.Monad);
  exports.fold = exports.matchE;
  exports.matchEW = exports.matchE;
  exports.foldW = exports.matchEW;
  exports.getOrElse = /* @__PURE__ */ ET.getOrElse(T.Monad);
  exports.getOrElseW = exports.getOrElse;
  var tryCatch = function(f, onRejected) {
    return function() {
      return __awaiter(void 0, void 0, void 0, function() {
        var reason_1;
        return __generator(this, function(_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 2, , 3]);
              return [4, f().then(_2.right)];
            case 1:
              return [2, _a.sent()];
            case 2:
              reason_1 = _a.sent();
              return [2, _2.left(onRejected(reason_1))];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
  };
  exports.tryCatch = tryCatch;
  var tryCatchK = function(f, onRejected) {
    return function() {
      var a = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        a[_i] = arguments[_i];
      }
      return (0, exports.tryCatch)(function() {
        return f.apply(void 0, a);
      }, onRejected);
    };
  };
  exports.tryCatchK = tryCatchK;
  exports.toUnion = ET.toUnion(T.Functor);
  exports.fromNullable = ET.fromNullable(T.Pointed);
  exports.fromNullableK = ET.fromNullableK(T.Pointed);
  exports.chainNullableK = /* @__PURE__ */ ET.chainNullableK(T.Monad);
  exports.orElse = /* @__PURE__ */ ET.orElse(T.Monad);
  exports.orElseW = exports.orElse;
  exports.tapError = (0, function_12.dual)(2, ET.tapError(T.Monad));
  var orElseFirstIOK = function(onLeft) {
    return (0, exports.tapError)((0, exports.fromIOK)(onLeft));
  };
  exports.orElseFirstIOK = orElseFirstIOK;
  var orElseFirstTaskK = function(onLeft) {
    return (0, exports.tapError)((0, exports.fromTaskK)(onLeft));
  };
  exports.orElseFirstTaskK = orElseFirstTaskK;
  exports.orLeft = /* @__PURE__ */ ET.orLeft(T.Monad);
  exports.swap = ET.swap(T.Functor);
  var fromTaskOptionK = function(onNone) {
    var from2 = (0, exports.fromTaskOption)(onNone);
    return function(f) {
      return (0, function_12.flow)(f, from2);
    };
  };
  exports.fromTaskOptionK = fromTaskOptionK;
  var chainTaskOptionKW = function(onNone) {
    return function(f) {
      return function(ma) {
        return (0, exports.flatMap)(ma, (0, exports.fromTaskOptionK)(onNone)(f));
      };
    };
  };
  exports.chainTaskOptionKW = chainTaskOptionKW;
  exports.chainTaskOptionK = exports.chainTaskOptionKW;
  var fromIOEitherK = function(f) {
    return (0, function_12.flow)(f, exports.fromIOEither);
  };
  exports.fromIOEitherK = fromIOEitherK;
  var _map = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.map)(f));
  };
  var _apPar = function(fab, fa) {
    return (0, function_12.pipe)(fab, (0, exports.ap)(fa));
  };
  var _apSeq = function(fab, fa) {
    return (0, exports.flatMap)(fab, function(f) {
      return (0, function_12.pipe)(fa, (0, exports.map)(f));
    });
  };
  var _alt = function(fa, that) {
    return (0, function_12.pipe)(fa, (0, exports.alt)(that));
  };
  exports.map = ET.map(T.Functor);
  exports.mapBoth = (0, function_12.dual)(3, ET.mapBoth(T.Functor));
  exports.bimap = exports.mapBoth;
  exports.mapError = (0, function_12.dual)(2, ET.mapError(T.Functor));
  exports.mapLeft = exports.mapError;
  exports.ap = /* @__PURE__ */ ET.ap(T.ApplyPar);
  exports.apW = exports.ap;
  exports.flatMap = (0, function_12.dual)(2, ET.flatMap(T.Monad));
  exports.flattenW = /* @__PURE__ */ (0, exports.flatMap)(function_12.identity);
  exports.flatten = exports.flattenW;
  exports.alt = /* @__PURE__ */ ET.alt(T.Monad);
  exports.altW = exports.alt;
  exports.of = exports.right;
  exports.throwError = exports.left;
  exports.URI = "TaskEither";
  function getApplicativeTaskValidation(A, S2) {
    var ap2 = (0, Apply_12.ap)(A, E2.getApplicativeValidation(S2));
    return {
      URI: exports.URI,
      _E: void 0,
      map: _map,
      ap: function(fab, fa) {
        return (0, function_12.pipe)(fab, ap2(fa));
      },
      of: exports.of
    };
  }
  function getAltTaskValidation(S2) {
    var alt2 = ET.altValidation(T.Monad, S2);
    return {
      URI: exports.URI,
      _E: void 0,
      map: _map,
      alt: function(fa, that) {
        return (0, function_12.pipe)(fa, alt2(that));
      }
    };
  }
  var getCompactable = function(M) {
    var C = E2.getCompactable(M);
    return {
      URI: exports.URI,
      _E: void 0,
      compact: (0, Compactable_12.compact)(T.Functor, C),
      separate: (0, Compactable_12.separate)(T.Functor, C, E2.Functor)
    };
  };
  exports.getCompactable = getCompactable;
  function getFilterable(M) {
    var F = E2.getFilterable(M);
    var C = (0, exports.getCompactable)(M);
    var filter3 = (0, Filterable_1.filter)(T.Functor, F);
    var filterMap2 = (0, Filterable_1.filterMap)(T.Functor, F);
    var partition2 = (0, Filterable_1.partition)(T.Functor, F);
    var partitionMap2 = (0, Filterable_1.partitionMap)(T.Functor, F);
    return {
      URI: exports.URI,
      _E: void 0,
      map: _map,
      compact: C.compact,
      separate: C.separate,
      filter: function(fa, predicate) {
        return (0, function_12.pipe)(fa, filter3(predicate));
      },
      filterMap: function(fa, f) {
        return (0, function_12.pipe)(fa, filterMap2(f));
      },
      partition: function(fa, predicate) {
        return (0, function_12.pipe)(fa, partition2(predicate));
      },
      partitionMap: function(fa, f) {
        return (0, function_12.pipe)(fa, partitionMap2(f));
      }
    };
  }
  exports.Functor = {
    URI: exports.URI,
    map: _map
  };
  exports.as = (0, function_12.dual)(2, (0, Functor_12.as)(exports.Functor));
  exports.asUnit = (0, Functor_12.asUnit)(exports.Functor);
  exports.flap = (0, Functor_12.flap)(exports.Functor);
  exports.Pointed = {
    URI: exports.URI,
    of: exports.of
  };
  exports.ApplyPar = {
    URI: exports.URI,
    map: _map,
    ap: _apPar
  };
  exports.apFirst = (0, Apply_12.apFirst)(exports.ApplyPar);
  exports.apFirstW = exports.apFirst;
  exports.apSecond = (0, Apply_12.apSecond)(exports.ApplyPar);
  exports.apSecondW = exports.apSecond;
  exports.ApplicativePar = {
    URI: exports.URI,
    map: _map,
    ap: _apPar,
    of: exports.of
  };
  exports.ApplySeq = {
    URI: exports.URI,
    map: _map,
    ap: _apSeq
  };
  exports.ApplicativeSeq = {
    URI: exports.URI,
    map: _map,
    ap: _apSeq,
    of: exports.of
  };
  exports.Chain = {
    URI: exports.URI,
    map: _map,
    ap: _apPar,
    chain: exports.flatMap
  };
  exports.Monad = {
    URI: exports.URI,
    map: _map,
    ap: _apPar,
    chain: exports.flatMap,
    of: exports.of
  };
  exports.MonadIO = {
    URI: exports.URI,
    map: _map,
    ap: _apPar,
    chain: exports.flatMap,
    of: exports.of,
    fromIO: exports.fromIO
  };
  exports.MonadTask = {
    URI: exports.URI,
    map: _map,
    ap: _apPar,
    chain: exports.flatMap,
    of: exports.of,
    fromIO: exports.fromIO,
    fromTask: exports.fromTask
  };
  exports.MonadThrow = {
    URI: exports.URI,
    map: _map,
    ap: _apPar,
    chain: exports.flatMap,
    of: exports.of,
    throwError: exports.throwError
  };
  exports.FromEither = {
    URI: exports.URI,
    fromEither: exports.fromEither
  };
  exports.FromIO = {
    URI: exports.URI,
    fromIO: exports.fromIO
  };
  exports.FromTask = {
    URI: exports.URI,
    fromIO: exports.fromIO,
    fromTask: exports.fromTask
  };
  exports.tap = (0, function_12.dual)(2, chainable.tap(exports.Chain));
  exports.tapEither = (0, function_12.dual)(2, (0, FromEither_1.tapEither)(exports.FromEither, exports.Chain));
  exports.tapIO = (0, function_12.dual)(2, (0, FromIO_1.tapIO)(exports.FromIO, exports.Chain));
  exports.tapTask = (0, function_12.dual)(2, (0, FromTask_1.tapTask)(exports.FromTask, exports.Chain));
  exports.Bifunctor = {
    URI: exports.URI,
    bimap: exports.mapBoth,
    mapLeft: exports.mapError
  };
  exports.Alt = {
    URI: exports.URI,
    map: _map,
    alt: _alt
  };
  exports.fromOption = /* @__PURE__ */ (0, FromEither_1.fromOption)(exports.FromEither);
  exports.fromOptionK = /* @__PURE__ */ (0, FromEither_1.fromOptionK)(exports.FromEither);
  exports.chainOptionK = (0, FromEither_1.chainOptionK)(exports.FromEither, exports.Chain);
  exports.chainOptionKW = exports.chainOptionK;
  var _FromEither = {
    fromEither: exports.FromEither.fromEither
  };
  exports.liftNullable = _2.liftNullable(_FromEither);
  exports.liftOption = _2.liftOption(_FromEither);
  var _FlatMap = {
    flatMap: exports.flatMap
  };
  var _FromIO = {
    fromIO: exports.FromIO.fromIO
  };
  var _FromTask = {
    fromTask: exports.fromTask
  };
  exports.flatMapNullable = _2.flatMapNullable(_FromEither, _FlatMap);
  exports.flatMapOption = _2.flatMapOption(_FromEither, _FlatMap);
  exports.flatMapEither = _2.flatMapEither(_FromEither, _FlatMap);
  exports.flatMapIO = _2.flatMapIO(_FromIO, _FlatMap);
  exports.flatMapTask = _2.flatMapTask(_FromTask, _FlatMap);
  exports.flatMapIOEither = (0, function_12.dual)(2, function(self2, f) {
    return (0, exports.flatMap)(self2, (0, exports.fromIOEitherK)(f));
  });
  exports.flatMapTaskOption = (0, function_12.dual)(3, function(self2, f, onNone) {
    return (0, exports.flatMap)(self2, function(a) {
      return (0, exports.fromTaskOption)(function() {
        return onNone(a);
      })(f(a));
    });
  });
  exports.chainEitherK = exports.flatMapEither;
  exports.chainEitherKW = exports.flatMapEither;
  exports.chainFirstEitherK = exports.tapEither;
  exports.chainFirstEitherKW = exports.tapEither;
  exports.fromPredicate = (0, FromEither_1.fromPredicate)(exports.FromEither);
  exports.filterOrElse = (0, FromEither_1.filterOrElse)(exports.FromEither, exports.Chain);
  exports.filterOrElseW = exports.filterOrElse;
  exports.fromEitherK = (0, FromEither_1.fromEitherK)(exports.FromEither);
  exports.fromIOK = (0, FromIO_1.fromIOK)(exports.FromIO);
  exports.chainIOK = exports.flatMapIO;
  exports.chainFirstIOK = exports.tapIO;
  exports.fromTaskK = (0, FromTask_1.fromTaskK)(exports.FromTask);
  exports.chainTaskK = exports.flatMapTask;
  exports.chainFirstTaskK = exports.tapTask;
  exports.chainIOEitherKW = exports.flatMapIOEither;
  exports.chainIOEitherK = exports.flatMapIOEither;
  function taskify(f) {
    return function() {
      var args = Array.prototype.slice.call(arguments);
      return function() {
        return new Promise(function(resolve) {
          var cbResolver = function(e, r) {
            return e != null ? resolve(_2.left(e)) : resolve(_2.right(r));
          };
          f.apply(null, args.concat(cbResolver));
        });
      };
    };
  }
  var bracket = function(acquire, use, release) {
    return (0, exports.bracketW)(acquire, use, release);
  };
  exports.bracket = bracket;
  var bracketW = function(acquire, use, release) {
    return (0, exports.flatMap)(acquire, function(a) {
      return T.flatMap(use(a), function(e) {
        return (0, exports.flatMap)(release(a, e), function() {
          return T.of(e);
        });
      });
    });
  };
  exports.bracketW = bracketW;
  exports.Do = (0, exports.of)(_2.emptyRecord);
  exports.bindTo = (0, Functor_12.bindTo)(exports.Functor);
  var let_2 = /* @__PURE__ */ (0, Functor_12.let)(exports.Functor);
  exports.let = let_2;
  exports.bind = chainable.bind(exports.Chain);
  exports.bindW = exports.bind;
  exports.apS = (0, Apply_12.apS)(exports.ApplyPar);
  exports.apSW = exports.apS;
  exports.ApT = (0, exports.of)(_2.emptyReadonlyArray);
  var traverseReadonlyNonEmptyArrayWithIndex = function(f) {
    return (0, function_12.flow)(T.traverseReadonlyNonEmptyArrayWithIndex(f), T.map(E2.traverseReadonlyNonEmptyArrayWithIndex(function_12.SK)));
  };
  exports.traverseReadonlyNonEmptyArrayWithIndex = traverseReadonlyNonEmptyArrayWithIndex;
  var traverseReadonlyArrayWithIndex = function(f) {
    var g = (0, exports.traverseReadonlyNonEmptyArrayWithIndex)(f);
    return function(as2) {
      return _2.isNonEmpty(as2) ? g(as2) : exports.ApT;
    };
  };
  exports.traverseReadonlyArrayWithIndex = traverseReadonlyArrayWithIndex;
  var traverseReadonlyNonEmptyArrayWithIndexSeq = function(f) {
    return function(as2) {
      return function() {
        return _2.tail(as2).reduce(function(acc, a, i) {
          return acc.then(function(ebs) {
            return _2.isLeft(ebs) ? acc : f(i + 1, a)().then(function(eb) {
              if (_2.isLeft(eb)) {
                return eb;
              }
              ebs.right.push(eb.right);
              return ebs;
            });
          });
        }, f(0, _2.head(as2))().then(E2.map(_2.singleton)));
      };
    };
  };
  exports.traverseReadonlyNonEmptyArrayWithIndexSeq = traverseReadonlyNonEmptyArrayWithIndexSeq;
  var traverseReadonlyArrayWithIndexSeq = function(f) {
    var g = (0, exports.traverseReadonlyNonEmptyArrayWithIndexSeq)(f);
    return function(as2) {
      return _2.isNonEmpty(as2) ? g(as2) : exports.ApT;
    };
  };
  exports.traverseReadonlyArrayWithIndexSeq = traverseReadonlyArrayWithIndexSeq;
  exports.traverseArrayWithIndex = exports.traverseReadonlyArrayWithIndex;
  var traverseArray = function(f) {
    return (0, exports.traverseReadonlyArrayWithIndex)(function(_3, a) {
      return f(a);
    });
  };
  exports.traverseArray = traverseArray;
  exports.sequenceArray = /* @__PURE__ */ (0, exports.traverseArray)(function_12.identity);
  exports.traverseSeqArrayWithIndex = exports.traverseReadonlyArrayWithIndexSeq;
  var traverseSeqArray = function(f) {
    return (0, exports.traverseReadonlyArrayWithIndexSeq)(function(_3, a) {
      return f(a);
    });
  };
  exports.traverseSeqArray = traverseSeqArray;
  exports.sequenceSeqArray = /* @__PURE__ */ (0, exports.traverseSeqArray)(function_12.identity);
  exports.chain = exports.flatMap;
  exports.chainW = exports.flatMap;
  exports.chainFirst = exports.tap;
  exports.chainFirstW = exports.tap;
  exports.orElseFirst = exports.tapError;
  exports.orElseFirstW = exports.tapError;
  exports.taskEither = {
    URI: exports.URI,
    bimap: exports.mapBoth,
    mapLeft: exports.mapError,
    map: _map,
    of: exports.of,
    ap: _apPar,
    chain: exports.flatMap,
    alt: _alt,
    fromIO: exports.fromIO,
    fromTask: exports.fromTask,
    throwError: exports.throwError
  };
  exports.taskEitherSeq = {
    URI: exports.URI,
    bimap: exports.mapBoth,
    mapLeft: exports.mapError,
    map: _map,
    of: exports.of,
    ap: _apSeq,
    chain: exports.flatMap,
    alt: _alt,
    fromIO: exports.fromIO,
    fromTask: exports.fromTask,
    throwError: exports.throwError
  };
  exports.getApplySemigroup = /* @__PURE__ */ (0, Apply_12.getApplySemigroup)(exports.ApplySeq);
  exports.getApplyMonoid = /* @__PURE__ */ (0, Applicative_1.getApplicativeMonoid)(exports.ApplicativeSeq);
  var getSemigroup = function(S2) {
    return (0, Apply_12.getApplySemigroup)(T.ApplySeq)(E2.getSemigroup(S2));
  };
  exports.getSemigroup = getSemigroup;
  function getTaskValidation(SE) {
    var applicativeTaskValidation = getApplicativeTaskValidation(T.ApplicativePar, SE);
    var altTaskValidation = getAltTaskValidation(SE);
    return {
      URI: exports.URI,
      _E: void 0,
      map: _map,
      ap: applicativeTaskValidation.ap,
      of: exports.of,
      chain: exports.flatMap,
      bimap: exports.mapBoth,
      mapLeft: exports.mapError,
      alt: altTaskValidation.alt,
      fromIO: exports.fromIO,
      fromTask: exports.fromTask,
      throwError: exports.throwError
    };
  }
})(TaskEither);
function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const kindOf = /* @__PURE__ */ ((cache) => (thing) => {
  const str = toString.call(thing);
  return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null));
const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type;
};
const typeOfTest = (type) => (thing) => typeof thing === type;
const { isArray } = Array;
const isUndefined = typeOfTest("undefined");
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(val) {
  let result2;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result2 = ArrayBuffer.isView(val);
  } else {
    result2 = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result2;
}
const isString = typeOfTest("string");
const isFunction = typeOfTest("function");
const isNumber = typeOfTest("number");
const isObject = (thing) => thing !== null && typeof thing === "object";
const isBoolean = (thing) => thing === true || thing === false;
const isPlainObject = (val) => {
  if (kindOf(val) !== "object") {
    return false;
  }
  const prototype2 = getPrototypeOf(val);
  return (prototype2 === null || prototype2 === Object.prototype || Object.getPrototypeOf(prototype2) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
const isDate = kindOfTest("Date");
const isFile = kindOfTest("File");
const isBlob$1 = kindOfTest("Blob");
const isFileList = kindOfTest("FileList");
const isStream = (val) => isObject(val) && isFunction(val.pipe);
const isFormData = (thing) => {
  let kind;
  return thing && (typeof FormData === "function" && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === "formdata" || // detect form-data instance
  kind === "object" && isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
const isURLSearchParams = kindOfTest("URLSearchParams");
const trim = (str) => str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach(obj, fn, { allOwnKeys = false } = {}) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  let i;
  let l;
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    const keys2 = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys2.length;
    let key;
    for (i = 0; i < len; i++) {
      key = keys2[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}
function findKey(obj, key) {
  key = key.toLowerCase();
  const keys2 = Object.keys(obj);
  let i = keys2.length;
  let _key;
  while (i-- > 0) {
    _key = keys2[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}
const _global = (() => {
  if (typeof globalThis !== "undefined")
    return globalThis;
  return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
})();
const isContextDefined = (context) => !isUndefined(context) && context !== _global;
function merge() {
  const { caseless } = isContextDefined(this) && this || {};
  const result2 = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result2, key) || key;
    if (isPlainObject(result2[targetKey]) && isPlainObject(val)) {
      result2[targetKey] = merge(result2[targetKey], val);
    } else if (isPlainObject(val)) {
      result2[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result2[targetKey] = val.slice();
    } else {
      result2[targetKey] = val;
    }
  };
  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result2;
}
const extend = (a, b, thisArg, { allOwnKeys } = {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, { allOwnKeys });
  return a;
};
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
};
const inherits = (constructor, superConstructor, props, descriptors2) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors2);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, "super", {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};
const toFlatObject = (sourceObj, destObj, filter3, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};
  destObj = destObj || {};
  if (sourceObj == null)
    return destObj;
  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter3 !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter3 || filter3(sourceObj, destObj)) && sourceObj !== Object.prototype);
  return destObj;
};
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === void 0 || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};
const toArray = (thing) => {
  if (!thing)
    return null;
  if (isArray(thing))
    return thing;
  let i = thing.length;
  if (!isNumber(i))
    return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};
const isTypedArray = /* @__PURE__ */ ((TypedArray) => {
  return (thing) => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];
  const iterator = generator.call(obj);
  let result2;
  while ((result2 = iterator.next()) && !result2.done) {
    const pair = result2.value;
    fn.call(obj, pair[0], pair[1]);
  }
};
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];
  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }
  return arr;
};
const isHTMLForm = kindOfTest("HTMLFormElement");
const toCamelCase = (str) => {
  return str.toLowerCase().replace(
    /[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};
const hasOwnProperty = (({ hasOwnProperty: hasOwnProperty2 }) => (obj, prop) => hasOwnProperty2.call(obj, prop))(Object.prototype);
const isRegExp = kindOfTest("RegExp");
const reduceDescriptors = (obj, reducer2) => {
  const descriptors2 = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};
  forEach(descriptors2, (descriptor, name) => {
    let ret;
    if ((ret = reducer2(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });
  Object.defineProperties(obj, reducedDescriptors);
};
const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    if (isFunction(obj) && ["arguments", "caller", "callee"].indexOf(name) !== -1) {
      return false;
    }
    const value = obj[name];
    if (!isFunction(value))
      return;
    descriptor.enumerable = false;
    if ("writable" in descriptor) {
      descriptor.writable = false;
      return;
    }
    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error("Can not rewrite read-only method '" + name + "'");
      };
    }
  });
};
const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};
  const define = (arr) => {
    arr.forEach((value) => {
      obj[value] = true;
    });
  };
  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
  return obj;
};
const noop = () => {
};
const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
};
const ALPHA = "abcdefghijklmnopqrstuvwxyz";
const DIGIT = "0123456789";
const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};
const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = "";
  const { length } = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length | 0];
  }
  return str;
};
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const toJSONObject = (obj) => {
  const stack = new Array(10);
  const visit = (source, i) => {
    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }
      if (!("toJSON" in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};
        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });
        stack[i] = void 0;
        return target;
      }
    }
    return source;
  };
  return visit(obj, 0);
};
const isAsyncFn = kindOfTest("AsyncFunction");
const isThenable = (thing) => thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
const utils = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob: isBlob$1,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
};
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = new Error().stack;
  }
  this.message = message;
  this.name = "AxiosError";
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}
utils.inherits(AxiosError, Error, {
  toJSON: function toJSON2() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const prototype$1 = AxiosError.prototype;
const descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((code) => {
  descriptors[code] = { value: code };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: true });
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);
  utils.toFlatObject(error, axiosError, function filter3(obj) {
    return obj !== Error.prototype;
  }, (prop) => {
    return prop !== "isAxiosError";
  });
  AxiosError.call(axiosError, error.message, code, config, request, response);
  axiosError.cause = error;
  axiosError.name = error.name;
  customProps && Object.assign(axiosError, customProps);
  return axiosError;
};
const httpAdapter = null;
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}
function removeBrackets(key) {
  return utils.endsWith(key, "[]") ? key.slice(0, -2) : key;
}
function renderKey(path, key, dots) {
  if (!path)
    return key;
  return path.concat(key).map(function each(token2, i) {
    token2 = removeBrackets(token2);
    return !dots && i ? "[" + token2 + "]" : token2;
  }).join(dots ? "." : "");
}
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}
const predicates = utils.toFlatObject(utils, {}, null, function filter2(prop) {
  return /^is[A-Z]/.test(prop);
});
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError("target must be an object");
  }
  formData = formData || new FormData();
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option2, source) {
    return !utils.isUndefined(source[option2]);
  });
  const metaTokens = options.metaTokens;
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);
  if (!utils.isFunction(visitor)) {
    throw new TypeError("visitor must be a function");
  }
  function convertValue(value) {
    if (value === null)
      return "";
    if (utils.isDate(value)) {
      return value.toISOString();
    }
    if (!useBlob && utils.isBlob(value)) {
      throw new AxiosError("Blob is not supported. Use a Buffer instead.");
    }
    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
    }
    return value;
  }
  function defaultVisitor(value, key, path) {
    let arr = value;
    if (value && !path && typeof value === "object") {
      if (utils.endsWith(key, "{}")) {
        key = metaTokens ? key : key.slice(0, -2);
        value = JSON.stringify(value);
      } else if (utils.isArray(value) && isFlatArray(value) || (utils.isFileList(value) || utils.endsWith(key, "[]")) && (arr = utils.toArray(value))) {
        key = removeBrackets(key);
        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : indexes === null ? key : key + "[]",
            convertValue(el)
          );
        });
        return false;
      }
    }
    if (isVisitable(value)) {
      return true;
    }
    formData.append(renderKey(path, key, dots), convertValue(value));
    return false;
  }
  const stack = [];
  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });
  function build2(value, path) {
    if (utils.isUndefined(value))
      return;
    if (stack.indexOf(value) !== -1) {
      throw Error("Circular reference detected in " + path.join("."));
    }
    stack.push(value);
    utils.forEach(value, function each(el, key) {
      const result2 = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData,
        el,
        utils.isString(key) ? key.trim() : key,
        path,
        exposedHelpers
      );
      if (result2 === true) {
        build2(el, path ? path.concat(key) : [key]);
      }
    });
    stack.pop();
  }
  if (!utils.isObject(obj)) {
    throw new TypeError("data must be an object");
  }
  build2(obj);
  return formData;
}
function encode$1(str) {
  const charMap = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match5) {
    return charMap[match5];
  });
}
function AxiosURLSearchParams(params, options) {
  this._pairs = [];
  params && toFormData(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};
prototype.toString = function toString2(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;
  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + "=" + _encode(pair[1]);
  }, "").join("&");
};
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(url, params, options) {
  if (!params) {
    return url;
  }
  const _encode = options && options.encode || encode;
  const serializeFn = options && options.serialize;
  let serializedParams;
  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ? params.toString() : new AxiosURLSearchParams(params, options).toString(_encode);
  }
  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}
const transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};
const URLSearchParams$1 = typeof URLSearchParams !== "undefined" ? URLSearchParams : AxiosURLSearchParams;
const FormData$1 = typeof FormData !== "undefined" ? FormData : null;
const Blob$1 = typeof Blob !== "undefined" ? Blob : null;
const isStandardBrowserEnv = (() => {
  let product;
  if (typeof navigator !== "undefined" && ((product = navigator.product) === "ReactNative" || product === "NativeScript" || product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
})();
const isStandardBrowserWebWorkerEnv = (() => {
  return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
  self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const platform = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  isStandardBrowserEnv,
  isStandardBrowserWebWorkerEnv,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function toURLEncodedForm(data, options) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString("base64"));
        return false;
      }
      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}
function parsePropPath(name) {
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map((match5) => {
    return match5[0] === "[]" ? "" : match5[1] || match5[0];
  });
}
function arrayToObject(arr) {
  const obj = {};
  const keys2 = Object.keys(arr);
  let i;
  const len = keys2.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys2[i];
    obj[key] = arr[key];
  }
  return obj;
}
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;
    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }
      return !isNumericKey;
    }
    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }
    const result2 = buildPath(path, value, target[name], index);
    if (result2 && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }
    return !isNumericKey;
  }
  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};
    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });
    return obj;
  }
  return null;
}
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== "SyntaxError") {
        throw e;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http"],
  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || "";
    const hasJSONContentType = contentType.indexOf("application/json") > -1;
    const isObjectPayload = utils.isObject(data);
    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }
    const isFormData2 = utils.isFormData(data);
    if (isFormData2) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }
    if (utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
      return data.toString();
    }
    let isFileList2;
    if (isObjectPayload) {
      if (contentType.indexOf("application/x-www-form-urlencoded") > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }
      if ((isFileList2 = utils.isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
        const _FormData = this.env && this.env.FormData;
        return toFormData(
          isFileList2 ? { "files[]": data } : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }
    if (isObjectPayload || hasJSONContentType) {
      headers.setContentType("application/json", false);
      return stringifySafely(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    const transitional2 = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
    const JSONRequested = this.responseType === "json";
    if (data && utils.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
      const silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === "SyntaxError") {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }
    return data;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils.forEach(["delete", "get", "head", "post", "put", "patch"], (method) => {
  defaults.headers[method] = {};
});
const defaults$1 = defaults;
const ignoreDuplicateOf = utils.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]);
const parseHeaders = (rawHeaders) => {
  const parsed = {};
  let key;
  let val;
  let i;
  rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
    i = line.indexOf(":");
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();
    if (!key || parsed[key] && ignoreDuplicateOf[key]) {
      return;
    }
    if (key === "set-cookie") {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    }
  });
  return parsed;
};
const $internals = Symbol("internals");
function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }
  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
  const tokens2 = /* @__PURE__ */ Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match5;
  while (match5 = tokensRE.exec(str)) {
    tokens2[match5[1]] = match5[2];
  }
  return tokens2;
}
const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter3, isHeaderNameFilter) {
  if (utils.isFunction(filter3)) {
    return filter3.call(this, value, header);
  }
  if (isHeaderNameFilter) {
    value = header;
  }
  if (!utils.isString(value))
    return;
  if (utils.isString(filter3)) {
    return value.indexOf(filter3) !== -1;
  }
  if (utils.isRegExp(filter3)) {
    return filter3.test(value);
  }
}
function formatHeader(header) {
  return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
    return char.toUpperCase() + str;
  });
}
function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(" " + header);
  ["get", "set", "has"].forEach((methodName) => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}
class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }
  set(header, valueOrRewrite, rewrite) {
    const self2 = this;
    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);
      if (!lHeader) {
        throw new Error("header name must be a non-empty string");
      }
      const key = utils.findKey(self2, lHeader);
      if (!key || self2[key] === void 0 || _rewrite === true || _rewrite === void 0 && self2[key] !== false) {
        self2[key || _header] = normalizeValue(_value);
      }
    }
    const setHeaders = (headers, _rewrite) => utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));
    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if (utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }
    return this;
  }
  get(header, parser) {
    header = normalizeHeader(header);
    if (header) {
      const key = utils.findKey(this, header);
      if (key) {
        const value = this[key];
        if (!parser) {
          return value;
        }
        if (parser === true) {
          return parseTokens(value);
        }
        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }
        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(header, matcher) {
    header = normalizeHeader(header);
    if (header) {
      const key = utils.findKey(this, header);
      return !!(key && this[key] !== void 0 && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }
    return false;
  }
  delete(header, matcher) {
    const self2 = this;
    let deleted = false;
    function deleteHeader(_header) {
      _header = normalizeHeader(_header);
      if (_header) {
        const key = utils.findKey(self2, _header);
        if (key && (!matcher || matchHeaderValue(self2, self2[key], key, matcher))) {
          delete self2[key];
          deleted = true;
        }
      }
    }
    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }
    return deleted;
  }
  clear(matcher) {
    const keys2 = Object.keys(this);
    let i = keys2.length;
    let deleted = false;
    while (i--) {
      const key = keys2[i];
      if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }
    return deleted;
  }
  normalize(format2) {
    const self2 = this;
    const headers = {};
    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);
      if (key) {
        self2[key] = normalizeValue(value);
        delete self2[header];
        return;
      }
      const normalized = format2 ? formatHeader(header) : String(header).trim();
      if (normalized !== header) {
        delete self2[header];
      }
      self2[normalized] = normalizeValue(value);
      headers[normalized] = true;
    });
    return this;
  }
  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }
  toJSON(asStrings) {
    const obj = /* @__PURE__ */ Object.create(null);
    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(", ") : value);
    });
    return obj;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ": " + value).join("\n");
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }
  static concat(first, ...targets) {
    const computed = new this(first);
    targets.forEach((target) => computed.set(target));
    return computed;
  }
  static accessor(header) {
    const internals = this[$internals] = this[$internals] = {
      accessors: {}
    };
    const accessors = internals.accessors;
    const prototype2 = this.prototype;
    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);
      if (!accessors[lHeader]) {
        buildAccessors(prototype2, _header);
        accessors[lHeader] = true;
      }
    }
    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
    return this;
  }
}
AxiosHeaders.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils.reduceDescriptors(AxiosHeaders.prototype, ({ value }, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1);
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  };
});
utils.freezeMethods(AxiosHeaders);
const AxiosHeaders$1 = AxiosHeaders;
function transformData(fns, response) {
  const config = this || defaults$1;
  const context = response || config;
  const headers = AxiosHeaders$1.from(context.headers);
  let data = context.data;
  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : void 0);
  });
  headers.normalize();
  return data;
}
function isCancel(value) {
  return !!(value && value.__CANCEL__);
}
function CanceledError(message, config, request) {
  AxiosError.call(this, message == null ? "canceled" : message, AxiosError.ERR_CANCELED, config, request);
  this.name = "CanceledError";
}
utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});
function settle(resolve, reject, response) {
  const validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      "Request failed with status code " + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}
const cookies = platform.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  /* @__PURE__ */ function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        const cookie = [];
        cookie.push(name + "=" + encodeURIComponent(value));
        if (utils.isNumber(expires)) {
          cookie.push("expires=" + new Date(expires).toGMTString());
        }
        if (utils.isString(path)) {
          cookie.push("path=" + path);
        }
        if (utils.isString(domain)) {
          cookie.push("domain=" + domain);
        }
        if (secure === true) {
          cookie.push("secure");
        }
        document.cookie = cookie.join("; ");
      },
      read: function read(name) {
        const match5 = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match5 ? decodeURIComponent(match5[3]) : null;
      },
      remove: function remove(name) {
        this.write(name, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  /* @__PURE__ */ function nonStandardBrowserEnv() {
    return {
      write: function write() {
      },
      read: function read() {
        return null;
      },
      remove: function remove() {
      }
    };
  }()
);
function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}
const isURLSameOrigin = platform.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function standardBrowserEnv2() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    function resolveURL(url) {
      let href = url;
      if (msie) {
        urlParsingNode.setAttribute("href", href);
        href = urlParsingNode.href;
      }
      urlParsingNode.setAttribute("href", href);
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
      };
    }
    originURL = resolveURL(window.location.href);
    return function isURLSameOrigin2(requestURL) {
      const parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
      return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function nonStandardBrowserEnv2() {
    return function isURLSameOrigin2() {
      return true;
    };
  }()
);
function parseProtocol(url) {
  const match5 = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match5 && match5[1] || "";
}
function speedometer(samplesCount, min2) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;
  min2 = min2 !== void 0 ? min2 : 1e3;
  return function push(chunkLength) {
    const now2 = Date.now();
    const startedAt = timestamps[tail];
    if (!firstSampleTS) {
      firstSampleTS = now2;
    }
    bytes[head] = chunkLength;
    timestamps[head] = now2;
    let i = tail;
    let bytesCount = 0;
    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }
    head = (head + 1) % samplesCount;
    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }
    if (now2 - firstSampleTS < min2) {
      return;
    }
    const passed = startedAt && now2 - startedAt;
    return passed ? Math.round(bytesCount * 1e3 / passed) : void 0;
  };
}
function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);
  return (e) => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : void 0;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;
    bytesNotified = loaded;
    const data = {
      loaded,
      total,
      progress: total ? loaded / total : void 0,
      bytes: progressBytes,
      rate: rate ? rate : void 0,
      estimated: rate && total && inRange ? (total - loaded) / rate : void 0,
      event: e
    };
    data[isDownloadStream ? "download" : "upload"] = true;
    listener(data);
  };
}
const isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
const xhrAdapter = isXHRAdapterSupported && function(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = AxiosHeaders$1.from(config.headers).normalize();
    const responseType = config.responseType;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }
      if (config.signal) {
        config.signal.removeEventListener("abort", onCanceled);
      }
    }
    let contentType;
    if (utils.isFormData(requestData)) {
      if (platform.isStandardBrowserEnv || platform.isStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false);
      } else if (!requestHeaders.getContentType(/^\s*multipart\/form-data/)) {
        requestHeaders.setContentType("multipart/form-data");
      } else if (utils.isString(contentType = requestHeaders.getContentType())) {
        requestHeaders.setContentType(contentType.replace(/^\s*(multipart\/form-data);+/, "$1"));
      }
    }
    let request = new XMLHttpRequest();
    if (config.auth) {
      const username = config.auth.username || "";
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
      requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
    }
    const fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
    request.timeout = config.timeout;
    function onloadend() {
      if (!request) {
        return;
      }
      const responseHeaders = AxiosHeaders$1.from(
        "getAllResponseHeaders" in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };
      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request = null;
    }
    if ("onloadend" in request) {
      request.onloadend = onloadend;
    } else {
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }
      reject(new AxiosError("Request aborted", AxiosError.ECONNABORTED, config, request));
      request = null;
    };
    request.onerror = function handleError() {
      reject(new AxiosError("Network Error", AxiosError.ERR_NETWORK, config, request));
      request = null;
    };
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
      const transitional2 = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional2.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request
      ));
      request = null;
    };
    if (platform.isStandardBrowserEnv) {
      const xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName && cookies.read(config.xsrfCookieName);
      if (xsrfValue) {
        requestHeaders.set(config.xsrfHeaderName, xsrfValue);
      }
    }
    requestData === void 0 && requestHeaders.setContentType(null);
    if ("setRequestHeader" in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request.responseType = config.responseType;
    }
    if (typeof config.onDownloadProgress === "function") {
      request.addEventListener("progress", progressEventReducer(config.onDownloadProgress, true));
    }
    if (typeof config.onUploadProgress === "function" && request.upload) {
      request.upload.addEventListener("progress", progressEventReducer(config.onUploadProgress));
    }
    if (config.cancelToken || config.signal) {
      onCanceled = (cancel) => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };
      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
      }
    }
    const protocol = parseProtocol(fullPath);
    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError("Unsupported protocol " + protocol + ":", AxiosError.ERR_BAD_REQUEST, config));
      return;
    }
    request.send(requestData || null);
  });
};
const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter
};
utils.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, "name", { value });
    } catch (e) {
    }
    Object.defineProperty(fn, "adapterName", { value });
  }
});
const renderReason = (reason) => `- ${reason}`;
const isResolvedHandle = (adapter) => utils.isFunction(adapter) || adapter === null || adapter === false;
const adapters = {
  getAdapter: (adapters2) => {
    adapters2 = utils.isArray(adapters2) ? adapters2 : [adapters2];
    const { length } = adapters2;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters2[i];
      let id;
      adapter = nameOrAdapter;
      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
        if (adapter === void 0) {
          throw new AxiosError(`Unknown adapter '${id}'`);
        }
      }
      if (adapter) {
        break;
      }
      rejectedReasons[id || "#" + i] = adapter;
    }
    if (!adapter) {
      const reasons = Object.entries(rejectedReasons).map(
        ([id, state]) => `adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build")
      );
      let s = length ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
      throw new AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return adapter;
  },
  adapters: knownAdapters
};
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new CanceledError(null, config);
  }
}
function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = AxiosHeaders$1.from(config.headers);
  config.data = transformData.call(
    config,
    config.transformRequest
  );
  if (["post", "put", "patch"].indexOf(config.method) !== -1) {
    config.headers.setContentType("application/x-www-form-urlencoded", false);
  }
  const adapter = adapters.getAdapter(config.adapter || defaults$1.adapter);
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );
    response.headers = AxiosHeaders$1.from(response.headers);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders$1.from(reason.response.headers);
      }
    }
    return Promise.reject(reason);
  });
}
const headersToObject = (thing) => thing instanceof AxiosHeaders$1 ? thing.toJSON() : thing;
function mergeConfig(config1, config2) {
  config2 = config2 || {};
  const config = {};
  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({ caseless }, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(void 0, a, caseless);
    }
  }
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(void 0, b);
    }
  }
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(void 0, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(void 0, a);
    }
  }
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(void 0, a);
    }
  }
  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };
  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge2 = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge2(config1[prop], config2[prop], prop);
    utils.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
}
const VERSION = "1.5.1";
const validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((type, i) => {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function transitional(validator2, version, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return (value, opt, opts) => {
    if (validator2 === false) {
      throw new AxiosError(
        formatMessage(opt, " has been removed" + (version ? " in " + version : "")),
        AxiosError.ERR_DEPRECATED
      );
    }
    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(
        formatMessage(
          opt,
          " has been deprecated since v" + version + " and will be removed in the near future"
        )
      );
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys2 = Object.keys(options);
  let i = keys2.length;
  while (i-- > 0) {
    const opt = keys2[i];
    const validator2 = schema[opt];
    if (validator2) {
      const value = options[opt];
      const result2 = value === void 0 || validator2(value, opt, options);
      if (result2 !== true) {
        throw new AxiosError("option " + opt + " must be " + result2, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError("Unknown option " + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}
const validator = {
  assertOptions,
  validators: validators$1
};
const validators = validator.validators;
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    if (typeof configOrUrl === "string") {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }
    config = mergeConfig(this.defaults, config);
    const { transitional: transitional2, paramsSerializer, headers } = config;
    if (transitional2 !== void 0) {
      validator.assertOptions(transitional2, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }
    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }
    config.method = (config.method || this.defaults.method || "get").toLowerCase();
    let contextHeaders = headers && utils.merge(
      headers.common,
      headers[config.method]
    );
    headers && utils.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (method) => {
        delete headers[method];
      }
    );
    config.headers = AxiosHeaders$1.concat(contextHeaders, headers);
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
        return;
      }
      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    let promise;
    let i = 0;
    let len;
    if (!synchronousRequestInterceptors) {
      const chain2 = [dispatchRequest.bind(this), void 0];
      chain2.unshift.apply(chain2, requestInterceptorChain);
      chain2.push.apply(chain2, responseInterceptorChain);
      len = chain2.length;
      promise = Promise.resolve(config);
      while (i < len) {
        promise = promise.then(chain2[i++], chain2[i++]);
      }
      return promise;
    }
    len = requestInterceptorChain.length;
    let newConfig = config;
    i = 0;
    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }
    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }
    i = 0;
    len = responseInterceptorChain.length;
    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }
    return promise;
  }
  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}
utils.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url,
        data
      }));
    };
  }
  Axios.prototype[method] = generateHTTPMethod();
  Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
const Axios$1 = Axios;
class CancelToken {
  constructor(executor) {
    if (typeof executor !== "function") {
      throw new TypeError("executor must be a function.");
    }
    let resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });
    const token2 = this;
    this.promise.then((cancel) => {
      if (!token2._listeners)
        return;
      let i = token2._listeners.length;
      while (i-- > 0) {
        token2._listeners[i](cancel);
      }
      token2._listeners = null;
    });
    this.promise.then = (onfulfilled) => {
      let _resolve;
      const promise = new Promise((resolve) => {
        token2.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);
      promise.cancel = function reject() {
        token2.unsubscribe(_resolve);
      };
      return promise;
    };
    executor(function cancel(message, config, request) {
      if (token2.reason) {
        return;
      }
      token2.reason = new CanceledError(message, config, request);
      resolvePromise(token2.reason);
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token2 = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token: token2,
      cancel
    };
  }
}
const CancelToken$1 = CancelToken;
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}
function isAxiosError(payload) {
  return utils.isObject(payload) && payload.isAxiosError === true;
}
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});
const HttpStatusCode$1 = HttpStatusCode;
function createInstance(defaultConfig) {
  const context = new Axios$1(defaultConfig);
  const instance = bind(Axios$1.prototype.request, context);
  utils.extend(instance, Axios$1.prototype, context, { allOwnKeys: true });
  utils.extend(instance, context, null, { allOwnKeys: true });
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };
  return instance;
}
const axios = createInstance(defaults$1);
axios.Axios = Axios$1;
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;
axios.AxiosError = AxiosError;
axios.Cancel = axios.CanceledError;
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = spread;
axios.isAxiosError = isAxiosError;
axios.mergeConfig = mergeConfig;
axios.AxiosHeaders = AxiosHeaders$1;
axios.formToJSON = (thing) => formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = adapters.getAdapter;
axios.HttpStatusCode = HttpStatusCode$1;
axios.default = axios;
/*! js-cookie v3.0.5 | MIT */
function assign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
}
var defaultConverter = {
  read: function(value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function init(converter, defaultAttributes) {
  function set2(name, value, attributes) {
    if (typeof document === "undefined") {
      return;
    }
    attributes = assign({}, defaultAttributes, attributes);
    if (typeof attributes.expires === "number") {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = "";
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += "; " + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }
      stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
    }
    return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
  }
  function get2(name) {
    if (typeof document === "undefined" || arguments.length && !name) {
      return;
    }
    var cookies2 = document.cookie ? document.cookie.split("; ") : [];
    var jar = {};
    for (var i = 0; i < cookies2.length; i++) {
      var parts = cookies2[i].split("=");
      var value = parts.slice(1).join("=");
      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);
        if (name === found) {
          break;
        }
      } catch (e) {
      }
    }
    return name ? jar[name] : jar;
  }
  return Object.create(
    {
      set: set2,
      get: get2,
      remove: function(name, attributes) {
        set2(
          name,
          "",
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function(attributes) {
        return init(this.converter, assign({}, this.attributes, attributes));
      },
      withConverter: function(converter2) {
        return init(assign({}, this.converter, converter2), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  );
}
var api = init(defaultConverter, { path: "/" });
class InvalidTokenError extends Error {
}
InvalidTokenError.prototype.name = "InvalidTokenError";
function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, (m, p) => {
    let code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = "0" + code;
    }
    return "%" + code;
  }));
}
function base64UrlDecode(str) {
  let output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return b64DecodeUnicode(output);
  } catch (err) {
    return atob(output);
  }
}
function jwtDecode(token2, options) {
  if (typeof token2 !== "string") {
    throw new InvalidTokenError("Invalid token specified: must be a string");
  }
  options || (options = {});
  const pos = options.header === true ? 0 : 1;
  const part = token2.split(".")[pos];
  if (typeof part !== "string") {
    throw new InvalidTokenError(`Invalid token specified: missing part #${pos + 1}`);
  }
  let decoded;
  try {
    decoded = base64UrlDecode(part);
  } catch (e) {
    throw new InvalidTokenError(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
  }
  try {
    return JSON.parse(decoded);
  } catch (e) {
    throw new InvalidTokenError(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
  }
}
const AuthTokenKeys = {
  AccessToken: "ss_access",
  Expiry: "ss_access_exp",
  RefreshToken: "ss_refresh"
};
function encodeToken(authInfo) {
  if (!authInfo.accessToken || !authInfo.expiry)
    return Option.none;
  if (!isValid(new Date(authInfo.expiry)))
    return Option.none;
  return Option.some({
    accessToken: authInfo.accessToken,
    expiry: authInfo.expiry,
    refreshToken: Option.fromNullable(authInfo.refreshToken)
  });
}
function decodeToken(tokens2) {
  return {
    accessToken: tokens2.accessToken,
    expiry: tokens2.expiry,
    refreshToken: Option.getOrElseW(() => null)(tokens2.refreshToken)
  };
}
function getLocalStorageTokens() {
  const accessToken = window.localStorage.getItem("ssAccess");
  const expiry = window.localStorage.getItem("ssExp");
  const refreshToken = window.localStorage.getItem("ssRefresh");
  return encodeToken({
    accessToken,
    expiry,
    refreshToken
  });
}
function getCookieTokens() {
  const accessToken = api.get(AuthTokenKeys.AccessToken);
  const expiry = api.get(AuthTokenKeys.Expiry);
  const refreshToken = api.get(AuthTokenKeys.RefreshToken);
  return encodeToken({
    accessToken,
    expiry,
    refreshToken
  });
}
function getTokensFromWindow() {
  return _function.pipe(
    Option.fromNullable(window),
    Option.flatMap((d) => Option.fromNullable(d.User)),
    Option.flatMap((d) => Option.fromNullable(d.AuthInfo)),
    Option.chain(encodeToken)
  );
}
function getTokens() {
  return _function.pipe(
    getCookieTokens(),
    Option.orElse(() => getTokensFromWindow()),
    Option.orElse(() => getLocalStorageTokens())
  );
}
function updateTokens(tokens2) {
  return TaskEither.rightIO(() => {
    api.set(AuthTokenKeys.AccessToken, tokens2.accessToken, { secure: true });
    api.set(AuthTokenKeys.Expiry, tokens2.expiry, { secure: true });
    _function.pipe(
      tokens2.refreshToken,
      Option.map((refreshToken) => api.set(AuthTokenKeys.RefreshToken, refreshToken, { secure: true })),
      Option.orElse(() => api.remove(AuthTokenKeys.RefreshToken))
    );
  });
}
function getUserInfoFromTokens(tokens2) {
  return _function.pipe(
    tokens2,
    Option.map((tokens22) => jwtDecode(tokens22.accessToken))
  );
}
const _XHR = class _XHR {
  /**
   *
   * @param {string|xhrData} param1 - The endpoint name or @type {xhrData} object
   * @param {xhrData} [param2=Object] - Additional options & data for the request
   * @param {string} operation - The REST operation for axios to perform
   */
  constructor(param1, param2, operation) {
    /**
     * @method
     * @returns {Promise} Promise object represents the axios call
     */
    __publicField(this, "getXHRResult", () => {
      if (this.data.fetchAll) {
        return this.fetchAllPaginatedItems();
      }
      return this.axiosXHRAction();
    });
    __publicField(this, "updateUrlWithDevRoot", () => {
      var _a, _b;
      const apiRoot = this.url.split("/")[0];
      const foundDevRoute = Object.keys(window.devRoutes).find((route2) => {
        let routeName = route2.split("Api")[0];
        routeName = routeName.toLowerCase();
        return routeName === apiRoot;
      });
      this.url = `${foundDevRoute ? window.devRoutes[foundDevRoute] : ((_b = (_a = window.ENVIRONMENT) == null ? void 0 : _a.ApiRoot) == null ? void 0 : _b.Base) ?? "https://api.dev.schemeserve.com"}/${foundDevRoute ? this.url.split(apiRoot)[1] : this.url}`;
      this.url = this.url.replace(/([^:]\/)\/+/g, "$1");
    });
    /**
     * Format the data
     * @method
     */
    __publicField(this, "formatData", () => {
      var _a, _b;
      const { uri = {}, params = {} } = this.data;
      this.url = this.endpoint;
      if (!this.url) {
        throw new Error("No url provided to xhr handler");
      }
      if (Object.keys(uri).length) {
        this.url = this.getReplacedUri();
      }
      if (Object.keys(params).length) {
        this.url = this.addQueryParams();
      }
      if (Object.keys((window == null ? void 0 : window.devRoutes) ?? {}).length && !process.env.API_KEY) {
        this.updateUrlWithDevRoot();
      } else {
        this.url = `${((_b = (_a = window.ENVIRONMENT) == null ? void 0 : _a.ApiRoot) == null ? void 0 : _b.Base) ?? "https://api.dev.schemeserve.com"}/${this.url}`;
      }
    });
    __publicField(this, "removeReactErrorOverlay", () => {
      let count = 0;
      const interval = setInterval(() => {
        count += 1;
        if (count > 1e3) {
          clearInterval(interval);
        }
        if (document.body.lastChild.nodeName === "IFRAME") {
          clearInterval(interval);
          document.body.lastChild.style.display = "none";
        }
      }, 1);
    });
    /**
     * Perform axios operation, and resolve with the response.
     * @method
     * @returns {Promise} Promise object represents the axios call
     */
    __publicField(this, "axiosXHRAction", () => {
      const { onError, isCritical, errorText } = this.data;
      return new Promise((resolve) => {
        const token2 = _function.pipe(
          getTokens(),
          Option.map((tokens2) => tokens2.accessToken),
          Option.getOrElse(() => "")
        );
        axios({
          method: this.operation,
          url: this.url,
          data: this.data.payload,
          headers: {
            Authorization: `bearer ${token2}`
          },
          endpointName: this.endpoint,
          errorText
        }).then((res) => {
          resolve({
            data: res.data,
            status: res.status,
            statusText: res.statusText,
            headers: res.headers
          });
        }).catch((error) => {
          if (onError) {
            onError(error);
            return;
          }
          if (isCritical) {
            if (process.env.NODE_ENV === "development") {
              this.removeReactErrorOverlay();
            }
          }
          if (errorText) {
            return;
          }
          resolve({
            status: error.response && error.response.status,
            statusText: error.response && error.response.statusText,
            message: error.message,
            error,
            headers: error.response && error.response.headers
          });
        });
      });
    });
    /**
     * Keep fetching from given endpoint until all items are aquired.
     * Adjust the skip each time it fetches.
     * @method
     * @returns {Promise} Promise object the data obtained from continuous fetching.
     */
    __publicField(this, "fetchAllPaginatedItems", async () => new Promise((resolve) => {
      let skip = 0;
      let loopCount = 0;
      let items = [];
      const { params = {} } = this.data;
      let hasParams = Object.keys(params).length;
      if (!params.skip) {
        if (hasParams) {
          this.url = `${this.url}&Skip=0`;
        } else {
          this.url = `${this.url}?Skip=0`;
        }
        hasParams = true;
      }
      if (!params.size) {
        if (hasParams) {
          this.url = `${this.url}&Size=50`;
        } else {
          this.url = `${this.url}?Size=50`;
        }
      }
      const updateUrl = () => {
        this.url = this.url.replace(/Skip=\d+/, `Skip=${skip}`).replace(/Size=\d+/, `Size=50`);
      };
      const getAllItems = async () => {
        if (loopCount > 10) {
          return;
        }
        updateUrl();
        const { data = { items: [] } } = await this.axiosXHRAction();
        loopCount += 1;
        skip += 50;
        items = [...items, ...data.items];
        if (data.items.length && items.length < data.totalItemCount) {
          await getAllItems();
        }
        resolve({ data: { items } });
      };
      getAllItems();
    }));
    /**
     * Construct a query string and return the url with string attached.
     * Omit any params that are falsy.
     * @method
     */
    __publicField(this, "addQueryParams", () => {
      const updatedParams = `${this.data.params ? Object.keys(
        _$3.pickBy(this.data.params, (param) => param || param === 0)
      ).reduce(
        (acc, param, index) => `${acc}${index > 0 ? "&" : ""}${param}=${this.data.params[param]}`,
        "?"
      ) : ""}`;
      if (this.data.trailingSlash && this.url.charAt(this.url.length - 1) !== "/") {
        return `${this.url}/${updatedParams}`;
      }
      return `${this.url}${updatedParams}`;
    });
    /**
     * Add the uri parts onto the url.
     * Parts are defined by their property names &
     * the placeholder names to match in the endpoints constant.
     *
     * @method
     */
    __publicField(this, "getReplacedUri", () => this.url.split(/\{(.*?)\}/).map((part, index) => {
      if (part.includes("/") || part.includes("\\")) {
        return part;
      }
      return this.data.uri[part];
    }).join(""));
    this.operation = operation;
    this.data = typeof param1 === "string" ? param2 || {} : param1;
    this.endpoint = typeof param1 === "string" ? param1 : param1.endpoint;
    if (this.data && this.data.url) {
      this.endpoint = this.data.url;
    }
  }
};
/**
 * @memberof XHR
 * @method
 * @param {string|xhrData} endpoint
 * @param {xhrData} [data=Object]
 */
__publicField(_XHR, "get", (endpoint, data = {}) => {
  const instance = new _XHR(endpoint, data, "get");
  instance.formatData();
  return instance.getXHRResult();
});
/**
 * @memberof XHR
 * @method
 * @param {string|xhrData} endpoint
 * @param {xhrData} [data=Object]
 */
__publicField(_XHR, "post", (endpoint, data = {}) => {
  const instance = new _XHR(endpoint, data, "post");
  instance.formatData();
  return instance.getXHRResult();
});
/**
 * @memberof XHR
 * @method
 * @param {string|xhrData} endpoint
 * @param {xhrData} [data=Object]
 */
__publicField(_XHR, "patch", (endpoint, data = {}) => {
  const instance = new _XHR(endpoint, data, "patch");
  instance.formatData();
  return instance.getXHRResult();
});
/**
 * @memberof XHR
 * @method
 * @param {string|xhrData} endpoint
 * @param {xhrData} [data=Object]
 */
__publicField(_XHR, "delete", (endpoint, data = {}) => {
  const instance = new _XHR(endpoint, data, "delete");
  instance.formatData();
  return instance.getXHRResult();
});
/**
 * @memberof XHR
 * @method
 * @param {string|xhrData} endpoint
 * @param {xhrData} [data=Object]
 */
__publicField(_XHR, "put", (endpoint, data = {}) => {
  const instance = new _XHR(endpoint, data, "put");
  instance.formatData();
  return instance.getXHRResult();
});
let XHR = _XHR;
function isValidResponse(data) {
  return data && (data == null ? void 0 : data.status) >= 200 && (data == null ? void 0 : data.status) < 300;
}
function sleep(time = 250) {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
}
function sleepTask(ms = 250) {
  return () => new Promise((resolve) => setTimeout(resolve, ms));
}
function buildErrorResponse(response, options) {
  var _a, _b;
  let msg = "Unexpected error has occurred";
  if (response.error.message) {
    msg = response.error.message;
  }
  if ((options == null ? void 0 : options.detailedErrorMessage) && ((_b = (_a = response.error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.Message)) {
    msg = response.error.response.data.Message;
  }
  return Promise.resolve({
    type: ResponseStatus.Error,
    code: response.status,
    data: new Error(msg)
  });
}
function buildSuccessResponse(response, options) {
  const { data } = response;
  const payload = !(data == null ? void 0 : data.items) ? {
    size: 10,
    skip: 0,
    totalItemCount: 1,
    items: [data]
  } : {
    ...data,
    items: Array.isArray(data.items) ? data.items : [data.items]
  };
  return Promise.resolve({ type: ResponseStatus.Success, data: payload });
}
function buildResponse(response, options) {
  const isSuccessful = isValidResponse(response);
  return isSuccessful ? buildSuccessResponse(response) : buildErrorResponse(response, options);
}
function isError(response) {
  return response.type === ResponseStatus.Error;
}
function isSuccess(response) {
  return response.type === ResponseStatus.Success;
}
function createPatchPayload(original, updated) {
  return Object.keys(updated).reduce(
    (acc, key) => {
      const originalValue = original[key];
      const updatedValue = updated[key];
      if (originalValue !== updatedValue) {
        if (Array.isArray(updatedValue)) {
          updatedValue.forEach((entry, index) => {
            acc.push({
              path: `/${String(key)}/${index}/value`,
              value: entry.value,
              op: "replace"
            });
          });
        } else {
          acc.push({
            path: `/${String(key)}`,
            value: updatedValue,
            op: "replace"
          });
        }
      }
      return acc;
    },
    []
  );
}
function convertResponseToOptions(data, keys2) {
  if (!data || !Array.isArray(data.items))
    return [];
  return data.items.map((item) => ({
    label: item[keys2.label],
    value: item[keys2.value],
    ...item
  }));
}
var build = {};
var either = {};
var option = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.isNone = exports.isSome = exports.None = exports.Some = exports.OptionType = void 0;
  exports.OptionType = {
    Some: Symbol(":some"),
    None: Symbol(":none")
  };
  function Some(val) {
    return typeof val === "undefined" ? none_constructor() : some_constructor(val);
  }
  exports.Some = Some;
  exports.None = none_constructor();
  function some_constructor(val) {
    return {
      type: exports.OptionType.Some,
      isSome() {
        return true;
      },
      isNone() {
        return false;
      },
      match(fn) {
        return fn.some(val);
      },
      map(fn) {
        return some_constructor(fn(val));
      },
      andThen(fn) {
        return fn(val);
      },
      or(_optb) {
        return this;
      },
      and(optb) {
        return optb;
      },
      unwrapOr(_def) {
        return val;
      },
      unwrap() {
        return val;
      }
    };
  }
  function none_constructor() {
    return {
      type: exports.OptionType.None,
      isSome() {
        return false;
      },
      isNone() {
        return true;
      },
      match(matchObject) {
        const { none } = matchObject;
        if (typeof none === "function") {
          return none();
        }
        return none;
      },
      map(_fn) {
        return none_constructor();
      },
      andThen(_fn) {
        return none_constructor();
      },
      or(optb) {
        return optb;
      },
      and(_optb) {
        return none_constructor();
      },
      unwrapOr(def) {
        if (def == null) {
          throw new Error("Cannot call unwrapOr with a missing value.");
        }
        return def;
      },
      unwrap() {
        throw new ReferenceError("Trying to unwrap None.");
      }
    };
  }
  function isSome(val) {
    return val.isSome();
  }
  exports.isSome = isSome;
  function isNone(val) {
    return val.isNone();
  }
  exports.isNone = isNone;
})(option);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.isRight = exports.isLeft = exports.Right = exports.Left = exports.EitherType = void 0;
  const option_1 = option;
  exports.EitherType = {
    Left: Symbol(":left"),
    Right: Symbol(":right")
  };
  function Left(val) {
    return {
      type: exports.EitherType.Left,
      isLeft() {
        return true;
      },
      isRight() {
        return false;
      },
      left() {
        return (0, option_1.Some)(val);
      },
      leftAndThen(fn) {
        return fn(val);
      },
      right() {
        return option_1.None;
      },
      rightAndThen(_fn) {
        return Left(val);
      },
      unwrap() {
        return val;
      },
      unwrapLeft() {
        return val;
      },
      unwrapLeftOr(_other) {
        return val;
      },
      unwrapLeftOrElse(_fn) {
        return val;
      },
      unwrapRight() {
        throw new ReferenceError("Cannot unwrap Right value of Either.Left");
      },
      unwrapRightOr(other) {
        return other;
      },
      unwrapRightOrElse(fn) {
        return fn(val);
      },
      match(matchObject) {
        return matchObject.left(val);
      },
      map(fn) {
        return Left(fn(val));
      },
      mapLeft(fn) {
        return Left(fn(val));
      },
      mapRight(_fn) {
        return Left(val);
      }
    };
  }
  exports.Left = Left;
  function Right(val) {
    return {
      type: exports.EitherType.Right,
      isLeft() {
        return false;
      },
      isRight() {
        return true;
      },
      left() {
        return option_1.None;
      },
      leftAndThen(_fn) {
        return Right(val);
      },
      right() {
        return (0, option_1.Some)(val);
      },
      rightAndThen(fn) {
        return fn(val);
      },
      unwrap() {
        return val;
      },
      unwrapLeft() {
        throw new ReferenceError("Cannot unwrap Left value of Either.Right");
      },
      unwrapLeftOr(other) {
        return other;
      },
      unwrapLeftOrElse(fn) {
        return fn(val);
      },
      unwrapRight() {
        return val;
      },
      unwrapRightOr(_other) {
        return val;
      },
      unwrapRightOrElse(_fn) {
        return val;
      },
      match(matchObject) {
        return matchObject.right(val);
      },
      map(fn) {
        return Right(fn(val));
      },
      mapLeft(_fn) {
        return Right(val);
      },
      mapRight(fn) {
        return Right(fn(val));
      }
    };
  }
  exports.Right = Right;
  function isLeft(val) {
    return val.isLeft();
  }
  exports.isLeft = isLeft;
  function isRight(val) {
    return val.isRight();
  }
  exports.isRight = isRight;
})(either);
var result = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.isErr = exports.isOk = exports.Err = exports.Ok = exports.ResultType = void 0;
  const option_1 = option;
  exports.ResultType = {
    Ok: Symbol(":ok"),
    Err: Symbol(":err")
  };
  function Ok(val) {
    return {
      type: exports.ResultType.Ok,
      isOk() {
        return true;
      },
      isErr() {
        return false;
      },
      ok() {
        return (0, option_1.Some)(val);
      },
      err() {
        return option_1.None;
      },
      unwrap() {
        return val;
      },
      unwrapOr(_optb) {
        return val;
      },
      unwrapOrElse(_fn) {
        return val;
      },
      unwrapErr() {
        throw new ReferenceError("Cannot unwrap Err value of Result.Ok");
      },
      match(matchObject) {
        return matchObject.ok(val);
      },
      map(fn) {
        return Ok(fn(val));
      },
      mapErr(_fn) {
        return Ok(val);
      },
      andThen(fn) {
        return fn(val);
      },
      orElse(_fn) {
        return Ok(val);
      }
    };
  }
  exports.Ok = Ok;
  function Err(err) {
    return {
      type: exports.ResultType.Err,
      isOk() {
        return false;
      },
      isErr() {
        return true;
      },
      ok() {
        return option_1.None;
      },
      err() {
        return (0, option_1.Some)(err);
      },
      unwrap() {
        throw new ReferenceError("Cannot unwrap Ok value of Result.Err");
      },
      unwrapOr(optb) {
        return optb;
      },
      unwrapOrElse(fn) {
        return fn(err);
      },
      unwrapErr() {
        return err;
      },
      match(matchObject) {
        return matchObject.err(err);
      },
      map(_fn) {
        return Err(err);
      },
      mapErr(fn) {
        return Err(fn(err));
      },
      andThen(_fn) {
        return Err(err);
      },
      orElse(fn) {
        return fn(err);
      }
    };
  }
  exports.Err = Err;
  function isOk(val) {
    return val.isOk();
  }
  exports.isOk = isOk;
  function isErr(val) {
    return val.isErr();
  }
  exports.isErr = isErr;
})(result);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.Ok = exports.isOk = exports.isErr = exports.Err = exports.Some = exports.None = exports.isSome = exports.isNone = exports.Right = exports.Left = exports.isRight = exports.isLeft = void 0;
  var either_1 = either;
  Object.defineProperty(exports, "isLeft", { enumerable: true, get: function() {
    return either_1.isLeft;
  } });
  Object.defineProperty(exports, "isRight", { enumerable: true, get: function() {
    return either_1.isRight;
  } });
  Object.defineProperty(exports, "Left", { enumerable: true, get: function() {
    return either_1.Left;
  } });
  Object.defineProperty(exports, "Right", { enumerable: true, get: function() {
    return either_1.Right;
  } });
  var option_1 = option;
  Object.defineProperty(exports, "isNone", { enumerable: true, get: function() {
    return option_1.isNone;
  } });
  Object.defineProperty(exports, "isSome", { enumerable: true, get: function() {
    return option_1.isSome;
  } });
  Object.defineProperty(exports, "None", { enumerable: true, get: function() {
    return option_1.None;
  } });
  Object.defineProperty(exports, "Some", { enumerable: true, get: function() {
    return option_1.Some;
  } });
  var result_1 = result;
  Object.defineProperty(exports, "Err", { enumerable: true, get: function() {
    return result_1.Err;
  } });
  Object.defineProperty(exports, "isErr", { enumerable: true, get: function() {
    return result_1.isErr;
  } });
  Object.defineProperty(exports, "isOk", { enumerable: true, get: function() {
    return result_1.isOk;
  } });
  Object.defineProperty(exports, "Ok", { enumerable: true, get: function() {
    return result_1.Ok;
  } });
})(build);
var Record = {};
var _Array = {};
var NonEmptyArray = {};
(function(exports) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule)
      return mod2;
    var result2 = {};
    if (mod2 != null) {
      for (var k in mod2)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
          __createBinding2(result2, mod2, k);
    }
    __setModuleDefault2(result2, mod2);
    return result2;
  };
  var __spreadArray = commonjsGlobal && commonjsGlobal.__spreadArray || function(to2, from2, pack) {
    if (pack || arguments.length === 2)
      for (var i = 0, l = from2.length, ar; i < l; i++) {
        if (ar || !(i in from2)) {
          if (!ar)
            ar = Array.prototype.slice.call(from2, 0, i);
          ar[i] = from2[i];
        }
      }
    return to2.concat(ar || Array.prototype.slice.call(from2));
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.reduceRightWithIndex = exports.reduceRight = exports.reduceWithIndex = exports.reduce = exports.mapWithIndex = exports.map = exports.flatten = exports.duplicate = exports.extend = exports.flatMap = exports.ap = exports.alt = exports.altW = exports.chunksOf = exports.splitAt = exports.chop = exports.chainWithIndex = exports.foldMap = exports.foldMapWithIndex = exports.intersperse = exports.prependAll = exports.unzip = exports.zipWith = exports.of = exports.copy = exports.modifyAt = exports.updateAt = exports.insertAt = exports.sort = exports.groupBy = exports.reverse = exports.unappend = exports.unprepend = exports.range = exports.replicate = exports.makeBy = exports.fromArray = exports.fromReadonlyNonEmptyArray = exports.rotate = exports.union = exports.sortBy = exports.uniq = exports.unsafeUpdateAt = exports.unsafeInsertAt = exports.append = exports.appendW = exports.prepend = exports.prependW = exports.isOutOfBound = exports.isNonEmpty = void 0;
  exports.snoc = exports.unsnoc = exports.uncons = exports.filterWithIndex = exports.chain = exports.intercalate = exports.updateLast = exports.modifyLast = exports.updateHead = exports.modifyHead = exports.matchRight = exports.matchLeft = exports.concatAll = exports.max = exports.min = exports.init = exports.last = exports.tail = exports.head = exports.apS = exports.bind = exports.let = exports.bindTo = exports.Do = exports.Comonad = exports.Alt = exports.TraversableWithIndex = exports.Traversable = exports.FoldableWithIndex = exports.Foldable = exports.Monad = exports.chainFirst = exports.Chain = exports.Applicative = exports.apSecond = exports.apFirst = exports.Apply = exports.FunctorWithIndex = exports.Pointed = exports.flap = exports.Functor = exports.getUnionSemigroup = exports.getEq = exports.getSemigroup = exports.getShow = exports.URI = exports.extract = exports.traverseWithIndex = exports.sequence = exports.traverse = void 0;
  exports.nonEmptyArray = exports.fold = exports.prependToAll = void 0;
  exports.concatW = concatW;
  exports.concat = concat2;
  exports.group = group;
  exports.zip = zip;
  exports.groupSort = groupSort;
  exports.filter = filter3;
  exports.cons = cons;
  var Apply_12 = Apply;
  var Chain_12 = Chain;
  var function_12 = _function;
  var Functor_12 = Functor;
  var _2 = __importStar2(internal);
  var Ord_1 = Ord;
  var RNEA = __importStar2(ReadonlyNonEmptyArray);
  var isNonEmpty = function(as2) {
    return as2.length > 0;
  };
  exports.isNonEmpty = isNonEmpty;
  var isOutOfBound = function(i, as2) {
    return i < 0 || i >= as2.length;
  };
  exports.isOutOfBound = isOutOfBound;
  var prependW = function(head) {
    return function(tail2) {
      return __spreadArray([head], tail2, true);
    };
  };
  exports.prependW = prependW;
  exports.prepend = exports.prependW;
  var appendW = function(end) {
    return function(init3) {
      return __spreadArray(__spreadArray([], init3, true), [end], false);
    };
  };
  exports.appendW = appendW;
  exports.append = exports.appendW;
  var unsafeInsertAt = function(i, a, as2) {
    if ((0, exports.isNonEmpty)(as2)) {
      var xs = (0, exports.fromReadonlyNonEmptyArray)(as2);
      xs.splice(i, 0, a);
      return xs;
    }
    return [a];
  };
  exports.unsafeInsertAt = unsafeInsertAt;
  var unsafeUpdateAt = function(i, a, as2) {
    var xs = (0, exports.fromReadonlyNonEmptyArray)(as2);
    xs[i] = a;
    return xs;
  };
  exports.unsafeUpdateAt = unsafeUpdateAt;
  var uniq = function(E2) {
    return function(as2) {
      if (as2.length === 1) {
        return (0, exports.copy)(as2);
      }
      var out = [(0, exports.head)(as2)];
      var rest = (0, exports.tail)(as2);
      var _loop_1 = function(a2) {
        if (out.every(function(o) {
          return !E2.equals(o, a2);
        })) {
          out.push(a2);
        }
      };
      for (var _i = 0, rest_1 = rest; _i < rest_1.length; _i++) {
        var a = rest_1[_i];
        _loop_1(a);
      }
      return out;
    };
  };
  exports.uniq = uniq;
  var sortBy = function(ords) {
    if ((0, exports.isNonEmpty)(ords)) {
      var M = (0, Ord_1.getMonoid)();
      return (0, exports.sort)(ords.reduce(M.concat, M.empty));
    }
    return exports.copy;
  };
  exports.sortBy = sortBy;
  var union = function(E2) {
    var uniqE = (0, exports.uniq)(E2);
    return function(second) {
      return function(first) {
        return uniqE((0, function_12.pipe)(first, concat2(second)));
      };
    };
  };
  exports.union = union;
  var rotate = function(n) {
    return function(as2) {
      var len = as2.length;
      var m = Math.round(n) % len;
      if ((0, exports.isOutOfBound)(Math.abs(m), as2) || m === 0) {
        return (0, exports.copy)(as2);
      }
      if (m < 0) {
        var _a = (0, exports.splitAt)(-m)(as2), f = _a[0], s = _a[1];
        return (0, function_12.pipe)(s, concat2(f));
      } else {
        return (0, exports.rotate)(m - len)(as2);
      }
    };
  };
  exports.rotate = rotate;
  exports.fromReadonlyNonEmptyArray = _2.fromReadonlyNonEmptyArray;
  var fromArray = function(as2) {
    return (0, exports.isNonEmpty)(as2) ? _2.some(as2) : _2.none;
  };
  exports.fromArray = fromArray;
  var makeBy = function(f) {
    return function(n) {
      var j = Math.max(0, Math.floor(n));
      var out = [f(0)];
      for (var i = 1; i < j; i++) {
        out.push(f(i));
      }
      return out;
    };
  };
  exports.makeBy = makeBy;
  var replicate = function(a) {
    return (0, exports.makeBy)(function() {
      return a;
    });
  };
  exports.replicate = replicate;
  var range = function(start, end) {
    return start <= end ? (0, exports.makeBy)(function(i) {
      return start + i;
    })(end - start + 1) : [start];
  };
  exports.range = range;
  var unprepend = function(as2) {
    return [(0, exports.head)(as2), (0, exports.tail)(as2)];
  };
  exports.unprepend = unprepend;
  var unappend = function(as2) {
    return [(0, exports.init)(as2), (0, exports.last)(as2)];
  };
  exports.unappend = unappend;
  function concatW(second) {
    return function(first) {
      return first.concat(second);
    };
  }
  function concat2(x, y) {
    return y ? x.concat(y) : function(y2) {
      return y2.concat(x);
    };
  }
  var reverse2 = function(as2) {
    return __spreadArray([(0, exports.last)(as2)], as2.slice(0, -1).reverse(), true);
  };
  exports.reverse = reverse2;
  function group(E2) {
    return function(as2) {
      var len = as2.length;
      if (len === 0) {
        return [];
      }
      var out = [];
      var head = as2[0];
      var nea = [head];
      for (var i = 1; i < len; i++) {
        var a = as2[i];
        if (E2.equals(a, head)) {
          nea.push(a);
        } else {
          out.push(nea);
          head = a;
          nea = [head];
        }
      }
      out.push(nea);
      return out;
    };
  }
  var groupBy = function(f) {
    return function(as2) {
      var out = {};
      for (var _i = 0, as_1 = as2; _i < as_1.length; _i++) {
        var a = as_1[_i];
        var k = f(a);
        if (_2.has.call(out, k)) {
          out[k].push(a);
        } else {
          out[k] = [a];
        }
      }
      return out;
    };
  };
  exports.groupBy = groupBy;
  var sort = function(O) {
    return function(as2) {
      return as2.slice().sort(O.compare);
    };
  };
  exports.sort = sort;
  var insertAt = function(i, a) {
    return function(as2) {
      return i < 0 || i > as2.length ? _2.none : _2.some((0, exports.unsafeInsertAt)(i, a, as2));
    };
  };
  exports.insertAt = insertAt;
  var updateAt = function(i, a) {
    return (0, exports.modifyAt)(i, function() {
      return a;
    });
  };
  exports.updateAt = updateAt;
  var modifyAt = function(i, f) {
    return function(as2) {
      return (0, exports.isOutOfBound)(i, as2) ? _2.none : _2.some((0, exports.unsafeUpdateAt)(i, f(as2[i]), as2));
    };
  };
  exports.modifyAt = modifyAt;
  exports.copy = exports.fromReadonlyNonEmptyArray;
  var of = function(a) {
    return [a];
  };
  exports.of = of;
  var zipWith = function(as2, bs, f) {
    var cs2 = [f(as2[0], bs[0])];
    var len = Math.min(as2.length, bs.length);
    for (var i = 1; i < len; i++) {
      cs2[i] = f(as2[i], bs[i]);
    }
    return cs2;
  };
  exports.zipWith = zipWith;
  function zip(as2, bs) {
    if (bs === void 0) {
      return function(bs2) {
        return zip(bs2, as2);
      };
    }
    return (0, exports.zipWith)(as2, bs, function(a, b) {
      return [a, b];
    });
  }
  var unzip = function(abs2) {
    var fa = [abs2[0][0]];
    var fb = [abs2[0][1]];
    for (var i = 1; i < abs2.length; i++) {
      fa[i] = abs2[i][0];
      fb[i] = abs2[i][1];
    }
    return [fa, fb];
  };
  exports.unzip = unzip;
  var prependAll = function(middle) {
    return function(as2) {
      var out = [middle, as2[0]];
      for (var i = 1; i < as2.length; i++) {
        out.push(middle, as2[i]);
      }
      return out;
    };
  };
  exports.prependAll = prependAll;
  var intersperse = function(middle) {
    return function(as2) {
      var rest = (0, exports.tail)(as2);
      return (0, exports.isNonEmpty)(rest) ? (0, function_12.pipe)(rest, (0, exports.prependAll)(middle), (0, exports.prepend)((0, exports.head)(as2))) : (0, exports.copy)(as2);
    };
  };
  exports.intersperse = intersperse;
  exports.foldMapWithIndex = RNEA.foldMapWithIndex;
  exports.foldMap = RNEA.foldMap;
  var chainWithIndex = function(f) {
    return function(as2) {
      var out = (0, exports.fromReadonlyNonEmptyArray)(f(0, (0, exports.head)(as2)));
      for (var i = 1; i < as2.length; i++) {
        var bs = f(i, as2[i]);
        for (var j = 0; j < bs.length; j++) {
          out.push(bs[j]);
        }
      }
      return out;
    };
  };
  exports.chainWithIndex = chainWithIndex;
  var chop = function(f) {
    return function(as2) {
      var _a = f(as2), b = _a[0], rest = _a[1];
      var out = [b];
      var next = rest;
      while ((0, exports.isNonEmpty)(next)) {
        var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
        out.push(b_1);
        next = rest_2;
      }
      return out;
    };
  };
  exports.chop = chop;
  var splitAt = function(n) {
    return function(as2) {
      var m = Math.max(1, n);
      return m >= as2.length ? [(0, exports.copy)(as2), []] : [(0, function_12.pipe)(as2.slice(1, m), (0, exports.prepend)((0, exports.head)(as2))), as2.slice(m)];
    };
  };
  exports.splitAt = splitAt;
  var chunksOf = function(n) {
    return (0, exports.chop)((0, exports.splitAt)(n));
  };
  exports.chunksOf = chunksOf;
  var _map = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.map)(f));
  };
  var _mapWithIndex = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.mapWithIndex)(f));
  };
  var _ap = function(fab, fa) {
    return (0, function_12.pipe)(fab, (0, exports.ap)(fa));
  };
  var _extend = function(wa, f) {
    return (0, function_12.pipe)(wa, (0, exports.extend)(f));
  };
  var _reduce = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduce)(b, f));
  };
  var _foldMap = function(M) {
    var foldMapM = (0, exports.foldMap)(M);
    return function(fa, f) {
      return (0, function_12.pipe)(fa, foldMapM(f));
    };
  };
  var _reduceRight = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduceRight)(b, f));
  };
  var _traverse = function(F) {
    var traverseF = (0, exports.traverse)(F);
    return function(ta, f) {
      return (0, function_12.pipe)(ta, traverseF(f));
    };
  };
  var _alt = function(fa, that) {
    return (0, function_12.pipe)(fa, (0, exports.alt)(that));
  };
  var _reduceWithIndex = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduceWithIndex)(b, f));
  };
  var _foldMapWithIndex = function(M) {
    var foldMapWithIndexM = (0, exports.foldMapWithIndex)(M);
    return function(fa, f) {
      return (0, function_12.pipe)(fa, foldMapWithIndexM(f));
    };
  };
  var _reduceRightWithIndex = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduceRightWithIndex)(b, f));
  };
  var _traverseWithIndex = function(F) {
    var traverseWithIndexF = (0, exports.traverseWithIndex)(F);
    return function(ta, f) {
      return (0, function_12.pipe)(ta, traverseWithIndexF(f));
    };
  };
  var altW = function(that) {
    return function(as2) {
      return (0, function_12.pipe)(as2, concatW(that()));
    };
  };
  exports.altW = altW;
  exports.alt = exports.altW;
  var ap2 = function(as2) {
    return (0, exports.flatMap)(function(f) {
      return (0, function_12.pipe)(as2, (0, exports.map)(f));
    });
  };
  exports.ap = ap2;
  exports.flatMap = (0, function_12.dual)(2, function(ma, f) {
    return (0, function_12.pipe)(ma, (0, exports.chainWithIndex)(function(i, a) {
      return f(a, i);
    }));
  });
  var extend2 = function(f) {
    return function(as2) {
      var next = (0, exports.tail)(as2);
      var out = [f(as2)];
      while ((0, exports.isNonEmpty)(next)) {
        out.push(f(next));
        next = (0, exports.tail)(next);
      }
      return out;
    };
  };
  exports.extend = extend2;
  exports.duplicate = (0, exports.extend)(function_12.identity);
  exports.flatten = (0, exports.flatMap)(function_12.identity);
  var map2 = function(f) {
    return (0, exports.mapWithIndex)(function(_3, a) {
      return f(a);
    });
  };
  exports.map = map2;
  var mapWithIndex = function(f) {
    return function(as2) {
      var out = [f(0, (0, exports.head)(as2))];
      for (var i = 1; i < as2.length; i++) {
        out.push(f(i, as2[i]));
      }
      return out;
    };
  };
  exports.mapWithIndex = mapWithIndex;
  exports.reduce = RNEA.reduce;
  exports.reduceWithIndex = RNEA.reduceWithIndex;
  exports.reduceRight = RNEA.reduceRight;
  exports.reduceRightWithIndex = RNEA.reduceRightWithIndex;
  var traverse = function(F) {
    var traverseWithIndexF = (0, exports.traverseWithIndex)(F);
    return function(f) {
      return traverseWithIndexF(function(_3, a) {
        return f(a);
      });
    };
  };
  exports.traverse = traverse;
  var sequence = function(F) {
    return (0, exports.traverseWithIndex)(F)(function(_3, a) {
      return a;
    });
  };
  exports.sequence = sequence;
  var traverseWithIndex = function(F) {
    return function(f) {
      return function(as2) {
        var out = F.map(f(0, (0, exports.head)(as2)), exports.of);
        for (var i = 1; i < as2.length; i++) {
          out = F.ap(F.map(out, function(bs) {
            return function(b) {
              return (0, function_12.pipe)(bs, (0, exports.append)(b));
            };
          }), f(i, as2[i]));
        }
        return out;
      };
    };
  };
  exports.traverseWithIndex = traverseWithIndex;
  exports.extract = RNEA.head;
  exports.URI = "NonEmptyArray";
  exports.getShow = RNEA.getShow;
  var getSemigroup = function() {
    return {
      concat: concat2
    };
  };
  exports.getSemigroup = getSemigroup;
  exports.getEq = RNEA.getEq;
  var getUnionSemigroup = function(E2) {
    var unionE = (0, exports.union)(E2);
    return {
      concat: function(first, second) {
        return unionE(second)(first);
      }
    };
  };
  exports.getUnionSemigroup = getUnionSemigroup;
  exports.Functor = {
    URI: exports.URI,
    map: _map
  };
  exports.flap = (0, Functor_12.flap)(exports.Functor);
  exports.Pointed = {
    URI: exports.URI,
    of: exports.of
  };
  exports.FunctorWithIndex = {
    URI: exports.URI,
    map: _map,
    mapWithIndex: _mapWithIndex
  };
  exports.Apply = {
    URI: exports.URI,
    map: _map,
    ap: _ap
  };
  exports.apFirst = (0, Apply_12.apFirst)(exports.Apply);
  exports.apSecond = (0, Apply_12.apSecond)(exports.Apply);
  exports.Applicative = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of
  };
  exports.Chain = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    chain: exports.flatMap
  };
  exports.chainFirst = /* @__PURE__ */ (0, Chain_12.chainFirst)(exports.Chain);
  exports.Monad = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of,
    chain: exports.flatMap
  };
  exports.Foldable = {
    URI: exports.URI,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight
  };
  exports.FoldableWithIndex = {
    URI: exports.URI,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    reduceWithIndex: _reduceWithIndex,
    foldMapWithIndex: _foldMapWithIndex,
    reduceRightWithIndex: _reduceRightWithIndex
  };
  exports.Traversable = {
    URI: exports.URI,
    map: _map,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence
  };
  exports.TraversableWithIndex = {
    URI: exports.URI,
    map: _map,
    mapWithIndex: _mapWithIndex,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence,
    reduceWithIndex: _reduceWithIndex,
    foldMapWithIndex: _foldMapWithIndex,
    reduceRightWithIndex: _reduceRightWithIndex,
    traverseWithIndex: _traverseWithIndex
  };
  exports.Alt = {
    URI: exports.URI,
    map: _map,
    alt: _alt
  };
  exports.Comonad = {
    URI: exports.URI,
    map: _map,
    extend: _extend,
    extract: exports.extract
  };
  exports.Do = (0, exports.of)(_2.emptyRecord);
  exports.bindTo = (0, Functor_12.bindTo)(exports.Functor);
  var let_2 = /* @__PURE__ */ (0, Functor_12.let)(exports.Functor);
  exports.let = let_2;
  exports.bind = (0, Chain_12.bind)(exports.Chain);
  exports.apS = (0, Apply_12.apS)(exports.Apply);
  exports.head = RNEA.head;
  var tail = function(as2) {
    return as2.slice(1);
  };
  exports.tail = tail;
  exports.last = RNEA.last;
  var init2 = function(as2) {
    return as2.slice(0, -1);
  };
  exports.init = init2;
  exports.min = RNEA.min;
  exports.max = RNEA.max;
  var concatAll2 = function(S2) {
    return function(as2) {
      return as2.reduce(S2.concat);
    };
  };
  exports.concatAll = concatAll2;
  var matchLeft = function(f) {
    return function(as2) {
      return f((0, exports.head)(as2), (0, exports.tail)(as2));
    };
  };
  exports.matchLeft = matchLeft;
  var matchRight = function(f) {
    return function(as2) {
      return f((0, exports.init)(as2), (0, exports.last)(as2));
    };
  };
  exports.matchRight = matchRight;
  var modifyHead = function(f) {
    return function(as2) {
      return __spreadArray([f((0, exports.head)(as2))], (0, exports.tail)(as2), true);
    };
  };
  exports.modifyHead = modifyHead;
  var updateHead = function(a) {
    return (0, exports.modifyHead)(function() {
      return a;
    });
  };
  exports.updateHead = updateHead;
  var modifyLast = function(f) {
    return function(as2) {
      return (0, function_12.pipe)((0, exports.init)(as2), (0, exports.append)(f((0, exports.last)(as2))));
    };
  };
  exports.modifyLast = modifyLast;
  var updateLast = function(a) {
    return (0, exports.modifyLast)(function() {
      return a;
    });
  };
  exports.updateLast = updateLast;
  exports.intercalate = RNEA.intercalate;
  exports.chain = exports.flatMap;
  function groupSort(O) {
    var sortO = (0, exports.sort)(O);
    var groupO = group(O);
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? groupO(sortO(as2)) : [];
    };
  }
  function filter3(predicate) {
    return (0, exports.filterWithIndex)(function(_3, a) {
      return predicate(a);
    });
  }
  var filterWithIndex = function(predicate) {
    return function(as2) {
      return (0, exports.fromArray)(as2.filter(function(a, i) {
        return predicate(i, a);
      }));
    };
  };
  exports.filterWithIndex = filterWithIndex;
  exports.uncons = exports.unprepend;
  exports.unsnoc = exports.unappend;
  function cons(head, tail2) {
    return tail2 === void 0 ? (0, exports.prepend)(head) : (0, function_12.pipe)(tail2, (0, exports.prepend)(head));
  }
  var snoc = function(init3, end) {
    return (0, function_12.pipe)(init3, (0, exports.append)(end));
  };
  exports.snoc = snoc;
  exports.prependToAll = exports.prependAll;
  exports.fold = RNEA.concatAll;
  exports.nonEmptyArray = {
    URI: exports.URI,
    of: exports.of,
    map: _map,
    mapWithIndex: _mapWithIndex,
    ap: _ap,
    chain: exports.flatMap,
    extend: _extend,
    extract: exports.extract,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence,
    reduceWithIndex: _reduceWithIndex,
    foldMapWithIndex: _foldMapWithIndex,
    reduceRightWithIndex: _reduceRightWithIndex,
    traverseWithIndex: _traverseWithIndex,
    alt: _alt
  };
})(NonEmptyArray);
var ReadonlyArray = {};
var number = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.Field = exports.MonoidProduct = exports.MonoidSum = exports.SemigroupProduct = exports.SemigroupSum = exports.MagmaSub = exports.Show = exports.Bounded = exports.Ord = exports.Eq = exports.isNumber = void 0;
  var isNumber2 = function(u) {
    return typeof u === "number";
  };
  exports.isNumber = isNumber2;
  exports.Eq = {
    equals: function(first, second) {
      return first === second;
    }
  };
  exports.Ord = {
    equals: exports.Eq.equals,
    compare: function(first, second) {
      return first < second ? -1 : first > second ? 1 : 0;
    }
  };
  exports.Bounded = {
    equals: exports.Eq.equals,
    compare: exports.Ord.compare,
    top: Infinity,
    bottom: -Infinity
  };
  exports.Show = {
    show: function(n) {
      return JSON.stringify(n);
    }
  };
  exports.MagmaSub = {
    concat: function(first, second) {
      return first - second;
    }
  };
  exports.SemigroupSum = {
    concat: function(first, second) {
      return first + second;
    }
  };
  exports.SemigroupProduct = {
    concat: function(first, second) {
      return first * second;
    }
  };
  exports.MonoidSum = {
    concat: exports.SemigroupSum.concat,
    empty: 0
  };
  exports.MonoidProduct = {
    concat: exports.SemigroupProduct.concat,
    empty: 1
  };
  exports.Field = {
    add: exports.SemigroupSum.concat,
    zero: 0,
    mul: exports.SemigroupProduct.concat,
    one: 1,
    sub: exports.MagmaSub.concat,
    degree: function(_2) {
      return 1;
    },
    div: function(first, second) {
      return first / second;
    },
    mod: function(first, second) {
      return first % second;
    }
  };
})(number);
(function(exports) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule)
      return mod2;
    var result2 = {};
    if (mod2 != null) {
      for (var k in mod2)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
          __createBinding2(result2, mod2, k);
    }
    __setModuleDefault2(result2, mod2);
    return result2;
  };
  var __spreadArray = commonjsGlobal && commonjsGlobal.__spreadArray || function(to2, from2, pack) {
    if (pack || arguments.length === 2)
      for (var i = 0, l = from2.length, ar; i < l; i++) {
        if (ar || !(i in from2)) {
          if (!ar)
            ar = Array.prototype.slice.call(from2, 0, i);
          ar[i] = from2[i];
        }
      }
    return to2.concat(ar || Array.prototype.slice.call(from2));
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.sortBy = exports.uniq = exports.rotate = exports.intersperse = exports.prependAll = exports.unzip = exports.zipWith = exports.sort = exports.lefts = exports.rights = exports.reverse = exports.modifyAt = exports.deleteAt = exports.updateAt = exports.insertAt = exports.findLastIndex = exports.findLastMap = exports.findFirstMap = exports.findIndex = exports.dropRight = exports.dropLeft = exports.takeRight = exports.takeLeft = exports.init = exports.tail = exports.last = exports.head = exports.isOutOfBound = exports.size = exports.scanRight = exports.scanLeft = exports.chainWithIndex = exports.foldRight = exports.matchRight = exports.matchRightW = exports.foldLeft = exports.matchLeft = exports.matchLeftW = exports.match = exports.matchW = exports.fromEither = exports.fromOption = exports.replicate = exports.makeBy = exports.appendW = exports.append = exports.prependW = exports.prepend = exports.isNonEmpty = exports.isEmpty = void 0;
  exports.getIntersectionSemigroup = exports.getUnionMonoid = exports.getUnionSemigroup = exports.getOrd = exports.getEq = exports.getMonoid = exports.getSemigroup = exports.getShow = exports.URI = exports.unfold = exports.wilt = exports.wither = exports.traverseWithIndex = exports.sequence = exports.traverse = exports.reduceRightWithIndex = exports.reduceRight = exports.reduceWithIndex = exports.foldMap = exports.reduce = exports.foldMapWithIndex = exports.duplicate = exports.extend = exports.filterWithIndex = exports.partitionMapWithIndex = exports.partitionMap = exports.partitionWithIndex = exports.partition = exports.compact = exports.filterMap = exports.filterMapWithIndex = exports.filter = exports.separate = exports.mapWithIndex = exports.map = exports.flatten = exports.flatMap = exports.ap = exports.alt = exports.altW = exports.zero = exports.of = exports._chainRecBreadthFirst = exports._chainRecDepthFirst = exports.concat = exports.concatW = exports.fromOptionK = exports.chunksOf = exports.splitAt = exports.chop = void 0;
  exports.cons = exports.range = exports.chain = exports.apS = exports.bind = exports.let = exports.bindTo = exports.Do = exports.intercalate = exports.exists = exports.some = exports.empty = exports.fromArray = exports.toArray = exports.unsafeDeleteAt = exports.unsafeUpdateAt = exports.unsafeInsertAt = exports.fromEitherK = exports.FromEither = exports.filterE = exports.Witherable = exports.ChainRecBreadthFirst = exports.chainRecBreadthFirst = exports.ChainRecDepthFirst = exports.chainRecDepthFirst = exports.TraversableWithIndex = exports.Traversable = exports.FoldableWithIndex = exports.Foldable = exports.FilterableWithIndex = exports.Filterable = exports.Compactable = exports.Extend = exports.Alternative = exports.guard = exports.Zero = exports.Alt = exports.Unfoldable = exports.chainFirst = exports.Monad = exports.Chain = exports.Applicative = exports.apSecond = exports.apFirst = exports.Apply = exports.FunctorWithIndex = exports.Pointed = exports.flap = exports.Functor = exports.getDifferenceMagma = void 0;
  exports.readonlyArray = exports.prependToAll = exports.snoc = void 0;
  exports.fromPredicate = fromPredicate2;
  exports.lookup = lookup;
  exports.takeLeftWhile = takeLeftWhile;
  exports.spanLeft = spanLeft;
  exports.dropLeftWhile = dropLeftWhile;
  exports.findFirst = findFirst;
  exports.findLast = findLast;
  exports.zip = zip;
  exports.elem = elem;
  exports.comprehension = comprehension;
  exports.union = union;
  exports.intersection = intersection;
  exports.difference = difference;
  exports.every = every;
  var Apply_12 = Apply;
  var Chain_12 = Chain;
  var Eq_1 = Eq;
  var FromEither_1 = FromEither;
  var function_12 = _function;
  var Functor_12 = Functor;
  var _2 = __importStar2(internal);
  var N = __importStar2(number);
  var Ord_1 = Ord;
  var RNEA = __importStar2(ReadonlyNonEmptyArray);
  var Separated_12 = Separated;
  var Witherable_1 = Witherable;
  var Zero_1 = Zero;
  var isEmpty = function(as2) {
    return as2.length === 0;
  };
  exports.isEmpty = isEmpty;
  exports.isNonEmpty = RNEA.isNonEmpty;
  exports.prepend = RNEA.prepend;
  exports.prependW = RNEA.prependW;
  exports.append = RNEA.append;
  exports.appendW = RNEA.appendW;
  var makeBy = function(n, f) {
    return n <= 0 ? exports.empty : RNEA.makeBy(f)(n);
  };
  exports.makeBy = makeBy;
  var replicate = function(n, a) {
    return (0, exports.makeBy)(n, function() {
      return a;
    });
  };
  exports.replicate = replicate;
  function fromPredicate2(predicate) {
    return function(a) {
      return predicate(a) ? [a] : exports.empty;
    };
  }
  var fromOption2 = function(ma) {
    return _2.isNone(ma) ? exports.empty : [ma.value];
  };
  exports.fromOption = fromOption2;
  var fromEither = function(e) {
    return _2.isLeft(e) ? exports.empty : [e.right];
  };
  exports.fromEither = fromEither;
  var matchW = function(onEmpty, onNonEmpty) {
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? onNonEmpty(as2) : onEmpty();
    };
  };
  exports.matchW = matchW;
  exports.match = exports.matchW;
  var matchLeftW = function(onEmpty, onNonEmpty) {
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? onNonEmpty(RNEA.head(as2), RNEA.tail(as2)) : onEmpty();
    };
  };
  exports.matchLeftW = matchLeftW;
  exports.matchLeft = exports.matchLeftW;
  exports.foldLeft = exports.matchLeft;
  var matchRightW = function(onEmpty, onNonEmpty) {
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? onNonEmpty(RNEA.init(as2), RNEA.last(as2)) : onEmpty();
    };
  };
  exports.matchRightW = matchRightW;
  exports.matchRight = exports.matchRightW;
  exports.foldRight = exports.matchRight;
  var chainWithIndex = function(f) {
    return function(as2) {
      if ((0, exports.isEmpty)(as2)) {
        return exports.empty;
      }
      var out = [];
      for (var i = 0; i < as2.length; i++) {
        var bs = f(i, as2[i]);
        for (var j = 0; j < bs.length; j++) {
          out.push(bs[j]);
        }
      }
      return out;
    };
  };
  exports.chainWithIndex = chainWithIndex;
  var scanLeft = function(b, f) {
    return function(as2) {
      var len = as2.length;
      var out = new Array(len + 1);
      out[0] = b;
      for (var i = 0; i < len; i++) {
        out[i + 1] = f(out[i], as2[i]);
      }
      return out;
    };
  };
  exports.scanLeft = scanLeft;
  var scanRight = function(b, f) {
    return function(as2) {
      var len = as2.length;
      var out = new Array(len + 1);
      out[len] = b;
      for (var i = len - 1; i >= 0; i--) {
        out[i] = f(as2[i], out[i + 1]);
      }
      return out;
    };
  };
  exports.scanRight = scanRight;
  var size = function(as2) {
    return as2.length;
  };
  exports.size = size;
  exports.isOutOfBound = RNEA.isOutOfBound;
  function lookup(i, as2) {
    return as2 === void 0 ? function(as3) {
      return lookup(i, as3);
    } : (0, exports.isOutOfBound)(i, as2) ? _2.none : _2.some(as2[i]);
  }
  var head = function(as2) {
    return (0, exports.isNonEmpty)(as2) ? _2.some(RNEA.head(as2)) : _2.none;
  };
  exports.head = head;
  var last = function(as2) {
    return (0, exports.isNonEmpty)(as2) ? _2.some(RNEA.last(as2)) : _2.none;
  };
  exports.last = last;
  var tail = function(as2) {
    return (0, exports.isNonEmpty)(as2) ? _2.some(RNEA.tail(as2)) : _2.none;
  };
  exports.tail = tail;
  var init2 = function(as2) {
    return (0, exports.isNonEmpty)(as2) ? _2.some(RNEA.init(as2)) : _2.none;
  };
  exports.init = init2;
  var takeLeft = function(n) {
    return function(as2) {
      return (0, exports.isOutOfBound)(n, as2) ? as2 : n === 0 ? exports.empty : as2.slice(0, n);
    };
  };
  exports.takeLeft = takeLeft;
  var takeRight = function(n) {
    return function(as2) {
      return (0, exports.isOutOfBound)(n, as2) ? as2 : n === 0 ? exports.empty : as2.slice(-n);
    };
  };
  exports.takeRight = takeRight;
  function takeLeftWhile(predicate) {
    return function(as2) {
      var out = [];
      for (var _i = 0, as_1 = as2; _i < as_1.length; _i++) {
        var a = as_1[_i];
        if (!predicate(a)) {
          break;
        }
        out.push(a);
      }
      var len = out.length;
      return len === as2.length ? as2 : len === 0 ? exports.empty : out;
    };
  }
  var spanLeftIndex = function(as2, predicate) {
    var l = as2.length;
    var i = 0;
    for (; i < l; i++) {
      if (!predicate(as2[i])) {
        break;
      }
    }
    return i;
  };
  function spanLeft(predicate) {
    return function(as2) {
      var _a = (0, exports.splitAt)(spanLeftIndex(as2, predicate))(as2), init3 = _a[0], rest = _a[1];
      return { init: init3, rest };
    };
  }
  var dropLeft = function(n) {
    return function(as2) {
      return n <= 0 || (0, exports.isEmpty)(as2) ? as2 : n >= as2.length ? exports.empty : as2.slice(n, as2.length);
    };
  };
  exports.dropLeft = dropLeft;
  var dropRight = function(n) {
    return function(as2) {
      return n <= 0 || (0, exports.isEmpty)(as2) ? as2 : n >= as2.length ? exports.empty : as2.slice(0, as2.length - n);
    };
  };
  exports.dropRight = dropRight;
  function dropLeftWhile(predicate) {
    return function(as2) {
      var i = spanLeftIndex(as2, predicate);
      return i === 0 ? as2 : i === as2.length ? exports.empty : as2.slice(i);
    };
  }
  var findIndex = function(predicate) {
    return function(as2) {
      for (var i = 0; i < as2.length; i++) {
        if (predicate(as2[i])) {
          return _2.some(i);
        }
      }
      return _2.none;
    };
  };
  exports.findIndex = findIndex;
  function findFirst(predicate) {
    return function(as2) {
      for (var i = 0; i < as2.length; i++) {
        if (predicate(as2[i])) {
          return _2.some(as2[i]);
        }
      }
      return _2.none;
    };
  }
  var findFirstMap = function(f) {
    return function(as2) {
      for (var i = 0; i < as2.length; i++) {
        var out = f(as2[i]);
        if (_2.isSome(out)) {
          return out;
        }
      }
      return _2.none;
    };
  };
  exports.findFirstMap = findFirstMap;
  function findLast(predicate) {
    return function(as2) {
      for (var i = as2.length - 1; i >= 0; i--) {
        if (predicate(as2[i])) {
          return _2.some(as2[i]);
        }
      }
      return _2.none;
    };
  }
  var findLastMap = function(f) {
    return function(as2) {
      for (var i = as2.length - 1; i >= 0; i--) {
        var out = f(as2[i]);
        if (_2.isSome(out)) {
          return out;
        }
      }
      return _2.none;
    };
  };
  exports.findLastMap = findLastMap;
  var findLastIndex = function(predicate) {
    return function(as2) {
      for (var i = as2.length - 1; i >= 0; i--) {
        if (predicate(as2[i])) {
          return _2.some(i);
        }
      }
      return _2.none;
    };
  };
  exports.findLastIndex = findLastIndex;
  var insertAt = function(i, a) {
    return function(as2) {
      return i < 0 || i > as2.length ? _2.none : _2.some(RNEA.unsafeInsertAt(i, a, as2));
    };
  };
  exports.insertAt = insertAt;
  var updateAt = function(i, a) {
    return (0, exports.modifyAt)(i, function() {
      return a;
    });
  };
  exports.updateAt = updateAt;
  var deleteAt = function(i) {
    return function(as2) {
      return (0, exports.isOutOfBound)(i, as2) ? _2.none : _2.some((0, exports.unsafeDeleteAt)(i, as2));
    };
  };
  exports.deleteAt = deleteAt;
  var modifyAt = function(i, f) {
    return function(as2) {
      return (0, exports.isOutOfBound)(i, as2) ? _2.none : _2.some((0, exports.unsafeUpdateAt)(i, f(as2[i]), as2));
    };
  };
  exports.modifyAt = modifyAt;
  var reverse2 = function(as2) {
    return as2.length <= 1 ? as2 : as2.slice().reverse();
  };
  exports.reverse = reverse2;
  var rights = function(as2) {
    var r = [];
    for (var i = 0; i < as2.length; i++) {
      var a = as2[i];
      if (a._tag === "Right") {
        r.push(a.right);
      }
    }
    return r;
  };
  exports.rights = rights;
  var lefts = function(as2) {
    var r = [];
    for (var i = 0; i < as2.length; i++) {
      var a = as2[i];
      if (a._tag === "Left") {
        r.push(a.left);
      }
    }
    return r;
  };
  exports.lefts = lefts;
  var sort = function(O) {
    return function(as2) {
      return as2.length <= 1 ? as2 : as2.slice().sort(O.compare);
    };
  };
  exports.sort = sort;
  var zipWith = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for (var i = 0; i < len; i++) {
      fc[i] = f(fa[i], fb[i]);
    }
    return fc;
  };
  exports.zipWith = zipWith;
  function zip(as2, bs) {
    if (bs === void 0) {
      return function(bs2) {
        return zip(bs2, as2);
      };
    }
    return (0, exports.zipWith)(as2, bs, function(a, b) {
      return [a, b];
    });
  }
  var unzip = function(as2) {
    var fa = [];
    var fb = [];
    for (var i = 0; i < as2.length; i++) {
      fa[i] = as2[i][0];
      fb[i] = as2[i][1];
    }
    return [fa, fb];
  };
  exports.unzip = unzip;
  var prependAll = function(middle) {
    var f = RNEA.prependAll(middle);
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? f(as2) : as2;
    };
  };
  exports.prependAll = prependAll;
  var intersperse = function(middle) {
    var f = RNEA.intersperse(middle);
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? f(as2) : as2;
    };
  };
  exports.intersperse = intersperse;
  var rotate = function(n) {
    var f = RNEA.rotate(n);
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? f(as2) : as2;
    };
  };
  exports.rotate = rotate;
  function elem(E2) {
    return function(a, as2) {
      if (as2 === void 0) {
        var elemE_1 = elem(E2);
        return function(as3) {
          return elemE_1(a, as3);
        };
      }
      var predicate = function(element) {
        return E2.equals(element, a);
      };
      var i = 0;
      for (; i < as2.length; i++) {
        if (predicate(as2[i])) {
          return true;
        }
      }
      return false;
    };
  }
  var uniq = function(E2) {
    var f = RNEA.uniq(E2);
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? f(as2) : as2;
    };
  };
  exports.uniq = uniq;
  var sortBy = function(ords) {
    var f = RNEA.sortBy(ords);
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? f(as2) : as2;
    };
  };
  exports.sortBy = sortBy;
  var chop = function(f) {
    var g = RNEA.chop(f);
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? g(as2) : exports.empty;
    };
  };
  exports.chop = chop;
  var splitAt = function(n) {
    return function(as2) {
      return n >= 1 && (0, exports.isNonEmpty)(as2) ? RNEA.splitAt(n)(as2) : (0, exports.isEmpty)(as2) ? [as2, exports.empty] : [exports.empty, as2];
    };
  };
  exports.splitAt = splitAt;
  var chunksOf = function(n) {
    var f = RNEA.chunksOf(n);
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? f(as2) : exports.empty;
    };
  };
  exports.chunksOf = chunksOf;
  var fromOptionK2 = function(f) {
    return function() {
      var a = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        a[_i] = arguments[_i];
      }
      return (0, exports.fromOption)(f.apply(void 0, a));
    };
  };
  exports.fromOptionK = fromOptionK2;
  function comprehension(input, f, g) {
    if (g === void 0) {
      g = function() {
        return true;
      };
    }
    var go = function(scope, input2) {
      return (0, exports.isNonEmpty)(input2) ? (0, exports.flatMap)(RNEA.head(input2), function(a) {
        return go((0, function_12.pipe)(scope, (0, exports.append)(a)), RNEA.tail(input2));
      }) : g.apply(void 0, scope) ? [f.apply(void 0, scope)] : exports.empty;
    };
    return go(exports.empty, input);
  }
  var concatW = function(second) {
    return function(first) {
      return (0, exports.isEmpty)(first) ? second : (0, exports.isEmpty)(second) ? first : first.concat(second);
    };
  };
  exports.concatW = concatW;
  exports.concat = exports.concatW;
  function union(E2) {
    var unionE = RNEA.union(E2);
    return function(first, second) {
      if (second === void 0) {
        var unionE_1 = union(E2);
        return function(second2) {
          return unionE_1(second2, first);
        };
      }
      return (0, exports.isNonEmpty)(first) && (0, exports.isNonEmpty)(second) ? unionE(second)(first) : (0, exports.isNonEmpty)(first) ? first : second;
    };
  }
  function intersection(E2) {
    var elemE = elem(E2);
    return function(xs, ys) {
      if (ys === void 0) {
        var intersectionE_1 = intersection(E2);
        return function(ys2) {
          return intersectionE_1(ys2, xs);
        };
      }
      return xs.filter(function(a) {
        return elemE(a, ys);
      });
    };
  }
  function difference(E2) {
    var elemE = elem(E2);
    return function(xs, ys) {
      if (ys === void 0) {
        var differenceE_1 = difference(E2);
        return function(ys2) {
          return differenceE_1(ys2, xs);
        };
      }
      return xs.filter(function(a) {
        return !elemE(a, ys);
      });
    };
  }
  var _map = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.map)(f));
  };
  var _mapWithIndex = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.mapWithIndex)(f));
  };
  var _ap = function(fab, fa) {
    return (0, function_12.pipe)(fab, (0, exports.ap)(fa));
  };
  var _filter = function(fa, predicate) {
    return (0, function_12.pipe)(fa, (0, exports.filter)(predicate));
  };
  var _filterMap = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.filterMap)(f));
  };
  var _partition = function(fa, predicate) {
    return (0, function_12.pipe)(fa, (0, exports.partition)(predicate));
  };
  var _partitionMap = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.partitionMap)(f));
  };
  var _partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, function_12.pipe)(fa, (0, exports.partitionWithIndex)(predicateWithIndex));
  };
  var _partitionMapWithIndex = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.partitionMapWithIndex)(f));
  };
  var _alt = function(fa, that) {
    return (0, function_12.pipe)(fa, (0, exports.alt)(that));
  };
  var _reduce = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduce)(b, f));
  };
  var _foldMap = function(M) {
    var foldMapM = (0, exports.foldMap)(M);
    return function(fa, f) {
      return (0, function_12.pipe)(fa, foldMapM(f));
    };
  };
  var _reduceRight = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduceRight)(b, f));
  };
  var _reduceWithIndex = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduceWithIndex)(b, f));
  };
  var _foldMapWithIndex = function(M) {
    var foldMapWithIndexM = (0, exports.foldMapWithIndex)(M);
    return function(fa, f) {
      return (0, function_12.pipe)(fa, foldMapWithIndexM(f));
    };
  };
  var _reduceRightWithIndex = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduceRightWithIndex)(b, f));
  };
  var _filterMapWithIndex = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.filterMapWithIndex)(f));
  };
  var _filterWithIndex = function(fa, predicateWithIndex) {
    return (0, function_12.pipe)(fa, (0, exports.filterWithIndex)(predicateWithIndex));
  };
  var _extend = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.extend)(f));
  };
  var _traverse = function(F) {
    var traverseF = (0, exports.traverse)(F);
    return function(ta, f) {
      return (0, function_12.pipe)(ta, traverseF(f));
    };
  };
  var _traverseWithIndex = function(F) {
    var traverseWithIndexF = (0, exports.traverseWithIndex)(F);
    return function(ta, f) {
      return (0, function_12.pipe)(ta, traverseWithIndexF(f));
    };
  };
  var _chainRecDepthFirst = function(a, f) {
    return (0, function_12.pipe)(a, (0, exports.chainRecDepthFirst)(f));
  };
  exports._chainRecDepthFirst = _chainRecDepthFirst;
  var _chainRecBreadthFirst = function(a, f) {
    return (0, function_12.pipe)(a, (0, exports.chainRecBreadthFirst)(f));
  };
  exports._chainRecBreadthFirst = _chainRecBreadthFirst;
  exports.of = RNEA.of;
  var zero = function() {
    return exports.empty;
  };
  exports.zero = zero;
  var altW = function(that) {
    return function(fa) {
      return fa.concat(that());
    };
  };
  exports.altW = altW;
  exports.alt = exports.altW;
  var ap2 = function(fa) {
    return (0, exports.flatMap)(function(f) {
      return (0, function_12.pipe)(fa, (0, exports.map)(f));
    });
  };
  exports.ap = ap2;
  exports.flatMap = (0, function_12.dual)(2, function(ma, f) {
    return (0, function_12.pipe)(ma, (0, exports.chainWithIndex)(function(i, a) {
      return f(a, i);
    }));
  });
  exports.flatten = (0, exports.flatMap)(function_12.identity);
  var map2 = function(f) {
    return function(fa) {
      return fa.map(function(a) {
        return f(a);
      });
    };
  };
  exports.map = map2;
  var mapWithIndex = function(f) {
    return function(fa) {
      return fa.map(function(a, i) {
        return f(i, a);
      });
    };
  };
  exports.mapWithIndex = mapWithIndex;
  var separate2 = function(fa) {
    var left2 = [];
    var right2 = [];
    for (var _i = 0, fa_1 = fa; _i < fa_1.length; _i++) {
      var e = fa_1[_i];
      if (e._tag === "Left") {
        left2.push(e.left);
      } else {
        right2.push(e.right);
      }
    }
    return (0, Separated_12.separated)(left2, right2);
  };
  exports.separate = separate2;
  var filter3 = function(predicate) {
    return function(as2) {
      return as2.filter(predicate);
    };
  };
  exports.filter = filter3;
  var filterMapWithIndex = function(f) {
    return function(fa) {
      var out = [];
      for (var i = 0; i < fa.length; i++) {
        var optionB = f(i, fa[i]);
        if (_2.isSome(optionB)) {
          out.push(optionB.value);
        }
      }
      return out;
    };
  };
  exports.filterMapWithIndex = filterMapWithIndex;
  var filterMap2 = function(f) {
    return (0, exports.filterMapWithIndex)(function(_3, a) {
      return f(a);
    });
  };
  exports.filterMap = filterMap2;
  exports.compact = (0, exports.filterMap)(function_12.identity);
  var partition2 = function(predicate) {
    return (0, exports.partitionWithIndex)(function(_3, a) {
      return predicate(a);
    });
  };
  exports.partition = partition2;
  var partitionWithIndex = function(predicateWithIndex) {
    return function(as2) {
      var left2 = [];
      var right2 = [];
      for (var i = 0; i < as2.length; i++) {
        var a = as2[i];
        if (predicateWithIndex(i, a)) {
          right2.push(a);
        } else {
          left2.push(a);
        }
      }
      return (0, Separated_12.separated)(left2, right2);
    };
  };
  exports.partitionWithIndex = partitionWithIndex;
  var partitionMap2 = function(f) {
    return (0, exports.partitionMapWithIndex)(function(_3, a) {
      return f(a);
    });
  };
  exports.partitionMap = partitionMap2;
  var partitionMapWithIndex = function(f) {
    return function(fa) {
      var left2 = [];
      var right2 = [];
      for (var i = 0; i < fa.length; i++) {
        var e = f(i, fa[i]);
        if (e._tag === "Left") {
          left2.push(e.left);
        } else {
          right2.push(e.right);
        }
      }
      return (0, Separated_12.separated)(left2, right2);
    };
  };
  exports.partitionMapWithIndex = partitionMapWithIndex;
  var filterWithIndex = function(predicateWithIndex) {
    return function(as2) {
      return as2.filter(function(a, i) {
        return predicateWithIndex(i, a);
      });
    };
  };
  exports.filterWithIndex = filterWithIndex;
  var extend2 = function(f) {
    return function(wa) {
      return wa.map(function(_3, i) {
        return f(wa.slice(i));
      });
    };
  };
  exports.extend = extend2;
  exports.duplicate = (0, exports.extend)(function_12.identity);
  var foldMapWithIndex = function(M) {
    return function(f) {
      return function(fa) {
        return fa.reduce(function(b, a, i) {
          return M.concat(b, f(i, a));
        }, M.empty);
      };
    };
  };
  exports.foldMapWithIndex = foldMapWithIndex;
  var reduce = function(b, f) {
    return (0, exports.reduceWithIndex)(b, function(_3, b2, a) {
      return f(b2, a);
    });
  };
  exports.reduce = reduce;
  var foldMap = function(M) {
    var foldMapWithIndexM = (0, exports.foldMapWithIndex)(M);
    return function(f) {
      return foldMapWithIndexM(function(_3, a) {
        return f(a);
      });
    };
  };
  exports.foldMap = foldMap;
  var reduceWithIndex = function(b, f) {
    return function(fa) {
      var len = fa.length;
      var out = b;
      for (var i = 0; i < len; i++) {
        out = f(i, out, fa[i]);
      }
      return out;
    };
  };
  exports.reduceWithIndex = reduceWithIndex;
  var reduceRight = function(b, f) {
    return (0, exports.reduceRightWithIndex)(b, function(_3, a, b2) {
      return f(a, b2);
    });
  };
  exports.reduceRight = reduceRight;
  var reduceRightWithIndex = function(b, f) {
    return function(fa) {
      return fa.reduceRight(function(b2, a, i) {
        return f(i, a, b2);
      }, b);
    };
  };
  exports.reduceRightWithIndex = reduceRightWithIndex;
  var traverse = function(F) {
    var traverseWithIndexF = (0, exports.traverseWithIndex)(F);
    return function(f) {
      return traverseWithIndexF(function(_3, a) {
        return f(a);
      });
    };
  };
  exports.traverse = traverse;
  var sequence = function(F) {
    return function(ta) {
      return _reduce(ta, F.of((0, exports.zero)()), function(fas, fa) {
        return F.ap(F.map(fas, function(as2) {
          return function(a) {
            return (0, function_12.pipe)(as2, (0, exports.append)(a));
          };
        }), fa);
      });
    };
  };
  exports.sequence = sequence;
  var traverseWithIndex = function(F) {
    return function(f) {
      return (0, exports.reduceWithIndex)(F.of((0, exports.zero)()), function(i, fbs, a) {
        return F.ap(F.map(fbs, function(bs) {
          return function(b) {
            return (0, function_12.pipe)(bs, (0, exports.append)(b));
          };
        }), f(i, a));
      });
    };
  };
  exports.traverseWithIndex = traverseWithIndex;
  var wither = function(F) {
    var _witherF = _wither(F);
    return function(f) {
      return function(fa) {
        return _witherF(fa, f);
      };
    };
  };
  exports.wither = wither;
  var wilt = function(F) {
    var _wiltF = _wilt(F);
    return function(f) {
      return function(fa) {
        return _wiltF(fa, f);
      };
    };
  };
  exports.wilt = wilt;
  var unfold = function(b, f) {
    var out = [];
    var bb = b;
    while (true) {
      var mt = f(bb);
      if (_2.isSome(mt)) {
        var _a = mt.value, a = _a[0], b_1 = _a[1];
        out.push(a);
        bb = b_1;
      } else {
        break;
      }
    }
    return out;
  };
  exports.unfold = unfold;
  exports.URI = "ReadonlyArray";
  var getShow = function(S2) {
    return {
      show: function(as2) {
        return "[".concat(as2.map(S2.show).join(", "), "]");
      }
    };
  };
  exports.getShow = getShow;
  var getSemigroup = function() {
    return {
      concat: function(first, second) {
        return (0, exports.isEmpty)(first) ? second : (0, exports.isEmpty)(second) ? first : first.concat(second);
      }
    };
  };
  exports.getSemigroup = getSemigroup;
  var getMonoid = function() {
    return {
      concat: (0, exports.getSemigroup)().concat,
      empty: exports.empty
    };
  };
  exports.getMonoid = getMonoid;
  var getEq = function(E2) {
    return (0, Eq_1.fromEquals)(function(xs, ys) {
      return xs.length === ys.length && xs.every(function(x, i) {
        return E2.equals(x, ys[i]);
      });
    });
  };
  exports.getEq = getEq;
  var getOrd = function(O) {
    return (0, Ord_1.fromCompare)(function(a, b) {
      var aLen = a.length;
      var bLen = b.length;
      var len = Math.min(aLen, bLen);
      for (var i = 0; i < len; i++) {
        var ordering2 = O.compare(a[i], b[i]);
        if (ordering2 !== 0) {
          return ordering2;
        }
      }
      return N.Ord.compare(aLen, bLen);
    });
  };
  exports.getOrd = getOrd;
  var getUnionSemigroup = function(E2) {
    var unionE = union(E2);
    return {
      concat: function(first, second) {
        return unionE(second)(first);
      }
    };
  };
  exports.getUnionSemigroup = getUnionSemigroup;
  var getUnionMonoid = function(E2) {
    return {
      concat: (0, exports.getUnionSemigroup)(E2).concat,
      empty: exports.empty
    };
  };
  exports.getUnionMonoid = getUnionMonoid;
  var getIntersectionSemigroup = function(E2) {
    var intersectionE = intersection(E2);
    return {
      concat: function(first, second) {
        return intersectionE(second)(first);
      }
    };
  };
  exports.getIntersectionSemigroup = getIntersectionSemigroup;
  var getDifferenceMagma = function(E2) {
    var differenceE = difference(E2);
    return {
      concat: function(first, second) {
        return differenceE(second)(first);
      }
    };
  };
  exports.getDifferenceMagma = getDifferenceMagma;
  exports.Functor = {
    URI: exports.URI,
    map: _map
  };
  exports.flap = (0, Functor_12.flap)(exports.Functor);
  exports.Pointed = {
    URI: exports.URI,
    of: exports.of
  };
  exports.FunctorWithIndex = {
    URI: exports.URI,
    map: _map,
    mapWithIndex: _mapWithIndex
  };
  exports.Apply = {
    URI: exports.URI,
    map: _map,
    ap: _ap
  };
  exports.apFirst = (0, Apply_12.apFirst)(exports.Apply);
  exports.apSecond = (0, Apply_12.apSecond)(exports.Apply);
  exports.Applicative = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of
  };
  exports.Chain = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    chain: exports.flatMap
  };
  exports.Monad = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of,
    chain: exports.flatMap
  };
  exports.chainFirst = /* @__PURE__ */ (0, Chain_12.chainFirst)(exports.Chain);
  exports.Unfoldable = {
    URI: exports.URI,
    unfold: exports.unfold
  };
  exports.Alt = {
    URI: exports.URI,
    map: _map,
    alt: _alt
  };
  exports.Zero = {
    URI: exports.URI,
    zero: exports.zero
  };
  exports.guard = (0, Zero_1.guard)(exports.Zero, exports.Pointed);
  exports.Alternative = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of,
    alt: _alt,
    zero: exports.zero
  };
  exports.Extend = {
    URI: exports.URI,
    map: _map,
    extend: _extend
  };
  exports.Compactable = {
    URI: exports.URI,
    compact: exports.compact,
    separate: exports.separate
  };
  exports.Filterable = {
    URI: exports.URI,
    map: _map,
    compact: exports.compact,
    separate: exports.separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap
  };
  exports.FilterableWithIndex = {
    URI: exports.URI,
    map: _map,
    mapWithIndex: _mapWithIndex,
    compact: exports.compact,
    separate: exports.separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap,
    partitionMapWithIndex: _partitionMapWithIndex,
    partitionWithIndex: _partitionWithIndex,
    filterMapWithIndex: _filterMapWithIndex,
    filterWithIndex: _filterWithIndex
  };
  exports.Foldable = {
    URI: exports.URI,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight
  };
  exports.FoldableWithIndex = {
    URI: exports.URI,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    reduceWithIndex: _reduceWithIndex,
    foldMapWithIndex: _foldMapWithIndex,
    reduceRightWithIndex: _reduceRightWithIndex
  };
  exports.Traversable = {
    URI: exports.URI,
    map: _map,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence
  };
  exports.TraversableWithIndex = {
    URI: exports.URI,
    map: _map,
    mapWithIndex: _mapWithIndex,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    reduceWithIndex: _reduceWithIndex,
    foldMapWithIndex: _foldMapWithIndex,
    reduceRightWithIndex: _reduceRightWithIndex,
    traverse: _traverse,
    sequence: exports.sequence,
    traverseWithIndex: _traverseWithIndex
  };
  var chainRecDepthFirst = function(f) {
    return function(a) {
      var todo = __spreadArray([], f(a), true);
      var out = [];
      while (todo.length > 0) {
        var e = todo.shift();
        if (_2.isLeft(e)) {
          todo.unshift.apply(todo, f(e.left));
        } else {
          out.push(e.right);
        }
      }
      return out;
    };
  };
  exports.chainRecDepthFirst = chainRecDepthFirst;
  exports.ChainRecDepthFirst = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    chain: exports.flatMap,
    chainRec: exports._chainRecDepthFirst
  };
  var chainRecBreadthFirst = function(f) {
    return function(a) {
      var initial = f(a);
      var todo = [];
      var out = [];
      function go(e2) {
        if (_2.isLeft(e2)) {
          f(e2.left).forEach(function(v) {
            return todo.push(v);
          });
        } else {
          out.push(e2.right);
        }
      }
      for (var _i = 0, initial_1 = initial; _i < initial_1.length; _i++) {
        var e = initial_1[_i];
        go(e);
      }
      while (todo.length > 0) {
        go(todo.shift());
      }
      return out;
    };
  };
  exports.chainRecBreadthFirst = chainRecBreadthFirst;
  exports.ChainRecBreadthFirst = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    chain: exports.flatMap,
    chainRec: exports._chainRecBreadthFirst
  };
  var _wither = /* @__PURE__ */ (0, Witherable_1.witherDefault)(exports.Traversable, exports.Compactable);
  var _wilt = /* @__PURE__ */ (0, Witherable_1.wiltDefault)(exports.Traversable, exports.Compactable);
  exports.Witherable = {
    URI: exports.URI,
    map: _map,
    compact: exports.compact,
    separate: exports.separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence,
    wither: _wither,
    wilt: _wilt
  };
  exports.filterE = (0, Witherable_1.filterE)(exports.Witherable);
  exports.FromEither = {
    URI: exports.URI,
    fromEither: exports.fromEither
  };
  exports.fromEitherK = (0, FromEither_1.fromEitherK)(exports.FromEither);
  exports.unsafeInsertAt = RNEA.unsafeInsertAt;
  var unsafeUpdateAt = function(i, a, as2) {
    return (0, exports.isNonEmpty)(as2) ? RNEA.unsafeUpdateAt(i, a, as2) : as2;
  };
  exports.unsafeUpdateAt = unsafeUpdateAt;
  var unsafeDeleteAt = function(i, as2) {
    var xs = as2.slice();
    xs.splice(i, 1);
    return xs;
  };
  exports.unsafeDeleteAt = unsafeDeleteAt;
  var toArray2 = function(as2) {
    return as2.slice();
  };
  exports.toArray = toArray2;
  var fromArray = function(as2) {
    return (0, exports.isEmpty)(as2) ? exports.empty : as2.slice();
  };
  exports.fromArray = fromArray;
  exports.empty = RNEA.empty;
  function every(predicate) {
    return function(as2) {
      return as2.every(predicate);
    };
  }
  var some2 = function(predicate) {
    return function(as2) {
      return as2.some(predicate);
    };
  };
  exports.some = some2;
  exports.exists = exports.some;
  var intercalate = function(M) {
    var intercalateM = RNEA.intercalate(M);
    return function(middle) {
      return (0, exports.match)(function() {
        return M.empty;
      }, intercalateM(middle));
    };
  };
  exports.intercalate = intercalate;
  exports.Do = (0, exports.of)(_2.emptyRecord);
  exports.bindTo = (0, Functor_12.bindTo)(exports.Functor);
  var let_2 = /* @__PURE__ */ (0, Functor_12.let)(exports.Functor);
  exports.let = let_2;
  exports.bind = (0, Chain_12.bind)(exports.Chain);
  exports.apS = (0, Apply_12.apS)(exports.Apply);
  exports.chain = exports.flatMap;
  exports.range = RNEA.range;
  exports.cons = RNEA.cons;
  exports.snoc = RNEA.snoc;
  exports.prependToAll = exports.prependAll;
  exports.readonlyArray = {
    URI: exports.URI,
    compact: exports.compact,
    separate: exports.separate,
    map: _map,
    ap: _ap,
    of: exports.of,
    chain: exports.flatMap,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap,
    mapWithIndex: _mapWithIndex,
    partitionMapWithIndex: _partitionMapWithIndex,
    partitionWithIndex: _partitionWithIndex,
    filterMapWithIndex: _filterMapWithIndex,
    filterWithIndex: _filterWithIndex,
    alt: _alt,
    zero: exports.zero,
    unfold: exports.unfold,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence,
    reduceWithIndex: _reduceWithIndex,
    foldMapWithIndex: _foldMapWithIndex,
    reduceRightWithIndex: _reduceRightWithIndex,
    traverseWithIndex: _traverseWithIndex,
    extend: _extend,
    wither: _wither,
    wilt: _wilt
  };
})(ReadonlyArray);
(function(exports) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule)
      return mod2;
    var result2 = {};
    if (mod2 != null) {
      for (var k in mod2)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
          __createBinding2(result2, mod2, k);
    }
    __setModuleDefault2(result2, mod2);
    return result2;
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.rotate = exports.intersperse = exports.prependAll = exports.unzip = exports.zipWith = exports.sort = exports.lefts = exports.rights = exports.reverse = exports.modifyAt = exports.deleteAt = exports.updateAt = exports.insertAt = exports.copy = exports.findLastIndex = exports.findLastMap = exports.findFirstMap = exports.findIndex = exports.dropRight = exports.dropLeft = exports.takeRight = exports.takeLeft = exports.init = exports.tail = exports.last = exports.head = exports.lookup = exports.isOutOfBound = exports.size = exports.scanRight = exports.scanLeft = exports.chainWithIndex = exports.foldRight = exports.matchRight = exports.matchRightW = exports.foldLeft = exports.matchLeft = exports.matchLeftW = exports.match = exports.matchW = exports.fromEither = exports.fromOption = exports.replicate = exports.makeBy = exports.appendW = exports.append = exports.prependW = exports.prepend = exports.isNonEmpty = exports.isEmpty = void 0;
  exports.getUnionMonoid = exports.getUnionSemigroup = exports.getOrd = exports.getEq = exports.getMonoid = exports.getSemigroup = exports.getShow = exports.URI = exports.unfold = exports.wilt = exports.wither = exports.traverseWithIndex = exports.sequence = exports.traverse = exports.reduceRightWithIndex = exports.reduceRight = exports.reduceWithIndex = exports.reduce = exports.foldMapWithIndex = exports.foldMap = exports.duplicate = exports.extend = exports.filterWithIndex = exports.alt = exports.altW = exports.partitionMapWithIndex = exports.partitionMap = exports.partitionWithIndex = exports.partition = exports.filter = exports.separate = exports.compact = exports.filterMap = exports.filterMapWithIndex = exports.mapWithIndex = exports.flatten = exports.flatMap = exports.ap = exports.map = exports.zero = exports.of = exports.concat = exports.concatW = exports.fromOptionK = exports.chunksOf = exports.splitAt = exports.chop = exports.sortBy = exports.uniq = exports.elem = void 0;
  exports.cons = exports.empty = exports.range = exports.chain = exports.apS = exports.bind = exports.let = exports.bindTo = exports.Do = exports.intercalate = exports.exists = exports.some = exports.every = exports.unsafeDeleteAt = exports.unsafeUpdateAt = exports.unsafeInsertAt = exports.fromEitherK = exports.FromEither = exports.filterE = exports.ChainRecBreadthFirst = exports.chainRecBreadthFirst = exports.ChainRecDepthFirst = exports.chainRecDepthFirst = exports.Witherable = exports.TraversableWithIndex = exports.Traversable = exports.FoldableWithIndex = exports.Foldable = exports.FilterableWithIndex = exports.Filterable = exports.Compactable = exports.Extend = exports.Alternative = exports.guard = exports.Zero = exports.Alt = exports.Unfoldable = exports.Monad = exports.chainFirst = exports.Chain = exports.Applicative = exports.apSecond = exports.apFirst = exports.Apply = exports.FunctorWithIndex = exports.Pointed = exports.flap = exports.Functor = exports.getDifferenceMagma = exports.getIntersectionSemigroup = void 0;
  exports.array = exports.prependToAll = exports.snoc = void 0;
  exports.fromPredicate = fromPredicate2;
  exports.takeLeftWhile = takeLeftWhile;
  exports.spanLeft = spanLeft;
  exports.dropLeftWhile = dropLeftWhile;
  exports.findFirst = findFirst;
  exports.findLast = findLast;
  exports.zip = zip;
  exports.comprehension = comprehension;
  exports.union = union;
  exports.intersection = intersection;
  exports.difference = difference;
  var Apply_12 = Apply;
  var Chain_12 = Chain;
  var FromEither_1 = FromEither;
  var function_12 = _function;
  var Functor_12 = Functor;
  var _2 = __importStar2(internal);
  var NEA = __importStar2(NonEmptyArray);
  var RA = __importStar2(ReadonlyArray);
  var Separated_12 = Separated;
  var Witherable_1 = Witherable;
  var Zero_1 = Zero;
  var isEmpty = function(as2) {
    return as2.length === 0;
  };
  exports.isEmpty = isEmpty;
  exports.isNonEmpty = NEA.isNonEmpty;
  exports.prepend = NEA.prepend;
  exports.prependW = NEA.prependW;
  exports.append = NEA.append;
  exports.appendW = NEA.appendW;
  var makeBy = function(n, f) {
    return n <= 0 ? [] : NEA.makeBy(f)(n);
  };
  exports.makeBy = makeBy;
  var replicate = function(n, a) {
    return (0, exports.makeBy)(n, function() {
      return a;
    });
  };
  exports.replicate = replicate;
  function fromPredicate2(predicate) {
    return function(a) {
      return predicate(a) ? [a] : [];
    };
  }
  var fromOption2 = function(ma) {
    return _2.isNone(ma) ? [] : [ma.value];
  };
  exports.fromOption = fromOption2;
  var fromEither = function(e) {
    return _2.isLeft(e) ? [] : [e.right];
  };
  exports.fromEither = fromEither;
  var matchW = function(onEmpty, onNonEmpty) {
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? onNonEmpty(as2) : onEmpty();
    };
  };
  exports.matchW = matchW;
  exports.match = exports.matchW;
  var matchLeftW = function(onEmpty, onNonEmpty) {
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? onNonEmpty(NEA.head(as2), NEA.tail(as2)) : onEmpty();
    };
  };
  exports.matchLeftW = matchLeftW;
  exports.matchLeft = exports.matchLeftW;
  exports.foldLeft = exports.matchLeft;
  var matchRightW = function(onEmpty, onNonEmpty) {
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? onNonEmpty(NEA.init(as2), NEA.last(as2)) : onEmpty();
    };
  };
  exports.matchRightW = matchRightW;
  exports.matchRight = exports.matchRightW;
  exports.foldRight = exports.matchRight;
  var chainWithIndex = function(f) {
    return function(as2) {
      var out = [];
      for (var i = 0; i < as2.length; i++) {
        var bs = f(i, as2[i]);
        for (var j = 0; j < bs.length; j++) {
          out.push(bs[j]);
        }
      }
      return out;
    };
  };
  exports.chainWithIndex = chainWithIndex;
  var scanLeft = function(b, f) {
    return function(as2) {
      var len = as2.length;
      var out = new Array(len + 1);
      out[0] = b;
      for (var i = 0; i < len; i++) {
        out[i + 1] = f(out[i], as2[i]);
      }
      return out;
    };
  };
  exports.scanLeft = scanLeft;
  var scanRight = function(b, f) {
    return function(as2) {
      var len = as2.length;
      var out = new Array(len + 1);
      out[len] = b;
      for (var i = len - 1; i >= 0; i--) {
        out[i] = f(as2[i], out[i + 1]);
      }
      return out;
    };
  };
  exports.scanRight = scanRight;
  var size = function(as2) {
    return as2.length;
  };
  exports.size = size;
  exports.isOutOfBound = NEA.isOutOfBound;
  exports.lookup = RA.lookup;
  exports.head = RA.head;
  exports.last = RA.last;
  var tail = function(as2) {
    return (0, exports.isNonEmpty)(as2) ? _2.some(NEA.tail(as2)) : _2.none;
  };
  exports.tail = tail;
  var init2 = function(as2) {
    return (0, exports.isNonEmpty)(as2) ? _2.some(NEA.init(as2)) : _2.none;
  };
  exports.init = init2;
  var takeLeft = function(n) {
    return function(as2) {
      return (0, exports.isOutOfBound)(n, as2) ? (0, exports.copy)(as2) : as2.slice(0, n);
    };
  };
  exports.takeLeft = takeLeft;
  var takeRight = function(n) {
    return function(as2) {
      return (0, exports.isOutOfBound)(n, as2) ? (0, exports.copy)(as2) : n === 0 ? [] : as2.slice(-n);
    };
  };
  exports.takeRight = takeRight;
  function takeLeftWhile(predicate) {
    return function(as2) {
      var out = [];
      for (var _i = 0, as_1 = as2; _i < as_1.length; _i++) {
        var a = as_1[_i];
        if (!predicate(a)) {
          break;
        }
        out.push(a);
      }
      return out;
    };
  }
  var spanLeftIndex = function(as2, predicate) {
    var l = as2.length;
    var i = 0;
    for (; i < l; i++) {
      if (!predicate(as2[i])) {
        break;
      }
    }
    return i;
  };
  function spanLeft(predicate) {
    return function(as2) {
      var _a = (0, exports.splitAt)(spanLeftIndex(as2, predicate))(as2), init3 = _a[0], rest = _a[1];
      return { init: init3, rest };
    };
  }
  var dropLeft = function(n) {
    return function(as2) {
      return n <= 0 || (0, exports.isEmpty)(as2) ? (0, exports.copy)(as2) : n >= as2.length ? [] : as2.slice(n, as2.length);
    };
  };
  exports.dropLeft = dropLeft;
  var dropRight = function(n) {
    return function(as2) {
      return n <= 0 || (0, exports.isEmpty)(as2) ? (0, exports.copy)(as2) : n >= as2.length ? [] : as2.slice(0, as2.length - n);
    };
  };
  exports.dropRight = dropRight;
  function dropLeftWhile(predicate) {
    return function(as2) {
      return as2.slice(spanLeftIndex(as2, predicate));
    };
  }
  exports.findIndex = RA.findIndex;
  function findFirst(predicate) {
    return RA.findFirst(predicate);
  }
  exports.findFirstMap = RA.findFirstMap;
  function findLast(predicate) {
    return RA.findLast(predicate);
  }
  exports.findLastMap = RA.findLastMap;
  exports.findLastIndex = RA.findLastIndex;
  var copy = function(as2) {
    return as2.slice();
  };
  exports.copy = copy;
  var insertAt = function(i, a) {
    return function(as2) {
      return i < 0 || i > as2.length ? _2.none : _2.some((0, exports.unsafeInsertAt)(i, a, as2));
    };
  };
  exports.insertAt = insertAt;
  var updateAt = function(i, a) {
    return (0, exports.modifyAt)(i, function() {
      return a;
    });
  };
  exports.updateAt = updateAt;
  var deleteAt = function(i) {
    return function(as2) {
      return (0, exports.isOutOfBound)(i, as2) ? _2.none : _2.some((0, exports.unsafeDeleteAt)(i, as2));
    };
  };
  exports.deleteAt = deleteAt;
  var modifyAt = function(i, f) {
    return function(as2) {
      return (0, exports.isOutOfBound)(i, as2) ? _2.none : _2.some((0, exports.unsafeUpdateAt)(i, f(as2[i]), as2));
    };
  };
  exports.modifyAt = modifyAt;
  var reverse2 = function(as2) {
    return (0, exports.isEmpty)(as2) ? [] : as2.slice().reverse();
  };
  exports.reverse = reverse2;
  var rights = function(as2) {
    var r = [];
    for (var i = 0; i < as2.length; i++) {
      var a = as2[i];
      if (a._tag === "Right") {
        r.push(a.right);
      }
    }
    return r;
  };
  exports.rights = rights;
  var lefts = function(as2) {
    var r = [];
    for (var i = 0; i < as2.length; i++) {
      var a = as2[i];
      if (a._tag === "Left") {
        r.push(a.left);
      }
    }
    return r;
  };
  exports.lefts = lefts;
  var sort = function(O) {
    return function(as2) {
      return as2.length <= 1 ? (0, exports.copy)(as2) : as2.slice().sort(O.compare);
    };
  };
  exports.sort = sort;
  var zipWith = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for (var i = 0; i < len; i++) {
      fc[i] = f(fa[i], fb[i]);
    }
    return fc;
  };
  exports.zipWith = zipWith;
  function zip(as2, bs) {
    if (bs === void 0) {
      return function(bs2) {
        return zip(bs2, as2);
      };
    }
    return (0, exports.zipWith)(as2, bs, function(a, b) {
      return [a, b];
    });
  }
  var unzip = function(as2) {
    var fa = [];
    var fb = [];
    for (var i = 0; i < as2.length; i++) {
      fa[i] = as2[i][0];
      fb[i] = as2[i][1];
    }
    return [fa, fb];
  };
  exports.unzip = unzip;
  var prependAll = function(middle) {
    var f = NEA.prependAll(middle);
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? f(as2) : [];
    };
  };
  exports.prependAll = prependAll;
  var intersperse = function(middle) {
    var f = NEA.intersperse(middle);
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? f(as2) : (0, exports.copy)(as2);
    };
  };
  exports.intersperse = intersperse;
  var rotate = function(n) {
    var f = NEA.rotate(n);
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? f(as2) : (0, exports.copy)(as2);
    };
  };
  exports.rotate = rotate;
  exports.elem = RA.elem;
  var uniq = function(E2) {
    var f = NEA.uniq(E2);
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? f(as2) : (0, exports.copy)(as2);
    };
  };
  exports.uniq = uniq;
  var sortBy = function(ords) {
    var f = NEA.sortBy(ords);
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? f(as2) : (0, exports.copy)(as2);
    };
  };
  exports.sortBy = sortBy;
  var chop = function(f) {
    var g = NEA.chop(f);
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? g(as2) : [];
    };
  };
  exports.chop = chop;
  var splitAt = function(n) {
    return function(as2) {
      return n >= 1 && (0, exports.isNonEmpty)(as2) ? NEA.splitAt(n)(as2) : (0, exports.isEmpty)(as2) ? [(0, exports.copy)(as2), []] : [[], (0, exports.copy)(as2)];
    };
  };
  exports.splitAt = splitAt;
  var chunksOf = function(n) {
    var f = NEA.chunksOf(n);
    return function(as2) {
      return (0, exports.isNonEmpty)(as2) ? f(as2) : [];
    };
  };
  exports.chunksOf = chunksOf;
  var fromOptionK2 = function(f) {
    return function() {
      var a = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        a[_i] = arguments[_i];
      }
      return (0, exports.fromOption)(f.apply(void 0, a));
    };
  };
  exports.fromOptionK = fromOptionK2;
  function comprehension(input, f, g) {
    if (g === void 0) {
      g = function() {
        return true;
      };
    }
    var go = function(scope, input2) {
      return (0, exports.isNonEmpty)(input2) ? (0, exports.flatMap)(NEA.head(input2), function(a) {
        return go((0, function_12.pipe)(scope, (0, exports.append)(a)), NEA.tail(input2));
      }) : g.apply(void 0, scope) ? [f.apply(void 0, scope)] : [];
    };
    return go([], input);
  }
  var concatW = function(second) {
    return function(first) {
      return (0, exports.isEmpty)(first) ? (0, exports.copy)(second) : (0, exports.isEmpty)(second) ? (0, exports.copy)(first) : first.concat(second);
    };
  };
  exports.concatW = concatW;
  exports.concat = exports.concatW;
  function union(E2) {
    var unionE = NEA.union(E2);
    return function(first, second) {
      if (second === void 0) {
        var unionE_1 = union(E2);
        return function(second2) {
          return unionE_1(second2, first);
        };
      }
      return (0, exports.isNonEmpty)(first) && (0, exports.isNonEmpty)(second) ? unionE(second)(first) : (0, exports.isNonEmpty)(first) ? (0, exports.copy)(first) : (0, exports.copy)(second);
    };
  }
  function intersection(E2) {
    var elemE = (0, exports.elem)(E2);
    return function(xs, ys) {
      if (ys === void 0) {
        var intersectionE_1 = intersection(E2);
        return function(ys2) {
          return intersectionE_1(ys2, xs);
        };
      }
      return xs.filter(function(a) {
        return elemE(a, ys);
      });
    };
  }
  function difference(E2) {
    var elemE = (0, exports.elem)(E2);
    return function(xs, ys) {
      if (ys === void 0) {
        var differenceE_1 = difference(E2);
        return function(ys2) {
          return differenceE_1(ys2, xs);
        };
      }
      return xs.filter(function(a) {
        return !elemE(a, ys);
      });
    };
  }
  var _map = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.map)(f));
  };
  var _mapWithIndex = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.mapWithIndex)(f));
  };
  var _ap = function(fab, fa) {
    return (0, function_12.pipe)(fab, (0, exports.ap)(fa));
  };
  var _filter = function(fa, predicate) {
    return (0, function_12.pipe)(fa, (0, exports.filter)(predicate));
  };
  var _filterMap = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.filterMap)(f));
  };
  var _partition = function(fa, predicate) {
    return (0, function_12.pipe)(fa, (0, exports.partition)(predicate));
  };
  var _partitionMap = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.partitionMap)(f));
  };
  var _partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, function_12.pipe)(fa, (0, exports.partitionWithIndex)(predicateWithIndex));
  };
  var _partitionMapWithIndex = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.partitionMapWithIndex)(f));
  };
  var _alt = function(fa, that) {
    return (0, function_12.pipe)(fa, (0, exports.alt)(that));
  };
  var _reduce = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduce)(b, f));
  };
  var _foldMap = function(M) {
    var foldMapM = (0, exports.foldMap)(M);
    return function(fa, f) {
      return (0, function_12.pipe)(fa, foldMapM(f));
    };
  };
  var _reduceRight = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduceRight)(b, f));
  };
  var _reduceWithIndex = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduceWithIndex)(b, f));
  };
  var _foldMapWithIndex = function(M) {
    var foldMapWithIndexM = (0, exports.foldMapWithIndex)(M);
    return function(fa, f) {
      return (0, function_12.pipe)(fa, foldMapWithIndexM(f));
    };
  };
  var _reduceRightWithIndex = function(fa, b, f) {
    return (0, function_12.pipe)(fa, (0, exports.reduceRightWithIndex)(b, f));
  };
  var _filterMapWithIndex = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.filterMapWithIndex)(f));
  };
  var _filterWithIndex = function(fa, predicateWithIndex) {
    return (0, function_12.pipe)(fa, (0, exports.filterWithIndex)(predicateWithIndex));
  };
  var _extend = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.extend)(f));
  };
  var _traverse = function(F) {
    var traverseF = (0, exports.traverse)(F);
    return function(ta, f) {
      return (0, function_12.pipe)(ta, traverseF(f));
    };
  };
  var _traverseWithIndex = function(F) {
    var traverseWithIndexF = (0, exports.traverseWithIndex)(F);
    return function(ta, f) {
      return (0, function_12.pipe)(ta, traverseWithIndexF(f));
    };
  };
  var _chainRecDepthFirst = RA._chainRecDepthFirst;
  var _chainRecBreadthFirst = RA._chainRecBreadthFirst;
  exports.of = NEA.of;
  var zero = function() {
    return [];
  };
  exports.zero = zero;
  var map2 = function(f) {
    return function(fa) {
      return fa.map(function(a) {
        return f(a);
      });
    };
  };
  exports.map = map2;
  var ap2 = function(fa) {
    return (0, exports.flatMap)(function(f) {
      return (0, function_12.pipe)(fa, (0, exports.map)(f));
    });
  };
  exports.ap = ap2;
  exports.flatMap = (0, function_12.dual)(2, function(ma, f) {
    return (0, function_12.pipe)(ma, (0, exports.chainWithIndex)(function(i, a) {
      return f(a, i);
    }));
  });
  exports.flatten = (0, exports.flatMap)(function_12.identity);
  var mapWithIndex = function(f) {
    return function(fa) {
      return fa.map(function(a, i) {
        return f(i, a);
      });
    };
  };
  exports.mapWithIndex = mapWithIndex;
  var filterMapWithIndex = function(f) {
    return function(fa) {
      var out = [];
      for (var i = 0; i < fa.length; i++) {
        var optionB = f(i, fa[i]);
        if (_2.isSome(optionB)) {
          out.push(optionB.value);
        }
      }
      return out;
    };
  };
  exports.filterMapWithIndex = filterMapWithIndex;
  var filterMap2 = function(f) {
    return (0, exports.filterMapWithIndex)(function(_3, a) {
      return f(a);
    });
  };
  exports.filterMap = filterMap2;
  exports.compact = (0, exports.filterMap)(function_12.identity);
  var separate2 = function(fa) {
    var left2 = [];
    var right2 = [];
    for (var _i = 0, fa_1 = fa; _i < fa_1.length; _i++) {
      var e = fa_1[_i];
      if (e._tag === "Left") {
        left2.push(e.left);
      } else {
        right2.push(e.right);
      }
    }
    return (0, Separated_12.separated)(left2, right2);
  };
  exports.separate = separate2;
  var filter3 = function(predicate) {
    return function(as2) {
      return as2.filter(predicate);
    };
  };
  exports.filter = filter3;
  var partition2 = function(predicate) {
    return (0, exports.partitionWithIndex)(function(_3, a) {
      return predicate(a);
    });
  };
  exports.partition = partition2;
  var partitionWithIndex = function(predicateWithIndex) {
    return function(as2) {
      var left2 = [];
      var right2 = [];
      for (var i = 0; i < as2.length; i++) {
        var b = as2[i];
        if (predicateWithIndex(i, b)) {
          right2.push(b);
        } else {
          left2.push(b);
        }
      }
      return (0, Separated_12.separated)(left2, right2);
    };
  };
  exports.partitionWithIndex = partitionWithIndex;
  var partitionMap2 = function(f) {
    return (0, exports.partitionMapWithIndex)(function(_3, a) {
      return f(a);
    });
  };
  exports.partitionMap = partitionMap2;
  var partitionMapWithIndex = function(f) {
    return function(fa) {
      var left2 = [];
      var right2 = [];
      for (var i = 0; i < fa.length; i++) {
        var e = f(i, fa[i]);
        if (e._tag === "Left") {
          left2.push(e.left);
        } else {
          right2.push(e.right);
        }
      }
      return (0, Separated_12.separated)(left2, right2);
    };
  };
  exports.partitionMapWithIndex = partitionMapWithIndex;
  var altW = function(that) {
    return function(fa) {
      return fa.concat(that());
    };
  };
  exports.altW = altW;
  exports.alt = exports.altW;
  var filterWithIndex = function(predicateWithIndex) {
    return function(as2) {
      return as2.filter(function(b, i) {
        return predicateWithIndex(i, b);
      });
    };
  };
  exports.filterWithIndex = filterWithIndex;
  var extend2 = function(f) {
    return function(wa) {
      return wa.map(function(_3, i) {
        return f(wa.slice(i));
      });
    };
  };
  exports.extend = extend2;
  exports.duplicate = (0, exports.extend)(function_12.identity);
  exports.foldMap = RA.foldMap;
  exports.foldMapWithIndex = RA.foldMapWithIndex;
  exports.reduce = RA.reduce;
  exports.reduceWithIndex = RA.reduceWithIndex;
  exports.reduceRight = RA.reduceRight;
  exports.reduceRightWithIndex = RA.reduceRightWithIndex;
  var traverse = function(F) {
    var traverseWithIndexF = (0, exports.traverseWithIndex)(F);
    return function(f) {
      return traverseWithIndexF(function(_3, a) {
        return f(a);
      });
    };
  };
  exports.traverse = traverse;
  var sequence = function(F) {
    return function(ta) {
      return _reduce(ta, F.of((0, exports.zero)()), function(fas, fa) {
        return F.ap(F.map(fas, function(as2) {
          return function(a) {
            return (0, function_12.pipe)(as2, (0, exports.append)(a));
          };
        }), fa);
      });
    };
  };
  exports.sequence = sequence;
  var traverseWithIndex = function(F) {
    return function(f) {
      return (0, exports.reduceWithIndex)(F.of((0, exports.zero)()), function(i, fbs, a) {
        return F.ap(F.map(fbs, function(bs) {
          return function(b) {
            return (0, function_12.pipe)(bs, (0, exports.append)(b));
          };
        }), f(i, a));
      });
    };
  };
  exports.traverseWithIndex = traverseWithIndex;
  var wither = function(F) {
    var _witherF = _wither(F);
    return function(f) {
      return function(fa) {
        return _witherF(fa, f);
      };
    };
  };
  exports.wither = wither;
  var wilt = function(F) {
    var _wiltF = _wilt(F);
    return function(f) {
      return function(fa) {
        return _wiltF(fa, f);
      };
    };
  };
  exports.wilt = wilt;
  var unfold = function(b, f) {
    var out = [];
    var bb = b;
    while (true) {
      var mt = f(bb);
      if (_2.isSome(mt)) {
        var _a = mt.value, a = _a[0], b_1 = _a[1];
        out.push(a);
        bb = b_1;
      } else {
        break;
      }
    }
    return out;
  };
  exports.unfold = unfold;
  exports.URI = "Array";
  exports.getShow = RA.getShow;
  var getSemigroup = function() {
    return {
      concat: function(first, second) {
        return first.concat(second);
      }
    };
  };
  exports.getSemigroup = getSemigroup;
  var getMonoid = function() {
    return {
      concat: (0, exports.getSemigroup)().concat,
      empty: []
    };
  };
  exports.getMonoid = getMonoid;
  exports.getEq = RA.getEq;
  exports.getOrd = RA.getOrd;
  var getUnionSemigroup = function(E2) {
    var unionE = union(E2);
    return {
      concat: function(first, second) {
        return unionE(second)(first);
      }
    };
  };
  exports.getUnionSemigroup = getUnionSemigroup;
  var getUnionMonoid = function(E2) {
    return {
      concat: (0, exports.getUnionSemigroup)(E2).concat,
      empty: []
    };
  };
  exports.getUnionMonoid = getUnionMonoid;
  var getIntersectionSemigroup = function(E2) {
    var intersectionE = intersection(E2);
    return {
      concat: function(first, second) {
        return intersectionE(second)(first);
      }
    };
  };
  exports.getIntersectionSemigroup = getIntersectionSemigroup;
  var getDifferenceMagma = function(E2) {
    var differenceE = difference(E2);
    return {
      concat: function(first, second) {
        return differenceE(second)(first);
      }
    };
  };
  exports.getDifferenceMagma = getDifferenceMagma;
  exports.Functor = {
    URI: exports.URI,
    map: _map
  };
  exports.flap = (0, Functor_12.flap)(exports.Functor);
  exports.Pointed = {
    URI: exports.URI,
    of: exports.of
  };
  exports.FunctorWithIndex = {
    URI: exports.URI,
    map: _map,
    mapWithIndex: _mapWithIndex
  };
  exports.Apply = {
    URI: exports.URI,
    map: _map,
    ap: _ap
  };
  exports.apFirst = (0, Apply_12.apFirst)(exports.Apply);
  exports.apSecond = (0, Apply_12.apSecond)(exports.Apply);
  exports.Applicative = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of
  };
  exports.Chain = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    chain: exports.flatMap
  };
  exports.chainFirst = /* @__PURE__ */ (0, Chain_12.chainFirst)(exports.Chain);
  exports.Monad = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of,
    chain: exports.flatMap
  };
  exports.Unfoldable = {
    URI: exports.URI,
    unfold: exports.unfold
  };
  exports.Alt = {
    URI: exports.URI,
    map: _map,
    alt: _alt
  };
  exports.Zero = {
    URI: exports.URI,
    zero: exports.zero
  };
  exports.guard = (0, Zero_1.guard)(exports.Zero, exports.Pointed);
  exports.Alternative = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    of: exports.of,
    alt: _alt,
    zero: exports.zero
  };
  exports.Extend = {
    URI: exports.URI,
    map: _map,
    extend: _extend
  };
  exports.Compactable = {
    URI: exports.URI,
    compact: exports.compact,
    separate: exports.separate
  };
  exports.Filterable = {
    URI: exports.URI,
    map: _map,
    compact: exports.compact,
    separate: exports.separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap
  };
  exports.FilterableWithIndex = {
    URI: exports.URI,
    map: _map,
    mapWithIndex: _mapWithIndex,
    compact: exports.compact,
    separate: exports.separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap,
    partitionMapWithIndex: _partitionMapWithIndex,
    partitionWithIndex: _partitionWithIndex,
    filterMapWithIndex: _filterMapWithIndex,
    filterWithIndex: _filterWithIndex
  };
  exports.Foldable = {
    URI: exports.URI,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight
  };
  exports.FoldableWithIndex = {
    URI: exports.URI,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    reduceWithIndex: _reduceWithIndex,
    foldMapWithIndex: _foldMapWithIndex,
    reduceRightWithIndex: _reduceRightWithIndex
  };
  exports.Traversable = {
    URI: exports.URI,
    map: _map,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence
  };
  exports.TraversableWithIndex = {
    URI: exports.URI,
    map: _map,
    mapWithIndex: _mapWithIndex,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    reduceWithIndex: _reduceWithIndex,
    foldMapWithIndex: _foldMapWithIndex,
    reduceRightWithIndex: _reduceRightWithIndex,
    traverse: _traverse,
    sequence: exports.sequence,
    traverseWithIndex: _traverseWithIndex
  };
  var _wither = /* @__PURE__ */ (0, Witherable_1.witherDefault)(exports.Traversable, exports.Compactable);
  var _wilt = /* @__PURE__ */ (0, Witherable_1.wiltDefault)(exports.Traversable, exports.Compactable);
  exports.Witherable = {
    URI: exports.URI,
    map: _map,
    compact: exports.compact,
    separate: exports.separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence,
    wither: _wither,
    wilt: _wilt
  };
  exports.chainRecDepthFirst = RA.chainRecDepthFirst;
  exports.ChainRecDepthFirst = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    chain: exports.flatMap,
    chainRec: _chainRecDepthFirst
  };
  exports.chainRecBreadthFirst = RA.chainRecBreadthFirst;
  exports.ChainRecBreadthFirst = {
    URI: exports.URI,
    map: _map,
    ap: _ap,
    chain: exports.flatMap,
    chainRec: _chainRecBreadthFirst
  };
  exports.filterE = (0, Witherable_1.filterE)(exports.Witherable);
  exports.FromEither = {
    URI: exports.URI,
    fromEither: exports.fromEither
  };
  exports.fromEitherK = (0, FromEither_1.fromEitherK)(exports.FromEither);
  exports.unsafeInsertAt = NEA.unsafeInsertAt;
  var unsafeUpdateAt = function(i, a, as2) {
    return (0, exports.isNonEmpty)(as2) ? NEA.unsafeUpdateAt(i, a, as2) : [];
  };
  exports.unsafeUpdateAt = unsafeUpdateAt;
  var unsafeDeleteAt = function(i, as2) {
    var xs = as2.slice();
    xs.splice(i, 1);
    return xs;
  };
  exports.unsafeDeleteAt = unsafeDeleteAt;
  exports.every = RA.every;
  var some2 = function(predicate) {
    return function(as2) {
      return as2.some(predicate);
    };
  };
  exports.some = some2;
  exports.exists = exports.some;
  exports.intercalate = RA.intercalate;
  exports.Do = (0, exports.of)(_2.emptyRecord);
  exports.bindTo = (0, Functor_12.bindTo)(exports.Functor);
  var let_2 = /* @__PURE__ */ (0, Functor_12.let)(exports.Functor);
  exports.let = let_2;
  exports.bind = (0, Chain_12.bind)(exports.Chain);
  exports.apS = (0, Apply_12.apS)(exports.Apply);
  exports.chain = exports.flatMap;
  exports.range = NEA.range;
  exports.empty = [];
  exports.cons = NEA.cons;
  exports.snoc = NEA.snoc;
  exports.prependToAll = exports.prependAll;
  exports.array = {
    URI: exports.URI,
    compact: exports.compact,
    separate: exports.separate,
    map: _map,
    ap: _ap,
    of: exports.of,
    chain: exports.flatMap,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap,
    mapWithIndex: _mapWithIndex,
    partitionMapWithIndex: _partitionMapWithIndex,
    partitionWithIndex: _partitionWithIndex,
    filterMapWithIndex: _filterMapWithIndex,
    filterWithIndex: _filterWithIndex,
    alt: _alt,
    zero: exports.zero,
    unfold: exports.unfold,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: exports.sequence,
    reduceWithIndex: _reduceWithIndex,
    foldMapWithIndex: _foldMapWithIndex,
    reduceRightWithIndex: _reduceRightWithIndex,
    traverseWithIndex: _traverseWithIndex,
    extend: _extend,
    wither: _wither,
    wilt: _wilt
  };
})(_Array);
var ReadonlyRecord = {};
(function(exports) {
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule)
      return mod2;
    var result2 = {};
    if (mod2 != null) {
      for (var k in mod2)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
          __createBinding2(result2, mod2, k);
    }
    __setModuleDefault2(result2, mod2);
    return result2;
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.Compactable = exports.getFoldableWithIndex = exports.getFoldable = exports.FunctorWithIndex = exports.flap = exports.Functor = exports.URI = exports.separate = exports.compact = exports.partitionMap = exports.partition = exports.filterMap = exports.filter = exports._sequence = exports._traverse = exports._filterWithIndex = exports._filterMapWithIndex = exports._partitionWithIndex = exports._partitionMapWithIndex = exports._reduceRightWithIndex = exports._foldMapWithIndex = exports._reduceWithIndex = exports._partitionMap = exports._partition = exports._filterMap = exports._filter = exports._reduceRight = exports._foldMap = exports._reduce = exports._mapWithIndex = exports._map = exports.difference = exports.intersection = exports.union = exports.fromEntries = exports.toEntries = exports.wilt = exports.wither = exports.singleton = exports.empty = exports.modifyAt = exports.updateAt = exports.has = exports.upsertAt = exports.toReadonlyArray = exports.keys = exports.isEmpty = exports.size = exports.toRecord = exports.fromRecord = void 0;
  exports.readonlyRecord = exports.insertAt = exports.Witherable = exports.TraversableWithIndex = exports.Traversable = exports.FoldableWithIndex = exports.Foldable = exports.getDifferenceMagma = exports.getIntersectionSemigroup = exports.getUnionMonoid = exports.getUnionSemigroup = exports.getWitherable = exports.getTraversableWithIndex = exports.getTraversable = exports.FilterableWithIndex = exports.Filterable = void 0;
  exports.collect = collect;
  exports.toUnfoldable = toUnfoldable;
  exports.deleteAt = deleteAt;
  exports.pop = pop;
  exports.isSubrecord = isSubrecord;
  exports.lookup = lookup;
  exports.mapWithIndex = mapWithIndex;
  exports.map = map2;
  exports.reduceWithIndex = reduceWithIndex;
  exports.foldMapWithIndex = foldMapWithIndex;
  exports.reduceRightWithIndex = reduceRightWithIndex;
  exports.traverseWithIndex = traverseWithIndex;
  exports.traverse = traverse;
  exports.sequence = sequence;
  exports.partitionMapWithIndex = partitionMapWithIndex;
  exports.partitionWithIndex = partitionWithIndex;
  exports.filterMapWithIndex = filterMapWithIndex;
  exports.filterWithIndex = filterWithIndex;
  exports.fromFoldable = fromFoldable;
  exports.fromFoldableMap = fromFoldableMap;
  exports.every = every;
  exports.some = some2;
  exports.elem = elem;
  exports.reduce = reduce;
  exports.foldMap = foldMap;
  exports.reduceRight = reduceRight;
  exports.getShow = getShow;
  exports.getEq = getEq;
  exports.getMonoid = getMonoid;
  exports.hasOwnProperty = hasOwnProperty2;
  var Eq_1 = Eq;
  var function_12 = _function;
  var Functor_12 = Functor;
  var _2 = __importStar2(internal);
  var Separated_12 = Separated;
  var S2 = __importStar2(string);
  var Witherable_1 = Witherable;
  var fromRecord = function(r) {
    return Object.assign({}, r);
  };
  exports.fromRecord = fromRecord;
  var toRecord = function(r) {
    return Object.assign({}, r);
  };
  exports.toRecord = toRecord;
  var size = function(r) {
    return Object.keys(r).length;
  };
  exports.size = size;
  var isEmpty = function(r) {
    for (var k in r) {
      if (_2.has.call(r, k)) {
        return false;
      }
    }
    return true;
  };
  exports.isEmpty = isEmpty;
  var keys_ = function(O) {
    return function(r) {
      return Object.keys(r).sort(O.compare);
    };
  };
  exports.keys = keys_(S2.Ord);
  function collect(O) {
    if (typeof O === "function") {
      return collect(S2.Ord)(O);
    }
    var keysO = keys_(O);
    return function(f) {
      return function(r) {
        var out = [];
        for (var _i = 0, _a = keysO(r); _i < _a.length; _i++) {
          var key = _a[_i];
          out.push(f(key, r[key]));
        }
        return out;
      };
    };
  }
  exports.toReadonlyArray = /* @__PURE__ */ collect(S2.Ord)(function(k, a) {
    return [k, a];
  });
  function toUnfoldable(U) {
    return function(r) {
      var sas = (0, exports.toReadonlyArray)(r);
      var len = sas.length;
      return U.unfold(0, function(b) {
        return b < len ? _2.some([sas[b], b + 1]) : _2.none;
      });
    };
  }
  var upsertAt = function(k, a) {
    return function(r) {
      if (_2.has.call(r, k) && r[k] === a) {
        return r;
      }
      var out = Object.assign({}, r);
      out[k] = a;
      return out;
    };
  };
  exports.upsertAt = upsertAt;
  var has = function(k, r) {
    return _2.has.call(r, k);
  };
  exports.has = has;
  function deleteAt(k) {
    return function(r) {
      if (!_2.has.call(r, k)) {
        return r;
      }
      var out = Object.assign({}, r);
      delete out[k];
      return out;
    };
  }
  var updateAt = function(k, a) {
    return function(r) {
      if (!(0, exports.has)(k, r)) {
        return _2.none;
      }
      if (r[k] === a) {
        return _2.some(r);
      }
      var out = Object.assign({}, r);
      out[k] = a;
      return _2.some(out);
    };
  };
  exports.updateAt = updateAt;
  var modifyAt = function(k, f) {
    return function(r) {
      if (!(0, exports.has)(k, r)) {
        return _2.none;
      }
      var next = f(r[k]);
      if (next === r[k]) {
        return _2.some(r);
      }
      var out = Object.assign({}, r);
      out[k] = next;
      return _2.some(out);
    };
  };
  exports.modifyAt = modifyAt;
  function pop(k) {
    var deleteAtk = deleteAt(k);
    return function(r) {
      var oa = lookup(k, r);
      return _2.isNone(oa) ? _2.none : _2.some([oa.value, deleteAtk(r)]);
    };
  }
  function isSubrecord(E2) {
    return function(me, that) {
      if (that === void 0) {
        var isSubrecordE_1 = isSubrecord(E2);
        return function(that2) {
          return isSubrecordE_1(that2, me);
        };
      }
      for (var k in me) {
        if (!_2.has.call(that, k) || !E2.equals(me[k], that[k])) {
          return false;
        }
      }
      return true;
    };
  }
  function lookup(k, r) {
    if (r === void 0) {
      return function(r2) {
        return lookup(k, r2);
      };
    }
    return _2.has.call(r, k) ? _2.some(r[k]) : _2.none;
  }
  exports.empty = {};
  function mapWithIndex(f) {
    return function(r) {
      var out = {};
      for (var k in r) {
        if (_2.has.call(r, k)) {
          out[k] = f(k, r[k]);
        }
      }
      return out;
    };
  }
  function map2(f) {
    return mapWithIndex(function(_3, a) {
      return f(a);
    });
  }
  function reduceWithIndex() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (args.length === 2) {
      return reduceWithIndex(S2.Ord).apply(void 0, args);
    }
    var keysO = keys_(args[0]);
    return function(b, f) {
      return function(fa) {
        var out = b;
        var ks = keysO(fa);
        var len = ks.length;
        for (var i = 0; i < len; i++) {
          var k = ks[i];
          out = f(k, out, fa[k]);
        }
        return out;
      };
    };
  }
  function foldMapWithIndex(O) {
    if ("compare" in O) {
      var keysO_1 = keys_(O);
      return function(M) {
        return function(f) {
          return function(fa) {
            var out = M.empty;
            var ks = keysO_1(fa);
            var len = ks.length;
            for (var i = 0; i < len; i++) {
              var k = ks[i];
              out = M.concat(out, f(k, fa[k]));
            }
            return out;
          };
        };
      };
    }
    return foldMapWithIndex(S2.Ord)(O);
  }
  function reduceRightWithIndex() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (args.length === 2) {
      return reduceRightWithIndex(S2.Ord).apply(void 0, args);
    }
    var keysO = keys_(args[0]);
    return function(b, f) {
      return function(fa) {
        var out = b;
        var ks = keysO(fa);
        var len = ks.length;
        for (var i = len - 1; i >= 0; i--) {
          var k = ks[i];
          out = f(k, fa[k], out);
        }
        return out;
      };
    };
  }
  var singleton = function(k, a) {
    var _a;
    return _a = {}, _a[k] = a, _a;
  };
  exports.singleton = singleton;
  function traverseWithIndex(F) {
    var traverseWithIndexOF = _traverseWithIndex(S2.Ord)(F);
    return function(f) {
      return function(ta) {
        return traverseWithIndexOF(ta, f);
      };
    };
  }
  function traverse(F) {
    var traverseOF = (0, exports._traverse)(S2.Ord)(F);
    return function(f) {
      return function(ta) {
        return traverseOF(ta, f);
      };
    };
  }
  function sequence(F) {
    return (0, exports._sequence)(S2.Ord)(F);
  }
  var wither = function(F) {
    var traverseF = traverse(F);
    return function(f) {
      return function(fa) {
        return F.map((0, function_12.pipe)(fa, traverseF(f)), exports.compact);
      };
    };
  };
  exports.wither = wither;
  var wilt = function(F) {
    var traverseF = traverse(F);
    return function(f) {
      return function(fa) {
        return F.map((0, function_12.pipe)(fa, traverseF(f)), exports.separate);
      };
    };
  };
  exports.wilt = wilt;
  function partitionMapWithIndex(f) {
    return function(r) {
      var left2 = {};
      var right2 = {};
      for (var k in r) {
        if (_2.has.call(r, k)) {
          var e = f(k, r[k]);
          switch (e._tag) {
            case "Left":
              left2[k] = e.left;
              break;
            case "Right":
              right2[k] = e.right;
              break;
          }
        }
      }
      return (0, Separated_12.separated)(left2, right2);
    };
  }
  function partitionWithIndex(predicateWithIndex) {
    return function(r) {
      var left2 = {};
      var right2 = {};
      for (var k in r) {
        if (_2.has.call(r, k)) {
          var a = r[k];
          if (predicateWithIndex(k, a)) {
            right2[k] = a;
          } else {
            left2[k] = a;
          }
        }
      }
      return (0, Separated_12.separated)(left2, right2);
    };
  }
  function filterMapWithIndex(f) {
    return function(r) {
      var out = {};
      for (var k in r) {
        if (_2.has.call(r, k)) {
          var ob = f(k, r[k]);
          if (_2.isSome(ob)) {
            out[k] = ob.value;
          }
        }
      }
      return out;
    };
  }
  function filterWithIndex(predicateWithIndex) {
    return function(fa) {
      var out = {};
      var changed = false;
      for (var key in fa) {
        if (_2.has.call(fa, key)) {
          var a = fa[key];
          if (predicateWithIndex(key, a)) {
            out[key] = a;
          } else {
            changed = true;
          }
        }
      }
      return changed ? out : fa;
    };
  }
  function fromFoldable(M, F) {
    var fromFoldableMapM = fromFoldableMap(M, F);
    return function(fka) {
      return fromFoldableMapM(fka, function_12.identity);
    };
  }
  function fromFoldableMap(M, F) {
    return function(ta, f) {
      return F.reduce(ta, {}, function(r, a) {
        var _a = f(a), k = _a[0], b = _a[1];
        r[k] = _2.has.call(r, k) ? M.concat(r[k], b) : b;
        return r;
      });
    };
  }
  exports.toEntries = exports.toReadonlyArray;
  var fromEntries = function(fa) {
    var out = {};
    for (var _i = 0, fa_1 = fa; _i < fa_1.length; _i++) {
      var a = fa_1[_i];
      out[a[0]] = a[1];
    }
    return out;
  };
  exports.fromEntries = fromEntries;
  function every(predicate) {
    return function(r) {
      for (var k in r) {
        if (!predicate(r[k])) {
          return false;
        }
      }
      return true;
    };
  }
  function some2(predicate) {
    return function(r) {
      for (var k in r) {
        if (predicate(r[k])) {
          return true;
        }
      }
      return false;
    };
  }
  function elem(E2) {
    return function(a, fa) {
      if (fa === void 0) {
        var elemE_1 = elem(E2);
        return function(fa2) {
          return elemE_1(a, fa2);
        };
      }
      for (var k in fa) {
        if (E2.equals(fa[k], a)) {
          return true;
        }
      }
      return false;
    };
  }
  var union = function(M) {
    return function(second) {
      return function(first) {
        if ((0, exports.isEmpty)(first)) {
          return second;
        }
        if ((0, exports.isEmpty)(second)) {
          return first;
        }
        var out = {};
        for (var k in first) {
          if ((0, exports.has)(k, second)) {
            out[k] = M.concat(first[k], second[k]);
          } else {
            out[k] = first[k];
          }
        }
        for (var k in second) {
          if (!(0, exports.has)(k, out)) {
            out[k] = second[k];
          }
        }
        return out;
      };
    };
  };
  exports.union = union;
  var intersection = function(M) {
    return function(second) {
      return function(first) {
        if ((0, exports.isEmpty)(first) || (0, exports.isEmpty)(second)) {
          return exports.empty;
        }
        var out = {};
        for (var k in first) {
          if ((0, exports.has)(k, second)) {
            out[k] = M.concat(first[k], second[k]);
          }
        }
        return out;
      };
    };
  };
  exports.intersection = intersection;
  var difference = function(second) {
    return function(first) {
      if ((0, exports.isEmpty)(first)) {
        return second;
      }
      if ((0, exports.isEmpty)(second)) {
        return first;
      }
      var out = {};
      for (var k in first) {
        if (!(0, exports.has)(k, second)) {
          out[k] = first[k];
        }
      }
      for (var k in second) {
        if (!(0, exports.has)(k, first)) {
          out[k] = second[k];
        }
      }
      return out;
    };
  };
  exports.difference = difference;
  var _map = function(fa, f) {
    return (0, function_12.pipe)(fa, map2(f));
  };
  exports._map = _map;
  var _mapWithIndex = function(fa, f) {
    return (0, function_12.pipe)(fa, mapWithIndex(f));
  };
  exports._mapWithIndex = _mapWithIndex;
  var _reduce = function(O) {
    var reduceO = reduce(O);
    return function(fa, b, f) {
      return (0, function_12.pipe)(fa, reduceO(b, f));
    };
  };
  exports._reduce = _reduce;
  var _foldMap = function(O) {
    return function(M) {
      var foldMapM = foldMap(O)(M);
      return function(fa, f) {
        return (0, function_12.pipe)(fa, foldMapM(f));
      };
    };
  };
  exports._foldMap = _foldMap;
  var _reduceRight = function(O) {
    var reduceRightO = reduceRight(O);
    return function(fa, b, f) {
      return (0, function_12.pipe)(fa, reduceRightO(b, f));
    };
  };
  exports._reduceRight = _reduceRight;
  var _filter = function(fa, predicate) {
    return (0, function_12.pipe)(fa, (0, exports.filter)(predicate));
  };
  exports._filter = _filter;
  var _filterMap = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.filterMap)(f));
  };
  exports._filterMap = _filterMap;
  var _partition = function(fa, predicate) {
    return (0, function_12.pipe)(fa, (0, exports.partition)(predicate));
  };
  exports._partition = _partition;
  var _partitionMap = function(fa, f) {
    return (0, function_12.pipe)(fa, (0, exports.partitionMap)(f));
  };
  exports._partitionMap = _partitionMap;
  var _reduceWithIndex = function(O) {
    var reduceWithIndexO = reduceWithIndex(O);
    return function(fa, b, f) {
      return (0, function_12.pipe)(fa, reduceWithIndexO(b, f));
    };
  };
  exports._reduceWithIndex = _reduceWithIndex;
  var _foldMapWithIndex = function(O) {
    var foldMapWithIndexO = foldMapWithIndex(O);
    return function(M) {
      var foldMapWithIndexM = foldMapWithIndexO(M);
      return function(fa, f) {
        return (0, function_12.pipe)(fa, foldMapWithIndexM(f));
      };
    };
  };
  exports._foldMapWithIndex = _foldMapWithIndex;
  var _reduceRightWithIndex = function(O) {
    var reduceRightWithIndexO = reduceRightWithIndex(O);
    return function(fa, b, f) {
      return (0, function_12.pipe)(fa, reduceRightWithIndexO(b, f));
    };
  };
  exports._reduceRightWithIndex = _reduceRightWithIndex;
  var _partitionMapWithIndex = function(fa, f) {
    return (0, function_12.pipe)(fa, partitionMapWithIndex(f));
  };
  exports._partitionMapWithIndex = _partitionMapWithIndex;
  var _partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, function_12.pipe)(fa, partitionWithIndex(predicateWithIndex));
  };
  exports._partitionWithIndex = _partitionWithIndex;
  var _filterMapWithIndex = function(fa, f) {
    return (0, function_12.pipe)(fa, filterMapWithIndex(f));
  };
  exports._filterMapWithIndex = _filterMapWithIndex;
  var _filterWithIndex = function(fa, predicateWithIndex) {
    return (0, function_12.pipe)(fa, filterWithIndex(predicateWithIndex));
  };
  exports._filterWithIndex = _filterWithIndex;
  var _traverse = function(O) {
    var traverseWithIndexO = _traverseWithIndex(O);
    return function(F) {
      var traverseWithIndexOF = traverseWithIndexO(F);
      return function(ta, f) {
        return traverseWithIndexOF(ta, (0, function_12.flow)(function_12.SK, f));
      };
    };
  };
  exports._traverse = _traverse;
  var _sequence = function(O) {
    var traverseO = (0, exports._traverse)(O);
    return function(F) {
      var traverseOF = traverseO(F);
      return function(ta) {
        return traverseOF(ta, function_12.identity);
      };
    };
  };
  exports._sequence = _sequence;
  var _traverseWithIndex = function(O) {
    return function(F) {
      var keysO = keys_(O);
      return function(ta, f) {
        var ks = keysO(ta);
        if (ks.length === 0) {
          return F.of(exports.empty);
        }
        var fr = F.of({});
        var _loop_1 = function(key2) {
          fr = F.ap(F.map(fr, function(r) {
            return function(b) {
              var _a;
              return Object.assign({}, r, (_a = {}, _a[key2] = b, _a));
            };
          }), f(key2, ta[key2]));
        };
        for (var _i = 0, ks_1 = ks; _i < ks_1.length; _i++) {
          var key = ks_1[_i];
          _loop_1(key);
        }
        return fr;
      };
    };
  };
  var filter3 = function(predicate) {
    return filterWithIndex(function(_3, a) {
      return predicate(a);
    });
  };
  exports.filter = filter3;
  var filterMap2 = function(f) {
    return filterMapWithIndex(function(_3, a) {
      return f(a);
    });
  };
  exports.filterMap = filterMap2;
  var partition2 = function(predicate) {
    return partitionWithIndex(function(_3, a) {
      return predicate(a);
    });
  };
  exports.partition = partition2;
  var partitionMap2 = function(f) {
    return partitionMapWithIndex(function(_3, a) {
      return f(a);
    });
  };
  exports.partitionMap = partitionMap2;
  function reduce() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (args.length === 1) {
      var reduceWithIndexO_1 = reduceWithIndex(args[0]);
      return function(b, f) {
        return reduceWithIndexO_1(b, function(_3, b2, a) {
          return f(b2, a);
        });
      };
    }
    return reduce(S2.Ord).apply(void 0, args);
  }
  function foldMap(O) {
    if ("compare" in O) {
      var foldMapWithIndexO_1 = foldMapWithIndex(O);
      return function(M) {
        var foldMapWithIndexM = foldMapWithIndexO_1(M);
        return function(f) {
          return foldMapWithIndexM(function(_3, a) {
            return f(a);
          });
        };
      };
    }
    return foldMap(S2.Ord)(O);
  }
  function reduceRight() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (args.length === 1) {
      var reduceRightWithIndexO_1 = reduceRightWithIndex(args[0]);
      return function(b, f) {
        return reduceRightWithIndexO_1(b, function(_3, b2, a) {
          return f(b2, a);
        });
      };
    }
    return reduceRight(S2.Ord).apply(void 0, args);
  }
  var compact2 = function(r) {
    var out = {};
    for (var k in r) {
      if (_2.has.call(r, k)) {
        var oa = r[k];
        if (_2.isSome(oa)) {
          out[k] = oa.value;
        }
      }
    }
    return out;
  };
  exports.compact = compact2;
  var separate2 = function(r) {
    var left2 = {};
    var right2 = {};
    for (var k in r) {
      if (_2.has.call(r, k)) {
        var e = r[k];
        if (_2.isLeft(e)) {
          left2[k] = e.left;
        } else {
          right2[k] = e.right;
        }
      }
    }
    return (0, Separated_12.separated)(left2, right2);
  };
  exports.separate = separate2;
  exports.URI = "ReadonlyRecord";
  function getShow(O) {
    if ("compare" in O) {
      return function(S3) {
        return {
          show: function(r) {
            var elements = collect(O)(function(k, a) {
              return "".concat(JSON.stringify(k), ": ").concat(S3.show(a));
            })(r).join(", ");
            return elements === "" ? "{}" : "{ ".concat(elements, " }");
          }
        };
      };
    }
    return getShow(S2.Ord)(O);
  }
  function getEq(E2) {
    var isSubrecordE = isSubrecord(E2);
    return (0, Eq_1.fromEquals)(function(x, y) {
      return isSubrecordE(x)(y) && isSubrecordE(y)(x);
    });
  }
  function getMonoid(S3) {
    return {
      concat: function(first, second) {
        if ((0, exports.isEmpty)(first)) {
          return second;
        }
        if ((0, exports.isEmpty)(second)) {
          return first;
        }
        var r = Object.assign({}, first);
        for (var k in second) {
          if (_2.has.call(second, k)) {
            r[k] = _2.has.call(first, k) ? S3.concat(first[k], second[k]) : second[k];
          }
        }
        return r;
      },
      empty: exports.empty
    };
  }
  exports.Functor = {
    URI: exports.URI,
    map: exports._map
  };
  exports.flap = (0, Functor_12.flap)(exports.Functor);
  exports.FunctorWithIndex = {
    URI: exports.URI,
    map: exports._map,
    mapWithIndex: exports._mapWithIndex
  };
  var getFoldable = function(O) {
    return {
      URI: exports.URI,
      reduce: (0, exports._reduce)(O),
      foldMap: (0, exports._foldMap)(O),
      reduceRight: (0, exports._reduceRight)(O)
    };
  };
  exports.getFoldable = getFoldable;
  var getFoldableWithIndex = function(O) {
    return {
      URI: exports.URI,
      reduce: (0, exports._reduce)(O),
      foldMap: (0, exports._foldMap)(O),
      reduceRight: (0, exports._reduceRight)(O),
      reduceWithIndex: (0, exports._reduceWithIndex)(O),
      foldMapWithIndex: (0, exports._foldMapWithIndex)(O),
      reduceRightWithIndex: (0, exports._reduceRightWithIndex)(O)
    };
  };
  exports.getFoldableWithIndex = getFoldableWithIndex;
  exports.Compactable = {
    URI: exports.URI,
    compact: exports.compact,
    separate: exports.separate
  };
  exports.Filterable = {
    URI: exports.URI,
    map: exports._map,
    compact: exports.compact,
    separate: exports.separate,
    filter: exports._filter,
    filterMap: exports._filterMap,
    partition: exports._partition,
    partitionMap: exports._partitionMap
  };
  exports.FilterableWithIndex = {
    URI: exports.URI,
    map: exports._map,
    mapWithIndex: exports._mapWithIndex,
    compact: exports.compact,
    separate: exports.separate,
    filter: exports._filter,
    filterMap: exports._filterMap,
    partition: exports._partition,
    partitionMap: exports._partitionMap,
    filterMapWithIndex: exports._filterMapWithIndex,
    filterWithIndex: exports._filterWithIndex,
    partitionMapWithIndex: exports._partitionMapWithIndex,
    partitionWithIndex: exports._partitionWithIndex
  };
  var getTraversable = function(O) {
    return {
      URI: exports.URI,
      map: exports._map,
      reduce: (0, exports._reduce)(O),
      foldMap: (0, exports._foldMap)(O),
      reduceRight: (0, exports._reduceRight)(O),
      traverse: (0, exports._traverse)(O),
      sequence: (0, exports._sequence)(O)
    };
  };
  exports.getTraversable = getTraversable;
  var getTraversableWithIndex = function(O) {
    return {
      URI: exports.URI,
      map: exports._map,
      mapWithIndex: exports._mapWithIndex,
      reduce: (0, exports._reduce)(O),
      foldMap: (0, exports._foldMap)(O),
      reduceRight: (0, exports._reduceRight)(O),
      reduceWithIndex: (0, exports._reduceWithIndex)(O),
      foldMapWithIndex: (0, exports._foldMapWithIndex)(O),
      reduceRightWithIndex: (0, exports._reduceRightWithIndex)(O),
      traverse: (0, exports._traverse)(O),
      sequence: (0, exports._sequence)(O),
      traverseWithIndex: _traverseWithIndex(O)
    };
  };
  exports.getTraversableWithIndex = getTraversableWithIndex;
  var getWitherable = function(O) {
    var T = (0, exports.getTraversable)(O);
    return {
      URI: exports.URI,
      map: exports._map,
      reduce: (0, exports._reduce)(O),
      foldMap: (0, exports._foldMap)(O),
      reduceRight: (0, exports._reduceRight)(O),
      traverse: T.traverse,
      sequence: T.sequence,
      compact: exports.compact,
      separate: exports.separate,
      filter: exports._filter,
      filterMap: exports._filterMap,
      partition: exports._partition,
      partitionMap: exports._partitionMap,
      wither: (0, Witherable_1.witherDefault)(T, exports.Compactable),
      wilt: (0, Witherable_1.wiltDefault)(T, exports.Compactable)
    };
  };
  exports.getWitherable = getWitherable;
  var getUnionSemigroup = function(S3) {
    var unionS = (0, exports.union)(S3);
    return {
      concat: function(first, second) {
        return unionS(second)(first);
      }
    };
  };
  exports.getUnionSemigroup = getUnionSemigroup;
  var getUnionMonoid = function(S3) {
    return {
      concat: (0, exports.getUnionSemigroup)(S3).concat,
      empty: exports.empty
    };
  };
  exports.getUnionMonoid = getUnionMonoid;
  var getIntersectionSemigroup = function(S3) {
    var intersectionS = (0, exports.intersection)(S3);
    return {
      concat: function(first, second) {
        return intersectionS(second)(first);
      }
    };
  };
  exports.getIntersectionSemigroup = getIntersectionSemigroup;
  var getDifferenceMagma = function() {
    return {
      concat: function(first, second) {
        return (0, exports.difference)(second)(first);
      }
    };
  };
  exports.getDifferenceMagma = getDifferenceMagma;
  exports.Foldable = {
    URI: exports.URI,
    reduce: /* @__PURE__ */ (0, exports._reduce)(S2.Ord),
    foldMap: /* @__PURE__ */ (0, exports._foldMap)(S2.Ord),
    reduceRight: /* @__PURE__ */ (0, exports._reduceRight)(S2.Ord)
  };
  exports.FoldableWithIndex = {
    URI: exports.URI,
    reduce: /* @__PURE__ */ (0, exports._reduce)(S2.Ord),
    foldMap: /* @__PURE__ */ (0, exports._foldMap)(S2.Ord),
    reduceRight: /* @__PURE__ */ (0, exports._reduceRight)(S2.Ord),
    reduceWithIndex: /* @__PURE__ */ (0, exports._reduceWithIndex)(S2.Ord),
    foldMapWithIndex: /* @__PURE__ */ (0, exports._foldMapWithIndex)(S2.Ord),
    reduceRightWithIndex: /* @__PURE__ */ (0, exports._reduceRightWithIndex)(S2.Ord)
  };
  exports.Traversable = {
    URI: exports.URI,
    map: exports._map,
    reduce: /* @__PURE__ */ (0, exports._reduce)(S2.Ord),
    foldMap: /* @__PURE__ */ (0, exports._foldMap)(S2.Ord),
    reduceRight: /* @__PURE__ */ (0, exports._reduceRight)(S2.Ord),
    traverse: /* @__PURE__ */ (0, exports._traverse)(S2.Ord),
    sequence
  };
  exports.TraversableWithIndex = {
    URI: exports.URI,
    map: exports._map,
    mapWithIndex: exports._mapWithIndex,
    reduce: /* @__PURE__ */ (0, exports._reduce)(S2.Ord),
    foldMap: /* @__PURE__ */ (0, exports._foldMap)(S2.Ord),
    reduceRight: /* @__PURE__ */ (0, exports._reduceRight)(S2.Ord),
    reduceWithIndex: /* @__PURE__ */ (0, exports._reduceWithIndex)(S2.Ord),
    foldMapWithIndex: /* @__PURE__ */ (0, exports._foldMapWithIndex)(S2.Ord),
    reduceRightWithIndex: /* @__PURE__ */ (0, exports._reduceRightWithIndex)(S2.Ord),
    traverse: /* @__PURE__ */ (0, exports._traverse)(S2.Ord),
    sequence,
    traverseWithIndex: /* @__PURE__ */ _traverseWithIndex(S2.Ord)
  };
  var _wither = /* @__PURE__ */ (0, Witherable_1.witherDefault)(exports.Traversable, exports.Compactable);
  var _wilt = /* @__PURE__ */ (0, Witherable_1.wiltDefault)(exports.Traversable, exports.Compactable);
  exports.Witherable = {
    URI: exports.URI,
    map: exports._map,
    reduce: /* @__PURE__ */ (0, exports._reduce)(S2.Ord),
    foldMap: /* @__PURE__ */ (0, exports._foldMap)(S2.Ord),
    reduceRight: /* @__PURE__ */ (0, exports._reduceRight)(S2.Ord),
    traverse: /* @__PURE__ */ (0, exports._traverse)(S2.Ord),
    sequence,
    compact: exports.compact,
    separate: exports.separate,
    filter: exports._filter,
    filterMap: exports._filterMap,
    partition: exports._partition,
    partitionMap: exports._partitionMap,
    wither: _wither,
    wilt: _wilt
  };
  exports.insertAt = exports.upsertAt;
  function hasOwnProperty2(k, r) {
    return _2.has.call(r === void 0 ? this : r, k);
  }
  exports.readonlyRecord = {
    URI: exports.URI,
    map: exports._map,
    reduce: /* @__PURE__ */ (0, exports._reduce)(S2.Ord),
    foldMap: /* @__PURE__ */ (0, exports._foldMap)(S2.Ord),
    reduceRight: /* @__PURE__ */ (0, exports._reduceRight)(S2.Ord),
    traverse: /* @__PURE__ */ (0, exports._traverse)(S2.Ord),
    sequence,
    compact: exports.compact,
    separate: exports.separate,
    filter: exports._filter,
    filterMap: exports._filterMap,
    partition: exports._partition,
    partitionMap: exports._partitionMap,
    mapWithIndex: exports._mapWithIndex,
    reduceWithIndex: /* @__PURE__ */ (0, exports._reduceWithIndex)(S2.Ord),
    foldMapWithIndex: /* @__PURE__ */ (0, exports._foldMapWithIndex)(S2.Ord),
    reduceRightWithIndex: /* @__PURE__ */ (0, exports._reduceRightWithIndex)(S2.Ord),
    filterMapWithIndex: exports._filterMapWithIndex,
    filterWithIndex: exports._filterWithIndex,
    partitionMapWithIndex: exports._partitionMapWithIndex,
    partitionWithIndex: exports._partitionWithIndex,
    traverseWithIndex: /* @__PURE__ */ _traverseWithIndex(S2.Ord),
    wither: _wither,
    wilt: _wilt
  };
})(ReadonlyRecord);
(function(exports) {
  var __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
    __assign = Object.assign || function(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
          if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  var __createBinding2 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault2 = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar2 = commonjsGlobal && commonjsGlobal.__importStar || function(mod2) {
    if (mod2 && mod2.__esModule)
      return mod2;
    var result2 = {};
    if (mod2 != null) {
      for (var k in mod2)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod2, k))
          __createBinding2(result2, mod2, k);
    }
    __setModuleDefault2(result2, mod2);
    return result2;
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.Foldable = exports.getDifferenceMagma = exports.getIntersectionSemigroup = exports.getUnionMonoid = exports.getUnionSemigroup = exports.getWitherable = exports.getTraversableWithIndex = exports.getTraversable = exports.FilterableWithIndex = exports.Filterable = exports.Compactable = exports.getFoldableWithIndex = exports.getFoldable = exports.FunctorWithIndex = exports.flap = exports.Functor = exports.getMonoid = exports.getEq = exports.URI = exports.separate = exports.compact = exports.partitionMap = exports.partition = exports.filterMap = exports.filter = exports.difference = exports.intersection = exports.union = exports.elem = exports.some = exports.every = exports.fromEntries = exports.toEntries = exports.filterMapWithIndex = exports.partitionMapWithIndex = exports.wilt = exports.wither = exports.singleton = exports.map = exports.mapWithIndex = exports.lookup = exports.isSubrecord = exports.modifyAt = exports.updateAt = exports.has = exports.upsertAt = exports.toArray = exports.keys = exports.isEmpty = exports.size = void 0;
  exports.record = exports.hasOwnProperty = exports.insertAt = exports.empty = exports.Witherable = exports.TraversableWithIndex = exports.Traversable = exports.FoldableWithIndex = void 0;
  exports.collect = collect;
  exports.toUnfoldable = toUnfoldable;
  exports.deleteAt = deleteAt;
  exports.pop = pop;
  exports.reduceWithIndex = reduceWithIndex;
  exports.foldMapWithIndex = foldMapWithIndex;
  exports.reduceRightWithIndex = reduceRightWithIndex;
  exports.traverseWithIndex = traverseWithIndex;
  exports.traverse = traverse;
  exports.sequence = sequence;
  exports.partitionWithIndex = partitionWithIndex;
  exports.filterWithIndex = filterWithIndex;
  exports.fromFoldable = fromFoldable;
  exports.fromFoldableMap = fromFoldableMap;
  exports.reduce = reduce;
  exports.foldMap = foldMap;
  exports.reduceRight = reduceRight;
  exports.getShow = getShow;
  var A = __importStar2(_Array);
  var function_12 = _function;
  var Functor_12 = Functor;
  var _2 = __importStar2(internal);
  var RR = __importStar2(ReadonlyRecord);
  var Se = __importStar2(Semigroup);
  var S2 = __importStar2(string);
  var Witherable_1 = Witherable;
  exports.size = RR.size;
  exports.isEmpty = RR.isEmpty;
  var keys_ = function(O) {
    return function(r) {
      return Object.keys(r).sort(O.compare);
    };
  };
  exports.keys = keys_(S2.Ord);
  function collect(O) {
    if (typeof O === "function") {
      return collect(S2.Ord)(O);
    }
    var keysO = keys_(O);
    return function(f) {
      return function(r) {
        var out = [];
        for (var _i = 0, _a = keysO(r); _i < _a.length; _i++) {
          var key = _a[_i];
          out.push(f(key, r[key]));
        }
        return out;
      };
    };
  }
  exports.toArray = collect(S2.Ord)(function(k, a) {
    return [
      k,
      a
    ];
  });
  function toUnfoldable(U) {
    return function(r) {
      var sas = (0, exports.toArray)(r);
      var len = sas.length;
      return U.unfold(0, function(b) {
        return b < len ? _2.some([sas[b], b + 1]) : _2.none;
      });
    };
  }
  exports.upsertAt = RR.upsertAt;
  exports.has = RR.has;
  function deleteAt(k) {
    return function(r) {
      if (!_2.has.call(r, k)) {
        return r;
      }
      var out = Object.assign({}, r);
      delete out[k];
      return out;
    };
  }
  var updateAt = function(k, a) {
    return (0, exports.modifyAt)(k, function() {
      return a;
    });
  };
  exports.updateAt = updateAt;
  var modifyAt = function(k, f) {
    return function(r) {
      if (!(0, exports.has)(k, r)) {
        return _2.none;
      }
      var out = Object.assign({}, r);
      out[k] = f(r[k]);
      return _2.some(out);
    };
  };
  exports.modifyAt = modifyAt;
  function pop(k) {
    var deleteAtk = deleteAt(k);
    return function(r) {
      var oa = (0, exports.lookup)(k, r);
      return _2.isNone(oa) ? _2.none : _2.some([oa.value, deleteAtk(r)]);
    };
  }
  exports.isSubrecord = RR.isSubrecord;
  exports.lookup = RR.lookup;
  exports.mapWithIndex = RR.mapWithIndex;
  exports.map = RR.map;
  function reduceWithIndex() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return args.length === 1 ? RR.reduceWithIndex(args[0]) : RR.reduceWithIndex(S2.Ord).apply(void 0, args);
  }
  function foldMapWithIndex(O) {
    return "compare" in O ? RR.foldMapWithIndex(O) : RR.foldMapWithIndex(S2.Ord)(O);
  }
  function reduceRightWithIndex() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return args.length === 1 ? RR.reduceRightWithIndex(args[0]) : RR.reduceRightWithIndex(S2.Ord).apply(void 0, args);
  }
  exports.singleton = RR.singleton;
  function traverseWithIndex(F) {
    return RR.traverseWithIndex(F);
  }
  function traverse(F) {
    return RR.traverse(F);
  }
  function sequence(F) {
    return RR.sequence(F);
  }
  var wither = function(F) {
    var traverseF = traverse(F);
    return function(f) {
      return function(fa) {
        return F.map((0, function_12.pipe)(fa, traverseF(f)), exports.compact);
      };
    };
  };
  exports.wither = wither;
  var wilt = function(F) {
    var traverseF = traverse(F);
    return function(f) {
      return function(fa) {
        return F.map((0, function_12.pipe)(fa, traverseF(f)), exports.separate);
      };
    };
  };
  exports.wilt = wilt;
  exports.partitionMapWithIndex = RR.partitionMapWithIndex;
  function partitionWithIndex(predicateWithIndex) {
    return RR.partitionWithIndex(predicateWithIndex);
  }
  exports.filterMapWithIndex = RR.filterMapWithIndex;
  function filterWithIndex(predicateWithIndex) {
    return RR.filterWithIndex(predicateWithIndex);
  }
  function fromFoldable(M, F) {
    return RR.fromFoldable(M, F);
  }
  exports.toEntries = exports.toArray;
  var fromEntries = function(fa) {
    return fromFoldable(Se.last(), A.Foldable)(fa);
  };
  exports.fromEntries = fromEntries;
  function fromFoldableMap(M, F) {
    return RR.fromFoldableMap(M, F);
  }
  exports.every = RR.every;
  exports.some = RR.some;
  exports.elem = RR.elem;
  var union = function(M) {
    var unionM = RR.union(M);
    return function(second) {
      return function(first) {
        if ((0, exports.isEmpty)(first)) {
          return __assign({}, second);
        }
        if ((0, exports.isEmpty)(second)) {
          return __assign({}, first);
        }
        return unionM(second)(first);
      };
    };
  };
  exports.union = union;
  var intersection = function(M) {
    return function(second) {
      return function(first) {
        if ((0, exports.isEmpty)(first) || (0, exports.isEmpty)(second)) {
          return {};
        }
        return RR.intersection(M)(second)(first);
      };
    };
  };
  exports.intersection = intersection;
  var difference = function(second) {
    return function(first) {
      if ((0, exports.isEmpty)(first)) {
        return __assign({}, second);
      }
      if ((0, exports.isEmpty)(second)) {
        return __assign({}, first);
      }
      return RR.difference(second)(first);
    };
  };
  exports.difference = difference;
  var _map = RR._map;
  var _mapWithIndex = RR._mapWithIndex;
  var _reduce = RR._reduce;
  var _foldMap = RR._foldMap;
  var _reduceRight = RR._reduceRight;
  var _filter = RR._filter;
  var _filterMap = RR._filterMap;
  var _partition = RR._partition;
  var _partitionMap = RR._partitionMap;
  var _reduceWithIndex = RR._reduceWithIndex;
  var _foldMapWithIndex = RR._foldMapWithIndex;
  var _reduceRightWithIndex = RR._reduceRightWithIndex;
  var _partitionMapWithIndex = RR._partitionMapWithIndex;
  var _partitionWithIndex = RR._partitionWithIndex;
  var _filterMapWithIndex = RR._filterMapWithIndex;
  var _filterWithIndex = RR._filterWithIndex;
  var _traverse = RR._traverse;
  var _sequence = RR._sequence;
  var _traverseWithIndex = function(O) {
    return function(F) {
      var keysO = keys_(O);
      return function(ta, f) {
        var ks = keysO(ta);
        if (ks.length === 0) {
          return F.of({});
        }
        var fr = F.of({});
        var _loop_1 = function(key2) {
          fr = F.ap(F.map(fr, function(r) {
            return function(b) {
              r[key2] = b;
              return r;
            };
          }), f(key2, ta[key2]));
        };
        for (var _i = 0, ks_1 = ks; _i < ks_1.length; _i++) {
          var key = ks_1[_i];
          _loop_1(key);
        }
        return fr;
      };
    };
  };
  exports.filter = RR.filter;
  exports.filterMap = RR.filterMap;
  exports.partition = RR.partition;
  exports.partitionMap = RR.partitionMap;
  function reduce() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return args.length === 1 ? RR.reduce(args[0]) : RR.reduce(S2.Ord).apply(void 0, args);
  }
  function foldMap(O) {
    return "compare" in O ? RR.foldMap(O) : RR.foldMap(S2.Ord)(O);
  }
  function reduceRight() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return args.length === 1 ? RR.reduceRight(args[0]) : RR.reduceRight(S2.Ord).apply(void 0, args);
  }
  exports.compact = RR.compact;
  exports.separate = RR.separate;
  exports.URI = "Record";
  function getShow(O) {
    return "compare" in O ? RR.getShow(O) : RR.getShow(S2.Ord)(O);
  }
  exports.getEq = RR.getEq;
  exports.getMonoid = RR.getMonoid;
  exports.Functor = {
    URI: exports.URI,
    map: _map
  };
  exports.flap = (0, Functor_12.flap)(exports.Functor);
  exports.FunctorWithIndex = {
    URI: exports.URI,
    map: _map,
    mapWithIndex: _mapWithIndex
  };
  var getFoldable = function(O) {
    return {
      URI: exports.URI,
      reduce: _reduce(O),
      foldMap: _foldMap(O),
      reduceRight: _reduceRight(O)
    };
  };
  exports.getFoldable = getFoldable;
  var getFoldableWithIndex = function(O) {
    return {
      URI: exports.URI,
      reduce: _reduce(O),
      foldMap: _foldMap(O),
      reduceRight: _reduceRight(O),
      reduceWithIndex: _reduceWithIndex(O),
      foldMapWithIndex: _foldMapWithIndex(O),
      reduceRightWithIndex: _reduceRightWithIndex(O)
    };
  };
  exports.getFoldableWithIndex = getFoldableWithIndex;
  exports.Compactable = {
    URI: exports.URI,
    compact: exports.compact,
    separate: exports.separate
  };
  exports.Filterable = {
    URI: exports.URI,
    map: _map,
    compact: exports.compact,
    separate: exports.separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap
  };
  exports.FilterableWithIndex = {
    URI: exports.URI,
    map: _map,
    mapWithIndex: _mapWithIndex,
    compact: exports.compact,
    separate: exports.separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap,
    filterMapWithIndex: _filterMapWithIndex,
    filterWithIndex: _filterWithIndex,
    partitionMapWithIndex: _partitionMapWithIndex,
    partitionWithIndex: _partitionWithIndex
  };
  var getTraversable = function(O) {
    return {
      URI: exports.URI,
      map: _map,
      reduce: _reduce(O),
      foldMap: _foldMap(O),
      reduceRight: _reduceRight(O),
      traverse: _traverse(O),
      sequence: _sequence(O)
    };
  };
  exports.getTraversable = getTraversable;
  var getTraversableWithIndex = function(O) {
    return {
      URI: exports.URI,
      map: _map,
      mapWithIndex: _mapWithIndex,
      reduce: _reduce(O),
      foldMap: _foldMap(O),
      reduceRight: _reduceRight(O),
      reduceWithIndex: _reduceWithIndex(O),
      foldMapWithIndex: _foldMapWithIndex(O),
      reduceRightWithIndex: _reduceRightWithIndex(O),
      traverse: _traverse(O),
      sequence: _sequence(O),
      traverseWithIndex: _traverseWithIndex(O)
    };
  };
  exports.getTraversableWithIndex = getTraversableWithIndex;
  var getWitherable = function(O) {
    var T = (0, exports.getTraversable)(O);
    return {
      URI: exports.URI,
      map: _map,
      reduce: _reduce(O),
      foldMap: _foldMap(O),
      reduceRight: _reduceRight(O),
      traverse: T.traverse,
      sequence: T.sequence,
      compact: exports.compact,
      separate: exports.separate,
      filter: _filter,
      filterMap: _filterMap,
      partition: _partition,
      partitionMap: _partitionMap,
      wither: (0, Witherable_1.witherDefault)(T, exports.Compactable),
      wilt: (0, Witherable_1.wiltDefault)(T, exports.Compactable)
    };
  };
  exports.getWitherable = getWitherable;
  var getUnionSemigroup = function(S3) {
    var unionS = (0, exports.union)(S3);
    return {
      concat: function(first, second) {
        return unionS(second)(first);
      }
    };
  };
  exports.getUnionSemigroup = getUnionSemigroup;
  var getUnionMonoid = function(S3) {
    return {
      concat: (0, exports.getUnionSemigroup)(S3).concat,
      empty: {}
    };
  };
  exports.getUnionMonoid = getUnionMonoid;
  var getIntersectionSemigroup = function(S3) {
    var intersectionS = (0, exports.intersection)(S3);
    return {
      concat: function(first, second) {
        return intersectionS(second)(first);
      }
    };
  };
  exports.getIntersectionSemigroup = getIntersectionSemigroup;
  var getDifferenceMagma = function() {
    return {
      concat: function(first, second) {
        return (0, exports.difference)(second)(first);
      }
    };
  };
  exports.getDifferenceMagma = getDifferenceMagma;
  exports.Foldable = {
    URI: exports.URI,
    reduce: /* @__PURE__ */ _reduce(S2.Ord),
    foldMap: /* @__PURE__ */ _foldMap(S2.Ord),
    reduceRight: /* @__PURE__ */ _reduceRight(S2.Ord)
  };
  exports.FoldableWithIndex = {
    URI: exports.URI,
    reduce: /* @__PURE__ */ _reduce(S2.Ord),
    foldMap: /* @__PURE__ */ _foldMap(S2.Ord),
    reduceRight: /* @__PURE__ */ _reduceRight(S2.Ord),
    reduceWithIndex: /* @__PURE__ */ _reduceWithIndex(S2.Ord),
    foldMapWithIndex: /* @__PURE__ */ _foldMapWithIndex(S2.Ord),
    reduceRightWithIndex: /* @__PURE__ */ _reduceRightWithIndex(S2.Ord)
  };
  exports.Traversable = {
    URI: exports.URI,
    map: _map,
    reduce: /* @__PURE__ */ _reduce(S2.Ord),
    foldMap: /* @__PURE__ */ _foldMap(S2.Ord),
    reduceRight: /* @__PURE__ */ _reduceRight(S2.Ord),
    traverse: /* @__PURE__ */ _traverse(S2.Ord),
    sequence
  };
  exports.TraversableWithIndex = {
    URI: exports.URI,
    map: _map,
    mapWithIndex: _mapWithIndex,
    reduce: /* @__PURE__ */ _reduce(S2.Ord),
    foldMap: /* @__PURE__ */ _foldMap(S2.Ord),
    reduceRight: /* @__PURE__ */ _reduceRight(S2.Ord),
    reduceWithIndex: /* @__PURE__ */ _reduceWithIndex(S2.Ord),
    foldMapWithIndex: /* @__PURE__ */ _foldMapWithIndex(S2.Ord),
    reduceRightWithIndex: /* @__PURE__ */ _reduceRightWithIndex(S2.Ord),
    traverse: /* @__PURE__ */ _traverse(S2.Ord),
    sequence,
    traverseWithIndex: /* @__PURE__ */ _traverseWithIndex(S2.Ord)
  };
  var _wither = /* @__PURE__ */ (0, Witherable_1.witherDefault)(exports.Traversable, exports.Compactable);
  var _wilt = /* @__PURE__ */ (0, Witherable_1.wiltDefault)(exports.Traversable, exports.Compactable);
  exports.Witherable = {
    URI: exports.URI,
    map: _map,
    reduce: /* @__PURE__ */ _reduce(S2.Ord),
    foldMap: /* @__PURE__ */ _foldMap(S2.Ord),
    reduceRight: /* @__PURE__ */ _reduceRight(S2.Ord),
    traverse: /* @__PURE__ */ _traverse(S2.Ord),
    sequence,
    compact: exports.compact,
    separate: exports.separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap,
    wither: _wither,
    wilt: _wilt
  };
  exports.empty = {};
  exports.insertAt = exports.upsertAt;
  exports.hasOwnProperty = RR.hasOwnProperty;
  exports.record = {
    URI: exports.URI,
    map: _map,
    reduce: /* @__PURE__ */ _reduce(S2.Ord),
    foldMap: /* @__PURE__ */ _foldMap(S2.Ord),
    reduceRight: /* @__PURE__ */ _reduceRight(S2.Ord),
    traverse: /* @__PURE__ */ _traverse(S2.Ord),
    sequence,
    compact: exports.compact,
    separate: exports.separate,
    filter: _filter,
    filterMap: _filterMap,
    partition: _partition,
    partitionMap: _partitionMap,
    mapWithIndex: _mapWithIndex,
    reduceWithIndex: /* @__PURE__ */ _reduceWithIndex(S2.Ord),
    foldMapWithIndex: /* @__PURE__ */ _foldMapWithIndex(S2.Ord),
    reduceRightWithIndex: /* @__PURE__ */ _reduceRightWithIndex(S2.Ord),
    filterMapWithIndex: _filterMapWithIndex,
    filterWithIndex: _filterWithIndex,
    partitionMapWithIndex: _partitionMapWithIndex,
    partitionWithIndex: _partitionWithIndex,
    traverseWithIndex: /* @__PURE__ */ _traverseWithIndex(S2.Ord),
    wither: _wither,
    wilt: _wilt
  };
})(Record);
function handleResponse(response) {
  const defaultResponse = {
    skip: 0,
    size: 10,
    sortBy: "",
    sortDirection: SortDirection.Ascending,
    totalItemCount: 0,
    items: []
  };
  return {
    unwrap: () => response.data,
    unwrapOr: (fn) => {
      if (isError(response)) {
        fn(response);
      }
      const data = (response == null ? void 0 : response.data) ?? defaultResponse;
      return data;
    }
  };
}
function match(data) {
  const value = handleResponse(data).unwrap();
  return (fns) => {
    const t1 = Object.keys(ResponseStatus).length / 2;
    const t2 = Object.keys(fns).length;
    if (t1 !== t2) {
      throw new Error("Invalid match function");
    }
    if (isError(data)) {
      return fns[ResponseStatus.Error](data);
    }
    if (isSuccess(data)) {
      return fns[ResponseStatus.Success](value);
    }
  };
}
function getItemsFromResponse(response) {
  var _a;
  if (!((_a = response == null ? void 0 : response.items) == null ? void 0 : _a.length))
    return build.None;
  return build.Some(response.items);
}
const APIErrors = {
  unableToFindEndpoint: "Unable to find endpoint"
};
function getPath(obj) {
  var _a, _b;
  return ((_b = (_a = obj.ENVIRONMENT) == null ? void 0 : _a.ApiRoot) == null ? void 0 : _b.Base) ?? "https://api.dev.schemeserve.com";
}
function getDefaultResponse() {
  return () => Promise.resolve({
    skip: 0,
    size: 10,
    sortBy: "",
    sortDirection: SortDirection.Ascending,
    totalItemCount: 0,
    items: []
  });
}
function getEndpoint(endpoints) {
  return (endpoint) => _function.pipe(
    endpoints,
    Record.lookup(endpoint),
    Option.map((endpoint2) => _function.pipe(
      endpoint2,
      string.startsWith("/"),
      boolean.match(
        () => `/${endpoint2}`,
        () => endpoint2
      )
    )),
    Option.map((endpoint2) => endpoint2),
    Either.fromOption(() => new Error(APIErrors.unableToFindEndpoint))
  );
}
function replaceUriInEndpoint(uri) {
  return (endpoint) => {
    if (uri === void 0)
      return endpoint;
    const newUrl = endpoint.split(/\{(.*?)\}/).map((part) => {
      if (part.includes("/") || part.includes("\\")) {
        return part;
      }
      return uri == null ? void 0 : uri[part];
    }).join("");
    return newUrl;
  };
}
function buildQueryString(params) {
  return (endpoint) => {
    const qs = Object.entries(params ?? {}).map(([key, value]) => `${key.toLowerCase()}=${value}`).join("&");
    return qs.length >= 1 ? `${endpoint}?${qs}` : endpoint;
  };
}
function joinPathToEndpoint(path) {
  return (endpoint) => `${path}${endpoint}`;
}
function includeHeaders(token2) {
  return _function.pipe(
    token2,
    Option.map((tokens2) => ({
      Authorization: `Bearer ${tokens2.accessToken}`,
      "Content-Type": "application/json"
    })),
    Option.getOrElse(() => ({}))
  );
}
function safeFetchPost(data) {
  return TaskEither.tryCatch(
    () => fetch(data.url, {
      method: "POST",
      headers: data.headers,
      body: data.payload
    }),
    (reason) => new Error(String(reason))
  );
}
function safeFetchGet(data) {
  return TaskEither.tryCatch(
    () => fetch(data.url, {
      method: "GET",
      headers: data.headers
    }),
    (reason) => new Error(String(reason))
  );
}
function safeJson(resp) {
  return TaskEither.tryCatch(
    () => resp.json(),
    (reason) => new Error(String(reason))
  );
}
function isErrorTypeOne(error) {
  return error.StatusCode !== void 0;
}
function isErrorTypeTwo(error) {
  const err = error;
  return err.status !== void 0 && typeof err.status === "number";
}
function isResponseError(data) {
  const errorOne = isErrorTypeOne(data);
  const errorTwo = isErrorTypeTwo(data);
  return errorOne || errorTwo;
}
function isUnifiedResponse(data) {
  return data.items !== void 0;
}
function createUnifiedErrorFromTypeTwo(error) {
  return {
    status: error.status,
    message: error.title,
    type: error.type
  };
}
function createUnifiedErrorFromTypeOne(error) {
  return {
    status: error.StatusCode,
    message: error.Message,
    type: error.ExceptionType
  };
}
function createUnifiedError(error) {
  if (isErrorTypeOne(error))
    return createUnifiedErrorFromTypeOne(error);
  return createUnifiedErrorFromTypeTwo(error);
}
function handleFetchResponse(response) {
  if (isResponseError(response)) {
    const unifiedError = createUnifiedError(response);
    return TaskEither.left(unifiedError);
  }
  if (!isUnifiedResponse(response)) {
    return TaskEither.right({
      items: response,
      totalItemCount: 0,
      skip: 10,
      size: 10
    });
  }
  return TaskEither.right(response);
}
const apiContext = createContext(null);
function ApiContextProvider(endpoints) {
  return ({ children }) => {
    function get2({ endpoint, options }) {
      const path = getPath(window);
      const url = _function.pipe(
        endpoint,
        getEndpoint(endpoints),
        Either.map(replaceUriInEndpoint(options == null ? void 0 : options.uri)),
        Either.map(buildQueryString(options == null ? void 0 : options.params)),
        Either.map(joinPathToEndpoint(path)),
        Either.getOrElse(() => "")
      );
      const headers = includeHeaders(getTokens());
      return _function.pipe(
        safeFetchGet({ url, headers }),
        TaskEither.chain(safeJson),
        TaskEither.chainFirstTaskK(() => sleepTask()),
        TaskEither.chain(handleFetchResponse)
      );
    }
    function oldGet(endpoint, responseOptions) {
      return async (options) => {
        const url = endpoints[endpoint];
        const response = await XHR.get(url, options);
        const res = await buildResponse(response, responseOptions);
        await sleep();
        return res;
      };
    }
    function post({ endpoint, payload }) {
      const path = getPath(window);
      const url = _function.pipe(
        endpoint,
        getEndpoint(endpoints),
        Either.map(joinPathToEndpoint(path)),
        Either.getOrElse(() => "")
      );
      const headers = includeHeaders(getTokens());
      return _function.pipe(
        safeFetchPost({ url, headers, payload: JSON.stringify(payload) }),
        TaskEither.chain(safeJson),
        TaskEither.chain(handleFetchResponse)
      );
    }
    function update(endpoint, current, idKey, responseOptions) {
      return async (updated) => {
        const url = endpoints[endpoint];
        const payload = createPatchPayload(current, updated);
        const res = await XHR.patch(url, {
          payload,
          uri: { id: current[idKey] }
        });
        return buildResponse(res, responseOptions);
      };
    }
    function remove(endpoint, responseOptions) {
      return async (id) => {
        const url = endpoints[endpoint];
        const res = await XHR.delete(url, { uri: { id } });
        return buildResponse(res, responseOptions);
      };
    }
    function fetchAll(endpoint, handleError) {
      return async (options) => {
        const buildOptions = (options2) => (multiplier) => {
          var _a, _b;
          return {
            ...options2,
            params: {
              ...options2 == null ? void 0 : options2.params,
              skip: ((_a = options2 == null ? void 0 : options2.params) == null ? void 0 : _a.skip) ?? 100 * multiplier,
              size: ((_b = options2 == null ? void 0 : options2.params) == null ? void 0 : _b.size) ?? 100
            }
          };
        };
        const getRequest = oldGet(endpoint);
        const res = await getRequest(buildOptions(options)(0));
        const data = handleResponse(res).unwrapOr(handleError);
        const numberOfRequest = Math.ceil(data.totalItemCount / data.size) - 1;
        const requests = Array(numberOfRequest).fill(buildOptions(options)).map((fn, idx) => fn(idx + 1)).map((requestOptions) => getRequest(requestOptions));
        const respones = await Promise.all(requests);
        const restOfData = respones.map((res2) => handleResponse(res2).unwrapOr(handleError)).flatMap((data2) => data2.items);
        return data.items.concat(restOfData);
      };
    }
    function getAsOptions(endpoint, keys2, handleError) {
      return async (options) => {
        const res = await oldGet(endpoint)(options);
        const data = handleResponse(res).unwrapOr(handleError);
        return convertResponseToOptions(data, keys2);
      };
    }
    const contextValue = {
      get: get2,
      post,
      update,
      remove,
      fetchAll,
      getAsOptions
    };
    return /* @__PURE__ */ React.createElement(apiContext.Provider, { value: contextValue }, children);
  };
}
function useApiContext() {
  return () => {
    const context = useContext(apiContext);
    if (context === void 0) {
      throw new Error("useApiContext was used outside of its Provider");
    }
    return context;
  };
}
function apiContextWrapper(endpoints) {
  return {
    Provider: ApiContextProvider(endpoints),
    useApiContext: useApiContext()
  };
}
function modifyString(str, fnKey) {
  if (typeof str !== "string")
    return "";
  if (!fnKey)
    return "";
  return str.split(" ").map((word) => {
    const firstChar = word.charAt(0)[fnKey]();
    return `${firstChar}${word.substring(1)}`;
  }).join(" ");
}
function capitalize(str) {
  return modifyString(str, "toUpperCase");
}
function decapitalize(str) {
  return modifyString(str, "toLowerCase");
}
function getAt(items, idx) {
  if (!Array.isArray(items) || items.length === 0)
    return build.None;
  return build.Some(items[idx]);
}
function getFirstItem(items) {
  return getAt(items, 0);
}
function getLastItem(items) {
  return getAt(items, items.length - 1);
}
function hasNoItems(items) {
  return items.length <= 0;
}
function convertArrayToSelectOptionsArray(keys2) {
  return (data) => _function.pipe(
    data,
    _Array.isNonEmpty,
    boolean.match(
      () => [],
      () => _function.pipe(
        data,
        _Array.map((item) => ({
          label: item[keys2.label],
          value: item[keys2.value],
          raw: item
        }))
      )
    )
  );
}
function isBlob(item) {
  return item instanceof Blob;
}
function createBlob(item) {
  return new Blob(["\uFEFF", item]);
}
function getBlobUrl(input) {
  return _function.pipe(
    input,
    Either.fromPredicate(isBlob, () => input),
    Either.match(
      createBlob,
      (blob) => blob
    ),
    URL.createObjectURL
  );
}
function downloadFile(url, title) {
  const downloadLink = document.createElement("a");
  downloadLink.href = url;
  downloadLink.download = title;
  document.body.append(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}
function removeLeadingHash(hex) {
  return hex.replace(/^#/, "");
}
function getFullHexCode(hex) {
  return _function.pipe(
    hex,
    (h) => h.length === 3,
    boolean.match(
      () => hex,
      () => hex.split("").map((c) => c + c).join("")
    )
  );
}
function convertToRgb(hex) {
  const bigint = parseInt(hex, 16);
  const r = bigint >> 16 & 255;
  const g = bigint >> 8 & 255;
  const b = bigint & 255;
  return [r, g, b];
}
function hexToRgb(hex) {
  return _function.pipe(
    hex,
    removeLeadingHash,
    getFullHexCode,
    convertToRgb
  );
}
function luminance(rgb) {
  const a = rgb.map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}
function contrastRatio(l1, l2) {
  return (l1 + 0.05) / (l2 + 0.05);
}
function rgbToHex(rgb) {
  return "#" + rgb.map((x) => {
    const hex = x.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  }).join("");
}
function buildPayload(input) {
  return _function.pipe(
    input,
    (d) => ({
      rgb: {
        fg: hexToRgb(d.fg),
        bg: hexToRgb(d.bg)
      }
    }),
    (d) => ({
      ...d,
      luminance: {
        fg: luminance(d.rgb.fg),
        bg: luminance(d.rgb.bg)
      }
    }),
    (d) => ({
      ...d,
      ratio: contrastRatio(
        Math.max(d.luminance.fg, d.luminance.bg),
        Math.min(d.luminance.fg, d.luminance.bg)
      )
    })
  );
}
function darkenColour(rgb) {
  return rgb.map((v) => Math.max(0, v - 10));
}
function getAccessibleColor(payload) {
  return _function.pipe(
    payload,
    (payload2) => payload2.ratio >= 4.5,
    boolean.match(
      () => _function.pipe(
        {
          fg: rgbToHex(darkenColour(payload.rgb.fg)),
          bg: rgbToHex(payload.rgb.bg)
        },
        buildPayload,
        getAccessibleColor
      ),
      () => payload.rgb.fg
    )
  );
}
function adjustColorForAccessibility(foregroundHex, backgroundHex = "#fff") {
  return _function.pipe(
    {
      fg: foregroundHex,
      bg: backgroundHex
    },
    buildPayload,
    getAccessibleColor,
    rgbToHex
  );
}
const defineTheme = (userConfig) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const defaultConfig = {
    colors: {
      primary: "#7B3EF2",
      dark: "#3a3a3a",
      light: "#ffffff"
    },
    typography: {
      font: "graphik",
      typographyEnabled: true,
      textColorDark: "#434343",
      fontSize: "14px",
      fontWeight: "400"
    }
  };
  const primary = ((_a = userConfig == null ? void 0 : userConfig.colors) == null ? void 0 : _a.primary) || defaultConfig.colors.primary;
  const light = ((_b = userConfig == null ? void 0 : userConfig.colors) == null ? void 0 : _b.light) || defaultConfig.colors.light;
  const dark = ((_c = userConfig == null ? void 0 : userConfig.colors) == null ? void 0 : _c.dark) || defaultConfig.colors.dark;
  const font = ((_d = userConfig == null ? void 0 : userConfig.typography) == null ? void 0 : _d.font) || defaultConfig.typography.font;
  const typographyEnabled = ((_e = userConfig == null ? void 0 : userConfig.typography) == null ? void 0 : _e.typographyEnabled) || defaultConfig.typography.typographyEnabled;
  const textColorDark = ((_f = userConfig == null ? void 0 : userConfig.typography) == null ? void 0 : _f.textColorDark) || defaultConfig.typography.textColorDark;
  const fontSize = ((_g = userConfig == null ? void 0 : userConfig.typography) == null ? void 0 : _g.fontSize) || defaultConfig.typography.fontSize;
  const fontWeight = ((_h = userConfig == null ? void 0 : userConfig.typography) == null ? void 0 : _h.fontWeight) || defaultConfig.typography.fontWeight;
  const primaryColor = Color$1(primary);
  const primaryIsDark = primaryColor.isDark();
  document.documentElement.style.setProperty("--ss-light", light);
  document.documentElement.style.setProperty("--ss-dark", dark);
  document.documentElement.style.setProperty(
    "--ss-primary",
    primaryColor.toString()
  );
  document.documentElement.style.setProperty(
    "--ss-primary-darker",
    primaryColor.darken(0.1).toString()
  );
  document.documentElement.style.setProperty(
    "--ss-primary-light",
    `hsl(${primaryColor.hue().toString()}, ${primaryColor.saturationl().toString()}%, 95%)`
  );
  document.documentElement.style.setProperty(
    "--ss-primary-light-1",
    `hsl(${primaryColor.hue().toString()}, ${primaryColor.saturationl().toString()}%, 85%)`
  );
  document.documentElement.style.setProperty(
    "--ss-primary-contrast",
    primaryIsDark ? light : dark
  );
  document.documentElement.style.setProperty(
    "--ss-text-color--dark",
    textColorDark
  );
  document.documentElement.style.setProperty("--ss-font-size", fontSize);
  document.documentElement.style.setProperty("--ss-font-weight", fontWeight);
  document.documentElement.style.setProperty("--ss-primary-font", font);
  if (typographyEnabled) {
    document.getElementsByTagName("html")[0].setAttribute("class", "include-ss-typography");
  }
};
const downloadCSVByTableRows = (rows, name = "export") => {
  const parsedRows = rows.map(
    (row) => _$3.mapValues(row, (value) => `"${value}"`)
  );
  const csv = [].concat(parsedRows).map((x) => _$3.values(x).toString()).join("\n");
  const downloadLink = document.createElement("a");
  const blob = new Blob(["\uFEFF", csv]);
  const url = URL.createObjectURL(blob);
  downloadLink.href = url;
  downloadLink.download = `${name}-${hooks().format("DD-MM-YYYY")}.csv`;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};
const loadFromCDN = (src, attrs, parentNode) => {
  if (!window.requiredCDNScripts) {
    window.requiredCDNScripts = [];
  }
  if (window.requiredCDNScripts.includes(src)) {
    return new Promise((resolve) => resolve());
  }
  window.requiredCDNScripts.push(src);
  return attatchScript(src, attrs, parentNode);
};
const CDNPackages = {
  jsPDF: async () => {
    if (!window.jspdf) {
      await loadFromCDN("https://unpkg.com/jspdf@2.2.0/dist/jspdf.umd.min.js");
      window.jsPDF = jspdf.jsPDF;
      await loadFromCDN(
        "https://unpkg.com/jspdf-autotable@3.5.13/dist/jspdf.plugin.autotable.js"
      );
    }
  },
  reactAce: async () => {
    if (!window.ace) {
      await loadFromCDN(
        "https://cdnjs.cloudflare.com/ajax/libs/react-ace/9.2.1/react-ace.min.js"
      );
    }
  },
  froalaEditor: async () => {
    await loadFromCDN(
      "https://cdn.jsdelivr.net/npm/froala-editor@3.1.0/js/froala_editor.pkgd.min.js"
    );
  }
};
const downloadPDFByTableRows = async (tableRows, name = "export", options = {
  header: {
    items: [],
    colour: "#000"
  },
  tableOptions: {}
}) => {
  const head = [
    options.header.items.map((header) => ({
      content: header,
      styles: {
        fillColor: options.header.colour
      }
    }))
  ];
  const body = tableRows.map((row) => {
    const keys2 = Object.keys(row);
    return keys2.map((key) => ({ content: row[key] }));
  });
  await CDNPackages.jsPDF();
  const doc = new window.jsPDF({
    ...options.tableOptions
  });
  doc.setFontSize(10);
  doc.text(`${name}-${hooks().format("DD-MM-YYYY")}`, 15, 15);
  doc.autoTable({ html: "#table" });
  doc.autoTable({
    head,
    body
  });
  const url = doc.output("bloburl");
  const downloadLink = document.createElement("a");
  downloadLink.href = url;
  downloadLink.download = `${name}-${hooks().format("DD-MM-YYYY")}.pdf`;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};
const attatchScript = (src, attrs, parentNode) => new Promise((resolve, reject) => {
  const script = document.createElement("script");
  script.async = true;
  script.src = src;
  for (const [k, v] of Object.entries(attrs || {})) {
    script.setAttribute(k, v);
  }
  script.onload = () => {
    script.onerror = script.onload = null;
    resolve(script);
  };
  script.onerror = () => {
    script.onerror = script.onload = null;
    reject(new Error(`Failed to load ${src}`));
  };
  const node = parentNode || document.head || document.getElementsByTagName("head")[0];
  node.appendChild(script);
});
const getPaginationSkip = (providedSkip, providedSize, pagData) => {
  if (providedSkip !== void 0) {
    return providedSkip;
  }
  if (providedSize > pagData.totalItemCount) {
    return 0;
  }
  return pagData.skip;
};
const getHasBreakingError = (errorsObj, toValidate) => {
  const errors = _$3.keys(errorsObj).filter((key) => errorsObj[key]);
  if (toValidate) {
    return toValidate.some((key) => errors.includes(key));
  }
  return !!errors.length;
};
export {
  apiContextWrapper as APIContext,
  AccessGroups,
  CDNPackages,
  Environments,
  ResponseStatus,
  SortDirection,
  adjustColorForAccessibility,
  attatchScript,
  capitalize,
  convertArrayToSelectOptionsArray,
  convertCamelCaseToSentenceCase,
  decapitalize,
  decodeToken,
  defineTheme,
  downloadCSVByTableRows,
  downloadFile,
  downloadPDFByTableRows,
  encodeToken,
  filterNullValues,
  formatMoney,
  getAccessGroup,
  getAt,
  getBlobUrl,
  getDefaultResponse,
  getEnvironment,
  getFirstItem,
  getHasBreakingError,
  getItemsFromResponse,
  getLastItem,
  getModuleSize,
  getPaginationSkip,
  getTokens,
  getUserInfoFromTokens,
  getUserType,
  handleResponse,
  hasNoItems,
  loadFromCDN,
  match,
  updateTokens,
  useComponentVisible,
  useFieldArray,
  useForm,
  useGravatar,
  useLocalStorage,
  usePortal
};
